import pageText from './vi-VN/pageText';
import live from './live/vi-VN';
import timezone from './vi-VN/timezone';
import analysis from './vi-VN/analysis';
import activity from './vi-VN/activity';
import leaderboardActivity from './vi-VN/leaderboardActivity';
import vip from './vi-VN/vip';
import agent from './vi-VN/agent';
import commonSelect from './vi-VN/commonSelect';
import game from './vi-VN/game';
import webConfig from './vi-VN/webConfig';
import luckySpin from './vi-VN/luckySpin';
import adsAgent from './vi-VN/adsAgent';
import adsMccAccount from './vi-VN/adsMccAccount';
import adsAccount from './vi-VN/adsAccount';
import adsReport from './vi-VN/adsReport';
import adsUserPushRecord from './vi-VN/adsUserPushRecord';
import autoPushRecord from './vi-VN/autoPushRecord';
import autoPushConfig from './vi-VN/autoPushConfig';
import autoPushStats from './vi-VN/autoPushStats';
import manualPushRecord from './vi-VN/manualPushRecord';
import smsReport from './vi-VN/smsReport';
import smsChannels from './vi-VN/smsChannels';
import smsTemplates from './vi-VN/smsTemplates';
import smsLogs from './vi-VN/smsLogs';
import smsTasks from './vi-VN/smsTasks';
import inbox from './vi-VN/inbox';
import riskControl from './vi-VN/riskControl';
import news from './vi-VN/news';
import riskDimension from './vi-VN/riskDimension';
import manualTag from './vi-VN/manualTag';
import autoTag from './vi-VN/autoTag';
import auditReport from './vi-VN/auditReport';
import seoPlatform from './vi-VN/seoPlatform.js';
import aiModelConfig from './vi-VN/aiModelConfig.js';

export default {
  ...pageText,
  // Country configuration
  countries: {
    PH: 'PH - Philippines',
    VN: 'VN - Việt Nam',
    TH: 'TH - Thái Lan',
    CN: 'CN - Trung Quốc'
  },

  smsChannels,
  smsTemplates,
  smsLogs,
  smsTasks,
  inbox,
  riskControl,
  news,
  ...riskDimension,
  ...manualTag,
  autoTag,
  ...auditReport,
  ...live,
  ...analysis,
  ...activity,
  ...leaderboardActivity,
  ...vip,
  ...commonSelect,
  ...agent,
  ...webConfig,
  ...adsAgent,
  ...adsMccAccount,
  ...adsAccount,
  ...adsReport,
  ...adsUserPushRecord,
  autoPushRecord,
  ...smsReport,
  autoPushConfig,
  autoPushStats,
  manualPushRecord,
  game,
  ...luckySpin,
  seoPlatform,
  aiModelConfig,
  timezone,
    'common.requestFailed': 'Yêu cầu thất bại',
    'common.required': 'Bắt buộc',

    // Trang đăng nhập
  'login.language': 'Ngôn ngữ',
  'login.account': 'Tài khoản',
  'login.accountRequired': 'Tài khoản không được để trống',
  'login.accountPlaceholder': 'Vui lòng nhập tài khoản',
  'login.password': 'Mật khẩu',
  'login.passwordRequired': 'Mật khẩu không được để trống!',
  'login.passwordPlaceholder': 'Vui lòng nhập mật khẩu',
  'login.googleAuthCode': 'Mã xác thực Google',
  'login.googleAuthPlaceholder': 'Vui lòng nhập mã xác thực Google',
  'login.loginButton': 'Đăng nhập',
  'login.bindGoogleAuth': 'Vui lòng liên kết Google Authenticator và nhấp lại đăng nhập',
  'login.googleAuthMessage': 'Vui lòng liên kết Google Authenticator trước khi đăng nhập',
  'login.close': 'Đóng',
  'login.loading': 'Đang tải...',

  // Lỗi IP Whitelist
  'ipWhitelist.error.title': '404',
  'ipWhitelist.error.subTitle': 'Địa chỉ IP của bạn chưa được thêm vào danh sách trắng, vui lòng liên hệ quản trị viên',

  // Left Menu Management
  'indexLtMenu.tab.top': 'Menu Trên',
  'indexLtMenu.tab.middle': 'Menu Giữa',
  'indexLtMenu.tab.bottom': 'Menu Dưới',
  'indexLtMenu.tab.member': 'Menu thành viên',
  'indexLtMenu.tab.preferential': 'Menu giảm giá',
  'indexLtMenu.menuName': 'Tên Menu',
  'indexLtMenu.menuIcon': 'Biểu Tượng',
  'indexLtMenu.ltMenuArea': 'Loại Menu',
  'indexLtMenu.menuOrder': 'Thứ Tự',
  'indexLtMenu.language': 'Ngôn Ngữ',
  'indexLtMenu.menuLink': 'Liên Kết/Mã',
  'indexLtMenu.ltMenuStatus': 'Trạng Thái',
  'indexLtMenu.menuNote': 'Ghi Chú',
  'indexLtMenu.menuSection': 'Phần Menu',
  'indexLtMenu.languageSettings': 'Cài đặt ngôn ngữ',

  // Bottom Menu Management
  'indexBotMenu.menuName': 'Tên Menu',
  'indexBotMenu.menuIcon': 'Biểu Tượng Menu',
  'indexBotMenu.menuHighlightIcon': 'Biểu tượng menu nổi bật',
  'indexBotMenu.menuCode': 'Mã Menu',
  'indexBotMenu.menuOrder': 'Thứ Tự',
  'indexBotMenu.language': 'Ngôn Ngữ',
  'indexBotMenu.menuLink': 'Liên Kết/Mã',
  'indexBotMenu.isEnable': 'Trạng Thái',
  'indexBotMenu.h5Icon': 'Biểu Tượng H5',
  'indexBotMenu.pcIcon': 'Biểu Tượng PC',
  'indexBotMenu.appIcon': 'Biểu Tượng APP',

  'mlm.promote.userInviteInfoReport': 'Báo cáo thành tích mời.xls',
  'mlm.promote.rebate.level' :'Mức hoàn tiền',
  'mlm.promote.gameType_1': 'Hoàn tiền điện tử',
  'mlm.promote.gameType_2': 'Hoàn tiền cho người thật',
  'mlm.promote.gameType_3': 'Hoàn tiền thể thao',
  'mlm.promote.gameType_4': 'Hoàn tiền xổ số',
  'mlm.promote.gameType_5': 'Hoàn tiền câu cá',
  'mlm.promote.gameType_6': 'Hoàn tiền cờ vua',
  'mlm.promote.gameType_9': 'Hoàn tiền cược tốt hơn',
  'mlm.promote.gameType_10': 'Hoàn tiền thể thao điện tử',
  'mlm.promote.edit': 'Chỉnh sửa',

  'mlm.promote.edit_cancel': 'Hủy',
  'mlm.promote.save': 'Lưu',
  'mlm.promote.operation': 'Hoạt động',
  'mlm.promote.inviteNotOpen': 'Thành tích mời không được mở',
  'mlm.promote.isRebateOpen': 'Có nên bật hoàn tiền cược không',
  'mlm.promote.rebateRatioLimit': 'Tỷ lệ hoàn tiền không được vượt quá {rebateRatioLimit}',
  'mlm.promote.digital': 'Một số có tối đa hai chữ số thập phân',
  'mlm.promote.start': 'Từ ngày bắt đầu',
  'mlm.promote.end': 'Bắt ​​đầu thống kê',

  'mlm.promote.invited.isOpen': 'Có nên bật phần thưởng cho người được mời không',
  'mlm.promote.invited.amount': 'Số tiền thưởng mà mỗi người được mời có thể nhận được',

  'mlm.promote.invited.betflow':'betflow nhiều',
  'mlm.promote.invited.domain':'Tên miền được mời',
  'mlm.promote.invited.domainMsg':'Định dạng là tên miền được phân tách bằng dấu phẩy',

  'mlm.promote.bonus.invite':'Mời thưởng cho mọi người, {date}',
  'mlm.promote.bonus.rebate':'Phần thưởng hoàn tiền cho mọi người, {date}',
  'mlm.promote.bonus.domain':'Phần thưởng mời cho tên miền được chỉ định cho mọi người, {date}',
  'mlm.promote.bonus.point':'Điểm thưởng cho lời mời của mọi người,{0}',

  'mlm.promote.rebateReprot.title1':'số sê-ri',
  'mlm.promote.rebateReprot.title2':'tên người dùng',
  'mlm.promote.rebateReprot.title3':'Cấp độ đại lý',
  'mlm.promote.rebateReprot.title4':'Ngày phát hành',
  'mlm.promote.rebateReprot.title5':'Tổng số tiền hoàn lại',
  'mlm.promote.rebateReprot.view':'Xem chi tiết',
  'mlm.promote.rebateReprot.inviteUserAccount':'người mời username',
  'mlm.promote.rebateReprot.Excel': 'Báo cáo hoàn tiền của bạn bè.xls',
  'mlm.promote.rebateReprot.totalSum': 'Phần thưởng cho người được mời đã được phát: {count} pen, {sum} yuan',

  'mlm.promote.rebateReprotDetail.title1':'số sê-ri',
  'mlm.promote.rebateReprotDetail.title2':'Tên người dùng của người được mời',
  'mlm.promote.rebateReprotDetail.title3':'Cấp độ đại lý',
  'mlm.promote.rebateReprotDetail.title4':'Đại lý cấp cao',
  'mlm.promote.rebateReprotDetail.title5':'Cấp độ hoàn tiền',
  'mlm.promote.rebateReprotDetail.title6':'Ngày thống kê',

  'mlm.promote.rebateReprotDetail.title7':'Tổng tiền hoàn lại',
  'mlm.promote.rebateReprotDetail.suffix':'Reflow/Reprot',

  'mlm.promote.inviteeReprot.title1':'số sê-ri',
  'mlm.promote.inviteeReprot.title2':'Tên người dùng của người được mời',
  'mlm.promote.inviteeReprot.title3':'Số tiền thưởng của người được mời',
  'mlm.promote.inviteeReprot.title4':'Số lần doanh thu',
  'mlm.promote.inviteeReprot.title5':'Trạng thái phân phối',
  'mlm.promote.inviteeReprot.title6':'Mời tên miền',
  'mlm.promote.inviteeReprot.title7':'Tên người dùng của người mời',

  'mlm.promote.inviteeReprot.Excel': 'Báo cáo phần thưởng mời.xls',

  'mlm.promote.inviteeReprotDetail.title1':'Tên người dùng của người được mời',
  'mlm.promote.inviteeReprotDetail.title2':'Thời gian đăng ký',
  'mlm.promote.inviteeReprotDetail.title3':'Tiền gửi tích lũy',
  'mlm.promote.inviteeReprotDetail.title4':'Trạng thái',
  'mlm.promote.inviteeReprotDetail.title5':'Doanh thu hiệu quả tích lũy',
  'mlm.promote.inviteeReprotDetail.title6':'Có nên trở thành thành viên hợp lệ không',
  'mlm.promote.inviteeReprotDetail.title7':'Có giống với IP của thiết bị không',

  'mlm.promote.inviteeReprotDetail.title8':'Thời gian hoàn thành',
  'mlm.report.finishDomainStatus51': 'Đang tiến hành',
  'mlm.report.finishDomainStatus52': 'Đã hoàn thành',

  'mlm.report.title1' :'Báo cáo phân phối chiết khấu',
  'mlm.report.title2' :'Báo cáo thành tích mời',
  'mlm.report.title3' :'Báo cáo bạn bè gian lận',
  'mlm.report.title4' :'Báo cáo phần thưởng của người được mời',

  'mlm.report.agent': 'Người dùng',
  'mlm.report.agentLevel1': 'Đặc vụ cấp 1',
  'mlm.report.agentLevel2': 'Đặc vụ cấp 2',
  'mlm.report.agentLevel3': 'Cấp 3 agent',
  'mlm.report.agentLevel4': 'Cấp độ 4 agent',
  'mlm.report.agentLevel5': 'Cấp độ 5 agent',
  'mlm.report.agentLevel6': 'Cấp độ 6 agent',
  'mlm.report.finishDepositStatus21': 'Đang tiến hành',
  'mlm.report.finishDepositStatus22': 'Hoàn thành',
  'mlm.promote.title1' :'Cài đặt thành tích mời',
  'mlm.promote.title2' :'Cài đặt hoàn tiền cược',
  'mlm.promote.title3' :'Cài đặt khác',

  'avatar.changePassword': 'Đổi Mật Khẩu',
  'avatar.oldPassword': 'Mật Khẩu Cũ',
  'avatar.oldPasswordPlaceholder': 'Mật Khẩu Cũ',
  'avatar.newPassword': 'Mật Khẩu Mới',
  'avatar.newPasswordPlaceholder': 'Mật Khẩu Mới',
  'avatar.confirmPassword': 'Xác Nhận Mật Khẩu Mới',
  'avatar.confirmPasswordPlaceholder': 'Nhập Lại Mật Khẩu',
  'avatar.passwordMismatch': 'Mật khẩu mới và xác nhận mật khẩu không khớp',
  'avatar.changePasswordSuccess': 'Thành công, vui lòng đăng nhập lại!',
  'avatar.oldPasswordRequired': 'Vui lòng nhập mật khẩu cũ',
  'avatar.newPasswordRequired': 'Vui lòng nhập mật khẩu mới',
  'avatar.confirmPasswordRequired': 'Vui lòng nhập xác nhận mật khẩu',


  'common.finance.recharge':'Nạp tiền',
  'sys.copySuccess': 'Kết nối thành công',
  'sys.game': 'Trò chơi nhỏ',
  'sys.eventName': 'Tên hoạt động',
  'sys.enterEventName': 'Hãy nhập tên hoạt động',
  'sys.date.type': 'Kiểu giờ',
  'sys.permanent': 'Giá trị vĩnh viễn',
  'sys.validit.period': 'Tiền khuyến mãi',
  'sys.added.prize': 'Thêm Giải thưởng',
  'sys.added.prize1': 'Thêm Giải thưởng',
  'sys.noAdded.prize1': 'Chưa thêm giải thưởng nào',
  'sys.added.prize2': 'Thêm giải thưởng',
  'sys.open': 'Bật',
  'sys.close': 'Tắt',
  'sys.cashReward': 'Giải thưởng tiền mặt',
  'sys.pointReward': 'Điểm thưởng',
  'sys.physicalReward': 'Phần thưởng vật chất',
  'sys.select.prize': 'Phần thưởng tùy chọn',
  'sys.select.prizeType': 'Hãy chọn kiểu giải thưởng',
  'sys.noAdded.prize': 'Chưa thêm giải nào',
  'sys.activities': 'Nội dung hoạt động',
  'sys.fillActivities': 'Nội dung hoạt động',
  'sys.copyImageLink': 'Chép liên kết ảnh',
  'sys.imageLink': 'ảnh kết nối',
  'sys.addOffer': 'Thêm đề nghị',
  'sys.offer': 'Mức ưu tiên',
  'sys.enterOffer': 'Xin hãy điền vào đề nghị.',
  'sys.prizeName': 'Tên của giải thưởng',
  'sys.enterPrizeName': 'Hãy nhập tên giải thưởng.',
  'sys.prizeType': 'Kiểu giải thưởng',
  'sys.prizeType.desc': 'Loại giải thưởng: Tiền mặt | Số tiền: {prizeAmount} | Lưu lượng nhiều: {betMultiple}',
  'sys.prizeType.desc1': 'Kiểu giải thưởng: khác',
  'sys.prizeType.desc2': ' | Xác suất giải thưởng: {probability}%',
  'sys.prizeType.desc3': ' | Thứ tự giải thưởng: {sort}',
  'sys.prizeType.desc4': ' | Chi tiết giải thưởng: {prizeDetail}',
  'sys.prizeType.desc5': 'Tên giải thưởng: {PrizeName}',
  'sys.ropeType.descInfo': 'Loại dây thừng：{configRopeType} |Số tiền：{configPrizeAmount} |Lưu lượng nhiều：{betMultiple} |Đầu tư tích luỹ：{accumulationBetAmount} |Tổng hợp dây loại：{syntheticRopeType} |Số lượng dây tổng hợp：{syntheticQuantity} |Thứ tự giải thưởng：{sort} |Chi tiết giải thưởng：{configDetail}',
  'sys.prizeList': 'Danh sách giải thưởng',
  'sys.prizeAmount': 'Tiền khuyến mãi',
  'sys.probability': 'Xác',
  'sys.confirmCancel': 'Xác nhận thôi',
  'sys.content': 'Bạn có thể loại bỏ thành viên {userAccount} cho bản vẽ {activityGameType} này không?',
  'sys.activity.type': 'dạng hoạt động',
  'sys.prize': 'Giải',
  'sys.unspecifiedPrize': 'Chưa xác định giải',
  'sys.notIssued': 'KCharselect unicode block name',
  'sys.obsolete': 'Bỏ vô',
  'sys.upload': 'tải',
  'sys.upload.fail1': 'Lỗi tải tập tin, xoá và tải lên lần nữa',
  'sys.upload.picture1': 'Tải ảnh lên',
  'sys.upload.imageMaterial': 'Tải ảnh lên',
  'sys.upload.activityPicture': 'Tải ảnh hoạt động',
  'sys.pc.activityPicture': 'Ảnh hoạt động PC',
  'sys.h5.activityPicture': 'Ảnh hoạt động di động',
  'sys.uploadPC.activityPicture': 'Vui lòng tải ảnh hoạt động máy tính',
  'sys.uploadH5.activityPicture': 'Vui lòng tải lên ảnh hoạt động cơ động',
  'sys.lengthLimit1': 'Nhập vào các kí tự 300',
  'sys.lengthLimit2': 'Nhập vào các kí tự 250',
  'sys.giftCash2': 'Tiền mặt miễn phí',
  'sys.giftCash1': 'Tiền mặt miễn phí',
  'sys.maxBonusAmount':'Phần thưởng tối đa',
  'sys.enterPrizeType': 'Hãy nhập kiểu giải thưởng',
  'sys.discountCash': 'Tiền mặt ưa thích',
  'sys.giftCash': 'Tiền mặt miễn phí (Nhân dân tệ)',
  'sys.giftCashVN': 'Tiền mặt miễn phí (VND)',
  'sys.enterAmountPrize': 'Hãy nhập số tiền giải',
  'sys.flowMultiple': 'Chảy nhiều',
  'sys.flowMultiple2': 'Chảy nhiều',
  'sys.enterFlowMultiple': 'Hãy nhập thời gian dòng',
  'sys.typeData': 'Hãy nhập số 0-100',
  'sys.enterSort': 'Nhập vào chuỗi',
  'sys.winningProbability': 'Xác suất thắng',
  'sys.winningProbability1': 'Hãy nhập vào xác suất thắng trong 11.',
  'sys.enterNumber': 'nhập một số',
  'sys.prizeDetails': 'Chi tiết giải',
  'sys.enterPrizeDetails': 'Hãy nhập chi tiết giải thưởng',
  'sys.rules.number': 'Nhập tới 100 ký tự',
  'sys.prizePicture': 'Ảnh giải thưởng',
  'sys.upload.prizePicture': 'Vui lòng tải ảnh phần thưởng lên',
  'sys.pc.prizePicture': 'Ảnh chụp nhà ga di động',
  'sys.editOffer': 'Sửa nội dung đề nghị',
  'sys.addPrize.submit': 'Xin hãy thêm giải thưởng trước khi gởi!',
  'sys.add.success': 'Thêm thành công!',
  'common.requestfail': 'Yêu cầu thất bại, hãy thử lại!',
  'sys.drawTime': 'Thời gian rút may mắn',
  'sys.setPrizes': 'Cài đặt phần thưởng',
  'sys.disqualification': 'Hủy bỏ tư cách',
  'sys.addLottery': 'Thêm lần xổ số',
  'sys.allType': 'Tất cả các hình thức',
  'sys.allState': 'Toàn bộ trạng thái',
  'sys.addNumberDrawsWrong': 'Lỗi khi tính toán số lần xổ số, hãy thử lại sau!',
  'sys.smallGameType': 'Loại trò chơi nhỏ',
  'sys.selectSmallGameType': 'Hãy chọn một kiểu trò chơi nhỏ',
  'sys.frequency': 'tần số',
  'sys.enterNumberDraws': 'Hãy nhập số giờ vẽ',
  'sys.failedLoadPrizes': 'Lỗi tải phần thưởng, hãy thử lại sau!',
  'sys.selectPrize': 'Hãy chọn giải thưởng.',
  'sys.title.deleteBeforeDisable1': 'Để tránh lỗi, hãy tắt các trò nhỏ trước khi xóa chúng!',
  'sys.title.deleteGame': 'Trò chơi sẽ bị xóa: {activityName} Số lần mà tất cả người dùng về trò chơi này chưa rút thăm cũng sẽ bị xóa. Vui lòng xác nhận',
  'common.title.createAdmin1': 'Người tạo /thời gian tạo',
  'common.title.createAdmin2': 'Người tạo /thời gian tạo',
  'sys.expireDate': 'Hạn sử dụng',
  'sys.viewPrize': 'Kiểm tra phần thưởng',
  'constants.activityType_11': '1. Bánh xe may mắn',
  'constants.activityType_22': '2. Lắc đi.',
  'sys.addSmallGame': 'Thêm trò chơi mới',
  'bet.select.gameType1': 'Chọn kiểu game',
  'sys.cancel': 'hủy',
  'sys.submit': 'nộp',
  'sys.totalNumberTime': 'Tổng số tiền',
  'user.memberAccount': 'Tài khoản:',
  'user.memberAccount1': 'Số tài khoản:',
  'user.checkinTime': 'Thời gian báo danh',
  'sys.time': 'Thời gian công bố',
  'sys.receivePoints': 'Nhận điểm thưởng',
  'sys.receiveState': 'Trạng thái nhận thưởng',
  'sys.receivePrize': 'Nhận giải thưởng',
  'sys.rewardType': 'Thể lệ nhận thưởng',
  'sys.reward': 'Phần',
  'sys.processing': 'Tiến hành',
  'sys.whetherAdditionalRewards': 'Phần thưởng thêm hoặc không',
  'sys.confirmor': 'Người xác nhận',
  'sys.other': 'Khác',
  'sys.integral': 'Điểm thưởng',
  'sys.no': 'Chưa đọc',
  'sys.yes': 'Phải.',
  'sys.chooseCheckInTime': 'Chọn thời gian báo danh',
  'sys.confirmAward': 'Xác nhận công bố phần thưởng',
  'sys.confirmWhetherRewardIssued': 'Xin xác nhận nếu tiền thưởng được ban hành',
  'finance.title.remark2': 'Đăng kí',
  'sys.pickUpTime': 'Thời gian nhận thưởng',
  'sys.choosePickUpTime': 'Chọn thời gian nhận thưởng',
  'sys.receiveAward': 'Nhận giải',
  'sys.usePoints': 'Sử dụng điểm thưởng',
  'sys.grade': 'Cấp độ',
  'sys.enterGrade': 'Hãy nhập cấp độ',
  'sys.cumulativeBetAmount': 'Đặt chung',
  'sys.cumulativeBetAmount1': 'Lần cuối cùng',
  'sys.cumulativeBetAmount2': 'Tổng cộng lương hàng tuần',
  'sys.cumulativeBetAmount3': 'Tổng cộng lương hàng tháng',
  'sys.cumulativeBetAmount4': 'Lương và thưởng',
  'sys.cumulativeBetAmount5': 'Tiền thưởng tuần',
  'sys.cumulativeBetAmount6': 'Tiền thưởng trong tháng',
  'sys.cumulativeBetAmount7': 'Tổng thể tiền thưởng',
  'sys.update': 'Chỉnh:',
  'sys.updateTime': 'Thời gian cập nhật',
  'sys.upgradeUser.name': 'Nâng cấp danh sách Kỷ lục',
  'sys.offerName': 'Tên ưu đãi',
  'sys.enterOfferName': 'Hãy nhập tên của đề nghị',
  'sys.offerName1': 'Tên đề xuất:',
  'sys.offerName2': 'Tên ưu đãi,tên tài khoản',
  'sys.offerName3': 'Tên của công ty',
  'sys.default.sort': 'Mặc định',
  'sys.rank.ascending': 'Cấp bậc cao',
  'sys.rank.descending': 'Giảm dần theo cấp độ',
  'sys.all.offers': 'Tổng ưu đãi',
  'sys.title.delete': 'Sắp xoá: {bonusName}',
  'sys.mutuallyExclusiveOffer': 'Giá trị độc quyền',
  'sys.addMutuallyExclusiveOffer': 'Thêm giá trị',
  'sys.addMutuallyExclusiveOfferGroup': 'Thêm nhóm đề nghị độc quyền',
  'sys.alreadyCollectionRule': 'Anh có luật lệ yêu cầu',
  'sys.rule.name': 'Mục điều lệ:',
  'sys.rule.name1': 'Mục điều lệ',
  'sys.enterRule.name': 'Hãy nhập tên quy định.',
  'sys.collectionRule.description': 'Mô tả quy định răng',
  'sys.addCollectionRule': 'Thêm nguyên tắc yêu cầu',
  'sys.deleteRule': 'Quy tắc bộ sưu tập sắp bị xóa: {groupCode}',
  'sys.confirmDisabled': 'Xác nhận tắt',
  'sys.confirmDisabled1': 'Sắp có: {groupName}',
  'sys.confirmEnable': 'Xác nhận bật',
  'sys.confirmEnable1': 'Sắp bật: Groupname',
  'sys.changeSetting': 'Sửa đổi cấu hình',
  'sys.management': 'Chính:',
  'sys.next': 'Bước kế tiếp',
  'sys.addSpecialOffer': 'Thêm hoạt động mới',
  'sys.addSpecial': 'Thêm hoạt động mới',
  'sys.enterNameOfferArticle': 'Hãy nhập tên của bài báo đề nghị.',
  'sys.nameOfferArticle': 'Tên tác vụ',
  'sys.addOfferArticle': 'Tài liệu mới',
  'sys.category': 'Cấp độ',
  'sys.selectCategory': 'Vui lòng chọn hạng',
  'sys.displayOrder': 'Hiển thị trật tự',
  'sys.enterDisplayOrder': 'Hãy nhập lệnh bộ trình bày',
  'sys.selectPlatformType': 'Chọn kiểu nền',
  'sys.platformType': 'Phân loại nhà cái',
  'sys.enterPlatformType': 'Hãy nhập kiểu nền tảng',
  'sys.selectPlatformType1': 'Hãy chọn trình nền thích hợp',
  'sys.selectApplicationConditions': 'Xin vui lòng điền vào điều kiện',
  'sys.computerSideAdvertisingImage': 'Ảnh quảng cáo máy tính',
  'sys.uploadComputerImage': 'Vui lòng tải ảnh máy tính lên',
  'sys.mobileImage': 'Ảnh quảng cáo di động',
  'sys.uploadMobileImage': 'Vui lòng tải ảnh di động',
  'sys.associatedActivity': 'Hoạt động liên quan',
  'sys.selectOfferWantLink': 'Hãy chọn đề nghị bạn muốn hợp tác',
  'sys.addFail': 'Thêm lỗi',
  'sys.addError': 'Thêm lỗi',
  'sys.newClassification': 'Phân loại mới',
  'sys.categoryName': 'Tên phân loại',
  'sys.fillCategoryName': 'Điền vào tên phân hạng',
  'sys.deleteOffer': 'Đề nghị bị xóa: {bonusName}',
  'sys.confirmCopy': 'Xác nhận sao chép',
  'sys.confirmCopy1': 'Anh có chắc là sao chép đề nghị này không?',
  'sys.promptMessage': 'Thông tin nhanh',
  'sys.disableDelete': 'Hãy tắt trước khi xóa bỏ.',
  'sys.confirmDelete': 'Cô có chắc là xóa đề nghị này không?',
  'sys.confirm1': 'Anh có chắc muốn hủy đề nghị này không?',
  'sys.effectiveTime': 'Thời gian hiệu quả',
  'sys.startTime': 'Bắt đầu thời gian đấu:',
  'sys.startTime1': 'Bắt đầu thời gian đấu',
  'sys.endTime': 'Thời gian kết thúc:',
  'sys.endTime1': 'Thời gian kết thúc',
  'sys.associationSettings': 'Thiết lập tương đối',
  'sys.cancelRecommend': 'Bỏ đề nghị',
  'sys.copy': 'Rõ',
  'sys.modifySort': 'Sửa đổi loại',
  'sys.editCopy': 'Sửa đổi văn bản',
  'sys.platform': 'Nhà cái',
  'sys.computer': 'Máy',
  'sys.mobile': 'Đi!',
  'sys.editCategory': 'Sửa hạng',
  'sys.name': 'Tên:',
  'pay.title.sort1': 'Loại:',
  'sys.recommendSignature': 'Nhãn hướng dẫn:',
  'sys.recommendedDisplayImageUpload': 'Truyền ảnh hiển thị',
  'sys.recommendedDisplayImage': 'Hình vẽ nên',
  'sys.uploadImage': 'Vui lòng tải ảnh lên',
  'sys.collectionMethod': 'Dạng thức nhận',
  'sys.seletCollectionMethod': 'Hãy chọn phương pháp tập hợp',
  'sys.automaticDistribution': 'Đang gởi tự động',
  'sys.manually': 'Tập hợp thủ',
  'sys.flowMultipleCalculationAmount': 'Số đếm số ngày',
  'sys.selectFlowMultipleCalculationAmount': 'Hãy chọn đa ngày để tính số lượng',
  'sys.returnAmount': 'Số lượng nước trở về',
  'sys.withdrawalRestrictions': 'Hạn chế rút lui',
  'sys.enterWithdrawalRestrictions': 'Nhập giới hạn rút lui',
  'sys.doubleWaterWithdrawDiscount': 'Gấp đôi dòng chảy có thể giảm giá',
  'sys.platformPointSettings': 'Khung cảnh và các điểm',
  'sys.chooseGamePlatform': 'Chọn trình nền trò chơi',
  'sys.returnPoint': 'Địa điểm quay về',
  'sys.lowest': 'tối thiểu',
  'sys.highest': 'Cao',
  'sys.yuan': 'nguyên tố',
  'sys.yuanVN': 'VND',
  'sys.yuanPHP': 'PHP',
  'sys.yuan1': 'nguyên tố',
  'sys.validBetReached': 'Đã đạt được kết quả hợp lệ',
  'sys.storageReach': 'Kho dự trữ với',
  'sys.howManyGetDraw': 'Bao nhiêu người có cơ hội rút',
  'sys.onThatDay': 'Vào ngày đó',
  'sys.twoDays': 'Hai ngày.',
  'sys.activityPeriod': 'Giai đoạn hoạt động',
  'sys.runningWaterAmount': 'Số lượng nước chảy',
  'sys.platformConditionSettings': 'Khung cảnh và điều kiện',
  'sys.selectGamePlatform': 'Chọn trình nền chơi theo kiểu',
  'sys.addedOffers': 'Thêm đề nghị',
  'sys.NoSpecialOffersYet': 'Chưa thêm đề nghị nào',
  'sys.selectGiftType': 'Hãy chọn kiểu quà tặng',
  'sys.betAmount': 'Số Cá (bao gồm)',
  'sys.betAmount1': 'Đặt tối đa (trừ.)',
  'sys.betAmount2': 'Hãy nhập số cá cược tối đa',
  'sys.betAmount3': 'Tiền đặt cược',
  'sys.enterMinimumAmount': 'Hãy nhập số lượng tối thiểu',
  'sys.cashGiftForm': 'Dạng tiền quà',
  'sys.selectCashGiftForm': 'Hãy chọn hình thức nhận tiền mặt',
  'sys.giveCashFixedAmount': 'Tiền mặt bằng khoản tiền cố định',
  'sys.giveCashFixedAmount1': 'Tiền mặt Tỷ lệ cố định',
  'sys.numberGifts': 'Tỉ lệ trình diễn',
  'sys.enterNumberGifts': 'Xin hãy nhập số tài liệu.',
  'sys.enterAmountCashGiven': 'Hãy nhập số tiền mặt đã đệ trình',
  'sys.enterAmountCashGiven1': 'Hãy nhập vào số tiền mặt miễn phí tối đa',
  'sys.enterProportionCashGiven': 'Nhập số tiền mặt miễn phí',
  'sys.enterProportionmaxBonusAmount':'Vui lòng nhập phần thưởng tối đa',
  'sys.noMoreThan': 'Đến (Nhân dân tệ)',
  'sys.noMoreThanVN': 'Đến (VND)',
  'sys.noMoreThan1': 'Không nhiều hơn (điểm)',
  'sys.basicInformationOffer': 'Thông tin cơ bản về đề nghị',
  'sys.relatedArticles': 'Đóng mở văn bản',
  'sys.selectOfferArticleWantLink': 'Hãy chọn bài báo bạn muốn cộng tác với',
  'sys.pc.sideOfferPicture': 'Ảnh giảm giá bên máy tính',
  'sys.uploadPc.sideOfferPicture': 'Vui lòng tải ảnh máy tính',
  'sys.mobile.sideOfferPicture': 'Ảnh phúc lợi di động',
  'sys.mobile.accountAuthentication': 'Xác thực tài khoản',
  'sys.mobile.phoneAuthentication': 'Số điện thoại',
  'sys.mobile.emailAuthentication': 'Hòm thư',
  'sys.bindingBankCard': 'Thẻ ngân hàng in',
  'sys.setPreferentialConditions': 'Tạo điều kiện ưu tiên',
  'sys.selectLogType_platform': 'Hãy chọn một trình nền trò chơi',
  'sys.noteType': 'Kiểu ghi chú',
  'sys.noteNumber': 'Số ghi chú',
  'sys.selectDuplicateRequestLimit': 'Hãy chọn một giới hạn yêu cầu lặp lại',
  'sys.duplicateRequestLimit': 'Giới hạn ứng dụng lặp lại',
  'sys.payoutAmount': 'Số lượng xổ số',
  'sys.profitAmount': 'Lợi nhuận',
  'sys.onlyOnce': 'Chỉ một lần',
  'sys.everyDay': 'Ngày',
  'sys.weekly': 'tuần',
  'sys.perMonth': 'tháng',
  'sys.perYear': 'mỗi năm',
  'sys.maximumNumberApplications': 'Số kì:',
  'sys.enterMaximumNumberOffers': 'Xin hãy nhập số lần cuối cùng cần xin giảm giá.',
  'sys.expirationTimeType': 'Kiểu thời gian hạn',
  'sys.enterExpirationTimeType': 'Hãy chọn kiểu thời gian hết hạn',
  'sys.day': 'ngày',
  'sys.noteExpirationTime': 'Thời gian hạn sử dụng',
  'sys.enterBillingExpirationTime': 'Hãy nhập vào thời gian hết hạn của tờ giấy.',
  'sys.withdrawalConditions': 'Yêu cầu rút tiền',
  'sys.selectWithdrawalCondition': 'Vui lòng chọn điều kiện rút lui',
  'sys.directWithdrawal': 'Bản rút trực tiếp',
  'sys.flowRequirement': 'Yêu cầu doanh thu',
  'sys.enterFlowRequirement': 'Nhập đa lần hiện thời của yêu cầu rút lui ưu tiên',
  'sys.setBetRequirements': 'Đặt ghi chú',
  'sys.addWinningConditions': 'Thêm điều kiện thắng',
  'sys.winningConditions': 'Điều kiện mùa thắng',
  'sys.enterWinningCondition': 'Điều kiện mùa thắng',
  'sys.offerMethod': 'Cách ưu tiên',
  'sys.noteBetAmountMultiple': 'Đa số cá cược',
  'sys.noteBetAmountMultiple1': 'Nhiều số lượng lẻ xổ số',
  'sys.noteBetAmountMultiple2': 'Ghi chú mức lợi nhuận chung',
  'sys.giftPoints': 'Điểm thưởng (điểm)',
  'sys.giftPoints1': 'Điểm thưởng cộng cộng',
  'sys.giftPoints2': 'Điểm giới thiệu',
  'sys.giftPoints3': '| Điểm thưởng: {giftPoint} điểm',
  'sys.giftPoints4': '| Điểm thưởng: {pointPercent}% (không quá {maxPoint} điểm)',
  'sys.enterGiftPoints2': 'Hãy nhập các điểm',
  'sys.enterNumberBonusPoints': 'Hãy nhập số điểm thưởng',
  'sys.preferentialAmountBenchmarkRate': 'Tỷ lệ tiêu chuẩn',
  'sys.enterPreferentialAmountBenchmarkRate': 'Nhập tỷ lệ tiêu chuẩn của giá trị ưu tiên',
  'sys.enterPreferentialAmountBenchmarkRate1': 'Hãy nhập số tiền giảm giá',
  'sys.maximumDiscountAmountLimit': 'Giới hạn tối đa',
  'sys.enterMaximumDiscountAmountLimit': 'Xin hãy nhập vào giới hạn tối đa ưu tiên',
  'sys.integralBenchmarkMagnification': 'Màu tổng phân',
  'sys.integralBenchmarkMagnification1': 'Màu tổng phân',
  'sys.maximumPointLimit': 'Giới hạn điểm tối đa',
  'sys.enterMaximumPointLimit': 'Nhập vào giới hạn điểm tối đa',
  'sys.memberInformationBindingOffer': 'Lời hứa có hạn',
  'sys.binding': 'Thông tin ràng buộc',
  'sys.binding1': 'Kiểu tổ hợp',
  'sys.binding2': 'Hãy chọn kiểu ràng buộc',
  'sys.phoneNumber': 'Số di động',
  'sys.pequiredDepositAmount': 'Yêu cầu bồi thường',
  'sys.pequiredDepositAmount1': 'Hãy nhập số tiền đặt cọc.',
  'sys.giftAmount': 'Số quyên góp',
  'sys.giftAmount1': 'Hãy nhập số lượng quà',
  'sys.maximumAmountAvailable': 'Số đếm ngược tối đa',
  'sys.maximumAmountAvailable1': 'Xin tăng mức tối đa',
  'sys.continuousDeposit': 'Thiết lập ưa thích cho đặt cọc liên tục (phát tự động từ 4:00-4:30 là ngày tiếp theo)',
  'sys.newContinuousDeposit': 'Thiết lập ưa thích cho đặt cọc liên tục',
  'sys.depositRequestAmount': 'Khoản đặt cọc',
  'sys.depositRequestAmount1': 'Yêu cầu tiền doanh thu',
  'sys.consecutiveDays':'Những ngày liên tiếp',
  'sys.cumulativeDays':'Thời gian tích lũy',
  'sys.selectType': 'Hãy chọn kiểu',
  'sys.continuous': 'liên tục',
  'sys.cumulative':'Tích lũy',
  'sys.enterNumberDays': 'Hãy nhập số ngày',
  'sys.enterCumulativeDays': 'Xin hãy ghi lại những ngày tích lũy',
  'sys.enterAmount': 'Hãy nhập số lượng',
  'sys.userEffectiveFlowRequirements': 'Nhu cầu luồng hiệu quả',
  'sys.enterFlowRequirement1': 'Yêu cầu nhập dòng chảy',
  'sys.continuousDepositBonusSetting': 'Thiết lập tiền thưởng liên tục',
  'sys.cumulativeDepositBettingBonusSettings': 'Tiền gửi tích lũy tùy chọn',
  'sys.di': 'Đầu tiên',
  'sys.song': 'nói',
  'sys.bei': 'Gấp',
  'sys.wu': 'Chưa đọc',
  'sys.you': 'Phải.',
  'sys.extraBonus': 'Có phần thưởng nào không?',
  'sys.extraDelivery': 'Giao thêm',
  'sys.addedOffer': 'Tùy chọn',
  'sys.msg1': 'Không cần đăng ký đơn phát hành tự động ở 04:00 là ngày hôm sau',
  'sys.applicationConditions': 'Điều kiện ứng dụng',
  'sys.selectCategory1': 'Vui lòng chọn hạng',
  'sys.category1': 'Chủ đề:',
  'sys.selectDepositChannel': 'Hãy chọn kênh ký gửi',
  'sys.depositChannel': 'Gửi kênh',
  'sys.msg2': 'Số ký gửi tối đa phải lớn hơn mức ký gửi tối thiểu',
  'sys.msg3': 'Ký ức',
  'sys.msg4': 'Hãy nhập vào mức ký gửi tối thiểu.',
  'sys.msg5': 'Gửi tối đa',
  'sys.msg6': 'Hãy nhập vào mức ký gửi tối đa.',
  'sys.msg7': 'Tiền mặt đệ trình trong phạm vi bảo hiểm',
  'sys.pre-purchaseOffer': 'Giá trị rút tiền trước',
  'sys.pre-purchaseOffer1': 'Giảm giá trước',
  'sys.postOffer': 'Đặt yêu cầu đăng ký',
  'sys.postOffer1': 'Đăng ký',
  'sys.minusDiscount': 'Giảm bớt ưu đãi',
  'sys.accountType': 'Kiểu tài khoản',
  'sys.accountType1': 'Hãy chọn kiểu tài khoản',
  'sys.masterAccount': 'Tài khoản chính',
  'sys.gameAccount': 'Tài khoản chơi',
  'sys.gameAccountType': 'Kiểu tài khoản trò chơi',
  'sys.majorClass': 'Lớp lớn',
  'sys.account': 'Tài khoản người chơi',
  'sys.enterAccount1': 'Hãy chọn một tài khoản gửi.',
  'sys.depositOrder': 'Mật khẩu gởi',
  'sys.enterDepositOrder': 'Hãy chọn lệnh ký gửi',
  'sys.nthDeposit': 'Nth ký gửi',
  'sys.nthDeposit1': 'Không đầu tiền gởi',
  'sys.nthDeposit2': 'Mọi khoản gởi',
  'sys.nthDeposit3': 'Điền vào giá trị của n',
  'sys.nthDeposits': 'Nth ký gửi',
  'sys.greaterNthDeposit': 'Lớn hơn khoản tiền gửi thứ n',
  'sys.enterNumberDepositLimits': 'Hãy nhập số hạn chế ký gửi.',
  'sys.flowType': 'Kiểu chảy',
  'sys.selectypeFlow': 'Kiểu chảy',
  'sys.msg8': 'Đặt ống dẫn nhiều toàn cục',
  'sys.msg9': 'Đặt dòng chảy nhiều cho một nội dung ưu tiên',
  'sys.msg10': 'Giá trị đã được thêm (thay đổi kiểu dòng sẽ hủy bỏ mọi đề nghị. Nếu nó đã được sửa đổi, nó cần được sửa lại.Name',
  'sys.receivingValidityPeriod': 'Thời gian trả lời',
  'sys.enterExpirationDate': 'Nhập ngày tháng giá trị',
  'sys.pointGiftForm': 'Mẫu Bonus',
  'sys.selectPointGiftForm': 'Hãy chọn hình thức thưởng',
  'sys.givePointsFixedAmount': 'Điểm thưởng trong số lượng cố định',
  'sys.givePointsFixedAmount1': 'Điểm thưởng ở mức cố định',
  'sys.enterProportionBonusPoints': 'Xin hãy nhập tỷ lệ các điểm thưởng',
  'sys.enterMaximumCreditLimit': 'Xin hãy nhập tỷ lệ các điểm thưởng',
  'sys.msg11': 'Thời gian thực: đặt cọc cùng với thanh toán',
  'sys.uploadH5Image': 'Vui lòng tải ảnh H5',
  'sys.msg12': 'Kích cỡ cuối di động: 718* 158px',
  'sys.check-inPointSetting': 'Ký vào thiết lập điểm',
  'sys.check-inDaysSetting': 'Kiểm tra trong ngày đặt',
  'sys.check-in': 'Ký vô.',
  'sys.check-in1': 'Nhập',
  'sys.msg13': 'Thiết lập thưởng thêm ngày cố định',
  'sys.doubleWater': 'Có thể nâng nước đôi',
  'sys.pointRedemptionSettings': 'Thiết lập trao đổi điểm',
  'sys.exchange': 'trao',
  'sys.msg14': 'Chuẩn bị người yêu cầu',
  'sys.msg15': 'Chỉ trong vài ngày',
  'sys.rewarderSelection': 'Chọn phần thưởng',
  'sys.invitees': 'Người được mời',
  'sys.invitees1': 'Mời',
  'sys.inviterReward': 'Phần thưởng',
  'sys.inviterReward1': 'Vui lòng tham dự phần thưởng.',
  'sys.inviterReward2': 'Phần thưởng',
  'sys.inviterReward3': 'Hãy nhập vào phần thưởng của người mời.',
  'sys.unlimited': 'Có vô hạn không?',
  'sys.discountPoints': 'Điểm ưu tiên',
  'sys.preferential': 'Ưu tiên',
  'sys.doubleWater1': 'Dòng chảy đôi',
  'sys.maxWithdrawal': 'Giảm tối đa',
  'sys.enterMaxWithdrawalAmount': 'Nhập vào mức rút tiền tối đa.',
  'sys.msg16': 'Khung cảnh và điều kiện (giao hàng chính quy: 04:00 mỗi ngày)',
  'sys.msg17': 'Số chi trả tối đa phải lớn hơn số tiền chi trả tối thiểu',
  'sys.msg18': 'Số lần trả tiền còn lớn hơn số hiệu quả (bao gồm)',
  'sys.msg19': 'Hãy nhập vào chi phí tối thiểu lớn hơn số hiệu quả đa',
  'sys.msg20': 'Phần thưởng cao nhất còn lớn hơn số hiệu quả đa (ngoài)',
  'sys.msg21': 'Hãy nhập vào chi trả tối đa lớn hơn số hiệu quả đa',
  'sys.msg22': 'Nhiều cuộc cá cược miễn phí',
  'sys.msg23': 'Hãy nhập vào thời điểm cá cược miễn phí',
  'sys.msg24': 'Thời gian trả giá nước giảm giá (nếu đặt hai lần quay lại nước, hệ thống sẽ ban giảm giá dựa trên thời gian tạo trước)',
  'sys.msg25': 'Giới hạn rút lui, thời gian rút lui hiện thời',
  'sys.msg300':'Xe bán tải hàng ngày',
  'sys.enterDailyPickupCount':'Vui lòng nhập số lượng xe bán tải hàng ngày',
  'sys.selectLeastOne': 'Hãy chọn ít nhất một',
  'sys.addUpgradeConditions': 'Thêm điều kiện nâng cấp',
  'sys.msg26': 'Đặt cược yêu cầu',
  'sys.msg27': 'Hãy nhập số lượng cần thiết',
  'sys.msg28': 'Châu Hầu Vũ',
  'sys.msg29': 'Xin hãy nhập lương và quà.',
  'sys.msg30': 'Trả lương tháng',
  'sys.msg31': 'Xin nhập lương hàng tháng và quà tặng.',
  'sys.msg32': 'Các điều kiện nâng cấp (Hồ Phụng thiên sẽ được phân phối vào thứ tư và mỗi tháng Phụng thiên về thứ ba mỗi tháng)',
  'sys.msg33': 'Chưa thêm điều kiện nâng cấp nào',
  'sys.upgradeGift': 'Nâng cấp năng lượng',
  'sys.enterUpgradeGift': 'Hãy nhập vào quà nâng cấp',
  'sys.platformLevelSettings': 'Thiết lập platform',
  'sys.msg34': 'Tiền mặt miễn phí: {giftMoney}',
  'sys.msg34VN': 'Tiền mặt miễn phí: {giftMoney} VND',
  'sys.msg35': 'Tiền mặt miễn phí: {giftMoney}% (tối đa {maxMoney})',
  'sys.msg35VN': 'Tiền mặt miễn phí: {giftMoney}% (tối đa {maxMoney} VND)',
  'sys.msg36': '| Yêu cầu về lưu lượng: {betMultipl} lần',
  'sys.msg37': 'Cược tích lũy: {minBetAmount} ~ {maxBetAmount}',
  'sys.msg38': '| Quà tặng: {giftCount} lần',
  'sys.selectLeastOneGamePlatform': 'Hãy chọn ít nhất một sân chơi!',
  'sys.setLeastOneObtainingMethod': 'Hãy thiết lập ít nhất một phương tiện truy cập',
  'sys.editLeastOneOffer': 'Làm ơn sửa đổi ít nhất một đề nghị',
  'sys.vip1': 'Vip {vipLevel} Tỷ lệ nước trở lại phải lớn hơn hoặc bằng 0!',
  'sys.vip2': 'Vip {vipLevel} Số tiền tối đa phải là khoảng số tiền tối thiểu!',
  'sys.vip3': 'Vui lòng điền vào Vip {vipLevel}',
  'sys.vip4': 'Vui lòng điền số tiền hoàn tiền tối thiểu Vip {vipLevel}',
  'sys.vip5': 'Xin hãy đổ đầy lượng nước quay tối đa cho VlP',
  'sys.vip6': 'Vui lòng điền vào số tiền hoàn lại tối đa của Vip {vipLevel}',
  'sys.addBetConditionBeforeSubmitting': 'Vui lòng ghi chú trước khi gởi',
  'sys.noteTailNumber': 'Lưu ý số cuối: {conditionValue1}',
  'sys.noteTailNumber1': 'Số tiền đặt cược: {conditionValue1}',
  'sys.noteTailNumber2': 'Số tiền thanh toán cho phiếu cược: {conditionValue1}',
  'sys.noteTailNumber3': 'Lợi nhuận đặt cược: {conditionValue1}',
  'sys.msg39': 'Phương pháp cố định: số tiền chiết khấu: {giftMoney} nhân dân tệ, số điểm: {giftPoint}',
  'sys.msg39VN': 'Phương pháp cố định: số tiền chiết khấu: {giftMoney} VND, số điểm: {giftPoint}',
  'sys.msg40': 'Phương thức số tiền đặt cược: số nhân số tiền: {moneyPercent}, tối đa: {maxMoney} nhân dân tệ |',
  'sys.msg40VN': 'Phương thức số tiền đặt cược: số nhân số tiền: {moneyPercent}, tối đa: {maxMoney} VND |',
  'sys.msg41': 'Phương thức số tiền đặt cược: Số nhân điểm: {pointPercent}, mức cao nhất không vượt quá: {maxPoint}',
  'sys.msg42': 'Phương thức số tiền xuất chi: Số nhân số tiền: {moneyPercent}, tối đa: {maxMoney} nhân dân tệ |',
  'sys.msg42VN': 'Phương thức số tiền xuất chi: Số nhân số tiền: {moneyPercent}, tối đa: {maxMoney} VND |',
  'sys.msg43': 'Phương thức số tiền xuất chi: Số nhân điểm: {pointPercent}, tối đa không vượt quá: {maxPoint}',
  'sys.msg44': 'Phương pháp số tiền lãi: Số nhân số tiền: {moneyPercent}, tối đa: {maxMoney} nhân dân tệ |',
  'sys.msg44VN': 'Phương pháp số tiền lãi: Số nhân số tiền: {moneyPercent}, tối đa: {maxMoney} VND |',
  'sys.msg45': 'Phương thức số tiền lãi: Số nhân điểm: {pointPercent}, tối đa: {maxPoint}',
  'sys.msg46': 'Viên Liệt đạt được',
  'sys.msg46VN': 'VND đạt được',
  'sys.msg47': '{money} nhân dân tệ, {betflowMulti}',
  'sys.msg47VN': '{money} VND, {betflowMulti}',
  'sys.msg48': '{point} điểm',
  'sys.msg49': 'Xác suất chiến thắng {probability}%, {totalNumber} tổng, {dailyTotalNumber} mỗi ngày',
  'sys.msg50': 'Xin hãy thêm tiền trước khi nộp đơn!',
  'sys.msg51': '{giftMoney} nhân dân tệ tiền mặt vào tài khoản chính, {betMultipl} lần lưu lượng có thể được tăng lên.',
  'sys.msg52': 'Tài khoản chính được thêm các điểm giftpoint.',
  'sys.msg53': '{prizeName} Phần thưởng vật lý tùy chỉnh.',
  'sys.msg54': 'Tiếp tục đi.',
  'sys.msg55': 'Vật thể tự chọn',
  'sys.msg56': 'Cố gắng hết sức',
  'sys.msg57': 'Hãy thưởng thức liên tục trước khi nộp đơn!',
  'sys.msg58': 'Những ngày liên tục phải lớn hơn 0!',
  'sys.msg59': '"...tuột giá;',
  'sys.msg60': 'Tiền khuyến mãi',
  'sys.msg61': 'Tiền khuyến mãi',
  'sys.msg62': '| {betMultipl} Lần',
  'sys.app': 'Comment',
  'sys.mobileVersion': 'Phiên bản di động',
  'sys.webVersion': 'Phiên bản MạngName',
  'sys.continuousCheck-inForFixedRewards': 'Dấu liên tục trong phần thưởng cố định',
  'sys.singleSign-inRaffleReward': 'Chỉ một dấu trong xổ số',
  'sys.loginSide': 'Công cụ đăng nhập',
  'sys.selectLoginSide': 'Hãy chọn đăng nhập',
  'sys.prizeSetting': 'Đặt giải thưởng',
  'sys.selectPrizeSetting': 'Hãy chọn thiết lập giải thưởng',
  'sys.continuousCheck-in': 'Biểu tượng liên tục vào',
  'sys.continuousCheck-in1': 'Xin hãy nhập số các ngày liên tiếp tham dự.',
  'sys.amountObtained': 'Phát lương',
  'sys.earnPoints': 'Lấy ảnh',
  'sys.enterEarnPoints': 'Hãy nhập vào các điểm bạn có thể lấy',
  'sys.addedSweepstakesBonus': 'Thêm xổ số',
  'sys.no1': 'Không giới hạn.',
  'sys.addReward': 'Thêm phần thưởng',
  'sys.rewardAmount': 'Phần thưởng',
  'sys.enterRewardAmount': 'Hãy nhập số tiền thưởng.',
  'sys.cashFlowRequirement': 'Yêu cầu rút lui dòng chảy',
  'sys.enterCashFlowRequirement': 'Nhập yêu cầu dòng chảy rút lui',
  'sys.rewardPoints': 'Điểm thưởng',
  'sys.enterRewardPoints': 'Hãy nhập các điểm thưởng',
  'sys.physicalName': 'Tên vật lý',
  'sys.enterPhysicalName': 'Hãy nhập tên vật lý',
  'sys.clickSelectImage': 'Nhấn vào để chọn ảnh',
  'sys.enterProbabilityWinning': 'Hãy nhập vào xác suất đã thắng',
  'sys.totalNumberCopies': 'Tổng số tiền',
  'sys.enterTotalNumberCopies': 'Hãy nhập số bản sao tổng hợp',
  'sys.distributeMostDaily': 'Bán hàng ngày tối đa',
  'sys.enterDistributeMostDaily': 'Hãy nhập số lần phát tối đa mỗi ngày',
  'sys.lotteryConditions': 'Điều kiện vẽ may mắn',
  'sys.daysDeposit': 'Ngày kí gửi',
  'sys.enterDaysDeposit': 'Hãy nhập ngày tiếp tục gởi',
  'sys.dailyDepositAmount': 'Số tiền đặt cọc',
  'sys.addLotteryPrizes': 'Thêm vòng quay',
  'sys.ruleSetting': 'Điều chỉnh:',
  'sys.balance': 'dư',
  'sys.msg63': 'Số tiền ký gửi: {minDeposit} ~ {maxDeposit}',
  'sys.msg64': 'Tiền mặt miễn phí: {giftPercent}%,Số lượng tối đa: {maxBonusAmount}',
  'sys.msg65': '| Luồng nhiều: {betMultipl}',
  'sys.msg66': 'Số tiền ký gửi: {minDeposit} ~ {maxDeposit} | Yêu cầu lưu lượng: {betMultipl} lần trở lên',
  'sys.msg67': 'Tiền mặt miễn phí: {giftPercent}%,Số lượng tối đa: {maxBonusAmount} | Lưu lượng nhiều: {betMultipl}',
  'sys.discountInformation': 'Thông tin ưu tiên',
  'sys.displayInformation': 'Hiển thị thông tin',
  'sys.previous': 'Bước lùi',
  'sys.offerEditedSuccessfully': 'Đề nghị xong.',
  'sys.returnListPage': 'Quay về trang danh sách',
  'sys.msg68': 'Bội số đặt cược quà tặng: {giftMultipl}',
  'sys.msg69': '| Yêu cầu về lưu lượng: {betMultipl} lần | Số lượng quà tặng tối đa không thể vượt quá: {maxGiftMoney}',
  'sys.msg70': 'Khoản thanh toán lớn hơn bội số đặt cược hợp lệ: {minMult Môn} ~ {maxMult Môn}',
  'sys.msg71': 'Hãy chọn ít nhất một đề nghị!',
  'sys.msg72': 'Cấp độ: {cấp}, số tiền tích lũy hiệu quả của {betflow}',
  'sys.msg73': 'Thưởng thức: {upAmount} Quà tặng nâng cấp Yuan, {weekAmount} Quà tặng Yuan Zhou Lulu, {thángAmount} Quà tặng Yuan Yue Lulu. Tất cả quà tặng {betMultipl}',
  'sys.importTime': 'Nhập thời gian',
  'sys.importCount': 'Số mục nhập',
  'sys.importSuccessCount': 'Số lần nhập khẩu thành công',
  'sys.importFailCount': 'Số lần thất bại',
  'sys.seeDetails': 'Xem chi tiết',
  'sys.batchImport': 'Nhập đồng loạt',
  'sys.formatDescription': 'Mặc định',
  'sys.formatDescription1': '1. Số đứng',
  'sys.formatDescription2': '2. Tên tài khoản',
  'sys.formatDescription3': 'Năng lượng:',
  'sys.formatDescription4': '4. Yêu cầu tiền doanh thu',
  'sys.busyServer': 'Máy chủ đang bận. Vui lòng thử lại sau.',
  'sys.batchImportSucceeded': 'Liên Đoàn thành công',
  'sys.importSucceeded': 'Nhập thành công',
  'sys.importFail': 'Nhập thất bại',
  'sys.msg74': 'Tổng nhập khẩu (nhập cảnh quốc gia) thành công (nhập nhập nhập nhập nhập nhập nhập cảnh sản), thiếu nhập nhập số.',
  'sys.msg75': 'Tổng số lần nhập {importCount}, thành công {importSuccessCount}, fail {importFailCount}.',
  'sys.uploadError': 'Tải lỗi lên. Hãy thử lại sau.',
  'sys.batchImportOffers': 'Bưu kiện hàng loạt',
  'sys.batchImportOffersDetails': 'Thông tin về khoản nhập loạt',
  'sys.determine': 'Chọn',
  'sys.import': 'Nhập',
  'sys.whetherSucceed': 'Thành công',
  'sys.importStatus': 'Trạng thái Nhập',
  'sys.content1': 'nội dung',
  'sys.enterContent1': 'Hãy nhập nội dung',
  'sys.error.loadRoles': 'Không thể tải dữ liệu vai trò',
  'agent.title.confirmOffer2': 'Xin hãy xác nhận việc phát hành?',
  'sys.confirmRejectionThisOffer': 'Anh có chắc là anh muốn từ chối đề nghị này không?',
  'sys.confirmCancelThisOffer': 'Anh có chắc muốn hủy đề nghị này không?',
  'sys.winningNumber': 'Số lá thư',
  'sys.preferentialVariety': 'Tên người chơi',
  'sys.allVarieties': 'Tất cả các hình thức',
  'sys.preferentialPrincipal': 'Vốn ưu đãi',
  'sys.targetFlow': 'Mục tiêu doanh thu',
  'sys.effectiveFlow': 'Doanh thu đã đạt được',
  'sys.flowCalculationState': 'Trạng thái tính toán doanh thu:',
  'sys.completionCalculation': 'Đếm xong',
  'sys.hasFailed': 'Đã thất bại',
  'sys.offerCurrentStatus': 'Tình trạng hiện thời của ưu đại:',
  'sys.offerCurrentStatus1': 'Trạng thái ưu đãi hiện thời',
  'sys.offerArrivalTime': 'Thời gian ưu đãi',
  'sys.runningWaterCalculationCompletionTime': 'Thời gian tính toán hoàn thành',
  'sys.userWinsLoses': 'Tài khoản thắng thua',
  'sys.platformProfitLoss': 'Nhà cái thắng lời,lỗ',
  'sys.examinationPassed': 'Giấy tờ kiểm toán',
  'sys.setEffectiveFlow': 'Đặt luồng hiệu quả',
  'sys.winningNumber1': 'Số mùa',
  'sys.totalDiscount': 'Tổng tiền ưu đãi',
  'sys.totalDiscount1': 'Tổng số đơn ưu đãi',
  'sys.totalDiscount2': 'Tổng số đơn tiền trợ giúp',
  'sys.totalDiscount3': 'Phần thưởng lên cấp có tổng số đơn',
  'sys.totalDiscount4': 'Tổng số phần thưởng liên tiếp',
  'sys.totalDiscount5': 'Tổng số đơn ưu đãi được thêm vào',
  'sys.totalDiscount6': 'Doanh thu ưu đãi có tổng số đơn',
  'sys.totalDiscount7': 'Tiền nạp ưu đãi có tổng số đơn',
  'sys.totalDiscount8': 'Tổng số lời mời ưu đãi',
  'sys.totalDiscount9': 'Tổng số đơn ưu đãi khác',
  'sys.xls': 'Trình báo cáo lưu trữ',
  'sys.keyword': 'Từ khóa',
  'sys.releaseStartTime': 'Thời gian bắt đầu công bố',
  'sys.chooseStartTime': 'Chọn thời gian bắt đầu',
  'sys.chooseEndTime': 'Chọn thời gian kết thúc',
  'sys.releaseEndTime': 'Thời gian công bố kết thúc',
  'sys.enterValidWater': 'Hãy nhập dòng chảy hợp lệ',
  'sys.recommendedOfferTips': 'Gợi ý về đề nghị',
  'sys.setRecommendedBonusInformation': 'Đặt thông tin thưởng',
  'sys.offerTitle': 'Mục tiêu đề',
  'sys.offerTitleName': 'Đặt kiểu',
  'sys.offerTitle1': 'Kính đề',
  'sys.enterOfferTitle1': 'Xin hãy nhập phụ đề',
  'sys.msg76': 'Kích cỡ kết nối của máy tính: 1000* 150px',
  'sys.msg77': 'Hình thư giới thiệu thiết bị di động',
  'sys.msg78': 'Kích cỡ của kết nối di động: 360* 180pk',
  'sys.msg79': 'Trước khi đóng đề nghị này, bạn nên bỏ bài viết này đi.',
  'sys.msg80': 'Anh có chắc là hủy đề nghị trang chủ không?',
  'sys.offerType': 'Loại hình ưu đãi',
  'sys.scopeApplication': 'Phạm vi áp dụng',
  'sys.editor': 'Đang cài đặt',
  'sys.editTime': 'Thời gian cập nhật',
  'sys.self-serviceArea': 'Tự động',
  'sys.image': 'ảnh',
  'sys.whetherDisplayListBySort': 'Hiện thị danh sách',
  'sys.selectOfferType': 'Chọn kiểu cung cấp',
  'sys.msg81': 'Ông có rõ về thông tin ưu tiên liên quan không?',
  'sys.msg82': 'Xin kiểm tra cẩn thận để xác nhận?',
  'sys.offerList': 'Danh sách giảm giá',
  'sys.unlink': 'Hủy kết nối',
  'sys.firstDepositOffer': 'Đặt tiền đầu tiên',
  'sys.OtherOffers': 'Tùy chọn',
  'sys.clientType': 'Kiểu khách',
  'sys.offerMap': 'Bản đồ ưa thích',
  'sys.sharingPhoto': 'Ảnh chuẩn',
  'sys.amount': 'Đại lý thanh toán đang xử lý',
  'sys.profitLoss': 'Giá trị ưu đãi',
  'sys.numberRecipients': 'Số người nhận',
  'sys.numberIssues': 'Số lần phát hành',
  'sys.offerStatus': 'Trạng thái ưu đãi',
  'sys.msg83': 'Thông báo sắp xóa tiêu đề {name}',
  'sys.msg84': 'Bạn có chắc chắn muốn tắt thông báo này?',
  'sys.msg85': 'Ông có chắc muốn công bố việc này không?',
  'sys.msg86': 'Giới thiệu để xóa bài viết với tiêu đề {title}',
  'sys.msg87': 'Giới thiệu để xóa loại bài viết với tiêu đề {name}',
  'sys.msg88': 'Biểu tượng điều hướng trò chơi có tên {pcName} sắp bị xóa',
  'sys.confirmationOperation': 'Xác nhận hoạt động',
  'sys.pushTitle': 'Giới thiệu tiêu đề',
  'sys.usableNot': 'Có thể sử dụng không',
  'sys.usable': 'Có thể sử dụng không',
  'sys.usable1': 'Không có',
  'sys.modifyAnnouncementMessage': 'Sửa thông báo',
  'sys.addAnnouncement': 'Thông báo thêm',
  'sys.addAnnouncementMessage': 'Thêm thông điệp',
  'sys.announcementTitle': 'Mục tiêu đề',
  'sys.loseAnnouncementTitle': 'Hãy nhập vào tựa tuyên bố',
  'sys.enterTitleAnnouncement': 'Hãy nhập vào tựa tuyên bố',
  'sys.announcementType': 'Kiểu Thông báo',
  'sys.selectAnnouncementType': 'Hãy chọn kiểu thông báo',
  'sys.announcementContent': 'Thông báo nội dung',
  'sys.enterAnnouncementContent': 'Hãy nhập nội dung thông báo',
  'sys.startEndTime': 'Bắt đầu và dừng thời gian',
  'sys.selectStartEndTime': 'Hãy chọn « Chạy và kết thúc »',
  'sys.articleTitle': 'Mục tiêu đề:',
  'sys.enterArticleTitle': 'Hãy nhập vào tựa đề của bài báo',
  'sys.articleType': 'Loại tiêu đề',
  'sys.enterArticleType': 'Hãy nhập kiểu bài báo',
  'sys.pcPlatform': 'Nhà cái trên máy tính',
  'sys.h5Platform': 'H5 platform',
  'sys.modifyArticles': 'Xem lại bài',
  'sys.addArticle': 'Thêm bài báo',
  'sys.articleContent': 'Nội dung',
  'sys.enterArticleContent': 'Xin hãy điền vào bài báo.',
  'sys.addArticleType': 'Thêm kiểu bài',
  'sys.enterArticleTypeTitle': 'Hãy nhập tên kiểu bài báo',
  'sys.smallIcon': 'Biểu tượng nhỏ',
  'sys.bigIcon': 'Biểu tượng lớn',
  'sys.addGameNavigation': 'Thêm hạng mục trò chơi',
  'sys.addGameName': 'Tên định vị Trò chơi',
  'sys.msg89': 'Biểu tượng kích cỡ máy tính phải được truyền cho một',
  'sys.msg90': 'Biểu tượng kích cỡ di động phải truyền sang một',
  'sys.msg91': 'PC/ upload game logo',
  'sys.msg92': 'PC/ upload game logo',
  'sys.msg93': 'Một logo máy điện thoại',
  'sys.msg94': 'Một logo máy điện thoại',
  'sys.msg95': 'Mục cấu hình {name} sắp bị xóa!',
  'sys.msg96': 'URI: nếu thực hiện đường dẫn ảnh, khi nhấn vào ảnh, nó sẽ được chuyển sang trang Đường dẫn nhắp. Nếu trường này không có giá trị, không có thao tác nào được thực hiện để nhắp vào ảnh.',
  'sys.msg97': 'Ghi chú: định dạng của sự kiện đường dẫn ảnh URI; v. d. www.baidu',
  'sys.msg98': 'Chức năng này được dùng cho thương gia để tải ảnh lên để thêm/ thay thế ảnh trước',
  'sys.msg99': 'Thêm dãy: dãy ảnh có thể tự sắp xếp được',
  'sys.msg100': 'Hình ảnh có tên: {imgName} sắp bị xóa',
  'sys.msg101': 'Giá trị sẵn sàng',
  'sys.gameNavigationName': 'Tên định vị Trò chơi',
  'sys.enterGameNavigationName': 'Hãy nhập tên định hướng trò chơi',
  'sys.page': 'trang',
  'sys.fillRoleInformation': 'Điền thông tin về vai trò',
  'sys.enterName': 'Hãy nhập tên',
  'sys.enterType': 'Hãy nhập kiểu',
  'sys.enterStatus': 'Nhập trạng thái',
  'sys.contentConfiguration': 'Cấu hình nội dung',
  'sys.contentConfiguration1': 'Cấu hình trang',
  'sys.keywordSearch': 'Tìm từ khóa',
  'sys.imageName': 'Tên ảnh',
  'sys.enterImageName': 'Hãy nhập tên ảnh',
  'sys.imageName1': 'Tên bức ảnh',
  'sys.imageGroup': 'Nhóm ảnh',
  'sys.addPictures': 'Thêm ảnh',
  'sys.imageDescription': 'Nạp tiền cấp dưới',
  'sys.msg102': 'Liên kết khi nhắp vào ảnh',
  'sys.msg103': 'Số ảnh tối đa có thể tải lên: nó là để hạn chế số ảnh tối đa có thể sở hữu dưới nhóm mã này',
  'sys.msg104': 'Mô tả: tổng quát về vai trò của chụp ảnh/ nhóm ảnh',
  'sys.msg105': 'Nhóm hình ảnh có tên: (imgName) sắp bị vô hiệu hóa',
  'sys.msg106': 'Nhóm hình ảnh có tên: (imgName) sắp được bật',
  'sys.numberUploadedImages': 'Số ảnh tải lên',
  'sys.sendPushMessage': 'Gửi đi tin tức giới thiệu',
  'sys.pushPlatform': 'Giới thiệu nhà cái',
  'sys.pushPlatform1': 'Hãy chọn một nền đẩy',
  'sys.android': 'Android',
  'sys.ios': 'IOS(iphone)',
  'sys.title': 'Tiêu đề',
  'sys.fillPushTitle': 'Xin hãy điền vào tựa đẩy.',
  'sys.fillPushContent': 'Xin hãy điền vào nội dung đẩy.',
  'sys.pushContent': 'Nội dung giới thiệu',
  'sys.msg107': 'Người giới thiệu/thời gian giới thiệu',
  'sys.msg108': 'Chọn có nên đặt ghi chép theo sách hay không',
  'sys.msg109': 'Chọn có nên đặt ngày tháng chưa đọc',
  'sys.pushDate': 'Ngày giới thiệu',
  'sys.messageType': 'Tiêu đề thư',
  'sys.theme': 'Chủ đề',
  'sys.enterTheme': 'Hãy nhập vào vật thể',
  'sys.time1': 'Thời gian',
  'sys.haveRead': 'Đã đọc',
  'sys.unread': 'Chưa đọc',
  'sys.reply': 'Comment',
  'sys.hasBeenBack': 'Đã trở về',
  'sys.userNotSelected': 'Chưa chọn người dùng',
  'sys.markRead': 'Đánh dấu như đọc',
  'sys.markRead1': 'Đánh dấu chưa đọc',
  'sys.msg110': 'Xoá ghi chép đã chọn',
  'sys.recipient': 'Người gửi thư',
  'sys.selectRecipient': 'Hãy chọn người nhận',
  'sys.sender': 'Người gửi thư',
  'sys.systemSend': 'Hệ thống gửi',
  'sys.operationalTransmission': 'Hoạt động gửi đi:',
  'sys.operator': 'Người tạo',
  'sys.sender1': 'Người gửi thư',
  'sys.send': 'Gửi đi.',
  'sys.sendHand': 'Gửi thủ công',
  'sys.sendSiteMsg': 'Thêm mới trung tâm gửi thư',
  'sys.agentMustSelected': 'Đặc vụ phải được chọn',
  'sys.memberMustFilledOut': 'Yêu cầu:',
  'sys.mustFillVipLevel': 'Phải điền vào cấp VIP',
  'sys.mustFillTimePeriod': 'Phải điền vào thời gian',
  'sys.parameterNotComplete': 'Tham số chưa được điền hoàn toàn',
  'sys.msg111': 'Nhắc nhở ấm: nếu tài khoản thành viên bị ràng buộc với email, bạn có thể nhận email đã điền vào',
  'sys.msg112': 'Hãy nhập vào các thành viên riêng bởi:',
  'common.agent1': 'Đặc:',
  'sys.selectAgent': 'Hãy chọn đặc vụ',
  'sys.allMembers': 'Mọi thành viên',
  'sys.actingMembers': 'Thành viên tạm',
  'sys.contentEmail': 'Nội dung thư',
  'sys.fillLetter': 'Xin hãy điền vào tờ đơn.',
  'sys.stationLetterContent': 'Ghi chú thư nhà ga',
  'sys.operation.upgrade': 'Hình thức nâng cấp',
  'sys.msg113': 'Các điều kiện nâng cấp (Hồ Phụng Thanh sẽ được phân phối vào ngày thứ tư và tháng III)',
  'sys.timeArrival': 'Ngày thanh toán',
  'sys.totalNumberArticles': 'Tổng số tiền',
  'sys.add': 'Tạo mới',
  'sys.smg114': 'Xác nhận đi.',
  'sys.smg115': 'Thiết lập mới',
  'sys.smg116': 'Thiết lập đặc quyền',
  'sys.smg117': 'Đặc quyền được xóa: {title}',
  'sys.smg118': 'cấp độ {vipLevel}',
  'sys.smg119': 'Nhập vào đặc quyền Tiêu đề chính ít hơn 20',
  'sys.smg120': 'Hãy nhập tên của bộ phim quảng cáo',
  'sys.smg121': 'Hãy nhập vào một vùng đặc quyền dưới tám từ',
  'sys.smg122': 'Hãy xác nhận thông tin được điền là đúng và logic tương ứng là chính xác.',
  'sys.confirmModificationStatus': 'Xác nhận sửa đổi',
  'sys.vip7': 'Đặc quyền VIP',
  'sys.vip8': 'Tên phong phú',
  'sys.vip9': 'Phụ đề\'Máy móc\'.',
  'sys.vip10': 'Thêm quyền',
  'sys.ipAll': 'Mọi IP',
  'sys.ipAddr': 'Địa chỉ IP hiện tại',
  'sys.ipRemark': 'Địa chỉ:',
  'sys.abnormalOperation': 'Ca mổ bất thường, hãy thử lại sau.',
  'sys.vip11': 'Thêm thông tin đặc quyền',
  'sys.vip12': 'Hãy nhập vào danh hiệu chính của đặc quyền.',
  'sys.vip13': 'Xin hãy nhập đặc quyền phụ đề',
  'sys.vip14': 'Thiết lập cấp VIP',
  'sys.vip15': 'Tên Rắn',
  'sys.vip16': 'Hãy nhập tên VIP.',
  'sys.vip17': 'Cấp độ VIP',
  'sys.vip18': 'Đặc quyền xem',
  'sys.oldPromotionPicture': 'Ảnh giới thiệu cũ',
  'sys.uploadFile': 'Vui lòng tải lên tập tin',
  'sys.privilegeOrder': 'Đặc quyền',
  'sys.enterPrivilegeOrder': 'Hãy nhập vào thứ tự quyền hạn.',
  'sys.confirmSubmissionChanges': 'Xác nhận sửa đổi',
  'sys.memberExpirationDate': 'Tiền khuyến mãi',
  'sys.memberExpirationDate1': 'Hãy chọn thời gian hợp lệ',
  'sys.promotionRequirements': 'Nhu cầu:',
  'sys.requiredPoints': 'Cần thiết',
  'sys.requiredDeposit': 'Phải chuyển khoản',
  'sys.requiredFlow': 'Dòng chảy yêu cầu',
  'sys.requiredPoints2': 'Miễn phí điểm',
  'sys.requiredDeposit2': 'Tiền gửi bảo đảm',
  'sys.requiredFlow2': 'Cấp nước',
  'sys.relegationPeriod': 'Hiệu lực bảo mật',
  'sys.coupletRequest': 'Yêu cầu tái Chọn',
  'sys.runningWater': 'Comment=Flower',
  'sys.runningWater1': 'Doanh thu',
  'sys.msg123': 'Tổng cộng',
  'sys.msg124': 'Baker',
  'sys.issueOnce': 'Phóng một lần',
  'sys.issueOnce1': 'Đại lý thanh toán đang xử lý',
  'sys.issueOnce2': 'Bán hàng tuần',
  'sys.issueOnce3': 'Trả lương tháng',
  'sys.issueOnce4': 'Khoản tiền thường',
  'sys.msg125': 'Vip {vipLevel} Cấp độ ({vipName}) Cài đặt cấp độ thành viên?',
  'sys.showName': 'Hiển thị tên',
  'sys.view': 'Xem.',
  'sys.msg126': 'Xin xác nhận mở khóa chưa?',
  'sys.msg127': 'Xin hãy xác nhận nếu nó được chấp thuận?',
  'sys.lockedAmount': 'Số tiền mặc định',
  'sys.flowCompletionProgress': 'Tiến trình hoàn thành doanh thu',
  'sys.completedFlow': 'Đã hoàn thành doanh thu:',
  'sys.offerTime': 'Thời gian nhận tiền ưu đãi',
  'sys.offerLockList': 'Danh sách khóa ưu đãi',
  'sys.monthlySettlementCommission': 'Ủy ban giảm án',
  'sys.confirmationReview': 'Kiểm tra xác nhận',
  'sys.proxyName': 'Tên đại lý',
  'sys.selectDate': 'Hãy chọn ngày',
  'sys.completeSchedule': 'Tiến độ hoàn thành',
  'sys.rechargeTime': 'Số lần nạp',
  'sys.depositLockList': 'Danh sách khóa nạp tiền mạc định',
  'sys.transferAmount': 'Số tiền chuyển khoản',
  'sys.transferStatus': 'Trạng thái chuyển khoản',
  'sys.transferType': 'Loại hình chuyển khoản:',
  'sys.gameOut': 'Chuyển ra trong game',
  'sys.abnormal': 'bất thường',
  'sys.msg128': 'Đặt thành công?',
  'sys.msg129': 'Đặt thành công. Nếu kiểu chuyển nhượng được thả, s ố lượng sẽ được thêm vào tài sản của người chơi.',
  'sys.msg130': 'Đặt thành lỗi?',
  'sys.msg131': 'Đặt là thất bại. Nếu kiểu chuyển nhượng được truyền trong game, s ố lượng sẽ được thêm vào tài sản của người chơi.',
  'sys.msg132': 'Số hiệu, tên người dùng, trình nền trò chơi',
  'sys.setSuccess': 'Thiết lập thành công',
  'sys.setFail': 'Thiết lập thất bại',
  'sys.totalWithdrawal': 'Tổng rút tiền',
  'sys.offerComposition': 'Tác phẩm ưu tiên',
  'sys.gameWater': 'Doanh thu trò chơi',
  'sys.bankRelated': 'Ngân hàng liên quan',
  'sys.bankCode': 'mã ngân hàng:',
  'sys.bankName': 'Tên ngân hàng:',
  'sys.branchName': 'Tên chi nhánh:',
  'sys.branchAddr': 'Địa chỉ nhánh:',
  'sys.accountRelated': 'Tài khoản liên quan',
  'sys.msg133': 'Tên tài khoản:',
  'sys.msg134': 'tài khoản ngân hàng:',
  'sys.msg135': 'Số tiền cuối cùng nhận được',
  'sys.msg136': 'Lịch sử doanh thu trong 7 ngày.',
  'sys.msg137': 'Địa điểm IP',
  'sys.msg138': 'Xem người dùng đã đăng nhập bởi IP này',
  'sys.msg139': 'Thống kê địa chỉ IP',
  'sys.normal': 'Sắp xếp theo thứ tự',
  'sys.bankInformation': 'Thông tin ngân hàng',
  'sys.attributionType': 'Loại hình phân bổ',
  'sys.offerRecord': 'Loại hình ưu đãi',
  'sys.userDeviceID': 'ID thiết bị người dùng',
  'sys.deviceInformation': 'Thông tin thiết bị',
  'sys.operatingSystemVersion': 'Phiên bản Hệ điều hành',
  'sys.longitude': 'Kinh độ',
  'sys.latitude': 'vĩ độ',
  'sys.loginTimes': 'Số lần đăng nhập',
  'sys.loginTimes1': 'Số kì:',
  'sys.registrationTime': 'Thời gian đăng ký',
  'sys.cellphoneNumber': 'Số điện thoại',
  'sys.cellphoneNumber2': 'Số điện thoại:',
  'sys.cellphoneNumber3': 'Số điện thoại phải chăng đã xác nhận?',
  'sys.msg140': 'Những người dùng khác đã đăng nhập qua IP này',
  'sys.msg141': 'Thời gian lần cuối đăng nhập',
  'sys.msg142': 'Thời gian yêu cầu gửi đi',
  'sys.windControlManagement': 'Quản lý rủi ro',
  'sys.loginLog': 'Nhật kí đăng nhập',
  'sys.deviceID': 'ID thiết bị',
  'sys.browser': 'Hệ điều hành',
  'sys.transactionRecord': 'Lịch sử giao dịch',
  'sys.transactionType': 'Loại hình giao dịch',
  'sys.transferDetails': 'Chi tiết chuyển khoản:',
  'sys.amountAfterSettlement': 'Tiền còn lại sau khi thanh toán',
  'sys.fundChange': 'Số tiền thay đổi',
  'sys.increase': 'tăng',
  'sys.cutBack': 'giảm',
  'sys.winLossAmount': 'Thắng hay thua',
  'sys.chronologically': 'Thứ tự thời gian:',
  'sys.agentWithdraw': 'Yêu cầu rút tiền',
  'sys.selectRiskLevel': 'Chọn mức rủi ro',
  'sys.selectRiskLevel1': 'Hãy chọn Cấp độ rủi ro',
  'sys.windControlLevel': 'Cấp độ rủi ro',
  'sys.confirmConsent': 'Xác nhận chấp thuận',
  'sys.confirmConsent1': 'Phải chăng đồng ý với thao tác này?',
  'sys.confirmConsent2': 'Anh có muốn từ chối chiến dịch này không?',
  'sys.cardholder': 'Chủ thẻ',
  'sys.viewUserDetails': 'Xem chi tiết',
  'sys.by': 'Thông qua',
  'sys.notApproved': 'Chưa kiểm tra và phê duyệt',
  'sys.passed': 'Đã qua',
  'sys.paid': 'Đã rút tiền',
  'sys.successfulPayment': 'Dịch vụ',
  'sys.smg143': 'Người dùng cần phê duyệt',
  'sys.smg144': 'Tài khoản giới hạn ưu đãi',
  'sys.smg145': 'Tài khoản giới hạn rút tiền',
  'sys.smg146': 'Hạn chế người dùng đăng nhập',
  'sys.smg147': 'Đăng nhập thông qua địa chỉ IP',
  'sys.smg148': 'Thiết bị đăng ký và thông tin cùng IP',
  'sys.smg149': 'Biểu đồ thắng thua của tài khoản',
  'sys.smg150': 'Có phải email đã xác nhận',
  'sys.smg151': 'Danh sách thuộc tính rủi ro của người chơi',
  'sys.flowRecord': 'Lịch sử doanh thu',
  'sys.userInfo': 'Thông tin người dùng',
  'sys.attribution': 'Phân bổ điện thoại',
  'sys.registerationName': 'Tên miền đăng kí:',
  'sys.details': 'Chi tiết:',
  'sys.searchUser': 'Tên tài khoản:',
  'sys.numberDeposits': 'Số người được kích hoạt:',
  'sys.numberWithdrawals': 'Số lần xuất tiền:',
  'sys.allGrades': 'Mọi hạng',
  'sys.riskValueScore': 'Điểm số giá trị rủi ro',
  'sys.managementPlatformGame': 'Quản lý trò chơi',
  'sys.receivingTime': 'Thời gian nhận:',
  'sys.completeTime': 'Giờ hoàn thành:',
  'sys.processResult': 'Kết quả xử lý',
  'sys.addWorkOrder': 'Bảng làm việc',
  'sys.smg155': 'Chương trình:',
  'sys.fillWorkOrder': 'Điền vào thứ tự làm việc',
  'sys.enterTitle': 'Hãy nhập một tựa đề',
  'sys.smg156': 'Hãy nhập vào nội dung, gợi ý hay ý kiến',
  'sys.enterProcessingResult': 'Hãy nhập kết quả xử lý',
  'sys.realUnlockAmount': 'Số lượng người thật mở ra',
  'sys.enterParameterAmount': 'Hãy nhập số lượng tham số',
  'sys.realState': 'Trạng thái con người',
  'sys.videoGameUnlockAmount': 'Số lượng trò chơi mở khoá',
  'sys.videoGameStatus': 'Trạng thái trò chơi',
  'sys.sportsUnlockAmount': 'Số giải thích thể thao',
  'sys.sportsStatus': 'Thể thao',
  'sys.chessCardUnlockingAmount': 'Bỏ khoá lượng cờ và quân bài',
  'sys.chessState': 'Trạng thái Cờ',
  'sys.fishingUnlockAmount': 'Số lượng tháo cá',
  'sys.fishingStatus': 'Trạng thái cá',
  'sys.lotteryUnlockAmount': 'Số lượng thích xổ số',
  'sys.lotteryStatus': 'Bộ dạng xổ số',
  'sys.universalUnlockAmount': 'Tổng mức mở khoá',
  'sys.defaultState': 'Mặc định',
  'sys.smg157': 'Chú ý: số lượng mở khoá sẽ ảnh hưởng tới số tiền bị các thành viên khóa.',
  'sys.smg158': 'Giá trị khoá giảm giá giảm giá đã mất ít hơn lượng đã mở.',
  'sys.smg159': 'Số tiền đã khóa còn thiếu số tiền đã mất còn thấp hơn số tiền đã khoá.',
  'sys.smg160': 'Hệ thống sẽ tự động mở cửa đề nghị hay đặt cọc và đặt trạng thái bị lỗi.',
  'sys.smg161': 'Những tham số kích thích của kiểu chơi tương ứng sẽ được dùng cho việc nhượng bộ của kiểu chơi đã xác định, và tham số kích thích mặc định sẽ được dùng cho việc nhượng bộ và khóa đặt cọc của kiểu chơi không xác định.',
  'sys.confirmUpload': 'Xác nhận tải',
  'sys.smg162': 'Việc tải lên sẽ ảnh hưởng đến việc tải xuống ứng dụng người dùng.Xin hãy cẩn thận, upload hay không?',
  'sys.smg163': 'Phần mềm gói và tải lên',
  'sys.AppType': 'Kiểu APP',
  'sys.selectAppTypr': 'Hãy chọn ứng dụng',
  'sys.version': 'Số phiên bản',
  'sys.enterVersion': 'Hãy nhập số phiên bản',
  'sys.smg164': 'Nhập tới mười ký tự',
  'sys.pleaseUpload': 'Xin tải',
  'sys.pleaseUploadApp': 'Vui lòng tải dữ liệu',
  'sys.pleaseNote': 'Xin chú ý rằng',
  'sys.smg165': 'Chọn tập tin ứng dụng để xác nhận, rồi tự động đăng tải lên!',
  'sys.AppUploadUpdateSucceeded': 'Ứng dụng upload và cập nhật thành công',
  'sys.returnRefreshHome': 'Quay lại nhắc trang chủ',
  'sys.configurationItem': 'Mô tả cấu hình',
  'sys.enterConfigurationItem': 'Hãy nhập vào mô tả cấu hình',
  'sys.withdrawalOrderSplit': 'Lệnh rút lui chia tách',
  'sys.smg166': 'Là lệnh rút tiền {msg} được chia?',
  'sys.addPaymentChannel': 'Thêm kênh thanh toán',
  'sys.orderSplitConfiguration': 'Phân chia và cài đặt đơn',
  'sys.maxAmount': 'Tổng số tối đa',
  'sys.minAmount': 'Mức tối thiểu',
  'sys.nameCode': 'Tên/ mã',
  'sys.fillPaymentChannelInformation': 'Điền thông tin kênh thanh toán',
  'sys.paymentRate': 'Số tiền thưởng',
  'sys.enterPaymentRate': 'Xin hãy nhập giá đương',
  'sys.controllerPath': 'Đường điều khiển',
  'sys.fillPaymentSplitConfiguration': 'Điền vào bộ cấu hình chia tiền đã ủy nhiệm',
  'sys.splitMinimumAmount': 'Tỷ lệ tối thiểu',
  'sys.splitMaximumAmount': 'Khối lượng tối đa',
  'sys.whetherOpen': 'Có nên mở',
  'sys.isSubmit': 'Có nộp chưa',
  'sys.confirmSubmit': 'Hãy kiểm tra xem thông tin có đúng không và gửi cẩn thận',
  'sys.diffPass': 'Mật khẩu bất ổn, xin xác nhận',
  'sys.formatError': 'Chỉ có thể khởi động chữ cái dưới chữ cái, chỉ chứa chữ cái dưới chữ cái và con số',
  'sys.Pass': 'Mật khẩu',
  'sys.cleanValidator': 'Bạn có chắc muốn xoá trách nhiệm kiểm tra ràng buộc với tài khoản nền này không?',
  'sys.deleteAccount': 'Tài khoản sẽ bị xóa: {username}',
  'sys.forceOffline': 'Ngắt kết nối',
  'sys.resetValidator': 'Xác nhận lại',
  'sys.fillDeviceInfo': 'Điền thông tin về thiết bị',
  'sys.deviceNo': 'Số bộ phận',
  'sys.deviceNo1': 'Hãy nhập số thiết bị',
  'sys.deviceNo2': 'Ghi chú số dụng cụ',
  'sys.deviceNo3': 'Số thiết bị cần xóa: {deviceNum}',
  'sys.confirmRefreshBlackList': 'Anh có chắc muốn tải lại danh sách bị cấm không?',
  'sys.refreshBlackList': 'Cập nhật danh sách đen',
  'sys.addDeviceNo': 'Thêm số thiết bị',
  'sys.fillIPInfo': 'Điền thông tin IP',
  'sys.startIP': 'Thao tác IP',
  'sys.startIP1': 'Hãy nhập IP đầu',
  'sys.endIP': 'cuối IP',
  'sys.endIP1': 'Hãy nhập vào cuối IP',
  'sys.endIP2': 'Hãy nhập chú thích IP',
  'sys.deleteIP': 'IP cần xóa: {ipMinRange}',
  'sys.beginIP': 'Mở địa chỉ IP',
  'sys.overIP': 'Kết thúc địa chỉ IP',
  'sys.confirmRefreshIPBlackList': 'Cậu có chắc là muốn tải lại danh sách đen IP không?',
  'sys.addIP': 'Thêm IP',
  'sys.refreshIpBlackList': 'Cập nhật danh sách đen IP',
  'sys.changeTime': 'Thời gian sửa đổi',
  'sys.inputIPAddress': 'Hãy nhập địa chỉ IP',
  'sys.inputIPAddress1': 'Dùng\'; để phân chia IPS đa lần',
  'sys.editPlayMethodDesc': 'Sửa hướng dẫn',
  'sys.playMethodDesc': 'Hướng dẫn hoạt',
  'sys.playMethodDesc1': 'Hãy nhập vào mô tả cách chơi',
  'sys.winningExample': 'Ví dụ về chiến thắng',
  'sys.winningExample1': 'Hãy nhập vào ví dụ',
  'sys.confirmEnablePlayMethod': 'Bạn có chắc muốn bật vở kịch này không?',
  'sys.confirmDisablePlayMethod': 'Anh có chắc muốn vô hiệu hóa cuộc chơi này không?',
  'sys.people': 'Nhân',
  'sys.editDesc': 'Ghi chú bút',
  'sys.attributeName': 'Tên thuộc tính',
  'sys.confirmChangeLiuHeOdds': 'Bạn có chắc chắn sửa đổi tỷ lệ cược trò chơi Liuhecai [{FirstName} - {secondName}] không?',
  'sys.save': 'Bảo:',
  'sys.odds': 'Tỷ lệ là:',
  'sys.cleanWhiteListCache': 'Xoá bộ nhớ tạm danh sách trắng',
  'sys.inputIPAddress3': 'Hãy nhập địa chỉ IP, và dùng\'; để chia nhiều IPS',
  'sys.accountUnlockParam': 'Người chơi tải xuống',
  'sys.lowOrderCount': 'Lệnh tối thiểu',
  'sys.lowOrderCount1': 'Hãy nhập số lệnh tối thiểu',
  'sys.lowOrderCount2': 'Hãy nhập số đúng',
  'sys.percentageWarning': 'Bộ trăm cảnh giác',
  'sys.percentageWarning1': 'Hãy nhập phần trăm cảnh giác',
  'sys.disablePercentage': 'Mục tiêu:',
  'sys.disablePercentage1': 'Hãy nhập phần trăm người khuyết.',
  'sys.lowOrderCount3': 'Số lượng lệnh tối thiểu: nếu phương pháp bồi thường hàng loạt lớn hơn giá trị này, hãy xét xem phương pháp bồi thường có gửi thông điệp báo động không và tự động ngắt nó.',
  'sys.percentageWarning2': 'Thông báo: nếu tỷ lệ thành công của phương pháp thanh toán thấp hơn tỷ lệ này, thông điệp báo sẽ được gửi và hiển thị ở góc trên bên phải của trang này.',
  'sys.disablePercentage2': 'Tắt phần trăm: nếu tỷ lệ thành công của phương pháp thanh toán thấp hơn tỷ lệ này, phương pháp thanh toán sẽ bị tắt tự động và sẽ được gửi một thông điệp vô hiệu, nó sẽ được hiển thị ở góc trên bên phải của trang này.',
  'sys.disablePercentage3': 'Phương pháp thanh toán đã bị tắt sẽ không còn gửi thông điệp liên tục nữa.',
  'sys.gamePlatformInfo': 'Thông tin nền trò chơi',
  'sys.chineseName': 'Tên Trung Quốc',
  'sys.chineseName1': 'Nhập tên tiếng Trung',
  'sys.gameSort': 'Thiết lập chuỗi',
  'sys.gameSort1': 'Hãy nhập vào lệnh, từ nhỏ đến lớn',
  'sys.pc': 'Chính tả Name',
  'sys.pc1': 'Hãy chọn nếu máy tính được hỗ trợ',
  'sys.pc2': 'Chính tả Name',
  'sys.notSupport': 'Tôi sẽ không ủng hộ.',
  'sys.h5': 'Hỗ trợ H5',
  'sys.h51': 'Hãy chọn nếu H5 được hỗ trợ',
  'sys.h52': 'Hỗ trợ H5',
  'sys.hotGame': 'Trò nóng',
  'sys.notHotGame': 'Không náo nhiệt',
  'sys.newestGame': 'Trò cuối cùng',
  'sys.notNewGame': 'Không cập nhật',
  'sys.pcPic': 'Ảnh máy tính',
  'sys.h5Pic': 'Ảnh H5',
  'sys.gameNo': 'Số máy chơi',
  'sys.pcPicH5Pic': 'Ảnh PC/H5',
  'sys.notSupportPc': 'Phần máy tính không hỗ trợ',
  'sys.notSupportH5': 'Không hỗ trợ di động',
  'sys.newGame': 'Thêm trò chơi mới',
  'sys.tryPlay': 'Hỗ trợ thử thách',
  'sys.hot': 'Nhiệt',
  'sys.new': 'mới',
  'sys.try': 'thử',
  'sys.addMaintenanceInfoSuccess': 'Thông tin bảo trì thành công!',
  'sys.addMaintenanceInfoFail': 'Lỗi thêm thông tin bảo trì',
  'sys.addMaintenanceInfoError': 'Lỗi khi thêm thông tin bảo trì',
  'sys.maintenanceInfo1': 'Xin hãy điền thông tin bảo trì',
  'sys.maintenanceInfo': 'Thông tin bảo trì',
  'sys.fillGamePlatFormInfo': 'Điền thông tin nền tảng trò chơi',
  'sys.platFormNo': 'Hãy nhập số platform',
  'sys.platFormGameNo': 'Mạng chơi platform',
  'sys.platFormGameNo1': 'Hãy nhập số trận đấu platform',
  'sys.platFormFullName': 'Tên đầy đủ của nền tảng',
  'sys.gameNameAndGameType': 'Tên nhà cái +Name',
  'sys.platformRate': 'Tốc độ platform',
  'sys.platformRate1': 'Hãy nhập giá trình nền',
  'sys.platformDesc': 'Mô tả platform',
  'sys.platformDesc1': 'Hãy nhập vào mô tả platform',
  'sys.platformDesc2': 'Nhập vào các kí tự 255',
  'sys.platformSort1': 'Hãy nhập dạng nền tảng',
  'sys.platformSort2': 'Từ lớn đến nhỏ theo trật tự tự tự nhiên',
  'sys.platformSort': 'Bộ lọc platform',
  'sys.allPlatform': 'Tất cả bục',
  'sys.fullName': 'Tên đầy đủ',
  'sys.gameRate': 'Tốc độ chơi',
  'sys.confirmDeleteGamePlatForm': 'Nền tảng trò chơi sẽ bị xóa {fullName}',
  'sys.isHot': 'Mức độ náo nhiệt?',
  'sys.hotSort': 'Bộ lọc bình dân',
  'sys.addPlatFomr': 'Thêm nền',
  'sys.isMaintenance': 'Bảo:',
  'sys.changeHotSort': 'Chỉnh sửa loại phổ biến của {value}',
  'sys.hotSort1': 'Xin hãy nhập vào loại phổ biến.',
  'sys.mailInfo1': 'Điền thông tin e-mail vào',
  'sys.mailInfo2': 'Hãy nhập tên người dùng email',
  'sys.mailInfo3': 'Hãy nhập tên người dùng hộp thư ít hơn 80',
  'sys.mailPass': 'Mật khẩu bưu điện',
  'sys.mailPass1': 'Hãy nhập mật khẩu email',
  'sys.mailPass2': 'Hãy nhập mật khẩu hộp thư dưới kí hiệu 80',
  'sys.mailSMTP1': 'Hãy nhập địa chỉ SMTP',
  'sys.mailSMTP2': 'Hãy nhập một địa chỉ SMTP với ít hơn 200 ký tự',
  'sys.encryptionType': 'Kiểu mật mã',
  'sys.encryptionType1': 'Hãy chọn kiểu mã hóa',
  'sys.encryptionType2': 'Không có mật mã (hầu hết cổng là 25)',
  'sys.ssl': 'SSL (hầu hết cổng là 465)',
  'sys.tls': 'TLS (hầu hết cổng là 587)',
  'sys.port': 'Số cổng',
  'sys.port1': 'Hãy nhập số cổng',
  'sys.deleteMail': 'Hộp thư sẽ bị xóa: {Tên tài khoản}',
  'sys.addMail': 'Thêm thư',
  'sys.addMailTemplate': 'Điền vào thông tin mẫu thư',
  'sys.templateName': 'Tên mẫu',
  'sys.templateName1': 'Hãy nhập tên mẫu',
  'sys.mailTitle': 'Đặt thư',
  'sys.mailTitle1': 'Hãy nhập vào tựa của tin nhắn',
  'sys.mailContent1': 'Hãy nhập vào nội dung thông điệp',
  'sys.mailRemark': 'Ghi chú thư',
  'sys.mailRemark1': 'Vui lòng nhập thư',
  'sys.deleteMailTemplate': 'Mẫu thư sẽ bị xóa: {name}',
  'sys.addTemplate': 'thêm mẫu',
  'sys.allTemplate': 'Mọi mẫu',
  'sys.buttonPermissionMgt': 'Quản lý quản lý nút',
  'sys.noticeDataPermissionMgt': 'Quản lý nguồn dữ liệu',
  'sys.noticePermission': 'Thông báo',
  'sys.pageDataPermissionMgt': 'Quản lý giấy trang',
  'sys.console': 'Đóng',
  'sys.deleteRole': 'Vai trò cần xóa: {RoleName}',
  'sys.roleName': 'Tên đồng hồ',
  'sys.roleSort': 'Dãy số Rolex',
  'sys.dataPermission': 'Quyền truy cập',
  'sys.disableRole': 'Anh có muốn vô hiệu hóa vai diễn này không?',
  'sys.enableRole': 'Bạn có muốn bật vai này không?',
  'sys.addRole': 'Thêm ảnh',
  'sys.inputRoleName': 'Hãy nhập tên tác vụ',
  'sys.inputRoleSort': 'Vui lòng nhập trật tự',
  'sys.payLine': 'color',
  'sys.cumulativePrizePool': 'Bảng thu',
  'sys.classGame': 'Trò chơi cổ điển',
  'sys.eliminateMusic': 'Tiêu Tiểu',
  'sys.electricHorn': 'Sừng điện',
  'sys.gameId': 'Mã số game',
  'sys.intoGameParam': 'Nhập các tham số trò chơi và điền cẩn thận.',
  'sys.isTryGame': 'Hãy chọn xem hỗ trợ thử nghiệm',
  'sys.payLine1': 'Hãy nhập dòng bồi thường',
  'sys.uploadPcPic': 'Tải ảnh máy tính lên',
  'sys.oldPcPic': 'Ảnh cũ trên máy:',
  'sys.oldH5Pic': 'Ảnh cũ H5:',
  'sys.uploadH5Pic': 'Tải ảnh H5 lên',
  'sys.platformName': 'Tên nhà cái',
  'common.productName': '游石 · Game Stone',
  'common.changeLang': 'Chuyển ngôn ngữ',
  'common.page.showtotal': 'Tìm thấy {total} kết quả',
  'common.page.pageInfo': 'Page {currentPage} of {totalPages}',
  'common.page.showSelectTotal': 'Tìm thấy {total} kết quả, {select} Đã chọn',
  'common.404': '404',
  'common.unkonwException': 'Lỗi chưa biết',
  'common.unkonwError': 'Lỗi chưa biết',

  'common.operateFail': 'Thao tác thất bại',
  'common.action': 'Thao tác',
  'common.delete': 'Xóa',

  'common.operateFail1': 'Thao tác thất bại , vui lòng thử lại',

  'common.export': 'Tải xuống',
  'common.tip': 'Nhắc nhở',
  'common.pleaseSelectDateRange': 'Vui lòng chọn khoảng thời gian',
  'common.exportFailed': 'Tải xuống thất bại',

  'common.Button.details': 'Chi tiết',
  'common.Button.expandDetails': 'Mở rộng chi tiết',
  'common.Button.collapseDetails': 'Thu gọn chi tiết',
  'common.button.add': 'Mới',
  'common.queryFrm.search': 'Tìm kiếm',

  'common.queryFrm.keyWord': 'Từ khóa',
  'common.queryFrm.nickName': 'Biệt danh',

  'common.queryFrm.searchUserAccountPhoneMail': 'Tên người chơi / số điện thoại / Trung tâm gửi thư',
  'common.queryFrm.searchUserAccountBetflowNumber': 'Tên người chơi / Mã cược',

  'common.radio.today': 'Hôm nay',
  'common.radio.yesterday': 'Hôm qua',

  'common.radio.last7Day': '7 ngày trước',
  'common.radio.last15Day': '15 ngày trước',
  'common.radio.last30Day': '30 ngày trước',

  'common.title.operate': 'Thao tác',
  'common.title.serialNumber': 'Số Thứ Tự',

  'common.select.selectPlatform': 'Lựa chọn nền tảng',
  'common.select.allPlatform': 'Nhà cái hiện tại',

  'login.install.verify': 'Vui lòng cài đặt Google Authenticator',
  'login.input.username': 'Vui lòng nhập tên người dùng',
  'login.input.password': 'Vui lòng nhập mật khẩu của bạn',
  'login.submit': 'Nhật kí đăng nhập',
  'login.success': 'Đăng nhập thành công',
  'login.please': 'Vui lòng đăng nhập',
  'menu.index': 'Trang chủ',
  'menu.export': 'Xuất dữ liệu',
  'menu.console': 'Bảng điều khiển',
  'menu.queryMember': 'Danh sách người chơi',
  'menu.queryNewMember': 'Thêm người chơi mới',
  'menu.queryDepositMember': 'Người chơi nạp tiền',
  'menu.queryActiveUser': 'Hoạt động người chơi',
  'menu.queryProfitAndLossAccount': 'Tài khoản không online và còn online',
  'menu.querySilentUser': 'Người chơi không tích cực',
  'menu.retainedUser': 'Lưu trình phân tích',
  'menu.userAnalysis': 'Phân tích người dùng',
  'menu.memberContact': 'Thông tin người chơi',
  'menu.memberWithdrawalInformation': 'Thông tin rút tiền của thành viên',
  'menu.member': 'Quản lý người chơi',
  'menu.bonusSetting': 'Các hoạt động',
  'menu.bonusUpperLimit': 'Cung cấp giới hạn trên',
  'menu.bonusActivities': 'Chủ đề sự kiện',
  'menu.operation.bonus.bonusArticle': 'Quản lý điều lệ',
  'menu.bonusImport': 'Phát hành hàng loạt',
  'menu.operation.bonus.bonusApplyRole': 'Thiết lập bài trừ',
  'menu.bonusReport': 'Lịch sử lưu lại',
  'menu.bonusWinOrLoseReport': 'Thống kê lãi lỗ',
  'menu.bonus': 'Hệ thống ưu đãi',
  'menu.setting': 'Thiết lập cấp độ VIP',
  'menu.vip': 'Quản lý cấp bậc thành viên',
  'menu.announcement': 'Quản lý thông báo',
  'menu.operation.frontContent.articleMgmt': 'Quản lý điều lệ',
  'menu.operation.frontContent.articleTypeMgmt': 'Quản lý các thể loại điều lệ',
  'menu.operation.frontContent.nav': 'Quản lý điều hướng',
  'menu.gamePlatformLogo': 'Quản lý biểu tượng nền tảng trò chơi',
  'menu.operation.frontContent.pageMgmt': 'Quản lý trang',
  'menu.frontContent': 'Quản lý nội dung',
  'menu.activitySetting': 'Thiết lập trò chơi nhỏ',
  'menu.activitySyntheticLog': 'Trò chơi đánh máy tổng hợp',
  'menu.activityCashTurnLog': 'Hồ sơ bánh xe tiền mặt',
  'menu.activityLog': 'Lịch sử trò chơi rút thưởng',
  'menu.activityUserCount': 'Lịch sử số tiền trò chơi',
  'menu.operation.activity.checkin': 'Đăng nhập lịch sử khen thưởng',
  'menu.operation.activity.integralExchange': 'Lịch sử quy đổi điểm',
  'menu.activity': 'Quản lý trò chơi',
  'menu.operation.upgrade.upgradeSetting': 'Cài đặt cấp độ',
  'menu.operation.upgrade.upgradeUser': 'Danh sách người chơi',
  'menu.operation.upgrade.upgradeReport': 'Kỷ lục phát thưởng',
  'menu.operation.upgrade': 'Hình thức nâng cấp',
  'menu.sendSiteMsg': 'Trung tâm gửi thư',
  'menu.inbox': 'Nhận thư',
  'menu.siteMsg': 'Hòm thư trung tâm',
  'menu.sendMail': 'Hộp thư gửi đi',
  'menu.operation.queryPushMessageList': 'Quản lý mục giới thiệu',
  'menu.operation': 'Trung tâm hoạt động',
  'menu.information.sixLottery.queryGroupList': 'Thư viện ảnh',
  'menu.information.sixLottery.queryTopicList': 'Quản lý bài viết',
  'menu.information.sixLottery.queryReplyList': 'Trả lời quản lý',
  'menu.information.sixLottery.queryPushMessageList': 'Quản lý mục giới thiệu',
  'menu.information.sixLottery.queryComplaintList': 'Quản lý khiếu nại',
  'menu.information.sixLottery': 'Xổ số lục hợp của HongKong',
  'menu.information.lotteryUserTrace.lotteryUserLevel': 'Cấp bậc thành viên',
  'menu.information.lotteryUserTrace.lotteryUserAttention': 'Người chơi được chú ý',
  'menu.information.lotteryUserTrace.lotteryUserApprove': 'Thành viên thích',
  'menu.information.lotteryUserTrace.lotteryUserDailyTask': 'Nhiệm vụ hàng ngày',
  'menu.information.lotteryUserTrace': 'Theo dõi người dùng',
  'menu.information.lotteryOrder.orderList': 'Đơn mua sổ xố',
  'menu.information.lotteryOrder.giveBonusList': 'Lịch sử phát thưởng',
  'menu.information.lotteryOrder': 'Đơn đặt cược',
  'menu.information.lotteryManager.generalManager': 'Quản lý thường dùng',
  'menu.information.lotteryManager.userBanList': 'Quản lý phát ngôn',
  'menu.information.lotteryManager.dailyTaskManager': 'Nhiệm vụ hàng ngày',
  'menu.information.lotteryManager.lotteryLevelSetting': 'Cài đặt cấp độ',
  'menu.information.lotteryManager': 'Quản lý xổ số Lục hợp',
  'menu.information.lotteryOpen.queryLotteryEntryList': 'Quản lý mục giới thiệu',
  'menu.information.lotteryOpen.queryLotteryHistoryList': 'Kết quả xổ số',
  'menu.information.lotteryOpen.queryLotteryOpenDateList': 'Ngày mở thưởng',
  'menu.information.lotteryOpen': 'Quản lý xổ số',
  'menu.information': 'Thông tin',
  'menu.queryMarket': 'Danh sách của tôi',
  'menu.unLoggedList': 'Danh sách chưa đăng kí',
  'menu.queryAllocation': 'Danh sách phân phối',
  'menu.querySeat': 'Quản lý chỗ ngồi',
  'menu.queryTeam': 'Hiệu suất đội nhóm',
  'menu.queryMyScore': 'Hiệu suất cá nhân',
  'menu.queryAllScore': 'Xem chi tiết ủy viên',
  'menu.callListA': 'Chi tiết cuộc gọi',
  'menu.callRecord': 'Lịch sử cuộc gọi',
  'menu.userInfoCallRecord': 'Bản ghi cuộc gọi chi tiết thành viên',
  'menu.tele': 'Hệ thống điện tính',
  'menu.queryAgent': 'Danh sách đại lý',
  'menu.agentContact': 'Thông tin đại lý',
  'menu.queryPhoto': 'Truyền tải hình ảnh',
  'menu.agentCommissionSetting': 'Cài đặt hoa hồng',
  'menu.queryOtherCost': 'Chi phí khác của đại lý',
  'menu.agentDomain': 'Tên miền đại lý',
  'menu.commissionReport': 'Báo cáo tiền hoa hồng',
  'menu.agentReport': 'Danh sách đại lý',
  'menu.agent': 'Hệ thống đại lý',
  'menu.addAdvertising': 'Chi tiêu quảng cáo mới',
  'menu.queryAdAgent': 'Danh sách kênh quảng cáo',
  'menu.ad': 'Quản lý quảng cáo',
  'menu.market': 'Tiếp thị',
  'menu.riskSetting': 'Phê duyệt rút tiền',
  'menu.userPropAuth': 'Đánh giá Mức độ người chơi',
  'menu.bonusLockList': 'Khóa mặc định ưu đãi',
  'menu.depositLockList': 'Khóa nạp tiền mặc định',
  'menu.checkAgentCommissionByRisk': 'Kiểm toán số tiền hoa hồng của đại lý',
  'menu.queryGameTrans': 'Trò chơi chuyển khoản bất thường',
  'menu.risk': 'Kiểm soát rủi ro',
  'menu.overall': 'Xu hướng chung',
  'menu.reportBetRecord': 'Báo cáo kỉ lục đặt cược',
  'menu.sportUnSettlement': 'Lịch sử thể thao chưa thanh toán',
  'menu.realTimeStatistics': 'Thống kê hiện tại',
  'menu.analyze.onlineUser': 'Thành viên trực tuyến',
  'menu.reportPlatform': 'Tổng quan về nhà cái',
  'menu.reportChannel': 'Danh sách kênh',
  'menu.reportGamePlatform': 'Danh sách trò chơi của nhà cái',
  'menu.analyze.reportManualTransfer': 'Danh sách đối chiếu',
  'menu.reportDeposit': 'Báo cáo tiền nạp',
  'menu.reportWithdrawal': 'Danh sách rút tiền',
  'menu.reportDividend': 'Danh sách ưu đãi',
  'menu.analyze.userGameReport': 'Báo cáo thành viên trò chơi',
  'menu.userDeposit': 'Danh sách người chơi nạp tiền',
  'menu.paymentStatistics': 'Báo cáo kênh thanh toán',
  'menu.analyze.paymentTab': 'Danh sách tỉ lệ thanh toán thành công',
  'menu.operationLog': 'Nhật ký hoạt động',
  'menu.analyze.smsNameVerifyLog': 'Kỷ lục người chơi xác minh điện thoại',
  'menu.analyze': 'Phân tích dữ liệu',
  'menu.queryPayOrder': 'Quản lý đơn nạp tiền',
  'menu.finance.queryOfflinePayOrder': 'Phê duyệt thanh toán ngoại tuyến',
  'menu.finance.queryOnlinePayOrder': 'Quản lý thanh toán trực tuyến',
  'menu.finance.payFrontConfig': 'Thiết lập phân loại thanh toán',
  'menu.finance.payConfig': 'Thiết lập kênh thanh toán',
  'menu.finance.withdrawPay': 'Thiết lập kênh thanh toán',
  'menu.checkAgentCommissionByFinance': 'Đánh giá tài chính của đại lý',
  'menu.finance.config.payChannel': 'Cài đặt kênh thanh toán',
  'menu.finance.config.withdraw': 'Cài đặt kênh thanh toán',
  'menu.finance.config': 'Cài đặt thanh toán',
  'menu.finance': 'Trung tâm tài vụ',
  'menu.queryRole': 'Quản lý vai trò',
  'menu.adminAccount': 'Quản lý tài khoản nền tảng',
  'menu.sys.userSysAdmin': 'Quản lý tham số hệ thống',
  'menu.sys.lottery.queryLotteryMethodList': 'Quản lý cách chơi',
  'menu.sys.lottery.queryLotteryPropList': 'Quản lý thuộc tính',
  'menu.sys.lottery.queryLotteryRateList': 'Quản lý tỷ lệ cược',
  'menu.sys.lottery.queryLotteryHistoryList': 'Kết quả xổ số',
  'menu.sys.lottery': 'Quản lý xổ số',
  'menu.queryMailPool': 'Cấu hình hòm thư',
  'menu.queryMailTemplate': 'Mẫu thư',
  'menu.queryGameList': 'Cài đặt danh sách trò chơi',
  'menu.paymentSuccessRate': 'Cài đặt cảnh báo tỷ lệ thanh toán thành công',
  'menu.slotManage': 'Quản lý trò chơi điện tử',
  'menu.payIpWhitelist': 'Danh sách IP',
  'menu.sys.ipBlockList': 'Danh sách IP xấu',
  'menu.sys.deviceBlockList': 'Danh sách đen thiết bị người dùng',
  'menu.ipWhitelist': 'Danh sách nền tảng IP',
  'menu.ticket': 'Hệ thống trình tự làm việc',
  'menu.unlockCondition': 'Tự động mở khóa vòng cược',
  'menu.uploadPackage': 'Quản lý gói APP',
  'menu.sys': 'Thiết lập hệ thống',
  'menu.queryMenu': 'Quản lý thực đơn',
  'menu.queryButton': 'Quản lý nút',
  'menu.queryNotify': 'Quản lý loại thông báo',
  'menu.queryConfig': 'Tham số hệ thống',
  'menu.ee.withdrawPay': 'Cài đặt kênh thanh toán',
  'menu.paySetting': 'Thông số thanh toán',
  'menu.queryAdmin': 'Vòng quay may mắn',
  'menu.ee': '彩蛋',
  'menu.pictureGroup': 'Quản lý hình ảnh',
  'menu.queryGamePlatform': 'Cài đặt nền tảng trò chơi',
  'menu.queryWithdraw': 'Quản lý lệnh rút tiền mặt',
  'menu.C2CWithdraw': 'C2C Quản lý lệnh rút tiền mặt',
  'menu.configPictureGroup': 'Cấu hình nhóm hình',
  'menu.agentWithdraw': 'Lệnh rút tiền',
  'menu.settingGamePlatform': 'Thiết lập nền tảng trò chơi',

  'menu.pixel': 'Quản lý điểm ảnh',
  'menu.statistics': 'Hồ sơ thống kê',
  'menu.push': 'Đẩy hồ sơ',
  'menu.name': 'Quản lý tên',
  'menu.userPush':'Hồ sơ đẩy người dùng',

  'menu.yyg': 'Quản lý YYG',
  'menu.yygOrder': 'Quản lý đơn hàng',
  'menu.yygConfig': 'Cài đặt hệ thống',
  'menu.yygCommodity': 'Quản lý sản phẩm',
  'menu.yygSummaryMain': 'Tóm tắt dữ liệu',
  'menu.yygData': 'Quản lý dữ liệu',
  'menu.yygSummaryDetail': 'Chi tiết dữ liệu',
  'menu.yygMutiple': 'Định cấu hình ngôn ngữ nền tảng',
  'menu.yygPlatform': 'Cấu hình nhiều nền tảng',
  'menu.yygList': 'Danh sách sản phẩm',
  'menu.yygCategory': 'Phân loại sản phẩm',
  'menu.yygPlan': 'kế hoạch mua gấp',

  'constants.riskLevelType_20': 'Thêm phương thức nạp tiền',
  'constants.riskLevelType_10': 'Tiền nạp không bị chặn',
  'constants.riskLevelType_0': 'Phổ thông',
  'constants.riskLevelType_-9': 'Hạn chế nhận tiền hoàn trả',
  'constants.riskLevelType_-10': 'Hạn chế nhận ưu đãi',
  'constants.riskLevelType_-20': 'Hạn chế rút tiền',
  'constants.riskLevelType_-30': 'Hạn chế đăng nhập',
  'constants.gameType_1': 'Điện tử',
  'constants.gameType_2': 'Live',
  'constants.gameType_3': 'Thể thao',
  'constants.gameType_4': 'Xổ số',
  'constants.gameType_5': 'Bắn cá',
  'constants.gameType_6': 'cờ vua',
  'constants.transferType_1': 'Tăng giảm nền tảng',
  'constants.transferType_2': 'Nạp tiền',
  'constants.transferType_3': 'Rút tiền',
  'constants.transferType_4': 'Chuyển vào trong game',
  'constants.transferType_5': 'Chuyển ra từ trò chơi',
  'constants.transferType_6': 'Đóng băng',
  'constants.transferType_7': 'Mở khóa',
  'constants.transferType_8': 'Ưu đãi / Quỹ tích lũy',
  'constants.transferType_9': 'Nạp thủ công',
  'constants.transferType_10': 'Rút thủ công',
  'constants.transferType_14': 'Phần thưởng cho lời mời tên miền được chỉ định',
  'constants.transferType_15': 'Phần thưởng cho mọi người',
  'constants.transferType_17': 'Phần thưởng cho lời mời dành cho mọi người',
  'constants.regSourceType_0': 'Tự đăng ký',
  'constants.regSourceType_1': 'Đại lý',
  'constants.regSourceType_2': 'Quảng cáo',
  'constants.regSourceType_3': 'Telesale',
  'constants.regSourceType_4': 'Lời mời',
  'constants.gameSlot_NEWBBIN': 'BBIN game',
  'constants.gameSlot_BBIN': 'BBIN',
  'constants.gameSlot_NEWPT': 'PT GAME',
  'constants.gameSlot_NEWSA': 'SA GAME',
  'constants.gameSlot_PT': 'PT',
  'constants.gameSlot_MG': 'MG',
  'constants.gameSlot_HB': 'HB',
  'constants.gameSlot_JDB': 'JDB',
  'constants.gameSlot_DT': 'DT',
  'constants.gameSlot_VT': 'VT',
  'constants.gameSlot_PNG': 'Play\'n GO',
  'constants.gameSlot_AMEBA': 'AMEBA',
  'constants.gameSlot_SKYWIND': 'Skywind',
  'constants.gameSlot_CQ9': 'CQ9',
  'constants.gameSlot_GNS': 'GNS',
  'constants.gameSlot_GSS': 'GSS',
  'constants.gameSlot_AB': 'AB',
  'constants.gameSlot_REDTIGER': 'REDTIGER',
  'constants.gameSlot_SA': 'SA',
  'constants.gameSlot_NETENT': 'NetEnt',
  'constants.gameSlot_BETSOFT': 'BetSoft',
  'constants.gameSlot_PLAYSTAR': 'PlayStar Game',
  'constants.gameSlot_SG': 'SG Game',
  'constants.gameSlot_RTG': 'RTG Game',
  'constants.gameSlot_QT': 'QT Game',
  'constants.gameSlot_PGSOFT': 'PGSOFT Game',
  'constants.gameSlot1_PG': 'PGSOFT Game',
  'constants.gameSlot_LG': 'LG Game',
  'constants.gameSlot_ISOFTBET': 'ISOFTBET Game',
  'constants.gameSlot_KingMaker': 'KM Game',
  'constants.gameSlot_CG': 'CG Game',
  'constants.gameSlot_CRG': 'CRG Game',
  'constants.gameSlot_PP': 'PP Game',
  'constants.gameSlot_SEA': 'SEA Slot',
  'constants.gameSlot_FC': 'FC',
  'constants.gameSlot_YESBINGO': 'YESBINGO',
  'constants.gameSlot_SPRIBE': 'SPRIBE',
  'constants.gameSlot_BNG': 'BNG',
  'constants.gameSlot_MW': 'MW Game',
  'constants.gameSlot_WG': 'WG',
  'constants.gameSlot_PCLASSICG': 'PCLASSICG',
  'constants.gameSlot1_MW': 'MW Game',
  'constants.gameSlot_FUNKY': 'FUNKY Game',
  'constants.gameSlot1_JILISLOT': 'JILI',
  'constants.gameSlot1_JILI': 'JILI',
  'constants.gameSlot1_PHJILISLOT': 'PHJILI',
  'constants.gameSlot1_TTG': 'TTG Slot',
  'constants.gameSlot1_PGO': 'Play\'n GO Slot',
  'constants.gameSlot1_RT': 'Red Tiger Slot',
  'constants.gameSlot1_PRAP': 'PRAGMATIC PLAY Slot',
  'constants.gameSlot1_PST': 'PLAYSTAR Slot',
  'constants.gameSlot1_RICH': 'Rich88 Slot',
  'constants.gameSlot1_FUNKY': 'FUNKY Slot',
  'constants.gameSlot1_YESBINGO': 'YESBINGO',
  'constants.gameSlot1_SPRIBE': 'SPRIBE',
  'constants.gameSlot1_BNG': 'BNG',
  'constants.gameSlot1_NEWAG': 'NEWAG',
  'constants.gameSlot1_AG': 'AG',
  'constants.gameSlot1_WG': 'WG',
  'constants.gameSlot1_SPB': 'Spribe 街机',

  'constants.gameSlot1_OBDZ': 'OBDZ Slot',
  'constants.gameSlot1_FCSLOT':'FC Slot',
  'constants.gameSlot1_SEA':'SEA',
  'constants.gameSlot1_PHPSG': 'SG',
  'constants.vipValidType_0': 'Vĩnh viễn',
  'constants.vipValidType_1': 'Có hiệu lực ngay, 30 ngày',
  'constants.vipValidType_3': 'Có hiệu lực ngay lập tức, 365 ngày',
  'constants.vipValidType_5': 'Có hiệu lực ngay, 60 ngày.',
  'constants.vipValidType_6': 'Có hiệu lực ngay, 90 ngày.',
  'constants.status_0': 'Vô hiệu hóa',
  'constants.status_1': 'Đã kích hoạt',
  'constants.bonusType_1': 'Tiền nạp ưu đãi',
  'constants.bonusType_2': 'Đơn ưu đãi',
  'constants.bonusType_3': 'Luôn luôn hoàn tiền ưu đãi',
  'constants.bonusType_4': 'Ưu đãi đăng nhập',
  'constants.bonusType_5': 'Thủ công phê duyệt ưu đãi',
  'constants.bonusType_6': 'Ưu đãi tiền nạp liên tiếp',
  'constants.bonusType_7': 'Ưu đãi đăng ký',
  'constants.bonusType_8': 'Ưu đãi kênh nạp tiền',
  'constants.bonusType_9': 'Lời mời ưu đãi',
  'constants.bonusType_10': 'Ưu đãi đặt cược',
  'constants.bonusType_11': 'Ưu đãi doanh thu',
  'constants.bonusType_12': 'Ưu đãi nạp tiền hiện tại',
  'constants.bonusType_13': 'Ưu đãi liên kết thông tin',
  'constants.bonusType_14': 'Ưu đãi xuất chi',
  'constants.bonusType_15': 'Ưu đãi khi điểm danh',
  'constants.bonusType_16': 'Ưu đãi tiền gửi liên tục',
  'constants.bonusType_17': 'Ưu đãi cấp độ đặt cược',
  'constants.bonusType_19': 'Ưu đãi nhiệm vụ hằng ngày',
  'constants.bonusType_24': 'Mới Luôn luôn hoàn tiền ưu đãi',// 新邀请优惠
  'constants.bonusType_26': 'Mật khẩu màu đỏ',
  'constants.bonusType_28': 'Ưu đãi rút tiền đầu tiên',
  'constants.bonusType_30': 'Bàn xoay cung cấp',
  'constants.bonusType_31': 'Tiết kiệm và đầu tư tích lũy',
  'constants.bonusType_32': 'Trò chơi lưu bút',
  'constants.bonusType_33': 'Cung cấp kênh rút tiền',
  'constants.bonusType_34': 'Giảm giá tiền gửi bảy ngày',
  'constants.bonusType_38': 'Giảm giá trang nạp tiền',
  'constants.newBonusType_1': 'Tiền nạp ưu đãi',
  'constants.newBonusType_2': 'Đơn ưu đãi',
  'constants.newBonusType_3': 'Luôn luôn hoàn tiền ưu đãi',
  'constants.newBonusType_5': 'Thủ công phê duyệt ưu đãi',
  'constants.newBonusType_7': 'Ưu đãi đăng ký',
  'constants.newBonusType_8': 'Ưu đãi kênh nạp tiền',
  'constants.newBonusType_9': 'Lời mời ưu đãi',
  'constants.newBonusType_10': 'Ưu đãi đặt cược',
  'constants.newBonusType_11': 'Ưu đãi doanh thu',
  'constants.newBonusType_12': 'Ưu đãi nạp tiền hiện tại',
  'constants.newBonusType_13': 'Ưu đãi liên kết thông tin',
  'constants.newBonusType_14': 'Ưu đãi xuất chi',
  'constants.newBonusType_15': 'Ưu đãi khi điểm danh',
  'constants.newBonusType_16': 'Ưu đãi tiền gửi liên tục',
  'constants.newBonusType_19': 'Ưu đãi nhiệm vụ hằng ngày',
  'constants.newBonusType_24': 'Mới Luôn luôn hoàn tiền ưu đãi',// 新邀请优惠
  'constants.newBonusType_26': 'Mật khẩu màu đỏ',
  'constants.newBonusType_30': 'Bàn xoay cung cấp',
  'constants.newBonusType_31': 'Tiết kiệm và đầu tư tích lũy',
  'constants.newBonusType_32': 'Trò chơi lưu bút',
  'constants.newBonusType_33': 'Cung cấp kênh rút tiền',
  'constants.newBonusType_34': 'Giảm giá tiền gửi bảy ngày',
  'constants.newBonusType_38': 'Giảm giá trang nạp tiền',
  'constants.bonusMainType_A': 'Quỹ tích lũy',
  'constants.bonusMainType_B': 'Tiền thưởng khi lên cấp',
  'constants.bonusMainType_C': 'Tiền thưởng đoàn viên',
  'constants.bonusMainType_D': 'Yêu cầu nạp tiền',
  'constants.bonusMainType_0': 'Nhà cái thêm ưu đãi',
  'constants.bonusMainType_1': 'Tiền nạp ưu đãi',
  'constants.bonusMainType_2': 'Đơn ưu đãi',
  'constants.bonusMainType_3': 'Luôn luôn hoàn tiền ưu đãi',
  'constants.bonusMainType_4': 'Ưu đãi đăng nhập',
  'constants.bonusMainType_5': 'Thủ công phê duyệt ưu đãi',
  'constants.bonusMainType_6': 'Ưu đãi tiền gửi liên tục',
  'constants.bonusMainType_7': 'Ưu đãi đăng ký',
  'constants.bonusMainType_8': 'Ưu đãi kênh nạp tiền',
  'constants.bonusMainType_9': 'Lời mời ưu đãi',
  'constants.bonusMainType_10': 'Ưu đãi đặt cược',
  'constants.bonusMainType_11': 'Ưu đãi doanh thu',
  'constants.bonusMainType_12': 'Ưu đãi nạp tiền hiện tại',
  'constants.bonusMainType_13': 'Ưu đãi liên kết thông tin',
  'constants.bonusMainType_14': 'Ưu đãi xuất chi',
  'constants.bonusMainType_15': 'Ưu đãi khi điểm danh',
  'constants.bonusMainType_16': 'Ưu đãi tiền gửi liên tục',
  'constants.bonusMainType_18': 'Trúng thưởng trò chơi',
  'constants.bonusMainType_19': 'Ưu đãi nhiệm vụ hằng ngày',
  'constants.bonusMainType_24': 'Luôn luôn hoàn tiền ưu đãi',//新邀请优惠
  'constants.bonusMainType_26': 'Mật khẩu màu đỏ',
  'constants.bonusMainType_30': 'Bàn xoay cung cấp',
  'constants.bonusMainType_31': 'Tiết kiệm và đầu tư tích lũy',
  'constants.bonusMainType_32': 'Trò chơi lưu bút',
  'constants.bonusMainType_33': 'Cung cấp kênh rút tiền',
  'constants.bonusMainType_34': 'Giảm giá tiền gửi bảy ngày',
  'constants.bonusMainType_38': 'Giảm giá trang nạp tiền',
  'constants.newBonusMainType_A': 'Quỹ tích lũy',
  'constants.newBonusMainType_B': 'Tiền thưởng khi lên cấp',
  'constants.newBonusMainType_C': 'Tiền thưởng đoàn viên',
  'constants.newBonusMainType_0': 'Thêm tiền thưởng bằng tay',
  'constants.newBonusMainType_1': 'Tiền nạp ưu đãi',
  'constants.newBonusMainType_2': 'Đơn ưu đãi',
  'constants.newBonusMainType_3': 'Luôn luôn hoàn tiền ưu đãi',
  'constants.newBonusMainType_5': 'Thủ công phê duyệt ưu đãi',
  'constants.newBonusMainType_7': 'Ưu đãi đăng ký',
  'constants.newBonusMainType_8': 'Ưu đãi kênh nạp tiền',
  'constants.newBonusMainType_9': 'Lời mời ưu đãi',
  'constants.newBonusMainType_10': 'Ưu đãi đặt cược',
  'constants.newBonusMainType_11': 'Ưu đãi doanh thu',
  'constants.newBonusMainType_12': 'Ưu đãi nạp tiền hiện tại',
  'constants.newBonusMainType_13': 'Ưu đãi liên kết thông tin',
  'constants.newBonusMainType_14': 'Ưu đãi xuất chi',
  'constants.newBonusMainType_15': 'Ưu đãi khi điểm danh',
  'constants.newBonusMainType_16': 'Ưu đãi tiền gửi liên tục',
  'constants.newBonusMainType_17': 'Ưu đãi cấp độ đặt cược',
  'constants.newBonusMainType_18': 'Trúng thưởng trò chơi',
  'constants.newBonusMainType_19': 'Ưu đãi nhiệm vụ hằng ngày',
  'constants.newBonusMainType_24': 'Luôn luôn hoàn tiền ưu đãi',// 新邀请优惠
  'constants.newBonusMainType_26': 'Mật khẩu màu đỏ',
  // 'constants.newBonusMainType_21': 'Ưu đãi điểm đăng nhập mới',
  'constants.newBonusMainType_28': 'Ưu đãi rút tiền đầu tiên',
  'constants.newBonusMainType_29': 'phục sinh cung cấp',
  'constants.newBonusMainType_30': 'Bàn xoay cung cấp',
  'constants.newBonusMainType_31': 'Tiết kiệm và đầu tư tích lũy',
  'constants.newBonusMainType_32': 'Trò chơi lưu bút',
  'constants.newBonusMainType_33': 'Cung cấp kênh rút tiền',
  'constants.newBonusMainType_34': 'Giảm giá tiền gửi bảy ngày',
  'constants.newBonusMainType_38': 'Giảm giá trang nạp tiền',

  'constants.bonusStatus_0': 'Đang áp dụng',
  'constants.bonusStatus_1': 'Đang tính toán',
  'constants.bonusStatus_2': 'Đã hoàn thành',
  'constants.bonusStatus_3': 'từ chối',
  'constants.bonusStatus_4': 'Thất bại',
  'constants.bonusStatus_5': 'Chưa nhận thưởng',
  'constants.bonusStatus_6': 'Chưa trúng thưởng',
  'constants.ticketStatus_0': 'Đã gửi',
  'constants.ticketStatus_1': 'Đang xử lý',
  'constants.ticketStatus_2': 'Đã xử lý thành công',
  'constants.bonusConfigStatus_0': 'Đang chỉnh sửa',
  'constants.gameMaintain_0': 'Chưa bảo trì',
  'constants.gameMaintain_1': 'Đang bảo trì',
  'constants.payLevel_0': 'Thành viên cấp 1',
  'constants.payLevel_1': 'Toàn bộ thành viên',
  'constants.payLevel_2': 'Thành viên cấp 2',
  'constants.payLevel_3': 'Thành viên cấp 3',
  'constants.payLevel_4': 'Thành viên cấp 4',
  'constants.payLevel_5': 'Thành viên cấp 5',
  'constants.payLevel_6': 'Thành viên cấp 6',
  'constants.payLevel_7': 'Thành viên cấp 7',
  'constants.payLevel_8': 'Thành viên cấp 8',
  'constants.payLevel_9': 'Thành viên cấp 9',
  'constants.payLevel_10': 'Thành viên cấp 10',
  'constants.logType_ad': 'Quảng cáo',
  'constants.logType_admin': 'Tài khoản người chơi',
  'constants.logType_agent': 'Đại lý',
  'constants.logType_bonus': 'Ưu đãi',
  'constants.logType_button': 'Nút',
  'constants.logType_config': 'Thông số cấu hình hệ thống',
  'constants.logType_custom': 'Thông tin trình tự làm việc',
  'constants.logType_domain': 'Tên miền',
  'constants.logType_platform': 'Trò chơi của nhà cái',
  'constants.logType_ip': 'IP',
  'constants.logType_market': 'Telesale',
  'constants.logType_menu': 'Menu',
  'constants.logType_notify': 'Thông báo',
  'constants.logType_pay': 'Đại lý thanh toán đang xử lý',
  'constants.logType_risk': 'Kiểm soat rủi ro',
  'constants.logType_role': 'Vai trò',
  'constants.logType_withdraw': 'Quyền hạn',
  'constants.logType_user': 'Thành viên',
  'constants.logType_picture': 'Thiết lập hình ảnh',
  'constants.logType_announcement': 'Công bố',
  'constants.logType_login': 'Nhật kí đăng nhập',
  'constants.logType_logout': 'Đăng xuất',
  'constants.agentOtherType_0': 'Hoàn tiền',
  'constants.agentOtherType_1': 'Phí thị trường',
  'constants.sysAdminType_-1': 'Vòng quay may mắn',
  'constants.sysAdminType_-2': 'Vòng quay may mắn',
  'constants.activityType_1': 'Vòng quay may mắn',
  'constants.activityType_2': 'Lắc một lắc',
  'constants.activityType_3': 'Trò chơi tổng hợp',
  'constants.activityType_4': 'Vẽ hộp mù',
  'constants.activityType_5': 'Trò chơi quay tiền mặt',
  'constants.activityChannelType_0': 'Hệ thống thêm',
  'constants.activityChannelType_1': 'Thêm thủ công',
  'constants.activityChannelType_2': 'Giảm bốc thăm',
  'constants.activityChannelType_3': 'Xóa thủ công',
  'constants.prizeType_0': 'Tiền nạp lần đầu',
  'constants.prizeType_1': 'Khác',
  'constants.prizeType_2': 'Không trúng thưởng',
  'constants.prizeType_3': 'Điểm',
  'constants.announcementType_6': 'Công bố',
  'constants.announcementType_7': 'Đề xuất',
  'constants.frontType_0': 'Kết thúc PC',
  'constants.frontType_1': 'Kết thúc di động',
  'constants.frontType_3': 'Toàn bộ nhà cái',
  'constants.siteMsgType_0': 'Vấn đề nạp rút tiền',
  'constants.siteMsgType_1': 'Ưu đãi',
  'constants.siteMsgType_2': 'Vấn đề trò chơi',
  'constants.siteMsgType_3': 'Vấn đề khác',
  'constants.siteMsgType_4': 'Góp ý',
  'constants.siteMsgType_5': 'Khiếu nại',
  'constants.manualType_1': 'Thủ công làm lệnh',
  'constants.manualType_9': 'Thủ công nạp tiền',
  'constants.manualType_10': 'Thủ công rút tiền',

  'constants.gameSlot1_BBIN': 'BBIN',
  'constants.gameSlot1_NEWBBIN': 'BBIN GAME',
  'constants.gameSlot1_PT': 'PT',
  'constants.gameSlot1_NEWPT': 'PT GAME',
  'constants.gameSlot1_MG': 'MG',
  'constants.gameSlot1_HB': 'HB',
  'constants.gameSlot1_JDB': 'JDB',
  'constants.gameSlot1_JDB2': 'JDB2',
  'constants.gameSlot1_DT': 'DT',
  'constants.gameSlot1_VT': 'VT 路虎',
  'constants.gameSlot1_PNG': 'Play\'n GO',
  'constants.gameSlot1_PP': 'PP',
  'constants.gameSlot1_AMEBA': 'AMEBA',
  'constants.gameSlot1_TP': 'TP',
  'constants.gameSlot1_FKJILI': 'FKJILI',
  'constants.gameSlot1_FKJILI1': 'FKJILI1',
  'constants.gameSlot1_FKPG': 'FKPG',
  'constants.gameSlot1_FKPG1': 'FKPG1',
  'constants.gameSlot1_OMGPG': 'OMGPG',
  'constants.gameSlot1_OMGJILI': 'OMGJILI',
  'constants.gameSlot1_OMGPP': 'OMGPP',
  'constants.gameSlot1_JS2PG': 'JS2PG',
  'constants.gameSlot1_GB': 'GB',
  'constants.gameSlot1_YL': 'YL',
  'constants.gameSlot1_PCLASSICG': 'PCLASSICG',
  'constants.gameSlot1_WMDZ': 'WMDZ',
  'constants.gameSlot1_NS': 'NEXTSPIN',
  'constants.gameSlot1_WM': 'WM',
  'constants.gameSlot1_KA': 'KA',
  'constants.gameSlot1_CRG': 'CRG',
  'constants.gameSlot1_FTG': 'FTG',
  'constants.gameSlot1_VA': 'VA',
  'constants.gameSlot1_ASKME': 'ASKME',
  'constants.gameSlot1_OMG': 'OMG',
  'constants.gameSlot1_VNRICH88': 'VNRICH88',
  'constants.gameSlot1_VNRTG': 'VNRTG',
  'constants.gameSlot1_JL': 'JL',
  'constants.gameSlot1_SKYWIND': 'Skywind',
  'constants.gameSlot1_CQ9': 'CQ9',
  'constants.gameSlot1_GNS': 'GNS',
  'constants.gameSlot1_GSS': 'GSS',
  'constants.gameSlot1_AB': '欧博',
  'constants.gameSlot1_REDTIGER': '红虎',
  'constants.gameSlot1_FC': 'FC',
  'constants.gameSlot1_SA': 'SA',
  'constants.gameSlot1_SA2': '新SA',
  'constants.gameSlot1_MG2': 'MG2',
  'constants.gameSlot1_MG3': 'MG3',
  'constants.gameSlot1_NETENT': 'NetEnt',
  'constants.gameSlot1_BETSOFT': 'BetSoft',
  'constants.gameSlot1_PLAYSTAR': 'PLAY STAR GAME',
  'constants.gameSlot1_SG': 'SG GAME',
  'constants.gameSlot1_RTG': 'RTG GAME',
  'constants.gameSlot1_QT': 'QT GAME',
  'constants.gameSlot1_PGSOFT': 'PGSOFT GAME',
  'constants.gameSlot1_LG': 'LG电子',
  'constants.gameSlot1_ISOFTBET': 'IsoFtBet电子',
  'constants.gameSlot1_TOTALEGAME': 'TOTALEGAME电子',

  'constants.nav_0': 'trang chủ',
  'constants.nav_1': 'Người thật',
  'constants.nav_2': 'Thể',
  'constants.nav_3': 'Điện',
  'constants.nav_4': 'Cờ và thẻ',
  'constants.nav_5': 'đánh',
  'constants.nav_6': 'color',
  'constants.nav_7': 'Hộp đêm Diamond',
  'constants.nav_8': 'Giảm',
  'constants.nav_9': 'Phòng ý niệm',
  'constants.nav_10': 'Khác',
  'common.title.resultAmount': 'Lợi tích nhà cái',
  'pay.label.pageAmount': 'Số tiền trên trang này',
  'pay.label.pageUnTotal': 'Số đơn rút tiền khi yêu cầu trên trang này',
  'pay.label.pageRiskSuccess': 'Số đơn rút tiền thông qua yêu cầu rủi ro trên trang này',
  'pay.label.pageSuccess': 'Số đơn rút tiền thành công trên trang này',
  'pay.label.pageRefuse': 'Số đơn rút tiền đã bị từ chối trên trang này',
  'pay.label.amount': 'Tổng số tiền',
  'pay.label.unTotal': 'Tổng số đơn rút tiền khi yêu cầu',
  'pay.label.riskSuccessTotal': 'Tổng số đơn rút tiền được thông qua kiểm tra rủi ro',
  'pay.label.successTotal': 'Tổng số đơn rút tiền thành công',
  'pay.label.refuseTotal': 'Tổng số đơn bị từ chối rút tiền',
  'bet.strAttr1.titleNumber': 'Số bảng',
  'bet.select.gameType': 'Hãy chọn kiểu trò chơi',
  'user.chart.memberCount1': 'Số kì:',
  'user.title.register': 'Bình luận',
  'user.title.memberGroup': 'Member Group',
  'common.chart.orderCount': 'Âm lượng đơn (ngàn nét)',
  'common.chart.orderCount1': 'Khối lượng đơn',
  'common.chart.betOrderCount': 'Số lượng cá cược',
  'common.chart.date': 'ngày',
  'common.chart.date1': 'Hãy chọn ngày',
  'common.chart.percentage': 'Phần',
  'common.chart.user': 'người dùng',
  'common.chart.count': 'Số hiệu',
  'common.chart.amount': 'Số lượng (10000 yuan)',
  'common.chart.amount1': 'Số tiền hiện tại',
  'common.chart.amount3': 'Số lượng (Nhân dân tệ)',
  'common.chart.amount3VN': 'Số lượng (VND)',
  'common.chart.validBet': 'Đặt hiệu quả',
  'common.chart.amount2': 'Mức độ:',
  'finance.title.remark1': 'Hãy ghi chú',
  'finance.title.totalAmount': 'Tổng số tiền',
  'finance.title.totalOrderCount': 'Tổng số đơn',
  'finance.button.call': 'Gọi đi.',
  'finance.export.name': 'Báo cáo lẳng lơ',
  'finance.queryFrm.ManualTransferDate': 'Điều chỉnh giờ đối chiếu',
  'finance.queryFrm.ManualTransferType': 'Loại hình đối chiếu',
  'finance.queryFrm.urmoo': 'Tên người dùng, nhận xét, điều chỉnh tài khoản, số lệnh, tên thứ tự',
  'finance.queryFrm.urmoo2': 'Vui lòng nhập từ khóa nhận xét/điều chỉnh tài khoản',
  'user.title.name': 'Tên đầy đủ',
  'user.title.mobilePhone': 'Tên đầy đủ',
  'user.title.idNo': 'Số chứng minh nhân dân',
  'user.title.regType': 'Đường link đăng ký',
  'user.title.domain': 'Đường link lần trước đăng nhập',
  'user.title.registerTime': 'Ngày đăng ký',
  'user.title.createTime': 'Giờ trực tuyến',
  'user.title.level': 'Cấp｜Cấp độ rủi ro',
  'user.title.totalDeposit': 'Tổng nạp tiền',
  'user.title.totalWithdraw': 'Tổng rút tiền',
  'user.title.totalBonus': 'Tổng ưu đãi',
  'user.title.balance': 'Tổng số dư tài khoản chính',
  'user.description.totalUserNum': ': Số người online',
  'user.description.totalDeposit': 'Tổng nạp của người chơi đang online',
  'user.description.totalWithdraw': 'Tổng số tiền rút của người chơi đang online',
  'user.description.totalBonus': 'Tổng ưu đãi của người chơi đang online',
  'user.description.totalBetFlow': 'Tổng doanh thu của người chơi đang online',
  'user.radio.onlineUserType_-1': 'Không chọn.',
  'user.radio.onlineUserType_1': 'Tổng nạp tiền',
  'user.radio.onlineUserType_2': 'Tổng rút tiền',
  'user.radio.onlineUserType_3': 'Tổng ưu đãi',
  'user.radio.onlineUserType_4': 'Hiện tại',
  'user.select.channelType_1': 'Không chọn.',
  'user.select.channelType_0': 'Tổng nạp tiền',
  'user.select.channelType_4': 'Tổng rút tiền',
  'user.select.channelType_2': 'Tổng ưu đãi',
  'user.select.channelType_3': 'Hiện tại',
  'sys.title.createTime': 'Thời gian thao tác',
  'sys.title.createAdmin': 'Người thao tác',
  'sys.title.beingAdmin': 'Người bị thao tác',
  'sys.title.operatingMsg': 'Hướng dẫn thao tác',
  'sys.title.resultMsg': 'Kết quả hướng dẫn',
  'sys.title.logType': 'Loại hình nhật kí',
  'sys.title.operatingStatus': 'Trạng thái thao tác',
  'sys.title.operatingStatusFail': 'Thất bại',
  'sys.title.operatingStatusSuccess': 'Thành công',
  'bonus.title.newNumber': 'Người chơi mới',
  'bonus.title.oldNumber': 'Người chơi cũ',
  'bonus.title.oldUserRatio': 'Tỷ lệ Người chơi cũ',
  'analyze.card.cumulativeUser': 'Người chơi tích lũy',
  'analyze.card.last7dayActiveUser': 'Người dùng hoạt động trong vòng bảy ngày qua',
  'analyze.card.last30dayActiveUser': 'Người dùng hoạt động trong ba mươi ngày qua',
  'analyze.card.moreWaitting': 'Vui lòng chờ đợi.',
  'analyze.card.cumulativePayingUser': 'Người chơi tính tiền tích lũy',
  'analyze.card.cumulativePaymentAmount': 'Tiền thanh toán tích lũy',
  'analyze.card.paymentRate': 'Tỷ lệ thanh toán',
  'analyze.card.userComposition': 'Cấu thành người chơi',
  'analyze.card.activeUserComposition': 'Cấu thành người chơi',
  'analyze.card.newUsers': 'Người chơi mới',
  'analyze.card.firstDepositUsers': 'Tài khoản nạp lần đầu',
  'analyze.card.withdrawalUsers': 'Người chơi rút tiền',
  'analyze.card.depositUsers': 'Người chơi nạp tiền',
  'analyze.card.depositBet': 'Tổng số người dùng đầu tư',
  'analyze.card.activeUser': 'Hoạt động người chơi',
  'analyze.card.depositUsersDistinct': 'Người chơi nạp tiền(Không lặp lại)',
  'analyze.card.activeUserDistinct': 'Hoạt động người chơi(Không lặp lại)',
  'analyze.card.userRecharge': 'Người chơi nạp tiền',
  'analyze.card.top-upUser': 'Người dùng bộ nạp',
  'analyze.card.depositAmount': 'Số tiền nạp',
  'analyze.card.firstDepositAmount': 'Tiền nạp lần đầu',
  'analyze.card.totalDeposit': 'Tổng nạp tiền',
  'analyze.card.totalWithdrawal': 'Tổng rút tiền',
  'analyze.card.offerDiscount': 'Phân phối ưu đãi',
  'analyze.card.platformFlow': 'Đường ống platform',
  'analyze.card.platformFlow1': 'Doanh thu nhà cái (nhân dân tệ)',
  'analyze.card.platformFlow1VN': 'Doanh thu nhà cái (VND)',
  'analyze.card.betUserCount': 'Số người đặt cược (Dựa vào nhà cái)',
  'analyze.card.betUserCount1': 'Số người đặt cược',
  'analyze.card.orderCount': 'Số lượng đơn cược',
  'finance.title.firstDeposit': 'Nạp tiền lần đầu',
  'finance.title.totalDeposit': 'Tổng nạp tiền',
  'finance.title.totalWithdraw': 'Tổng xuất tiền',
  'finance.title.totalBetflow': 'Tổng doanh thu',
  'finance.title.totalWin': 'Chênh lệch tiền nạp và xuất khoản',
  'finance.title.profitLoss': 'Lợi nhuận',
  'pay.platformName': 'Nhà cái thanh toán',
  'pay.orderAmount': 'Số lượng',
  'pay.orderCount': 'Số lượng',
  'pay.platformNameOrderAmount': 'Phí bảo hiểm',
  'pay.platformNameOrderCount': 'Phí bảo hiểm',
  'pay.title.amountStatistics': 'Thống kê tài khoản giao dịch',
  'pay.title.countStatistics': 'Dữ liệu giao dịch của platform',
  'pay.title.successChannelRate': 'Tỷ lệ thanh toán thành công của mỗi kênh',
  'pay.title.usageRatio': 'Tỷ lệ các giàn tiêu thụ',
  'pay.title.successRatio': 'Phần trăm thanh toán',
  'pay.title.payName': 'Tên nạp bên thứ ba',
  'pay.title.successCount': 'Số lần chạy thành công',
  'pay.title.successAmount': 'Số lần thành công',
  'pay.title.orderCount': 'Tổng số đơn',
  'pay.title.amountSummary': 'Tổng số tiền',
  'pay.title.successRate': 'Tỉ lệ thành công',
  'pay.export.payExcel': 'Báo cáo thành công',
  'pay.label.settlementDate': 'Ngày thanh toán',
  'pay.label.allChannel': 'Mọi kênh',
  'pay.label.allPayType': 'Mọi loại thanh toán',
  'pay.label.payChannel': 'Kênh xuất tiền',
  'pay.label.payChannel1': 'Chọn kênh thanh toán',
  'pay.label.payType': 'Kiểu thanh toán',
  'pay.label.payType1': 'Hãy chọn kiểu thanh toán',
  'pay.label.useLevel': 'Cấp độ sử dụng',
  'pay.label.useLevel1': 'Hãy chọn cấp dụng',
  'pay.label.useLevelAbove': 'Cần phải đạt được cấp độ gì',
  'pay.label.depositMin': 'Số tiền tối thiểu',
  'pay.label.depositMin1': 'Hãy nhập số lượng tối thiểu',
  'pay.label.depositMax': 'Tổng số tiền',
  'pay.label.depositMax1': 'Hãy nhập số lượng tối đa',
  'pay.label.depositAmountNotice': 'Hãy nhập số lượng quy định',
  'pay.label.depositRequest': 'Yêu cầu nạp tiền',
  'pay.label.depositRequest1': 'Hãy nhập vào yêu cầu sạc',
  'pay.label.param': 'tham số',
  'pay.label.orderSort': 'Liệt kê và sắp xếp',
  'pay.label.orderSort1': 'Vui lòng ký vào luật pháp',
  'pay.label.amountType': 'Thể loại tiền',
  'pay.label.amountType1': 'Hãy chọn kiểu lượng',
  'pay.label.exchangeType': 'Vui lòng chọn loại tỷ giá hối đoái',
  'pay.label.amountType_1': 'Nhập số người dùng',
  'pay.label.amountType_2': 'Danh sách số lượng cố định',
  'pay.label.amountType_3': 'Cả hai đều được hỗ trợ',
  'pay.label.fixedAmountList': 'Sắp đặt',
  'pay.label.fixedAmountList1': 'Hãy nhập một số lượng cố định',
  'pay.label.fixedAmountList2': 'Nhập một số lượng cố định của các kí tự lên đến 200',
  'pay.label.fixedAmountList3': 'Hãy nhập một số lượng cố định, và chia nhiều số tiền bằng chữ\',',
  'pay.label.cardNumber': 'Tài khoản ngân hàng',
  'pay.label.cardOwner': 'tên chủ thẻ',
  'pay.label.withdrawalAmount': 'Số tiền rút',
  'pay.label.withdrawalAmount1': 'Số tiền rút',
  'pay.label.withdrawType': 'Phương thức rút tiền',
  'pay.label.withdrawInfo': 'Thông tin Thanh toán',
  'pay.withdraw.apName': 'Alipay name',
  'pay.withdraw.apName_jk4':'GCash name',
  'pay.withdraw.apAccount': 'Số tài khoản Alipay',
  'pay.withdraw.apAccount_jk4':'Số tài khoản GCash',
  'pay.withdraw.usdtPayCount': 'Số lượng thanh toán',
  'pay.withdraw.cardOwner': 'Tên tài khoản',
  'pay.withdraw.bankName': 'Thuộc về ngân hàng',
  'pay.withdraw.bankNumber': 'Số thẻ',
  'pay.label.bankName': 'Tên ngân hàng',
  'pay.label.bankName1': 'Hãy nhập tên ngân hàng',
  'pay.label.bankName2': 'Nhập tới các ký tự tự tự tự 25',
  'pay.label.bankAccount': 'Nợ',
  'pay.label.bankAccount1': 'Xin nhập người nhận.',
  'pay.label.bankAccount2': 'Nhập tới tận 50 kí tự',
  'pay.label.bankAccount3': 'Nhập tới 100 ký tự',
  'pay.label.bankAccount4': 'Nhập vào đầy các ký tự',
  'pay.label.bankAddr': 'Mở tài khoản',
  'pay.label.bankAddr1': 'Xin hãy nhập vào lối ra mở tài khoản.',
  'pay.label.bankNumber': 'Số thẻ ngân hàng',
  'pay.label.bankNumber1': 'Xin hãy nhập số thẻ ngân hàng',
  'pay.label.qrCode': 'Mã QR',
  'pay.label.qrCode1': 'Vui lòng tải mã QR lên',
  'pay.label.payDesc': 'Giới thiệu và mô tả',
  'pay.label.payDesc1': 'Hãy nhập mô tả thư giới thiệu.',
  'pay.label.payDesc3': 'Hãy nhập vào một mô tả đầy đủ 200Rs',
  'pay.label.payViewName': 'Tên tự chọn kênh',
  'pay.label.payViewName1': 'Hãy nhập tên tự chọn',
  'pay.loadConfigInfoFail': 'Lỗi tải thông tin cấu hình thanh to án',
  'pay.loadConfigInfoError': 'Lỗi tải lỗi thông tin cấu hình thanh to án',
  'pay.title.channelName': 'Tên kênh',
  'pay.title.channelName1': 'Hãy nhập tên kênh',
  'pay.title.channelName2': 'Hãy nhập tên kênh riêng của bạn',
  'analyze.title.cumulativeUsers': 'Người dùng tinh thể (tổng người dùng kênh) tổng hợp',
  'pay.title.payCode': 'Số kênh',
  'pay.title.viewName': 'Thể loại kênh',
  'pay.title.remark': 'Tên kênh tùy chỉnh',
  'pay.title.depositMin': 'Số tiền hạn chế',
  'common.agent': 'Comment',
  'common.channel': 'Comment',
  'common.title.agentAccount': 'Tài khoản của đại lý',
  'common.title.agentCode': 'CODE đại lý',
  'agent.h3.channelDistribution': 'Kênh phân phối',
  'finance.title.depositTime': 'Thời gian nạp tiền',
  'finance.title.depositAmount': 'Số tiền nạp',
  'finance.title.depositType': 'Phương thức nạp tiền',
  'finance.title.totalDepositUsers': 'Tổng số thành viên',
  'finance.title.totalDepositAmount': 'Tổng khoản kí gửi (Nhân dân tệ)',
  'finance.title.totalDepositAmountVN': 'Tổng khoản kí gửi (VND)',
  'finance.export.excel': 'Gởi báo cáo.xs',
  'bonus.export.excel': 'Báo cáo',
  'bonus.title.offerTime': 'Thời gian công bố ưu đãi',
  'finance.title.bonusAmount': 'Tiền khuyến mãi',
  'finance.title.bonusName': 'Tên ưu đãi',
  'finance.title.approveAdmin': 'Thêm mới người thao tác thủ công',
  'finance.title.totalUserCount': 'Tổng số người được ưu đãi',
  'finance.title.totalBonusAmount': 'Tổng tiền ưu đãi',
  'game.title.betUsers': 'Người chơi đặt cược',
  'game.title.betOrderCount': 'Lượng đơn đặt cược',
  'game.title.betAmount': 'Tiền đặt cược (Nhân dân tệ)',
  'game.title.betAmountVN': 'Tiền đặt cược (VND)',
  'game.title.playerProfit': 'Lợi nhuận người chơi (Nhân dân tệ)',
  'game.title.playerProfitVN': 'Lợi nhuận người chơi (VND)',
  'game.title.platformProfit': 'Lợi nhuận của nhà cái (Nhân dân tệ)',
  'game.title.platformProfitVN': 'Lợi nhuận của nhà cái (VND)',
  'game.title.platformProfitLose': 'Nhà cái thắng lời,lỗ',
  'user.title.pageBetOrderCount': 'Tổng số đơn đặt cược trên trang này',
  'user.title.pageBetAmount': 'Tổng tiền đặt cược trên trang này',
  'user.title.pagePlayerResultAmount': 'Tổng người chơi thắng thua trên trang này',
  'user.title.pageBetflow': 'Dòng chảy trong trang này',
  'user.title.totalOrderCount': 'Tổng số đơn đặt cược',
  'user.title.totalResultAmount': 'Tổng người chơi thắng thua',
  'pay.title.pageOrderAmount': 'Số tiền của đơn tại trang này',
  'pay.title.pagePaidOrders': 'Tổng số đơn thanh toán tại trang này',
  'pay.title.pageUnpaidOrders': 'Số đơn chưa thanh toán trên trang này',
  'pay.title.pageExpiredOrders': 'Tổng số đơn đã quá hạn trên trang này',
  'pay.title.totalOrderAmount': 'Tổng số đơn',
  'pay.title.totalPaidOrders': 'Tổng số đơn thanh toán tại trang này',
  'pay.title.totalUnpaidOrders': 'Tổng số đơn chưa thanh toán',
  'pay.title.totalExpiredOrders': 'Tổng số đơn đã quá hạn',
  'game.title.pageBetUserCount': 'Số người chơi đặt cược trên trang này',
  'game.title.pageBetOrderCount': 'Lượng đơn đặt cược trên trang này',
  'game.title.pageBetAmount': 'Số tiền cược trên trang này (Nhân dân tệ)',
  'game.title.pageBetAmountVN': 'Số tiền cược trên trang này (VND)',
  'game.title.pagePlatformProfit': 'Lợi nhuận của nhà cái trên trang này (Nhân dân tệ)',
  'game.title.pagePlatformProfitVN': 'Lợi nhuận của nhà cái trên trang này (VND)',
  'game.title.totalUserCount': 'Tổng số người chơi đặt cược',
  'game.title.totalOrderCount': 'Tổng đơn đặt cược',
  'game.title.totalBetAmount': 'Tổng cược (Nhân dân tệ)',
  'game.title.totalBetAmountVN': 'Tổng cược (VND)',
  'game.title.totalBetAmount1': 'Tổng số tiền đặt cược',
  'game.title.totalPlayerResultAmount11': 'Tổng người chơi thắng thua',
  'game.title.totalPlatformProfit': 'Tổng lợi nhuận của nhà cái (Nhân dân tệ)',
  'game.title.totalPlatformProfitVN': 'Tổng lợi nhuận của nhà cái (VND)',
  'game.title.totalPlayerResultAmount': 'Người chơi thắng hay thua',
  'game.title.totalPlayerResultAmount1': 'Người chơi thắng hay thua',
  'finance.title.pageDepositCount': 'Tổng số lần nạp trên trang này',
  'finance.title.pageDepositAmount': 'Tổng số lần nạp tiền trên trang này',
  'finance.title.pageFirstAmount': 'Lần nạp đầu tiên trên trang này',
  'finance.title.totalDepositProfit': 'Tổng số lần nạp',
  'finance.title.totalDepositAmount2': 'Tổng số tiền nạp (Nhân dân tệ)',
  'finance.title.totalDepositAmount2VN': 'Tổng số tiền nạp (VND)',
  'finance.title.totalFirstDepositAmount': 'Tổng tiền nạp đầu tiên (Nhân dân tệ)',
  'finance.title.totalFirstDepositAmountVN': 'Tổng tiền nạp đầu tiên (VND)',
  'game.export.platformExcel': 'Game platform report.xlsx',
  'game.title.platformName': 'Tên nhà cái',
  'game.title.platformName1': 'Hãy nhập tên platform',
  'common.title.dataDetail': 'Chi tiết',
  'finance.title.withdrawalTime': 'Thời gian trả lời',
  'finance.title.withdrawalAmount': 'Số tiền được rút',
  'finance.title.withdrawalType': 'Phương thức rút tiền',
  'finance.title.withdrawalType2': 'Phương thức rút tiền',
  'finance.title.totalWithdrawUsers': 'Tổng rút lui',
  'finance.title.totalWithdrawAmount': 'Tổng thu hồi',
  'finance.export.withdrawalExcel': 'Rút lui',
  'finance.export.userDepositExcel': 'Báo cáo nạp đầy người dùng.xs',
  'user.export.userGameExcel': 'Báo cáo Trò chơi.xlsx',
  'activity.export.excel': 'Kỷ lục xổ số trò chơi mini.xls',
  'common.title.type': 'Thể loại',
  'common.title.type1': 'Xác thực tên thật',
  'common.title.type2': 'SMSComment',
  'common.title.type3': 'Có tên thật không',


  'msg.title.certificationTime': 'Thời gian xác thực',
  'msg.title.period': 'Thắng,thua trong tháng',
  'game.title.gameName': 'Tên trò chơi',
  'bet.title.betFlowId': 'Số doanh thu',
  'bet.title.rawData': 'Dữ liệu thô (thời gian trình nền trò chơi)',
  'finance.title.depositCount': 'Số lần nạp',
  'finance.title.totalDepositAmount1': 'Tổng số tiền nạp',
  'finance.title.firstDepositTime': 'Thời gian nạp lần đầu',
  'finance.title.lastDepositTime': 'Thời gian nạp tiền lần cuối',
  'finance.text.addBlacklist': 'Danh sách đen mới',
  'finance.title.disablePaymentChannels': 'Vô hiệu hóa các kênh thanh toán',
  'finance.label.selectDisablePaymentChannels': 'Chọn cách vô hiệu hóa kênh thanh toán',
  'user.title.lastLoginTime': 'Thời gian lần cuối đăng nhập',
  'user.title.userLevel': 'Cấp độ người chơi',
  'user.title.riskLevel': 'Mức rủi ro',
  'user.title.registerIP': 'Đăng ký IP',
  'user.title.registerAddress': 'Địa chỉ đăng nhập',
  'user.title.registerType': 'Kiểu đăng ký',
  'analyze.title.statisticalDate': 'Thời gian thống kê',
  'user.title.betOrderCount': 'Số điểm cá cược',
  'user.title.betAmount': 'Tiền đặt cược',
  'user.title.dataOverview': 'Tổng quát dữ liệu',
  'user.title.displayNumber': 'Hiển thị số',
  'sys.title.exportName': 'Tên',
  'sys.title.exportName1': 'Hãy nhập tên đúng',
  'sys.title.nodeNumber': 'Số hiệu',
  'sys.title.exportStatus': 'Trạng thái xuất',
  'sys.title.exportStatus0': 'Chờ xuất khẩu',
  'sys.title.exportStatus1': 'Đã hoàn thành',
  'sys.title.exportStatus2': 'Thất bại',
  'sys.title.exportStatus3': 'Đang tải xuống',
  'sys.title.exportStatus4': 'Tải quá hạn',
  'sys.title.finishTime': 'Thời gian hoàn thành',
  'sys.title.nameAndNumber': 'Tên/ số',
  'sys.title.confirmDelete': 'xác nhận xoá',
  'sys.title.deletePicGroup': 'Sắp xoá bộ cấu hình nhóm ảnh：{imgCode}',
  'sys.title.deleteButton': 'Nút cần xoá：{btnName}',
  'sys.title.deleteConfig': 'Cấu hình sẽ bị xóa: {configKey}',
  'sys.title.deleteMenuName': 'Menu sẽ bị xóa: {menuName}',
  'sys.title.deleteNotifyName': 'Loại thông báo sẽ bị xóa: {notifyName}',
  'sys.title.deleteBeforeDisable': 'Để tránh lỗi, hãy tắt trước khi xóa!',
  'sys.title.addGroupConfig': 'Thêm cấu hình nhóm',
  'sys.title.repeatGroup': 'Thêm cấu hình nhóm',
  'sys.title.imgCode': 'Mã nhóm ảnh',
  'sys.title.imgCode1': 'Mã nhóm ảnh:',
  'sys.title.imgCode2': 'Hãy nhập mã nhóm ảnh',
  'sys.title.imgName': 'Tên nhóm ảnh',
  'sys.title.imgName1': 'Tên nhóm ảnh:',
  'sys.title.imgName2': 'Hãy nhập tên nhóm ảnh',
  'sys.title.remark': 'miêu tả',
  'sys.title.remark1': 'Tên:',
  'sys.title.remark2': 'Kiểu chụp',
  'sys.title.maxAmount': 'Số ảnh tối đa có thể tải lên',
  'sys.title.maxAmount1': 'Số ảnh tối đa có thể tải lên:',
  'sys.title.maxAmount2': 'Số ảnh tối đa có thể tải lên',
  'user.title.submit': 'Có nộp chưa',
  'user.title.confirmSubmit': 'Hãy kiểm tra xem thông tin có đúng không và gửi cẩn thận',
  'user.title.notSamePass': 'Mật khẩu bất ổn, xin xác nhận',
  'user.title.wrongPassNotice': 'Chỉ có thể khởi động chữ cái dưới chữ cái, chỉ chứa chữ cái dưới chữ cái và con số',
  'user.title.existUser': 'Người dùng đã có',
  'user.title.addBackAccount': 'Thêm tài khoản nền',
  'user.title.minUserNameLength': 'Hãy nhập tên người dùng với ít hơn sáu ký tự',
  'user.title.maxUserNameLength': 'Hãy nhập tên người dùng của các ký tự đến đường 25',
  'user.title.userNameLengthLimit': 'Hãy nhập tên người dùng, 6-25 ký tự',
  'user.title.name1': 'Hãy nhập tên',
  'user.title.name2': 'Hãy nhập tên đúng',
  'user.title.pass': 'Mật khẩu',
  'user.title.pass1': 'Hãy nhập mật khẩu đăng nhập và để trống nó.',
  'user.title.pass2': 'Nhập mật khẩu đi.',
  'user.title.pass3': 'Hãy nhập mật khẩu để đăng nhập',
  'user.title.pass4': 'Xác nhận mật khẩu',
  'user.title.pass5': 'Hãy nhập lại mật khẩu đăng nhập',
  'user.title.pass6': 'Xin hãy xác nhận mật khẩu.',
  'user.title.mail': 'Hộp thư',
  'user.title.mail1': 'Hãy nhập email đúng',
  'user.title.mail2': 'Hãy nhập email',
  'user.title.phone': 'Điện thoại di động',
  'user.title.phone1': 'Hãy nhập số điện thoại đúng',
  'user.title.phone2': 'Xin hãy nhập số điện thoại.',
  'user.title.role': 'vai',
  'user.title.role1': 'Hãy chọn một vai',
  'user.title.status': 'Trạng thái',
  'user.title.status1': 'Hãy chọn trạng thái',
  'user.title.goBack': 'Trở về!',
  'user.title.submit1': 'Xác nhận',
  'user.title.name3': 'Tên',
  'user.title.isOnline': 'Trên mạng?',
  'user.title.online': 'Online',
  'user.title.offline': 'Offline',
  'user.title.forceOffline': 'Offline',
  'sys.button.cleanCache': 'Xoá bộ nhớ tạm',
  'user.button.addAccount': 'Thêm tài khoản',
  'user.button.addButton': 'nút thêm',
  'user.button.addConfig': 'Thêm cấu hình',
  'sys.button.addLeafMenu': 'Thêm phụ',
  'sys.button.addParam': 'Thêm tham số',
  'sys.button.addTopMenu': 'Thêm thực đơn trên',
  'sys.button.addNotifyType': 'Thêm kiểu thông báo',
  'sys.button.addExternalChain': 'Thêm liên kết thanh toán',
  'user.disableNotice': 'Anh có chắc muốn tắt tài khoản nền này không?',
  'user.enableNotice': 'Bạn có chắc muốn bật tài khoản nền?',
  'user.title.confirmNotice': 'Lệnh xác nhận',
  'user.offlineUserAccountNotice': 'Anh có chắc muốn tắt tài khoản nền không?',
  'sys.title.fillButtonInfo': 'Điền thông tin vào nút',
  'sys.title.fillRejectReason': 'Điền đầy lý do từ chối',
  'sys.title.fillMenuInfo': 'Điền thông tin thực đơn',
  'sys.title.fillInfo': 'Điền thông tin vào',
  'sys.title.fillPayChannelInfo': 'Điền thông số kênh thanh toán',
  'sys.title.fillNoticeTypeInfo': 'Điền thông tin kiểu thông báo',
  'sys.title.fillOnlinePayInfo': 'Điền thông tin thanh toán trực tuyến',
  'sys.title.fillOffLinePayChannelInfo': 'Điền thông tin kênh thanh toán ngoại tuyến',
  'sys.title.groupName': 'Tên nhóm',
  'sys.title.groupName1': 'Hãy nhập tên nhóm',
  'sys.title.groupName2': 'Hãy nhập tên nhóm với ít hơn 20',
  'sys.title.buttonName': 'Tên nút',
  'sys.title.buttonName1': 'Hãy nhập tên cái nút',
  'sys.title.buttonName2': 'Hãy nhập tên một cái nút ít hơn 20',
  'sys.title.buttonNumber': 'Số nút',
  'sys.title.buttonNumber1': 'Hãy nhập số cái nút',
  'sys.title.buttonNumber2': 'Hãy nhập một số nút ít hơn 100 ký tự',
  'sys.title.buttonDes': 'Mô tả nút',
  'sys.title.buttonDes1': 'Hãy nhập vào mô tả cái nút',
  'sys.title.buttonDes2': 'Hãy nhập vào mô tả nút có ít hơn 1000ký tự',
  'sys.title.groupNameAndNumber': 'Tên nhóm/ số',
  'sys.title.buttonAndLink': 'Tên nút',
  'sys.title.configNameValueGroup': 'Tên cấu hình / Tiền khuyến mãi/ nhóm',
  'sys.title.belongUserGroup': 'Nhóm người dùng',
  'sys.title.userGroup': 'Nhóm người dùng',
  'sys.title.adminGroup': 'Nhóm quản lý',
  'sys.title.userGroup1': 'Hãy chọn nhóm người dùng',
  'sys.title.configGroup': 'Nhóm cấu hình',
  'sys.title.configGroup1': 'Hãy nhập nhóm cấu hình',
  'sys.title.group': 'nhóm',
  'sys.title.group1': 'Nhập nhóm',
  'sys.title.limitLength20': 'Hãy nhập ít hơn 20 kí tự',
  'sys.title.limitLength50': 'Hãy nhập ít hơn 50 kí tự',
  'sys.title.limitLength100': 'Hãy nhập ít hơn 100ký tự',
  'sys.title.limitLength1000': 'Hãy nhập ít hơn 1000ký tự',
  'sys.title.keyNotice': 'Nhập phím:',
  'sys.title.value': 'giá',
  'sys.title.valueNotice': 'Nhập giá trị.',
  'sys.title.sort': 'Thứ',
  'sys.title.sortNotice': 'Làm ơn xuất thứ tự',
  'sys.title.fillMenuInfoNotice': 'Số trình đơn phải là liên kết cuối cùng',
  'sys.title.hierarchical': 'Thư mục trình đơn',
  'sys.title.hierarchical1': 'Menu cấp {menuLevel}',
  'sys.title.topMenu': 'Trên thực đơn',
  'sys.title.leafMenu': 'Trình đơn Lea',
  'sys.title.leafMenu1': 'Trình đơn Lea',
  'sys.title.menuName': 'Tên trình đơn',
  'sys.title.menuName1': 'Hãy nhập tên thực đơn',
  'sys.title.menuName2': 'Hãy nhập tên thực đơn với ít hơn 20',
  'sys.title.menuLevel': 'Trình đơn',
  'sys.title.menuLevel1': 'Hãy chọn trình đơn',
  'sys.title.menuLevel_1': 'Trình đơn hạng nhất',
  'sys.title.menuLevel_2': 'Trình đơn hai cấp',
  'sys.title.menuLevel_3': 'Ba cấp',
  'sys.title.menuType': 'Kiểu trình đơn',
  'sys.title.menuType1': 'Có phải là thực đơn lá',
  'sys.title.menuOrder': 'Trình đơn',
  'sys.title.menuOrder1': 'Hãy nhập đơn vị',
  'sys.title.menuLink': 'Đường dẫn trình đơn',
  'sys.title.menuLink1': 'Hãy nhập số thực đơn cho việc chắp nối',
  'sys.title.menuLink2': 'Hãy nhập tên giá trị của thực đơn',
  'sys.title.menuLink3': '"\'\'con\' khởi động\'Liên kết trên\'\'con\' số thực đơn trong trình đơn',
  'sys.title.menuCode': 'Số trình đơn',
  'sys.title.menuCode1': 'Hãy nhập số thực đơn, chữ cái, số thập phân.',
  'sys.title.menuCode2': 'Hãy nhập tên giá trị của thực đơn',
  'sys.title.menuCode3': 'Cấu hình liên kết: số thực đơn phụ',
  'sys.title.menuIcon': 'Biểu tượng trình đơn',
  'sys.title.menuIcon1': 'Hãy nhập biểu tượng của thực đơn với ít hơn 20',
  'sys.title.menuIcon2': 'Hãy nhập vào biểu tượng thực đơn. Trình đơn cấp đầu không cần phải là',
  'sys.title.reviewIcon': 'Xem thử biểu tượng',
  'sys.title.menuGroup': 'Nhóm trình đơn',
  'sys.title.menuNameAndLink': 'Tên trình đơn',
  'msg.title.notifyName': 'Tên thông báo',
  'msg.title.notifyName1': 'Hãy nhập tên kiểu thông báo',
  'msg.title.notifyName2': 'Hãy nhập tên kiểu thông báo dưới người 20',
  'msg.title.notifyCode': 'Số thông báo',
  'msg.title.notifyCode1': 'Hãy nhập số kiểu thông báo cho đường nối',
  'msg.title.notifyCode2': 'Hãy nhập một số kiểu thông báo dưới các ký tự 100',
  'msg.title.notifyCode3': 'Cấu hình liên kết: kiểu thông báo cấp cao.',
  'msg.title.notifyDesc': 'Mô tả Thông báo',
  'msg.title.notifyDesc1': 'Hãy nhập vào mô tả kiểu thông báo ít hơn 20',
  'msg.title.notifyDesc2': 'Hãy nhập vào mô tả kiểu thông báo.',
  'msg.title.notifyNameAndLink': 'Tên kiểu thông báo/ liên kết',
  'msg.title.notifyNameR': 'Tên thông báo',
  'msg.title.notifyCodeR': 'Số thông báo',
  'sys.title.updateDesc': 'Ghi chú phát hành:',
  'sys.title.updateDesc1': 'Không nên vượt quá 5 dòng, với 15 ký tự (bao gồm cả ký tự) trên mỗi dòng',
  'agent.title.confirmOffer': 'Xác nhận thanh toán',
  'agent.title.confirmOffer1': 'Xin xác nhận nếu có trả lương?',
  'agent.title.confirmReject': 'Xác nhận chối',
  'agent.title.confirmReject1': 'Xin hãy xác nhận nếu từ chối phát hành?',
  'agent.title.confirmCumulative': 'Xác nhận sự kế toán',
  'agent.title.confirmCumulative1': 'Xin hãy xác nhận liệu thỏa thuận của Ủy ban có tích lũy cho đến tháng sau không?',
  'agent.title.settlementDate': 'Ngày thanh toán',
  'agent.title.monthlyProfitLoss': 'Lời lỗ hàng tháng',
  'agent.title.bonusAmount': 'Số tiền thưởng',
  'agent.title.depositWithdrawalFee': 'Phí dịch vụ đặt cọc và rút lui',
  'agent.title.depositWithdrawAndFee':'Tiền nạp và rút cùng phí dich vụ',
  'agent.title.deposit':'Gửi tiền',
  'agent.title.withdraw':'Rút tiền',
  'agent.title.transFee':'Phí xử lý',
  'agent.title.netProfit': 'Lợi tức',
  'agent.title.earningCommission': 'Tiền hoa hồng có được',
  'agent.title.commissionStatus1': 'Đang yêu cầu 1(rủi ro)',
  'agent.title.commissionStatus2': 'Đang yêu cầu 2(tài chính)',
  'agent.title.commissionStatus3': 'Ủy ban phân',
  'agent.title.commissionStatus4': 'Từ chối trợ cấp',
  'agent.title.commissionStatus5': 'Tích lũy mỗi tháng',
  'agent.title.offerCommission': 'Ủy ban',
  'agent.title.reject': 'Từ chối',
  'agent.title.marketCost': 'Giá thị trường',
  'agent.title.refundFee': 'Phí bồi thường',
  'agent.title.taxDeduction': 'Thuế thu nhập',
  'agent.title.lowerLevel': 'Đổ cấp dưới',
  'agent.title.alreadyOffer': 'Đã phát hành',
  'sys.upload.success': 'Tập tin đã tải',
  'sys.upload.fail': 'Lỗi tải tập tin. Hãy xoá và tải tập tin lên lần nữa.',
  'sys.upload.deleteSuccess': 'Xoá thành công.',
  'sys.upload.picture': 'Tải ảnh lên.',
  'sys.lengthLimit': 'Nhập vào các kí tự 300',
  'sys.input': 'Xin nhập',
  'pay.offline': 'Tiền ngoài lề',
  'pay.online': 'Kênh Comment',
  'pay.title.payTypeInfo': 'Thông tin chi tiêu',
  'sys.title.parentCode': 'Nhóm đóng vai',
  'sys.title.parentCode1': 'Hãy chọn nhóm liên kết',
  'sys.title.forwardUrl': 'Cột nhảy',
  'sys.title.forwardUrl1': 'Hãy nhập vào link nhảy',
  'sys.title.forwardUrl2': 'Hãy nhập một liên kết nhảy hợp lệ',
  'sys.title.background': 'Màu nền',
  'sys.title.background1': 'Hãy nhập vào màu nền',
  'sys.title.background2': 'Hãy nhập vào màu nền thứ tự',
  'sys.title.background3': 'Thư định: màu xanh\'954; 0ae/ xanh\'954; 22ac38/ màu xanh đen\'9552; 4a 79d6/ vàng\'21-56; d56; d57; d56',
  'sys.title.imgPC': 'Biểu tượng (PC)',
  'sys.title.imgMobile': 'Biểu tượng (H5)',
  'sys.title.img1': 'Vui lòng tải lên biểu tượng',
  'sys.title.img2': 'Đề nghị: độ rộng không giới hạn, độ cao 40pk, định dạng png',
  'pay.title.insideName': 'tên nội bộ',
  'pay.title.payViewName': 'Ứng dụng điện thoại của người chơi',
  'pay.title.groupLevel': 'Cấp độ phận nhóm',
  'pay.title.sort': 'Sắp xếp theo thứ tự',
  'pay.title.recommendDesc': 'Kiểu: đề nghị',
  'pay.title.externalChain': 'Trả công vòng ngoài',
  'pay.title.builtGrouping': 'Phân nhóm nội bộ',
  'pay.title.builtGrouping1': 'Phân nhóm nội bộ: {payDesc}',
  'pay.title.img': 'Biểu tượng',
  'pay.title.attributes': 'Thuộc tính',
  'pay.title.attributes1': 'Hiển thị',
  'pay.title.attributes2': 'Ẩn',
  'pay.title.attributes3': 'Giới thiệu',
  'pay.title.edit': 'Sửa đổi',
  'pay.title.confirmOrder': 'Lệnh xác nhận',
  'pay.title.confirmOrder1': 'Xin kiểm tra xem nó đã đến chưa?',
  'sys.title.loadingCallBtnFail': 'Lỗi tải nút cuộc gọi',
  'sys.title.callSuccess': 'Quay thành công',
  'sys.title.callError': 'Lỗi thoại',
  'sys.title.callError1': 'Gọi giờ ra ngoài, đợi đã.',
  'sys.title.orderNo': 'Số Thứ Tự',
  'sys.title.thirdPlatform': 'Người thứ ba',
  'sys.title.userAccount': 'Người chơi',
  'sys.title.payName': 'Nhà cái thanh toán',
  'sys.title.payerName': 'Thông tin nạp tiền',
  'sys.title.withdrawalInfo': 'Thông tin rút lui',
  'sys.title.bankName': 'Thông tin nhận tiền',
  'sys.title.orderAmount': 'Số tiền hiện tại',
  'sys.title.orderAmount1': 'Nạp tiền thành công',
  'sys.title.orderAmount0': 'Chưa thanh toán',
  'sys.title.orderAmount2': 'Đã quá hạn',
  'sys.title.create': 'Thời gian tạo/ sửa đổi',
  'sys.title.update': 'Thời hạn xử lý/nhân viên',
  'sys.title.dealTime': 'Thời hạn xử lý/nhân viên',
  'sys.title.dealAdmin': 'Nhân viên xử lý',
  'sys.title.applyTime': 'Thời gian yêu cầu',
  'finance.export.depositOfflineExcel': 'Báo cáo nạp lệnh',
  'finance.export.depositOnlineExcel': 'Báo cáo nạp lệnh',
  'pay.input.orderUserAccountPlatform': 'Số Thứ tự, tên người dùng, trình duyệt',
  'sys.title.checkPaymentPercent': 'Xem tỷ lệ thành công',
  'sys.title.orderStatus': 'Trật tự',
  'sys.title.dataType': 'Kiểu dữ liệu',
  'sys.title.dataType0': 'Người chơi tải xuống',
  'sys.title.dataType1': 'Tổng kết',
  'sys.title.dataType2': 'Tóm tắt kênh',
  'pay.title.deviceSource': 'Nguồn đơn',
  'pay.title.deviceSource1': 'Kết nối máy tính',
  'pay.title.deviceSource2': 'Dịch vụ mạngName',
  'pay.title.deviceSource3': 'ứng dụng khách android',
  'pay.title.deviceSource4': 'Máy khách iOS',
  'finance.export.orderDepositExcel': 'Báo cáo nạp năng lượng',
  'finance.export.orderWithdrawalExcel': 'Thu hồi lệnh',
  'pay.title.confirmReason': 'Lý do xác nhận',
  'pay.title.confirmReason1': 'Hãy nhập lí do xác nhận',
  'pay.title.confirmUnlock': 'Xác nhận mở',
  'pay.title.confirmUnlock1': 'Xác nhận mở khoá yêu cầu',
  'pay.title.rejectInfo': 'Thông tin từ chối',
  'pay.title.confirmWithdrawal': 'Xác nhận rút lui',
  'pay.title.confirmWithdrawal1': 'Bạn có đồng ý rút tiền với {name} không?',
  'pay.title.wrongSplitAmount': 'Lỗi tài khoản tách',
  'pay.title.wrongSplitAmount2': 'Số tiền được chia không được lớn hơn tổng số tiền',
  'pay.title.splitOrder': 'Bạn có chắc chắn đặt hàng vào các đơn đặt hàng {length} không?',
  'pay.title.success': 'Thành công',
  'pay.title.success1': 'Anh có chắc là sẽ rút vào tài khoản không?',
  'pay.title.fail': 'Thất bại',
  'pay.title.fail1': 'Anh có chắc là rút tiền không?',
  'pay.title.withdrawalOrder': 'Số đơn rút tiền',
  'pay.title.windControlAudit': 'Quản lý rủi ro',
  'pay.title.paymentReview': 'Yêu cầu xuất khoản',
  'pay.title.requestWithdrawalTime': 'Thời gian yêu cầu rút tiền',
  'pay.title.paymentMethod': 'Phương pháp xuất tiền',
  'pay.title.splitOrder1': 'Thời gian tạo/ xử lý',
  'pay.title.splitMasterOrder': 'Chia ra lệnh chính',
  'pay.title.splitMolecularOrder': 'Thời gian tạo/ xử lý',
  'pay.title.molecularTransNo': 'Số thứ tự phụ: (không có)',
  'pay.title.masterTransNo': 'Số đơn đặt hàng chính: {transNo}',
  'pay.title.refuseWithdrawCash': 'Từ chối rút tiền',
  'pay.title.confirmPayment': 'Xác nhận thanh toán',
  'pay.title.payForMoney': 'Gởi chi phí',
  'pay.title.unlock': 'Kích hoạt',
  'pay.title.denialReason': 'Nguyên nhân từ chối',
  'pay.title.withdrawalStatus2': 'Từ khoá thành công',
  'pay.title.withdrawalStatus1': 'Đợi thanh toán',
  'pay.title.withdrawalStatus3': 'Đã từ chối',
  'pay.title.withdrawalStatus0': 'Kiểm soát rủi ro cần xem xét',
  'pay.title.withdrawalStatus4': 'Đại lý thanh toán đang xử lý',
  'pay.title.withdrawalStatus5': 'Thiếu lương',
  'pay.title.withdrawalStatus6': 'Khoá giao dịch',
  'pay.title.withdrawalStatus8': 'Phân chia thành công',
  'pay.title.withdrawalStatus_1': 'Để kiểm toán',
  'pay.title.withdrawalStatus_2': 'Từ khoá thành công',
  'pay.title.withdrawalStatus_3': 'Đã từ chối',
  'pay.title.withdrawalStatus_0': 'Đang tiến hành kiểm tra mạo hiểm',
  'pay.title.withdrawalStatus_4': 'Đại lý thanh toán đang xử lý',
  'pay.title.withdrawalStatus_5': 'Thiếu lương',
  'pay.title.choseWithDrawalChannel': 'Chọn kênh thanh toán',
  'pay.title.rate': 'giá',
  'pay.title.eachOrderAmount': 'Mỗi tổng',
  'pay.title.splitAmountConfig': 'Thiết lập khối lượng',
  'pay.title.splitAmount': 'Hãy nhập số lượng đã chia',
  'pay.title.rejectReason': 'Hãy nêu nguyên nhân từ chối',
  'pay.title.withdrawalSuccessTime': 'Thời gian hoàn thành rút tiền',
  'pay.title.withdrawalChannel': 'Kênh xuất tiền',
  'pay.title.SuccessTimeOrFailTime': 'Thành công hay thất bại',
  'pay.title.withdrawalOrderUserAccount': 'Số đơn rút tiền, tên người chơi',
  'login.title.qrcode': 'Xin kiểm tra mã QR',
  'login.install.verify0': 'Kiểu phải sắc',
  'login.install.verify1': 'phiên bản Android',
  'login.install.verify2': 'Phiên bản IOS',
  'login.title.idcard': 'Hãy nhập mật mã xác thực.',
  'login.title.verifyIdcard': 'Xin kiểm tra mã xác thực.',
  'login.title.verificationCode': 'Mật khẩu',
  'login.title.finishVerify': 'Xác nhận mã',
  'lottery.title.userAccount': 'Tài khoản:',
  'lottery.title.complainantType': 'Kiểu khiếu nại',
  'lottery.title.targetId': 'Mục khiếu nại',
  'lottery.title.targetId1': 'Comment',
  'lottery.title.targetId2': 'Bình luận',
  'lottery.title.complainantAndComplainantTime': 'Người khiếu nại/thời gian khiếu nại',
  'lottery.title.complainantDate': 'Ngày khiếu nại',
  'lottery.title.keyword': 'Từ khóa',
  'lottery.title.targetCode': 'Số mục tiêu',
  'lottery.title.read': 'Đọc',
  'lottery.title.open': 'Kích hoạt',
  'lottery.title.close': 'Đóng',
  'lottery.title.dayLimit': 'Giới hạn mỗi ngày',
  'lottery.title.article': 'Trang',
  'lottery.title.ordinaryStickers': 'Bài bình thường',
  'lottery.title.cash': 'Tiền nạp lần đầu',
  'lottery.title.flow': 'Doanh thu',
  'lottery.title.point': 'Điểm thưởng',
  'lottery.title.expertStickers': 'Bài của chuyên gia',
  'lottery.title.greatGodSticker': 'Bài của đại thần!',
  'lottery.title.attention': 'Theo dõi',
  'lottery.title.perPerson': 'Gửi cho mỗi người',
  'lottery.title.person': 'người',
  'lottery.title.comment': 'Bình luận',
  'lottery.title.eachDelivery': 'Mỗi câu gửi',
  'lottery.title.article1': 'Trang',
  'lottery.title.like': 'Lượt thích.',
  'lottery.title.everyTimeSend': 'Mỗi lần gửi',
  'lottery.title.one': 'cá nhân',
  'lottery.title.buyLotterySwitch': 'Công tắc xổ số',
  'lottery.title.handicapTime': 'Thời gian của nhà cái',
  'lottery.title.switchOpen': 'Kích hoạt',
  'lottery.title.closingTime': 'Thời gian kết thúc',
  'lottery.title.inputNumber': 'nhập một số',
  'lottery.title.postReply': 'Đăng/ hồi',
  'lottery.title.post': 'Gửi bài đăng',
  'lottery.title.reply': 'Trả lời',
  'lottery.title.sticker': 'Bài đăng',
  'lottery.title.applyForGod': 'Mời gọi đại thần',
  'lottery.title.recentWinningStreak': 'Gần đây thắng liên tục',
  'lottery.title.inputPeriods': 'Hãy nhập số thời gian',
  'lottery.title.periods': 'Lời lỗ hàng tháng',
  'lottery.title.periods1': 'Số kì',
  'lottery.title.inputPeriods1': 'Hãy chọn số thời gian',
  'lottery.title.periods2': 'Vấn đề {mục}',
  'lottery.title.weekWinRate': 'Tỷ lệ thắng trong tuần',
  'lottery.title.monthWinRate': 'Tỷ lệ thắng trong tháng',
  'lottery.title.addMemberLevel': 'Thêm cấp thành viên',
  'lottery.title.levelName': 'Tên cấp độ',
  'lottery.title.level': 'Cấp độ',
  'lottery.title.addTime': 'Thêm thời gian',
  'lottery.title.addAdmin': 'Thêm người',
  'lottery.title.addBannedMember': 'Thêm thành viên cấm',
  'lottery.title.inputMemberAccount': 'Nhập số tài khoản thành viên',
  'lottery.title.inputMemberAccount1': 'Hãy nhập số tài khoản thành viên. Các tài khoản nhiều cách nhau bằng dấu phẩy.',
  'lottery.title.banCount': 'Gấp',
  'lottery.title.inputBanCount': 'Hãy nhập vào khoảng thời gian',
  'lottery.title.reason': 'IOS(iphone)',
  'lottery.title.inputReason': 'Hãy nhập vào lý do',
  'lottery.title.confirmNotice': 'Lệnh xác nhận',
  'lottery.title.confirmNotice1': 'Anh có chắc là muốn từ chối phần thưởng lệnh không?',
  'lottery.title.confirmNotice2': 'Bạn có chắc muốn xoá thành viên cấm không?',
  'lottery.title.confirmNotice3': 'Bạn có chắc chắn muốn xóa ngày bốc thăm cho {năm}, {tháng} và {ngày} không?',
  'lottery.title.confirmNotice4': 'Bạn có chắc muốn dùng số nguồn làm số giải?',
  'lottery.title.confirmNotice5': 'Bạn có chắc chắn đơn hàng cho {period} trong {năm} đã được thanh toán không?',
  'lottery.title.confirmNotice6': 'Bạn có chắc muốn phân phát phần thưởng lệnh đã chọn?',
  'lottery.title.confirmNotice7': 'Bạn có chắc muốn xoá câu trả lời đã chọn không?',
  'lottery.title.confirmNotice8': 'Bạn có chắc muốn sửa đổi kiểu dáng này không?',
  'lottery.title.confirmNotice9': 'Bạn có chắc muốn xoá thư đã chọn không?',
  'lottery.title.confirmNotice10': 'Bạn có chắc muốn đặt lại mật khẩu điệp viên? Bạn có cần mật khẩu mới để mật khẩu mật khẩu mật khẩu đặc vụ đăng nhập sau khi định vị lại không?',
  'lottery.title.confirmNotice11': 'Ông có chắc là sẽ xóa tỉ lệ của Ủy ban không?',
  'lottery.title.confirmNotice13': 'Thông tin này ảnh hưởng tới tỷ lệ tính toán mặc định của ủy ban. Xin kiểm tra cẩn thận thông tin?',
  'lottery.title.confirmNotice14': 'Thông tin này ảnh hưởng tới tỷ lệ tính toán toàn diện. Xin kiểm tra cẩn thận các thông tin.',
  'lottery.title.confirmNotice15': 'Thông tin này ảnh hưởng tới tỉ lệ tính toán của ủy ban mặc định của đại diện cấp toàn cầu. Xin kiểm tra cẩn thận thông tin?',
  'lottery.title.banTime': 'Thời gian cấm',
  'lottery.title.time': 'Thời gian',
  'lottery.title.timeStart': 'Bắt đầu thời gian đấu',
  'lottery.title.timeEnd': 'Thời gian kết thúc',
  'lottery.title.batchAdd': 'Thêm vào đồng loạt',
  'lottery.title.batchRemove': 'Xóa bỏ đồng loạt',
  'lottery.title.openDate': 'Thời gian mở thưởng',
  'lottery.title.openPeriods': 'Ngày mở thưởng',
  'lottery.title.openNumber': 'Mã xổ số',
  'lottery.title.openLottery1': 'Số tiền thưởng',
  'lottery.title.openLottery2': 'Phát thưởng đã hoàn thành',
  'lottery.title.confirmLotteryOpen': 'Giải thưởng đã kết thúc.',
  'lottery.title.lotteryResult': 'Giải thưởng đã kết thúc.',
  'lottery.title.batchGrant': 'Giải cho bó',
  'lottery.title.orderDate': 'Ngày đặt đơn',
  'lottery.title.officialTime': 'Khách chơi',
  'lottery.title.platfromTime': 'Nhà cái',
  'lottery.title.year': 'năm',
  'lottery.title.inputYear': 'Xin nhập năm',
  'lottery.title.month': 'Tháng',
  'lottery.title.inputMonth': 'Hãy nhập tháng',
  'lottery.title.date': 'ngày',
  'lottery.title.inputDate': 'Hãy nhập ngày',
  'lottery.title.enteringPersonAndTime': 'Người nhập/thời gian nhập',
  'lottery.title.openPersonAndOpenTime': 'Người mở thưởng/Thời gian mở thưởng',
  'lottery.title.addOpenDate': 'Thêm ngày mở thưởng',
  'lottery.title.enteringOpenNumber': 'Nhập mã số mở thưởng',
  'lottery.title.enteringDate': 'Ngày đăng nhập',
  'lottery.title.enteringNumber': 'Nhập mã số',
  'lottery.title.firstBall': 'Bóng thứ nhất',
  'lottery.title.firstBall1': 'Làm ơn đánh mất mục tiêu đầu tiên',
  'lottery.title.secondBall': 'Bóng thứ hai',
  'lottery.title.secondBall1': 'Xin hãy vào bóng thứ hai.',
  'lottery.title.thirdBall': 'Tam bóng',
  'lottery.title.thirdBall1': 'Tam bóng',
  'lottery.title.fourthBall': 'tứ bi',
  'lottery.title.fourthBall1': 'Xin hãy vào vòng thứ tư.',
  'lottery.title.fifthBall': 'Ngũ bi',
  'lottery.title.fifthBall1': 'Hãy nhập vào mục tiêu thứ năm.',
  'lottery.title.sixthBall': 'Vòng sáu',
  'lottery.title.sixthBall1': 'Hãy bước vào mục tiêu thứ sáu.',
  'lottery.title.seventhBall': 'Bảy bi.',
  'lottery.title.seventhBall1': 'Hãy nhập vào mục tiêu thứ bảy.',
  'lottery.title.status1': 'Chờ sử dụng',
  'lottery.title.status2': 'Đã sử dụng',
  'lottery.title.status3': 'Đã cự tuyệt',
  'lottery.title.firstLevelName': 'Tên loại xổ số cấp 1',
  'lottery.title.secondLevelName': 'Tên loại xổ số cấp 2',
  'lottery.title.hongkong': 'Xổ số HongKong',
  'lottery.title.markSix': 'Xổ số lục hợp',
  'lottery.title.playName': 'Bật tên',
  'lottery.title.playName1': 'Xin hãy chọn cách chơi',
  'lottery.title.bonusNumber': 'Mã số trúng thưởng',
  'lottery.title.bonusAmount': 'Số tiền trúng giải',
  'lottery.title.grantAdminAndGrantTime': 'Người phát thưởng/Thời gian mở thưởng',
  'lottery.title.grantDate': 'Thời gian phát thưởng',
  'lottery.title.orderNumber': 'Số Thứ Tự',
  'lottery.title.number': 'Số hiệu',
  'lottery.title.orderTimeAndOpenTime': 'Khoảng thời gian bắt đầu',
  'lottery.title.orderStatus1': 'Chờ đợi thanh toán',
  'lottery.title.orderStatus2': 'Chờ đợi mở thưởng',
  'lottery.title.orderStatus3': 'Điểm thưởng',
  'lottery.title.orderStatus4': 'Đang thanh toán',
  'lottery.title.orderStatus5': 'Đã trúng thưởng',
  'lottery.title.orderStatus6': 'Chưa trúng thưởng',
  'lottery.title.orderStatus7': 'Đơn hàng không đạt',
  'lottery.title.orderStatus8': 'Đơn hủy',
  'lottery.title.betAmount': 'Số kì',
  'lottery.title.eachBetAmount': 'Mỗi ghi chú',
  'lottery.title.totalAmount': 'Tổng số tiền',
  'lottery.title.galleryName': 'Tên thư viện ảnh',
  'lottery.title.isHeat': 'Mức độ náo nhiệt?',
  'lottery.title.isHeat1': 'Náo nhiệt',
  'lottery.title.isHeat0': 'Không náo nhiệt',
  'lottery.title.thumbnail': 'ảnh mẫu',
  'lottery.title.periodsMgt': 'Quản lý giai đoạn hiện tại',
  'lottery.title.isDisplaySort': 'Hiển thị trật tự theo ô xem',
  'lottery.title.ptrr': 'Thích những bước chân / đọc / bình luận',
  'lottery.title.praiseCount': 'Số treo',
  'lottery.title.treadCount': 'Số người bị chà đạp',
  'lottery.title.readCount': 'Đọc số',
  'lottery.title.reviewCount': 'Ghi chú',
  'lottery.title.lookBigPic': 'Xem toàn cảnh',
  'lottery.title.likeCount': 'Lượt thích',
  'lottery.title.content': 'Ghi chú nội dung',
  'lottery.title.content1': 'Hãy ghi chú',
  'lottery.title.UserAccountAndContent': 'Tên người dùng, nội dung',
  'lottery.title.sendPushMsg': 'Gửi đi tin tức giới thiệu',
  'lottery.title.pushPlatform': 'Giới thiệu nhà cái',
  'lottery.title.pushDate': 'Ngày giới thiệu',
  'lottery.title.pushPlatform1': 'Hãy chọn một nền đẩy',
  'lottery.title.android': 'Android',
  'lottery.title.ios': 'IOS(iphone)',
  'lottery.title.title': 'Tiêu đề',
  'lottery.title.title1': 'Xin hãy điền vào tựa đẩy.',
  'lottery.title.title2': 'Hãy nhập vào tựa đề của bài báo',
  'lottery.title.contents': 'Nội dung giới thiệu',
  'lottery.title.contents1': 'Xin hãy điền vào nội dung đẩy.',
  'lottery.title.pushAdminAndContents': 'Người giới thiệu/thời gian giới thiệu',
  'lottery.title.addSuccess': 'Thêm thành công!',
  'lottery.title.addException': 'Tăng dị số',
  'lottery.title.addLikeCountAndReadCount': 'Increase thích hay đọc',
  'lottery.title.choseType': 'Kiểu chọn',
  'lottery.title.choseType1': 'Hãy chọn Thêm kiểu',
  'lottery.title.countNumber': 'Số hiệu',
  'lottery.title.countNumber1': 'Nhập số',
  'lottery.title.commentSuccess': 'Diễn đạt!',
  'lottery.title.commentError': 'Lỗi liên quan',
  'lottery.title.postAndReply': 'Trả lời bài viết',
  'lottery.title.numberCode': 'Số hiệu',
  'lottery.title.replyAdmin': 'Người trả lời',
  'lottery.title.secondReply': 'Trả lời cấp độ 2',
  'lottery.title.upperNumberCode': 'Mã cấp trên',
  'lottery.title.firstReply': 'Trả lời cấp độ 1',
  'lottery.title.replyTime': 'Thời gian trả lời',
  'lottery.title.replyLevel': 'Tầng lớp trả lời',
  'lottery.title.conten': 'nội dung',
  'lottery.title.addLikeAndRead': 'Increase thích hay đọc',
  'lottery.title.addLikeAndRead1': 'Tăng số lượng thích, đọc và tài liệu',
  'lottery.title.follow': 'phim',
  'lottery.title.postNew': 'Phát hành mới',
  'lottery.title.category': 'phân loại',
  'lottery.title.category1': 'Hãy chọn phân loại',
  'lottery.title.postDate': 'Ngày đăng bài',
  'lottery.title.adPic': 'Quảng cáo ảnh',
  'lottery.title.adPic1': 'Vui lòng tải lên ảnh quảng cáo',
  'lottery.title.public': 'Có công khai không?',
  'lottery.title.public1': 'Hãy chọn nếu công bố',
  'lottery.title.public2': 'Kích hoạt',
  'lottery.title.public3': 'Người trả lời có thể xem',
  'lottery.title.pushSingleSticker': 'Đẩy hay không',
  'lottery.title.pushSingleSticker1': 'Hãy chọn kiểu thư',
  'lottery.title.pushSingleSticker2': 'Không đẩy',
  'lottery.title.pushSingleSticker3': 'Khăn choàng',
  'lottery.title.secondaryPlay': 'Hai tầng chơi',
  'lottery.title.secondaryPlay1': 'Hãy chọn phương pháp chơi cấp hai',
  'lottery.title.thirdPlay': 'Diễn ba cấp',
  'lottery.title.thirdPlay1': 'Hãy chọn ba mức độ chơi',
  'lottery.title.amountPerBet': 'Mức độ:',
  'lottery.title.amountPerBet1': 'Hãy nhập số lượng của mỗi ghi chú.',
  'lottery.title.ranking': 'Cấp độ',
  'lottery.title.ranking1': 'Chèn trang',
  'lottery.title.ranking2': 'Giới thiệu',
  'lottery.title.giftChoice': 'Chọn quà',
  'lottery.title.giftChoice1': 'lãng phí tiền vô ích.',
  'lottery.title.giftChoice2': 'Gửi các điểm',
  'lottery.title.readSendCash': 'Tiền để đọc',
  'lottery.title.readSendCash1': 'Hãy nhập số lượng',
  'lottery.title.readSendPoint': 'Điểm cần đọc',
  'lottery.title.readSendPoint1': 'Hãy nhập các điểm',
  'lottery.title.postAccount': 'Số tài khoản gởi',
  'lottery.title.postAccount1': 'Hãy nhập vào tài khoản gởi',
  'lottery.title.setStickerType': 'Đặt kiểu mục',
  'lottery.title.stickerType': 'Kiểu cổng',
  'lottery.title.stickerType1': 'Hãy nhập tên kiểu bưu điện',
  'lottery.title.typeName': 'Tên kiểu',
  'lottery.title.showOrder1': 'Vui lòng ghi vào thứ tự',
  'lottery.title.showOrder': 'Hiển thị trật tự',
  'lottery.title.addType': 'Thêm kiểu',
  'lottery.title.moveBeforeDelete': 'Xin hãy chuyển vị trí của bạn sang một loại khác trước khi xóa chúng.',
  'lottery.title.postAdmin': 'Người đăng bài',
  'lottery.title.categoryAndTitle': 'Phân loại/tiêu đề',
  'lottery.title.readContentLike': 'Đọc/ bình luận/ như',
  'lottery.title.postAndEditTime': 'Bài đăng/thời gian cài đặt',
  'lottery.title.unpin': 'Bỏ liên kết',
  'lottery.title.cancelRecom': 'Bỏ đề nghị',
  'lottery.title.viewReply': 'Xem và trả lời',
  'lottery.title.addQuantity': 'Thêm số lượng',
  'lottery.title.addSticker': 'Thêm bài viết mới',
  'lottery.title.deleteSticker': 'Xoá các văn bản',
  'lottery.title.updateCategory': 'Sửa đổi và phân loại',
  'lottery.title.setCategory': 'Cài đặt phân loại',
  'lottery.title.targetType': 'Thể loại tiêu đề',
  'lottery.title.likeContent': 'Nội dung đối tượng thích',
  'lottery.title.likeTime': 'Thời gian lượt thích',
  'lottery.title.beLikeAccount': 'Số tài khoản người chơi được chú ý',
  'lottery.title.attentionTime': 'Thời gian chú ý',
  'lottery.title.taskTime': 'Thời gian trả lời',
  'lottery.title.type': 'Thể loại',
  'lottery.title.readingTask1': 'Đọc mục\'General Post',
  'lottery.title.readingTask2': 'Đọc nhiệm vụ - mục chuyên gia',
  'lottery.title.readingTask3': 'Việc đọc poster',
  'lottery.title.readTask': 'Việc đọc',
  'lottery.title.focusTask': 'Tập trung vào nhiệm vụ',
  'lottery.title.contentTask': 'Nhiệm vụ bắt đầu',
  'lottery.title.likeTask': 'Lượt thích nhiệm vụ.',
  'lottery.title.taskTarget': 'Mục tiêu',
  'lottery.title.completed': 'Đã hoàn thành',
  'lottery.title.isReceive': 'Phải chăng nhận thưởng',
  'lottery.title.received': 'Đã nhận',
  'lottery.title.unaccalimed': 'Chưa sửa',
  'lottery.title.upgradeTime': 'Thời gian lên cấp',
  'agent.title.verificationFail': 'Xác nhận lỗi',
  'agent.title.verificationFail1': 'Tên người dùng đã tồn tại.Xin nhập lại.',
  'agent.title.confirmPassWrong': 'Hai mật khẩu không khớp!',
  'agent.title.fillAgentInfo': 'Điền thông tin đại lý',
  'agent.title.agentType': 'Thể loại đại lý',
  'agent.title.ordinaryAgent': 'Đại lý phổ thông',
  'agent.title.agentLevel': 'Số tiền điều chỉnh',
  'agent.title.manualAmount': 'Agency level',
  'agent.title.agentLevel1': 'Đại lý cấp 1',
  'agent.title.agentLevel2': 'Đại lý cấp 2',
  'agent.title.agentLevel3': 'Đại lý cấp 3.',
  'agent.title.adChannel': 'Kênh quảng cáo',
  'agent.title.addAdChannel': 'Thêm kênh quảng cáo',
  'agent.title.adCode': 'Mã code của kênh quảng cáo',
  'agent.title.adCode1': 'Hãy chọn mã quảng cáo',
  'agent.title.adName': 'Tên quảng cáo',
  'agent.title.adName1': 'Hãy nhập tên quảng cáo đúng',
  'agent.title.adAddress': 'Địa chỉ quảng cáo',
  'agent.title.adAddress1': 'Hãy nhập địa chỉ quảng cáo chính xác',
  'agent.title.adDesc': 'Mô tả quảng cáo',
  'agent.title.adDesc1': 'Hãy nhập vào mô tả quảng cáo chính xác',
  'agent.title.adPutDate': 'Ngày khởi động',
  'agent.title.adPutDate1': 'Hãy chọn ngày phát hành',
  'agent.title.payName': 'Số kì:',
  'agent.title.payName1': 'Hãy nhập tên thanh toán đúng',
  'agent.title.bankNo': 'Số thẻ ngân hàng',
  'agent.title.bankNo1': 'Hãy nhập đúng số thẻ ngân hàng.',
  'agent.title.adMgt': 'Quản lý quảng cáo',
  'agent.title.onlyOne': 'Chỉ có một kênh quảng cáo có thể chọn',
  'agent.title.outOfIndex': 'Quảng cáo kênh không có trong phạm vi chọn lọc, xin vui lòng nhập tên.',
  'agent.title.baseInfo': 'Thông tin cơ bản',
  'agent.title.payInfo': 'Thông tin chi trả',
  'agent.title.complete': 'Đã hoàn thành',
  'agent.title.nextStep': 'Bước kế tiếp',
  'agent.title.backStep': 'Bước lùi',
  'agent.title.oneMore': 'Thêm một cái nữa.',
  'agent.title.resetPassSuccess': 'Đặt mật khẩu thành công',
  'agent.title.newPassIs': 'Đặt lại mật khẩu thành công. Mật khẩu mới là:',
  'agent.title.unfreezeAgent': 'Anh có muốn làm tan băng đặc vụ này không?',
  'agent.title.activationAgent': 'Anh có muốn kích hoạt đặc vụ này không?',
  'agent.title.freezeAgent': 'Anh có muốn phong tỏa đặc vụ này không?',
  'agent.title.rejectActivationAgent': 'Anh có muốn từ chối quá trình kích hoạt đặc vụ này không?',
  'agent.title.confirmOperate': 'Xác nhận hoạt động',
  'agent.title.trackCode': 'Mã theo dõi',
  'agent.title.registerTimeAndLastLoginTime': 'Thời gian đăng ký/ Thời gian lần cuối đăng nhập',
  'agent.title.status0': 'không hoạt động',
  'agent.title.status1': 'Kích hoạt',
  'agent.title.status2': 'Đóng băng',
  'agent.title.status3': 'Đã từ chối',
  'agent.title.activation': 'Kích hoạt',
  'agent.title.freeze': 'Đóng băng',
  'agent.title.thaw': 'Cá',
  'agent.title.resetPass': 'Đặt lại mật khẩu đăng nhập',
  'agent.title.userCodeNameMail': 'Tên người dùng, mật mã, tên, email',
  'agent.title.registerTime': 'Thời gian đăng ký',
  'agent.title.upperCode': 'Hộ chỉ tối cao',
  'agent.title.upperAgentCode': 'Hãy nhập mật mã đặc vụ cấp cao.',
  'agent.title.platform': 'Nhà cái',
  'agent.title.platformDetail': 'Chi tiết platform',
  'agent.title.desc': 'Thắng hoặc thua trên nền tảng: {resultAmount}, tỷ lệ hoa hồng: {hoa hồngPercent}, hoa hồng nhận được: {hoa hồng}',
  'agent.title.monthSettlementCommission': 'Tiền hoa hồng quyết toán mỗi tuần',
  'agent.export.agentMonthExcel': 'Đặc vụ định cư hàng tháng',
  'agent.title.agentName': 'Tên đại lý',
  'agent.title.depositAmount': 'Lợi tích',
  'agent.title.withdrawAmount': 'Vẽ',
  'agent.title.totalChangeMoney': 'Phí dịch vụ',
  'agent.title.commissionReport1': 'Đặc vụ hoa hồng',
  'agent.title.commissionReport2': 'Hoa hồng nền tảng ngoại tuyến = (Nền tảng A thắng và thua * {platformCost} * Tỷ lệ hoa hồng của Nền tảng A) + (Nền tảng B thua và thắng * {platformCost} * Tỷ lệ hoa hồng của Nền tảng B) + (Nền tảng C thua và thắng * {platformCost} * Tỷ lệ hoa hồng của Nền tảng C) . . . .',
  'agent.title.commissionReport3': 'Giá trị ngoài tuyến tố tổng hợp tất cả giảm giá do các thành viên cấp dưới của đại diện',
  'agent.title.commissionReport4': 'Phí gửi và rút tiền ngoại tuyến = (tiền gửi ngoại tuyến + rút ngoại tuyến) * {minAmount}',
  'agent.title.commissionReport5': 'Hoa hồng đại lý = (nền tảng thắng và thua * {platformCost} tiền gửi và số tiền rút của người dùng hệ thống * {minAmount}) * tỷ lệ hoa hồng.',
  'agent.title.commissionReport6': 'Rõ ràng là tham gia phần thua của tập đoàn',
  'agent.title.commissionReport7': 'Hệ thống thưởng tố tố tố tổng cổ phần cổ phần cổ phần',
  'agent.title.commissionReport8': 'Số ký gửi và rút tiền người dùng là bao nhiêu ký gửi và thu hồi tổng hợp cho các thành viên cấp dưới.',
  'agent.title.commissionReport9': 'Tỷ lệ của Ủy ban',
  'agent.title.commissionForm': 'Danh sách tiền hoa hồng',
  'agent.title.dataForm': 'Báo cáo dữ liệu',
  'agent.title.childFlow': 'Doanh thu cấp dưới',
  'agent.title.childBonus': 'Ưu đãi cấp dưới',
  'agent.title.childDeposit': 'Mở lỗ',
  'agent.title.childWithdrawal': 'Nạp tiền cấp dưới',
  'agent.title.childResult': 'Thắng hay thua là cuối cùng',
  'agent.title.childCommission': 'Bộ phát hành Ủy ban',
  'agent.title.viewDetail': 'Xem chi tiết',
  'agent.title.childDWFee': 'Phí dịch vụ đặt cọc và rút lui ngoại tuyến',
  'agent.title.commission': 'Ủy ban',
  'agent.title.childPlatformResult': 'Thoát trình nền thắng',
  'agent.title.minimumMonthlyTotalNetProfit': 'Tổng thu sản tối thiểu lưới lợi nhuận',
  'agent.title.minimumMonthlyTotalNetProfit1': 'Nhập vào tối thiểu số tiền lãi lưới tổng hợp',
  'agent.title.maximumMonthlyTotalNetProfit': 'Tổng tiền lãi lưới tối đa',
  'agent.title.maximumMonthlyTotalNetProfit1': 'Nhập vào tổng phát tiền lãi lưới tổng thể tối đa',
  'agent.title.addAgentCommissionRatio': 'Thêm tỷ lệ hoa hồng điệp viên',
  'agent.title.activeMember': 'Thành viên hoạt động',
  'agent.title.activeMember1': 'Hãy nhập vào thành viên',
  'agent.title.commissionRatio': 'Phí hoa hồng',
  'agent.title.commissionRatio1': 'Nhập phần của Ủy ban',
  'agent.title.cancel': 'hủy',
  'agent.title.save': 'Bảo:',
  'agent.title.defaultAgentDivision': 'Số phần trăm của đại lý được dựa theo mặc định của nhà cái',
  'agent.title.platformFeeRatio': 'Ví dụ chi phí của nhà cái',
  'agent.title.platformWinLose': 'Hệ số thắng thua của nhà cái',
  'agent.title.depositWithdrawalFeeMui': 'Số phí dịch vụ ký gửi và rút lui',
  'agent.title.comprehensiveCost': 'Hãy nhập phí toàn diện (phần trăm\'0\'100\')',
  'agent.title.eachMonthSettlementDay': 'Ngày mỗi tháng thanh toán',
  'agent.title.eachMonthSettlementDayShowDetail': 'Giải pháp vào ngày này của mỗi tháng',
  'agent.title.halfMonthSettlementDay': 'Ngày định kỳ nửa tháng',
  'agent.title.halfMonthSettlementDayShowDetail': 'Giải quyết theo ngày đó hay ngày rằm trong mỗi tháng',
  'agent.title.eachWeekSettlementDay': 'Ngày bồi thường tuần',
  'agent.title.eachWeekSettlementDayShowDetail': 'Ngày thứ hai, ngày thứ hai là ngày đầu tiên.',
  'agent.title.settlementDayMsg': 'Hãy nhập ngày định cư',
  'agent.billRate.halfMonthErrorMsg': 'Ngày định cư nửa tháng không thể lớn hơn 10Name',
  'agent.billRate.eachWeekErrorMsg': 'Ngày định cư hàng tuần không thể lớn hơn 7',
  'agent.title.agentTaxPercentage': 'Phí thuế tảng',
  'agent.title.agentSharePercent': 'Tỷ lệ',
  'agent.title.childAgent': 'Thiết lập Ủy ban điệp viên',
  'agent.title.agentCommission': 'Ủy ban CIA',
  'agent.title.domainCheck': 'Không thể nhập các tên miền ở đầu HTTP, HTTPS và WWW. Xin bỏ qua.',
  'agent.title.fillDomainInfo': 'Điền thông tin tên miền',
  'agent.title.agentDomain': 'Tên miền ủy nhiệm',
  'agent.title.agentDomain1': 'Hãy nhập tên miền',
  'agent.title.isDefault': 'Có phải là mặc định không?',
  'agent.title.isDefault1': 'Hãy chọn xem mặc định có mặc định',
  'agent.title.isDefault2': 'mặc định',
  'agent.title.isDefault3': 'Không mặc định',
  'agent.title.domain': 'tên miền',
  'agent.title.domain1': 'Mặc định tên miền',
  'agent.title.domain2': 'Tên miền không mặc định',
  'agent.title.addDomain': 'Thêm tên miền',
  'agent.title.userNameDomainCode': 'Tên người dùng, tên miền, mã',
  'agent.title.currentStatus': 'hiện thời',
  'common.title.detailInfo': 'Chi tiết',
  'agent.title.addRemark': 'Ghi chú',
  'agent.title.addRemarkSuccess': 'Thêm bình luận thành công!',
  'agent.title.addRemarkFail': 'Lỗi thêm ghi chú',
  'agent.title.addRemarkError': 'Thêm lỗi bình luận',
  'agent.title.bankName': 'Tên ngân hàng',
  'agent.title.bankAccount': 'Tên tài khoản',
  'agent.title.bankAccount1': 'Hãy nhập tên tài khoản',
  'agent.title.bankAddr': 'Địa chỉ nhánh',
  'agent.title.bankAddr1': 'Hãy nhập địa chỉ chi nhánh',
  'agent.title.bankNumber': 'Tài khoản ngân hàng',
  'agent.title.normal': 'Sắp xếp theo thứ tự',
  'agent.title.activationCard': 'Anh có muốn kích hoạt thẻ ngân hàng này không?',
  'agent.title.deleteCard': 'Bạn có muốn xoá thẻ ngân hàng này không?',
  'agent.title.offlineCard': 'Anh có muốn vô hiệu hóa thẻ ngân hàng này không?',
  'agent.title.bankInfo': 'Thông tin ngân hàng',
  'agent.title.addBank': 'Thêm thẻ ngân hàng',
  'agent.title.qrCode': 'Hình mã QR',
  'agent.title.pubQrCode': 'Mật mã PR',
  'agent.title.phoneNumber': 'Số điện thoại',
  'user.title.registerTime1': 'Thời gian đăng ký',
  'user.title.firstDepositTime': 'Lần đầu kí gửi',
  'user.title.lastLoginTime1': 'Thời gian lần cuối đăng nhập',
  'user.title.lastDepositTime': 'Lần kí gửi cuối',
  'user.title.lastWithdrawalTime': 'Lần rút cuối',
  'user.title.taotalDepositAmount': 'Tổng số tiền nạp',
  'user.title.totalWithdrawalAmount': 'Tổng thu hồi',
  'user.title.totalBonus1': 'Tổng ưu đãi',
  'user.title.totalBetFlow': 'Tổng doanh thu',
  'user.title.goFail': 'Lỗi nhảy',
  'user.title.disableLogin': 'Tài khoản này không được bật hay đóng băng. Bạn không thể nhảy để đăng nhập.',
  'agent.export.agentChildUserExcel': 'Người dùng.xs dưới tên đặc vụ',
  'user.title.agentCommissionConfig': 'Thiết lập Ủy ban Đặc vụ',
  'user.title.goingTo': 'Nhảy...',
  'user.title.bonusBinding': 'Tiền khuyến mãi',
  'user.title.lastWithdrawalTime1': 'Lần rút cuối',
  'user.title.loginAsAgent': 'Đăng nhập làm gián điệp',
  'user.title.birthday': 'Ngày',
  'user.title.upperAgent': 'Nhân viên hạng nhất',
  'user.title.accountFunds': 'Tiền tài khoản',
  'user.title.freezingFunds': 'Tiền đông lạnh',
  'user.title.availableFunds': 'Có thể rút',
  'user.title.profileStatistics': 'Tổng thống',
  'user.title.historyPay': 'Thanh toán lịch sử',
  'user.title.exportChildUser': 'Xuất báo cáo người dùng dưới tên.xls',
  'user.title.fillBankCardInfo': 'Điền thông tin thẻ ngân hàng',
  'user.title.adjustAccountBalanceSuccess': 'Tài khoản đã được điều chỉnh thành công.',
  'user.title.adjustAccountBalanceFail': 'Lỗi điều chỉnh cân bằng tài khoản',
  'user.title.adjustAccountBalanceError': 'Lỗi điều chỉnh tài khoản',
  'user.title.manualTransfer1': 'Hãy chọn kiểu hòa giải',
  'user.title.increaseAmount': 'Tăng mức',
  'user.title.decreaseAmount': 'Giảm bớt lượng',
  'user.title.agencySpecificCommissionRatio': 'Phần của Ủy ban độc quyền',
  'user.title.addAgencySpecificCommissionRatio': 'Thêm đặc vụ độc quyền của Ủy ban',
  'user.title.previousBalance': 'Tập trước',
  'user.title.afterBalance': 'Sau khi cân bằng',
  'user.title.approved': 'Sắp xếp theo thứ tự',
  'user.title.notApproved': 'Chưa kiểm tra và phê duyệt',
  'user.title.pendingApproved': 'Chờ đợi phê duyệt',
  'user.title.rejected': 'Đã từ chối',
  'user.title.historyBill': 'hóa đơn lịch sử',
  'user.title.deleteThisFee': 'Xóa dữ liệu này?',
  'user.title.costTime': 'Thời gian phân bổ chi phí',
  'user.title.costType': 'Kiểu chi phí',
  'user.title.costCreateTime': 'Thời gian lập chi phí',
  'user.title.settled': 'Giải',
  'user.title.unsettlement': 'Chưa đọc',
  'user.title.changeFee': 'Sửa đổi phí',
  'user.title.addFee': 'Thêm mức chi phí',
  'user.title.notCalculated': 'Chưa tính toán',
  'user.title.Calculated': 'Tính',
  'user.title.fillCostInfo': 'Điền thông tin chi phí',
  'user.title.uploadPromotionPicture': 'Tải ảnh lên',
  'user.title.oldPromotionPicture': 'Ảnh giới thiệu cũ',
  'user.title.uploadFile': 'Vui lòng tải lên tập tin',
  'user.title.imageName': 'Tên ảnh',
  'user.title.imageName1': 'Hãy nhập tên ảnh',
  'user.title.imageName2': 'Hãy nhập tên của bộ phim quảng cáo',
  'user.title.addPromotionPicture': 'Thêm ảnh giới thiệu',
  'user.title.confirmActivation': 'Xác nhận kích hoạt',
  'user.title.activationPicture': 'Kích hoạt ảnh này?',
  'user.title.banPicture': 'Anh có muốn vô hiệu hóa bức ảnh này không?',
  'user.title.deletePicture': 'Xóa ảnh này?',
  'user.title.newChildCount': 'số lần cấp dưới đăng ký mới',
  'user.title.activationChildCount': 'Số lần hoạt động của cấp dưới',
  'user.title.lowerBetCount':'Tổng số người đặt cược ở cấp độ thấp hơn',
  'user.title.depositChildCount': 'Số kì:',
  'user.title.firstDepositChildCount': 'Số lần cấp dưới nạp lần đầu',
  'user.title.whitdrawalChildCount': 'Số lần cấp dưới rút tiền',
  'user.title.totalDepositChildAmount': 'Tổng gửi trực tuyến',
  'user.title.totalWithdrawalChildAmount': 'Tổng số lần cấp dưới rút tiền',
  'user.title.totalBonusChild': 'Tổng doanh thu của cấp dưới',
  'user.title.totalBetFlowChild': 'Giảm dòng chảy',
  'user.title.totalResultChild': 'Tổng thắng thua của cấp dưới',
  'user.title.confirmWithdrawal': 'Anh xác nhận rút lại chưa?',
  'user.title.confirmConfirm': 'Không thể thay đổi sau khi xác nhận?',
  'user.title.rejectWithdrawal': 'Anh có muốn từ chối việc rút tiền này không?',
  'user.title.rejectConfirm': 'Không thể thay đổi sau khi t ừ chối?',
  'user.title.withdrawalNumber': 'Mã rút tiền',
  'user.title.agree': 'Chiến!',
  'user.title.userAccountAndNumber': 'Tên người chơi/mã doanh thu',
  'user.title.fillRemarkInfo': 'Điền nốt vào',
  'user.title.confirmBinding': 'Xác nhận ràng buộc',
  'user.title.confirmBinding1': 'Anh có chắc là muốn làm hỏng đề nghị này không?',
  'user.title.alreadyBiding': 'Đặt sẵn rồi',
  'user.title.changeBindingBonus': 'Đại lý này đã bị ràng buộc với {BonusName} ưu đãi đăng ký này. Bạn có chắc chắn muốn thay thế ưu đãi này không?',
  'user.title.alreadyBindingBonus': '{agentAccount} Ưu đãi này đã được ràng buộc với {BonusName}.',
  'user.title.registerBonusBiding': 'Giấy tờ ghi nợ',
  'user.title.registerGiftAmount': 'Số tài khoản đã ký',
  'user.title.flowTimes': 'Chảy nhiều',
  'user.title.binding': 'Đang cài đặt',
  'user.title.noBackFlowAgent': 'Không có giảm giá cho các thành viên dưới đặc vụ này sao?(giảm giá nước và giảm giá thực tế)',
  'user.title.haveBackFlowAgent': 'Bạn có muốn lập thành viên dưới đặc vụ này để được giảm giá nước trở lại?(giảm giá nước và giảm giá thực tế)',
  'user.title.resetPayPass': 'Đặt mật khẩu thanh toán',
  'user.title.haveBackFlow': 'Có tiền trả lại',
  'user.title.noBackFlow': 'Không có nước trở về',
  'user.title.addCommonAgent': 'Thêm đại lý thường',
  'user.title.noSelect': 'Không lựa chọn.',
  'user.title.assignUser': 'Hãy chọn người dùng cần được chỉ định',
  'user.title.choseSalesperson': 'Hãy chọn nhân viên tiếp thị từ xa cần cung cấp.',
  'user.title.wrongChose': 'Chọn sai rồi',
  'user.title.assignUserError': 'Người dùng được chọn để phân phối phải lớn hơn hoặc ngang bằng nhân viên đã tuyển chọn',
  'user.title.userType': 'Kiểu khách hàng',
  'user.title.importUser': 'Người chơi tải xuống',
  'user.title.silentUser': 'Người dùng không tương tác',
  'user.title.registerUndepositUser': 'Đăng ký người dùng không gửi',
  'user.title.memberListImport': 'Nhập danh sách thành viên',
  'user.title.importInfo': 'Nhập thông tin',
  'user.title.importRemark': 'Xin mời',
  'user.title.importSrouce': 'Nhập nguồn',
  'user.title.stepTwo': 'Bước 2 chọn và phân công nhân sự dịch chuyển',
  'user.title.allSalesperson': 'Nhân viên marketing.',
  'user.title.assign': 'phân phối',
  'user.title.assignList': 'Danh sách',
  'user.title.assignListDetail': 'Chi tiết về danh sách',
  'user.title.assignTime': 'Thời gian trả lời',
  'user.title.isRecycle': 'Nó tái chế à?',
  'user.title.confirmRecycle': 'Cậu có chắc là muốn tái chế lại không?',
  'user.title.assignedTo': 'Gán vào',
  'user.title.assignedUser': 'Người phân phối',
  'user.title.recycled': 'Thu',
  'user.title.recycle': 'phục',
  'user.title.recycleAll': 'Tất cả tái chế',
  'user.title.confirmRecycle1': 'Chú ý: sau khi tái chế số điện thoại, khả năng tạo ra bởi số điện thoại sẽ không được tính toán.',
  'user.title.assignTime1': 'Thời gian trả lời',
  'user.title.userAttribute': 'thuộc tính người dùng',
  'user.title.assignPersonCount': 'Số người phân phối',
  'user.title.alreadyAssignList': 'Danh sách đã phân phối',
  'user.title.importListMode': 'Định dạng của danh sách nhập khẩu là như sau:',
  'user.title.importListMode1': 'Hàng 1: số điện thoại',
  'user.title.importListMode2': 'Cột 2: Thông tin nhập',
  'user.title.importListMode3': 'Tam cột: ghi chú nhập',
  'user.title.teleSaleAssignList': 'Danh sách phân phối-gọi điện mua bán',
  'user.title.importDesc': 'Nhập hướng dẫn',
  'user.title.assignMgt': 'Quản lý phân phối',
  'user.title.waitAssignList': 'Danh sách chờ',
  'user.title.lastLogin': 'Đăng nhập cuối',
  'user.title.activationTime': 'Thời gian thao tác',
  'user.title.activationFirstDeposit': 'Sau khi kích hoạt lần nạp đầu tiên',
  'user.title.activationTotalDeposit': 'Tổng gởi sau khi kích hoạt',
  'user.title.salesperson': 'Chuyên viên tiếp thị',
  'user.title.Salesperson1': 'Vui lòng chọn nhân viên điện tính.',
  'user.title.Salesperson2': 'Không chọn nhân viên tiếp thị.',
  'user.title.times': 'lần',
  'user.title.firstDepositCount': '{regNotDepositCount} Nạp lần đầu',
  'user.title.recoverCount': 'Trợ giúp {silentUserCount} người',
  'user.title.registerCount': 'Đăng ký {importRegCount} người',
  'user.title.saleStatus': 'Trạng thái mua bán bạn có thể nhấp vào bất kì để tiến hành xem danh sách tài khoản',
  'user.title.undialedUser': 'Người chơi chưa nghe điện thoại',
  'user.title.followUpUsers': 'Người dùng cần theo dõi',
  'user.title.dialed': 'Đã gọi',
  'user.title.dialedThisMonth': 'Gọi tháng này',
  'user.title.connectionRate': 'Tốc độ kết nối',
  'user.title.teleQuality': 'Chất lượng cuộc gọi',
  'user.title.performanceOverview': 'Tổng quan về hiểu suất',
  'user.title.averageCallDuration': 'Khoảng thời gian cuộc gọi',
  'user.title.commissioner': 'Chuyên viên trực thuộc',
  'user.title.numberDials': 'Số cuộc gọi',
  'user.title.chooseSalesperson': 'Chọn nhân viên marketing.',
  'user.title.uncalledUserList': 'Danh sách người dùng chưa quay',
  'user.title.dialedUserList': 'Quản lý phát ngôn',
  'user.title.followUpListUsers': 'Danh sách người dùng cần theo dõi',
  'user.title.activationDeposit': 'Nạp tiền sau khi kích hoạt',
  'user.title.notDialed': 'Chưa gọi',
  'user.title.keepFollow': 'Tiếp tục theo dõi',
  'user.title.cancelFollow': 'Hủy hỗ trợ',
  'user.title.affiliatedSales': 'Tiếp thị qua điện thoại',
  'user.title.invitationCodeUser': 'Người dùng mã mời',
  'user.title.myPerformance': 'Thành tựu của tôi',
  'user.title.performanceDetails': 'Chi tiết hiệu suất',
  'user.title.performanceList': 'Thông tin:',
  'user.title.dailyPerformanceStatistics': 'Thống kê hiểu suất hàng ngày',
  'user.title.registrationNoDeposit': 'Đăng kí mới chưa nạp tiền',
  'user.title.dialCount': 'Lượng cuộc gọi đi',
  'user.title.activationsCount': 'Số lần phát hành',
  'user.title.currentPerformanceOverview': 'Hiện thước phim',
  'user.title.calledThisMonth': 'Gọi tháng này',
  'user.title.seatNumber': 'Số chỗ ngồi',
  'user.title.currentAgentAssignor': 'Chỗ người của người phân phối hiện tại',
  'user.title.seatMgt': 'Quản lý "chỗ ngồi"',
  'user.title.assignSeatSalesperson': 'Khoảng cách bán hàng ghế',
  'user.title.seatSalesperson': 'Nhân viên ghế',
  'user.title.seatSalesperson1': 'Xin hãy nhập những người được giao dịch.',
  'user.title.times1': 'tần số',
  'user.title.percent': 'Tổng tiền được chia',
  'user.title.seatSalesperson2': 'Hãy chọn người sẽ được chỉ định',
  'user.title.offlineOutThreeDay': 'Người dùng không đăng nhập quá ba ngày',
  'user.title.userInfo': 'Thông tin người dùng',
  'user.title.registerAndLogin': 'Đăng ký/ đăng nhập',
  'user.title.telemarketing': 'Tình trạng suất đi',
  'user.title.remarkInfo': 'Thông tin',
  'user.title.editAt': 'Biên tập:',
  'user.title.confirm': 'Chọn',
  'user.title.waitIntoDialList': 'Có nên nhập danh sách người dùng cần gọi',
  'user.title.confirmWaitIntoDialList': 'Xin xác nhận có nên nhập danh sách người dùng cần gọi.',
  'user.title.waitIntoDialedList': 'Có nên nhập danh sách người dùng gọi đến',
  'user.title.confirmWaitIntoDialedList': 'Xin xác nhận có nên nhập danh sách người dùng gọi.',
  'user.title.waitIntoFollowList': 'Có nên nhập danh sách người dùng cần theo dõi',
  'user.title.confirmWaitIntoFollowList': 'Xin xác nhận có nên nhập danh sách người dùng cần theo dõi',
  'user.title.platformSerialNumber': 'Số seri của giàn khoan:',
  'user.title.gameSerialNumber': 'Số seri của game',
  'user.title.rawData': 'Dữ liệu thô (thời gian trình nền trò chơi)',
  'user.title.verified': 'phê duyệt',
  'user.title.unfilled': 'Chưa điền',
  'user.title.notCertified': 'Chưa xác thực',
  'user.title.userInfoExcel': 'Báo cáo chi tiết',
  'user.title.riskControlLevel': 'Cấp độ rủi ro',
  'user.title.dateEnrollment': 'Ngày đăng nhập',
  'user.title.firstDepositDate': 'Ngày nạp đầu tiên',
  'user.title.bankCardList': 'Danh sách thẻ ngân hàng',
  'user.title.unBinding': 'Tháo',
  'user.title.confirmUnBinding': 'Anh có chắc là sẽ tháo ra không?',
  'user.title.confirmEnableBankCard': 'Anh có chắc bật thẻ ngân hàng này không?',
  'user.title.isDisable': 'Có cấm không?',
  'user.title.confirmDisableBankCard': 'Anh có muốn vô hiệu hóa thẻ ngân hàng này không?',
  'user.title.bankRelated': 'Ngân hàng liên quan',
  'user.title.bankCode': 'Mã ngân hàng',
  'user.title.accountRelated': 'Tài khoản liên quan',
  'user.title.unbindingAll': 'Tháo hết',
  'user.title.confirmUnbindingAllCard': 'Ghi chú: sau thao tác này, tất cả thẻ ngân hàng của người dùng sẽ được tháo ra.',
  'user.title.changeUpperAgent': 'Sửa đại diện phụ huynh',
  'user.title.oldAgent': 'Nhân viên gốc',
  'user.title.newAgent': 'Nhân viên mới',
  'user.title.newAgentAccount': 'Tài khoản điệp viên mới',
  'user.title.deviceRelateUser': 'Đăng nhập với người dùng tương ứng của thiết bị',
  'user.title.devicId': 'ID thiết bị',
  'user.title.devicIdAppType': 'Nguồn thiết bị',
  'user.title.relateUser': 'Người liên kết',
  'user.title.relateUserNum': 'Số lượng tài khoản người dùng liên kết',
  'user.title.emailAuthentication': 'Hòm thư',
  'user.title.newMail': 'Hộp thư mới',
  'user.title.oldMail': 'Hộp thư cũ',
  'user.title.lockFundsList': 'Khóa danh sách quỹ',
  'user.title.bonusLock': 'Khoá hảo hạng',
  'user.title.depositLock': 'Khoá mở kho',
  'user.title.confirmOffer': 'Xin hãy xác nhận việc phát hành?',
  'user.title.confirmRejectApply': 'Anh có chắc là anh muốn từ chối đề nghị này không?',
  'user.title.confirmCancel': 'Xác nhận thôi',
  'user.title.confirmCancelBonus': 'Anh có chắc muốn hủy đề nghị này không?',
  'user.title.baseBonus': 'Vốn ưu đãi',
  'user.title.lockAmount': 'Số tiền mặc định',
  'user.title.getBonusTime': 'Thời gian nhận tiền ưu đãi',
  'user.title.flowCompletionProgress': 'Tiến trình hoàn thành doanh thu',
  'user.title.completedFlow': 'Xong chảy',
  'user.title.targetFlow': 'Mục tiêu doanh thu',
  'user.title.confirmUnlockDeposit': 'Anh có chắc sẽ mở khóa két tiền này không?',
  'user.title.inviteUserRecordList': 'Danh sách ghi vào người mời',
  'user.title.getBonus': 'Phân phối ưu đãi',
  'user.title.loginIpRelateUser': 'Đăng nhập vào người dùng tương ứng IP',
  'user.title.verifiedName': 'Xác thực tên thật',
  'user.title.realName': 'Tên thật',
  'user.title.newRealName': 'Tên thật mới',
  'user.title.newIdNo': 'Số thẻ mới',
  'user.title.oldRealName': 'Tên thật cũ',
  'user.title.oldIdNo': 'Số ID cũ',
  'user.title.realName1': 'Hãy nhập tên thật chính xác',
  'user.title.idNo1': 'Hãy nhập số nhận diện đúng',
  'user.title.verifyPhone': 'Số điện thoại',
  'user.title.phoneNumber': 'Số di động',
  'user.title.newPhoneNumber': 'Số điện thoại mới',
  'user.title.oldPhoneNumber': 'Số điện thoại cũ',
  'user.title.phoneNumber1': 'Xin hãy nhập số điện thoại đúng',

  'user.title.aliPayAccount': 'Tài khoản alipay',
  'user.title.alipayPhone': 'Số điện thoại di động alipay',
  'user.title.alipayEmail': 'Số email alipay',
  'user.title.alipayRealName': 'Alipay tên thật',
  'user.title.delAlipay': 'Xóa tài khoản alipay',
  'user.title.askDelAlipay': 'Hãy xác nhận xóa tài khoản alipay',
  'user.title.confirmUnbindingAllAliPay': 'Lưu ý: sau khi hoạt động này, sẽ được gỡ bỏ tất cả các tài khoản alipay thuộc về người dùng.',
  'user.title.confirmUnbindingAllUSDT': 'Lưu ý: sau khi hoạt động này, tất cả tài khoản USDT thuộc về người dùng này sẽ được gỡ bỏ.',
  'user.title.confirmUnbindingAllVirtual': 'Lưu ý: Sau thao tác này, tất cả tài khoản tiền ảo thuộc về người dùng này sẽ không bị ràng buộc.',
  'user.title.delUSDT': 'Xóa địa chỉ USDT',
  'user.title.askDelUSDT': 'Hãy xác nhận là đã xóa địa chỉ USDT?',

  'user.title.getAccountBalanceFail': 'Lỗi lấy số tài khoản.',
  'user.title.getAccountBalanceError': 'Lỗi lấy số tài khoản.',
  'user.title.getBackSuccess': 'Trở về thành công',
  'user.title.batchGetBack': 'Trong khi lấy hàng, xin kiểm tra tài khoản sau.',
  'user.title.getBackFail': 'Lỗi lấy lại',
  'user.title.getBackError': 'Lỗi lấy tải',
  'user.title.refreshSuccess': 'Làm lại thành công',
  'user.title.refreshFail': 'lỗi nhớ',
  'user.title.refreshError': 'lỗi nhớ',
  'user.title.accountInfo': 'Thông tin tài khoản (đơn vị: yuan)',
  'user.title.accountInfoVN': 'Thông tin tài khoản (đơn vị: VND)',
  'user.title.getBackAll': 'Lấy hết',
  'user.title.refreshAll': 'Cập nhật toàn bộ',
  'user.title.totalBalance': 'Tổng số tiền',
  'user.title.mainAccount': 'Tài khoản chính',
  'user.title.detail': 'Chi tiết',
  'user.title.refresh': 'Cập nhật',
  'user.title.money': 'nguyên tố',
  'user.title.moneyVN': 'VND',
  'user.title.point': 'Điểm thưởng',
  'user.title.requestTimeAndOfferTime': 'Khoảng thời gian ứng dụng',
  'user.title.bonusContent': 'Mức ưu tiên',
  'user.title.bonusType': 'Loại hình ưu đãi',
  'user.title.offerAdmin': 'Tình trạng suất đi',
  'user.title.resetWithdrawalPass': 'Đặt lại mật khẩu rút',
  'user.title.inviteRecord': 'Ghi nhớ lời mời',
  'user.title.relatedDevice': 'Thiết bị liên quan',
  'user.title.relateIP': 'IP liên quan',
  'user.title.bankCard': 'Thẻ ngân hàng',
  'user.title.noeLogin': 'Chưa đăng nhập',
  'user.title.relate': 'Cộng tác',
  'user.title.noBindingBankCard': 'Thẻ ngân hàng không ràng buộc',
  'user.title.relateBankCard': 'Thẻ ngân hàng liên quan',
  'user.title.female': 'Phụ nữ',
  'user.title.male': 'Nam',
  'user.title.unverifiedID': 'Nhận diện chưa xác thực',
  'user.title.verifiedMail': 'Hộp thư đã xác nhận',
  'user.title.unverifiedMail': 'Chưa xác thực thư',
  'user.title.verifiedPhone': 'Mã điện thoại',
  'user.title.mobilePhoneAttribution': 'Về nhà',
  'user.title.confirmResetUserPass': 'Bạn có chắc muốn đặt lại mật khẩu người dùng không? Bạn có cần một mật khẩu mới để đăng nhập sau khi đặt lại?',
  'user.title.confirmResetUserWithdrawal': 'Bạn có chắc muốn đặt lại mật khẩu rút lui của người dùng?',
  'user.title.confirmChangeSourceToRegister': 'Bạn có muốn xoá mật vụ gốc thành viên và đăng ký thay vào đó không?',
  'user.title.noneSet': 'Chưa đặt',
  'user.title.cancelAgent': 'Ủy ban thu hồi',
  'user.title.playerInviteCode': 'Mã mời người chơi',
  'user.title.invited': 'Mời:',
  'user.title.noneInvitedRecord': 'Tạm thời chưa có lời mời',
  'user.title.noneLoginRecord': 'Chưa ký tên',
  'user.title.changeRegisterSource': 'Sửa nguồn đăng ký',
  'user.title.signPoint': 'Điểm thưởng báo danh',
  'user.title.userRiskLevel': 'Cấp độ rủi ro',
  'user.title.userLevel1': 'Thành viên',
  'user.title.userLevelShow': '{vipLevel} Cấp độ',
  'user.title.expireDate': 'Thời gian',
  'user.title.permanent': 'Giá trị vĩnh viễn',
  'user.title.totalManualTransfer': 'Phát minh tổng hợp',
  'user.title.wechat': 'Đang cài đặt',
  'user.title.loginTimes': 'Đăng nhập 9999 {loginCount} lần',
  'user.title.pointChange': 'Thay đổi tổng phân',
  'user.title.remarkCount': 'Có ghi chú {length}',
  'user.title.getRiskInfoFail': 'Lỗi lấy thông tin kiểm soát rủi ro.',
  'user.title.getRiskInfoError': 'Lỗi lấy thông tin kiểm soát rủi ro.',
  'user.title.transactionTime': 'Thời gian giao dịch',
  'user.title.addBonusError': 'Thêm lỗi đề nghị',
  'user.title.addBonus': 'Thêm Tổng ưu đãi',
  'user.title.bonusName1': 'Hãy nhập tên của đề nghị',
  'user.title.bonusName2': 'Xin hãy nhập bao nhiêu mục tiêu cần để rút lui',
  'user.title.withdrawTargetFlow': 'Di chuyển mục tiêu',
  'user.title.orderNo': 'Hãy nhập số mệnh lệnh.',
  'user.title.processingFail': 'Lỗi xử lý, hãy thử lại sau',
  'user.title.adjustedLevelSuccess': 'Chỉnh trình thành công!',
  'user.title.adjustedLevelFail': 'Lỗi điều chỉnh cấp độ',
  'user.title.adjustedLevelError': 'Lỗi cấp điều chỉnh',
  'user.title.liuheLevel': 'Cấp Đào',
  'user.title.adjustLiuheLevel': 'Chỉnh sáu cấp thành viên',
  'user.title.liuheLevel1': 'Vui lòng chọn tầng sáu',
  'user.title.adjustUserLevel': 'Chỉnh cấp thành viên',
  'user.title.adjustAccountPointSuccess': 'Điều chỉnh các điểm tài khoản thành công.',
  'user.title.adjustAccountPointFail': 'Lỗi điều chỉnh các điểm tài khoản',
  'user.title.adjustAccountPointError': 'Lỗi điều chỉnh các điểm tài khoản',
  'user.title.pointAdjust': 'Điều chỉnh tổng phân',
  'user.title.changePoint': 'Vùng thêm và trừ',
  'user.title.changePoint1': 'Hãy nhập các điểm cần cộng hay trừ',
  'user.title.changedPoint': 'Xanh nước biển',
  'user.title.showColor': 'Màu vẽ',
  'user.title.showColor1': 'Hãy chọn màu vẽ',
  'user.title.defaultBlack': 'Đen (mặc định)',
  'user.title.red': 'Đỏ',
  'user.title.blue': 'xanh',
  'user.title.green': 'xanh',
  'user.title.riskLevel1': 'Hãy chọn mức độ rủi ro',
  'user.title.noneBindingMail': 'Hộp thư người dùng không được bọc',
  'user.title.sendMailSuccess': 'Thư đã gửi',
  'user.title.sendMailFail': 'Lỗi gửi thư',
  'user.title.sendMailError': 'Gửi lỗi thư',
  'user.title.loadTemplateFail': 'Lỗi tải mẫu',
  'user.title.loadTemplateError': 'Lỗi tải mẫu',
  'user.title.sendMail': 'Gởi email',
  'user.title.sendMail1': 'Hộp thư gửi đi',
  'user.title.optionalTemplate': 'Mẫu tùy chọn',
  'user.title.mailTitle': 'Đặt thư',
  'user.title.mailTitle1': 'Hãy nhập vào tựa của tin nhắn',
  'user.title.mailContent': 'Nội dung thư',
  'user.title.mailContent1': 'Hãy nhập vào nội dung thông điệp',
  'user.title.sendSiteTextSuccess': 'Đã thành công trong việc gửi thông điệp trạm',
  'user.title.sendSiteTextFail': 'Không gởi được thông điệp trong trạm',
  'user.title.sendSiteTextError': 'Lỗi khi gửi thông điệp trạm',
  'user.title.sendSiteText': 'Thêm mới trung tâm gửi thư',
  'user.title.siteText': 'Email',
  'user.title.missOrder': 'Bạn có thể tới quản lý hội đó...phục hồi lại lệnh cho xác nhận bằng tay sau khi thanh to án.',
  'user.title.countIn': 'Tài khoản gởi và rút lui',
  'user.title.orderName1': 'Hãy nhập tên hiệu lệnh, nếu không sẽ dùng giá trị mặc định.',
  'user.title.orderName': 'Số Thứ Tự',
  'user.title.orderName2': 'Vui lòng nhập số thứ tự',
  'user.title.unbindingSeatNumber': 'Không có số ghế. Vui lòng buộc số ghế trước khi chạy.',
  'user.title.recentMainAccountTran': 'Giao dịch gần đây nhất của người chơi',
  'user.title.last7DayBet': 'Bảy ngày trước.',
  'user.title.bonusBonus': 'Phân phối ưu đãi',
  'user.title.userPoint': 'Tỷ lệ:',
  'user.title.operateLog': 'Bản ghi hoạt động',
  'user.title.allUser': 'Mọi người dùng',
  'user.title.depositRate': 'Tiền tiết kiệm',
  'user.title.depositRate1': 'Tỷ lệ nạp tiền: Tài khoản nạp tiền/ Tổng người chơi',
  'user.title.depositUserComposition': 'Cách thức người chơi',
  'user.title.depositAmount': 'Số tiền nạp (Trong ngày)',
  'user.title.totalDepositCount': 'Tổng số lần nạp tiền',
  'user.title.totalDepositAmount': 'Tổng mức ký gửi',
  'user.title.senderRecipientTitle': 'Từ/ tới/ Đầu đề',
  'user.title.recipient': 'Người gửi thư',
  'user.title.sender': 'Người gửi thư',
  'user.title.registerAndFirstAndLastLoginTime': 'Thông tin Đăng ký, Đăng nhập lần đầu và Đăng nhập lần cuối',
  'user.title.unDeposit': 'Không ký gửi',
  'user.title.totalDepositTotalWithdrawal': 'Tổng nạp tiền',
  'user.title.realNamePhoneMail': 'Tên thật｜điện thoại di động｜email',
  'user.title.userListExcel': 'Báo cáo danh sách',
  'user.title.friendsInvite': 'Mời bạn',
  'user.title.minDepositCount': 'Thời gian ký gửi',
  'user.title.maxDepositCount': 'Thời hạn ký gửi tối đa',
  'user.title.depositCount': 'Số lần nạp',
  'user.title.minDepositAmount': 'Tiền ký gửi tối thiểu',
  'user.title.maxDepositAmount': 'Tổng mức ký gửi',
  'user.title.depositAmount1': 'Số tiền nạp',
  'user.title.resultExport': 'Kết quả xuất',
  'user.title.firstDepositRate': 'Tỷ lệ nạp lần đầu',
  'user.title.rate': 'tỉ',
  'user.title.7DaysLost': '7 days lost: Người dùng không đăng nhập trong bảy ngày liên tiếp',
  'user.title.14DaysLost': 'Mười ngày trôi qua: người dùng chưa đăng nhập hàng bốn ngày liên tiếp',
  'user.title.30DaysLost': '♪ 30 days lost: Người dùng không đăng nhập trong 30 liên tiếp days ♪',
  'user.title.7DaysLostAndBack': 'Người dùng hậu lưu: người dùng mất tích trong vòng bảy ngày và đăng nhập trong thời gian',
  'user.title.lostAndUserCount': 'Tốc độ thua: Người dùng thất lạc/ người dùng tổng',
  'user.title.lostBackAndTotalLost': 'Hậu phương: người dùng cuối cùng',
  'user.title.7DaysLost1': 'không online 7 ngày',
  'user.title.14DaysLost1': 'không online 14 ngày',
  'user.title.30DaysLost1': 'Không online 30 ngày',
  'user.title.lostAndLostBack': 'Tài khoản không online và còn online',
  'user.title.lostAndLostBack1': 'Tỷ lệ online và tỷ lệ không online',
  'user.title.lostUser': 'Người chơi không online',
  'user.title.lostBackUser': 'Người chơi online',
  'user.title.lostRate': 'Tỷ lệ không online',
  'user.title.lostBackRate': 'Tỷ lệ đang online',
  'user.title.newUserCount': 'Số Người chơi mới',
  'user.title.silentUserCount': 'Số người dùng im lặng',
  'user.title.silentUser90Days': 'Người dùng im lặng: người dùng đã không đăng nhập trong {days} ngày liên tiếp',
  'user.title.silentUserRate': 'Phần trăm người dùng im lặng: người dùng im lặng',
  'user.title.silentUserRate1': 'Phần trăm người dùng tương tác',
  'user.title.absoluteValue': 'giá trị tuyệt đối',
  'user.title.retentionRate': 'Giữ',
  'user.title.dayAfter': 'Ngày sau',
  'user.title.weekAfter': 'Chu Hầu',
  'user.title.monthAfter': 'Tháng này',
  'user.title.retentionUser': 'Người dùng duy trì: Người chơi mới gởi được gọi là người dùng đã giữ lại',
  'sys.stock': 'Vùng',
  'sys.download': 'tải',
  'sys.stockNum': 'Số cổ phiếu',
  'sys.stockNum1': 'Hãy nhập kho',
  'sys.platformCode': 'Mã code của nhà cái',
  'sys.inputYear': 'Năm nhập khẩu',
  'sys.operatePermission': 'Cơ quan quản lý',
  'sys.uploadApp': 'Tải tập tin ứng dụng',
  'common.operateSuccess2': 'Hoạt động thành công. Hệ thống sẽ xử lý nó tự động. Xin cập nhật lại yêu cầu sau.',
  'menu.signQueryGamePlatform': 'Thiết lập logo platform',
  'constants.gameChess6_LC': 'Cờ Long Thành',
  'user.title.channel': 'Kênh',
  'sys.navName': 'Tên duyệt qua',
  'sys.navName.prompt': 'Hãy nhập tên định vị',
  'sys.nav.type': 'Kiểu duyệt',
  'sys.nav.type.prompt': 'Hãy chọn một kiểu di chuyển',
  'sys.nav.img': 'Ảnh duyệt qua',
  'sys.nav.img.prompt': 'Vui lòng tải lên ảnh dẫn đường',
  'agent.settlementDate.month': 'Tháng giải quyết',
  'agent.settlementDate.startDate': 'Đầu',
  'agent.settlementDate.endDate': 'Cuối',
  'pay.title.cancelOrder1': 'Anh có chắc muốn hủy đơn đặt hàng không?',
  'sys.title.orderAmount3': 'Dừng',
  'login.install.current': 'Số phiên bản hiện tại',
  'user.title.updatePromotionPicture': 'Sửa ảnh giới thiệu',
  'user.title.silentRate': 'Người dùng không tương tác',
  'user.title.activationCount': 'Kích hoạt {importCount} người',
  'user.title.loading': 'Nạp...',
  'user.title.device': 'thiết bị',
  'user.title.registerSource': 'Nguồn nhập',
  'user.title.riskDetail': 'Chi tiết về rủi ro',
  'user.title.adjustedRiskLevel': 'Điều chỉnh mức rủi ro',
  'user.title.firstDepositRate1': 'Tiền kí gửi đầu tiên: người dùng đầu tiên/ Người chơi mới',
  'user.title.registerSelf': 'Tự đăng ký',
  'user.title.registerAgent': 'Kênh đặc vụ',
  'user.title.channelSource': 'Nguồn kênh',
  'user.title.giveRequire': 'Hạn chế phân phối',

  'common.requestException': 'Lỗi yêu cầu',
  'common.requestException1': 'Yêu cầu không bình thường, hãy thử lại sau.',
  'common.requestError1': 'Yêu cầu thất bại, hãy thử lại!',
  'common.requestError': '{err}, vui lòng thử lại sau.',
  'common.operateSuccess': 'Tỉ lệ thành công',
  'common.operateSuccess1': 'Thêm thành công',
  'common.operateFail2': 'Thao tác thất bại với {message}',
  'common.export.loading': 'Tính xuất',
  'common.export.success': 'Xuất đã thành công!',
  'common.export.error': 'Lỗi xuất, dữ liệu xuất khẩu quá lớn, xin xuất hàng loạt',
  'common.export.excel': 'báo cáo xuất',
  'common.export.noneExport': 'Người dùng hiện thời không có dữ liệu xuất khẩu',
  'common.export.type': 'Kiểu xuất',
  'common.export.type0': 'Nhập khẩu thành viên',
  'common.export.type2': 'Xuất đại diện',
  'common.export.type1': 'Thành viên xuất',
  'common.export.type3': 'Xuất đại diện tổng hợp',
  'common.export.notice': 'Vui lòng chọn nội dung bảng hoạt động tử tế',
  'common.button.update': 'Chỉnh:',
  'common.button.update.role': 'Sửa đổi vai trò',
  'common.button.delete': 'Xóa bỏ',
  'common.queryFrm.reset': 'Thiết lập mới',
  'common.refresh': 'Làm mới',
  'common.queryFrm.searchMore': 'Tìm thêm',
  'common.queryFrm.searchClean': 'Xóa mục tìm kiếm',
  'common.queryFrm.searchHide': 'Nhiều tìm kiếm ẩn. Nếu các tiêu chuẩn tìm kiếm không được xóa, hãy nhắp vào nút để xóa các tiêu chuẩn tìm kiếm.',
  'common.queryFrm.cleanAndClose': 'Rõ và đóng',
  'common.queryFrm.searchUserAccountRemark': 'Tên tài khoản',
  'common.radio.minute': 'Phút',
  'common.radio.hour': 'Thời gian',
  'common.radio.day': 'ngày',
  'common.radio.week': 'tuần',
  'common.radio.month': 'tháng',
  'common.radio.permanent': 'vĩnh viễn',
  'common.radio.beforeYesterday': 'Hôm kia',
  'common.radio.thisWeek': 'Tuần này',
  'common.radio.lastWeek': 'Tuần trước',
  'common.radio.thisMonth': 'Tháng này',
  'common.radio.lastMonth': 'Tháng trước',
  'common.radio.disable': 'Cấm',
  'common.radio.enable': 'Kích hoạt',
  'common.radio.enableDisable': 'Hãy chọn nếu cần bật',
  'common.radio.enableDisable1': 'Đã bật chưa?',
  'common.radio.block': 'trốn',
  'common.radio.display': 'Hiển thị',
  'common.radio.blockDisplay': 'Đã bật chưa?',
  'common.radio.recommend': 'Giới thiệu',
  'common.radio.notRecommend': 'Không nên',
  'common.radio.recommendAndNotRecommend': 'Giới thiệu',
  'common.radio.pc': 'Phiên bản máy tính',
  'common.radio.mobile': 'Ứng dụng điện thoại',
  'common.radio.pcAndMobile': 'Cuộn tròn',
  'common.radio.level1': 'Hạng A',
  'common.radio.level2': 'cấp hai',
  'common.title.dataSummary': 'Tập hợp dữ liệu',
  'common.title.userName': 'Tên tài khoản',
  'common.title.completeUserName': 'Vui lòng nhập số tài khoản thành viên đầy đủ của bạn',
  'common.title.createAdmin': 'Lập',
  'common.title.createTime': 'Thời gian tạo',
  'common.title.updateAdmin': 'Người tạo',
  'common.title.settlement': 'Thời gian quyết toán',
  'common.title.noData': 'Không có dữ liệu',
  'common.records': 'bản ghi',
  'common.queryFailed': 'Truy vấn thất bại',
  'common.search': 'Tìm kiếm',
  'common.reset': 'Đặt lại',
  'common.title.updateTime': 'Thời gian thao tác',
  'common.select.selectType1': 'Kiểu chọn',
  'common.select.selectType': 'Hãy chọn kiểu',
  'common.select.allType': 'Tất cả các hình thức',
  'common.select.allWay': 'Tất cả các phương thức',
  'common.select.allStatus': 'Toàn bộ trạng thái',
  'common.select.allDevice': 'Mọi thiết bị',
  'common.select.allLevel': 'Mọi cấp độ',
  'common.select.selectChannel': 'Hãy chọn kênh',
  'common.select.init': 'Mời lựa chọn',
  'common.select.allChannel': 'Mọi kênh',
  'common.select.init1': 'Toàn bộ',
  'common.select.init2': 'Cấu hình đầy đủ',
  'common.select.selectStatus': 'Hãy chọn trạng thái',
  'common.checkBox.selectAll': 'Mọi cuộc bỏ phiếu',
  'common.checkBox.selectAll2': 'Chọn tất cả',

  'constants.gameLive2_AG': 'AG',
  'constants.gameLive2_NEWAG': '新AG',
  'constants.gameLive2_EBET': 'EBET',
  'constants.gameLive2_OG': 'OG',
  'constants.gameLive2_OG1': 'OG1',
  'constants.gameLive2_BG': 'BG',
  'constants.gameLive2_BG2': 'BG2',
  'constants.gameLive2_GD': 'GD',
  'constants.gameLive2_EG': 'EG真人',
  'constants.gameLive2_SB': '申博真人',
  'constants.gameLive2_TS': '泰山真人',
  'constants.gameLive2_DG': 'DreamGame',
  'constants.gameLive2_SEXY': 'Sexy真人',
  'constants.gameLive2_VENUS': 'Venus真人',
  'constants.gameLive2_SEXY3': 'Sexy真人3',
  'constants.gameLive2_VENUS3': 'Venus真人3',
  'constants.gameLive2_MAYE': '玛雅真人',
  'constants.gameLive2_AB': '欧博',
  'constants.gameLive2_BBIN': 'BBIN',
  'constants.gameLive2_NEWBBIN': 'NEWBBIN',
  'constants.gameLive2_SA': 'SA',
  'constants.gameLive2_TP': 'TP',
  'constants.gameLive2_GPI': 'GPI',
  'constants.gameLive2_NEWSA': '新SA',

  'constants.gameSport3_XSPORT': 'HAHA体育',
  'constants.gameSport3_AVIA': '泛亚电竞',
  'constants.gameSport3_IBC': 'IBC 沙巴体育',
  'constants.gameSport3_UG': 'UG 联合体育',
  'constants.gameSport3_UG2': 'UG 联合体育',
  'constants.gameSport3_PINGBO': '平博体育',
  'constants.gameSport3_BETLINK': '博林体育',
  'constants.gameSport3_IM': 'IM体育',
  'constants.gameSport3_IMDJ': 'IM Sports',
  'constants.gameSport3_XINBAO': 'XINBAO Sports',
  'constants.gameSport3_IBC2': '沙巴体育',
  'constants.gameSport3_ESPORTS': 'ESports',
  'constants.gameSport3_THREESING': '3昇体育',
  'constants.gameSport3_UWIN': 'U赢 电竞',
  'constants.gameSport3_DSDJ': '东森电竞',
  'constants.gameSport3_XA': '小艾电竞',
  'constants.gameSport3_LH': '雷火电竞',
  'constants.gameSport3_FB': 'Speed sports',
  'constants.gameSport3_JC': 'Competitive lottery Sports',
  'constants.gameSport3_AISPORT' : 'AI sports',
  'constants.gameSport3_FBTY' : 'FB sports',
  'constants.gameSport3_SBO': 'SBO sports',
  'constants.gameSport3_HG' : 'crown sports',
  'constants.gameSport3_PM' : 'PM sports',
  'constants.gameSport3_SBOI': 'SBOI sports',
  'constants.gameSport3_SPB': 'SPB 街机',
  'constants.gameSport3_NEWIM': 'NEW IM',

  'constants.gameLottery4_CQ': 'ST胜天彩票',
  'constants.gameLottery4_VR': 'VR彩票',
  'constants.gameLottery4_KG': 'KG彩票',
  'constants.gameLottery4_DSEN': '东森彩票',
  'constants.gameLottery4_TCG': 'TCG lottery',
  'constants.gameLottery4_TCG_VN': 'TCG lottery',

  'constants.gameLottery4_IG_GFC': 'IG 官方彩',
  'constants.gameLottery4_GS': '本站彩票',
  'constants.gameLottery4_DBCP': 'DB lottery',
  'constants.gameLottery4_NEWDB': 'DB lottery',
  'constants.gameLottery4_TP': 'TP',
  'constants.gameLottery4_BBIN': 'BBIN',
  'constants.gameLottery4_DB': 'DB lottery',
  'constants.gameLottery4_SPRIBE': 'SPRIBE lottery',
  'constants.gameLottery4_CG': 'CG lottery',
  'constants.gameLottery4_QQK': 'QQKeno lottery',
  'constants.gameLottery4_FG': 'Funky Games lottery',
  'constants.gameLottery4_SEA': 'Sealotto lottery',
  'constants.gameLottery4_YESB': 'YES BINGO lottery',
  'constants.gameLottery4_VL': 'VL lottery',
  'constants.gameLottery4_AE': 'AE lottery',

  'constants.gameFish5_GG': 'GG捕鱼',
  'constants.gameFish5_BBIN': 'BBIN',
  'constants.gameFish5_NEWBBIN': 'NEWBBIN',
  'constants.gameFish5_SA': 'SA',
  'constants.gameFish5_SA2': '新SA',
  'constants.gameFish5_AG': 'AG',
  'constants.gameFish5_NEWAG': '新AG',
  'constants.gameFish5_JILI': 'JILI',
  'constants.gameFish5_TP': 'TP',
  'constants.gameFish5_YL': 'YL',
  'constants.gameFish5_KA': 'KA',
  'constants.gameFish5_VA': 'VA',
  'constants.gameFish5_FTG': 'FTG',
  'constants.gameFish5_PLAYSTAR': 'PLAYSTAR',
  'constants.gameFish5_ASKME': 'ASKME',
  'constants.gameFish5_VNRTG': 'VNRTG',
  'constants.gameFish5_FC': 'FC',
  'constants.gameFish5_YESBINGO': 'YESBINGO',
  'constants.gameFish5_LUCKY': 'Lucky',
  'constants.gameFish5_PHPSG': 'SG',
  'constants.gameFish5_WG': 'WG',
  'constants.gameFish5_ACE': 'ACE Fish',
  'constants.gameFish5_SGFISH': 'SG Fish',

  'constants.gameFish5_OBBY': 'OBBY',
  'constants.gameChess6_OBQP': 'DB棋牌',
  'constants.gameFish5_PHJILI': 'PHJILI',
  'constants.gameChess6_KY': '开元棋牌',
  'constants.gameChess6_LUCKY': '幸运棋牌',
  'constants.gameChess6_V8': 'V8 Chess',
  'constants.gameChess6_LY': 'LY棋牌',
  'constants.gameChess6_YL': 'YL棋牌',
  'constants.gameChess6_KM': 'KM Chess',
  'constants.gameChess6_TP': 'TP',
  'constants.gameChess6_VNRICH88': 'VNRICH88',
  'constants.gameChess6_FTG': 'FTG',
  'constants.gameChess6_KINGMAKER_CHESS': 'KINGMAKER Chess',
  'constants.gameChess6_VG': 'VG 棋牌',
  'constants.gameChess6_SSO761': '761棋牌',
  'constants.gameChess6_LEG': 'LEG 棋牌',
  'constants.gameChess6_CS': '财神棋牌',
  'constants.gameChess6_GAMMA': '加玛棋牌',
  'constants.gameChess6_HT': '黑桃棋牌',
  'constants.gameChess6_TM': '天美棋牌',
  'constants.gameChess6_JILI': 'JILI',
  'constants.gameChess6_PHJILI': 'JILI',
  'constants.gameChess6_WG': 'WG',

  'constants.platforms_BBIN': 'BBIN',
  'constants.platforms_NEWBBIN': 'NEWBBIN',
  'constants.platforms_SA': 'SA',
  'constants.platforms_SA2': '新SA',
  'constants.platforms_NEWSA': '新SA',
  'constants.platforms_AG': 'AG',
  'constants.platforms_NEWAG': '新AG',
  'user.searchUser': 'Tìm thấy thành viên , Tên người chơi:{userAccount}',
  'user.searchUserFail': 'Tìm không thấy thành viên',
  'user.logout': 'Đăng xuất',
  'user.changePass': 'Thay đổi mật khẩu',
  'user.title.message': 'Tin nhắn',
  'user.empty.message': 'Bạn đã đọc toàn bộ tin nhắn',
  'user.icon.online': 'Trực tuyến',
  'user.button.confirm': 'Xác nhận',
  'user.form.oldPass': 'Vui lòng nhập mật khẩu cũ',
  'user.form.newPass': 'Vui lòng nhập mật khẩu mới',
  'user.form.newPassAgain': 'Vui lòng nhập mật khẩu mới lần nữa',
  'msg.clear': 'Trống',
  'msg.allRead': 'Đã đọc toàn bộ',
  'msg.closeBeep': 'Tắt âm báo',
  'msg.openBeep': 'Bật âm báo',
  'bet.title.platformCode': 'Mã số của nhà cái',
  'bet.title.betAmount': 'Tiền cược',
  'bet.title.betflow': 'Tiền hiệu quả',
  'bet.title.betTime': 'Thời gian cược',
  'bet.title.createTime': 'Thời gian kết thúc',
  'bet.label.pageBet': 'Số tiền đặt cược trên trang này',
  'bet.label.pageFlow': 'Tiền đặt cược hiểu quả trên trang này',
  'bet.label.pageProfit': 'Lợi nhuận nhà cái trên trang này',
  'bet.label.pageProfitVN': 'Lợi nhuận nhà cái trên trang này (VND)',
  'bet.label.totalBet': 'Tổng số tiền đặt cược',
  'bet.label.totalBetVN': 'Tổng số tiền đặt cược (VND)',
  'bet.label.totalFlow': 'Tổng cược hiệu quả',
  'bet.label.totalFlowVN': 'Tổng cược hiệu quả (VND)',
  'bet.label.totalProfit': 'Tổng lợi nhuận nhà cái',
  'bet.label.totalProfitVN': 'Tổng lợi nhuận nhà cái (VND)',
  'bet.strAttr1.game': 'Game',
  'bet.strAttr1.platType': 'Cách chơi',
  'bet.strAttr1.period': 'Số phòng',
  'bet.strAttr1.result': 'Kết quả',
  'game.platform.order': 'Mã số của nhà cái：{gsId}',
  'game.game.order': 'Mã số trò chơi：{bizNo}',
  'bet.export.exportName': 'Xuất kỷ lục đặt cược',
  'bet.export.title': 'Gợi ý xuất ra',
  'bet.export.content': 'Đã được xuất ra , Bấm OK để xem tiến trình xuất hoặc sau đó qua Bảng điều khiển> Xuất dữ liệu Xem Tải xuống',
  'bet.queryFrm.betDate': 'Thời gian đặt cược',
  'bet.queryFrm.createDate': 'Thời gian kết thúc',
  'bet.queryFrm.platformCode': 'Trò chơi của nhà cái',
  'bet.queryFrm.gameType': 'Thể loại trò chơi',
  'user.chart.memberCount': 'Số lượng thành viên (người)',
  'user.title.activeUser': 'Hoạt động người chơi',
  'user.title.peopleNumber': 'Số người',
  'bet.chart.bettingSettlement': 'Thanh toán tiền cược',
  'finance.title.prompt': 'Gợi ý',
  'finance.content.prompt': 'Có cần thay đổi thành thống kê nạp rút',
  'finance.content.prompt2': 'Có cần thay đổi thành thống kê nạp rút',
  'bet.title.userAccount': 'Tên thành viên',
  'bet.title.ticketNumber': 'Ticket Number',
  'finance.title.transNoAndTransName': 'Số đơn hàng / Tên',
  'finance.title.transName': 'Tên: {transDetail}',
  'finance.title.transType': 'Loại hình đối chiếu',
  'finance.title.amount': 'Số tiền đối chiếu',
  'finance.title.transType1': 'Phương thức',
  'finance.title.transType1_1': 'Chưa thống kê',
  'finance.title.transType1_9': 'Thống kê nạp tiền',
  'finance.title.transType1_10': 'Thông kế rút tiền',
  'finance.title.afterAmount': 'Số tiền còn lại',
  'finance.title.remark': 'Ghi chú',
  'finance.title.createTimeAndCreateAdmin': 'Người đối chiếu/ Thời gian đối chiếu',
  'finance.title.updateTimeAndUpdateAdmin': 'Người chỉnh sửa / Thời gian chỉnh sửa',
  'sys.hasStock': 'Thể loại nạp tiền',
  'sys.hasStock0': 'Không giới hạn',
  'sys.hasStock1': 'Giới hạn số lượng',
  'sys.hasStock3': 'Vui lòng lựa chọn loại phần thưởng',
  'lottery.lotteryTime': 'Thời gian bốc thăm',
  'lottery.title.day': 'Ngày',
  'agent.export.agentReportExcel': 'Danh sách đại lý.xls',
  'user.title.from': 'Đường link đăng ký',
  'user.title.to': 'Đến',
  'lottery.title.confirmNotice16': 'Xác nhận rằng bạn muốn đặt lại mật khẩu thanh toán của đại lý. Sau khi đặt lại, việc rút tiền của đại lý cần có mật khẩu mới?',
  'user.title.assignDetail': 'Chi tiết phân phối',
  'common.radio.seconds': 'lần',
  'user.title.dial': 'Quay số',
  'game.title.betAmount1': 'Tiền đặt cược',
  'game.title.playerProfit1': 'Lợi nhuận của người chơi',
  'user.title.idNo2': 'Mã số chứng minh nhân dân',
  'user.title.gender': 'Giới tính',
  'user.title.address': 'Địa chỉ',
  'user.title.unVerifiedPhone': 'Chưa xác minh số điện thoại',
  'agent.title.resetPassSuccess1': ' Thiết lập mật khẩu rút tiền thành công',
  'user.title.playerInvite': 'Lời mời tham gia',
  'user.title.addBonusSuccess': 'Thêm ưu đãi thành công',
  'user.title.loadingUserInfoFail': 'Không thể tải thông tin người dùng',
  'user.title.loadingUserInfoError': 'Tải thông tin người dùng lỗi',
  'user.title.totalUserCount': 'Tổng số người chơi:',
  'user.title.totalDepositUserCount': 'Tổng số người nạp tiền',
  'user.title.totalFirstDepositUserCount': 'Tiền nạp đầu tiên',
  'user.title.last7': '7 ngày qua',
  'user.title.last30': '30 ngày qua',
  'user.title.last60': '60 ngày qua',
  'user.title.queryType': 'Tìm kiếm thể loại',
  'sys.title.limitLength200': 'Vui lòng nhập dưới 200 ký tự',
  'sys.set': 'Thiết lập',
  'sys.submitPer': ' Người đề xuất',
  'sys.submitTime': 'Thời gian đề xuất',
  'pay.title.cancelOrder': 'Hủy bỏ đơn',
  'user.title.devicTime': 'Thời gian liên kết',
  'user.title.unTied': 'Hủy liên kết',
  'agent.title.newPassIs1': 'Đặt lại mật khẩu rút tiền thành công, mật khẩu mới là：',
  'constants.signType_0': 'Phổ biến',
  'constants.signType_1': 'Hoạt động',
  'constants.signType_2': 'Giải thưởng lớn',
  'constants.gameSignType_0': ' Phổ biến',
  'constants.gameSignType_1': 'Trò chơi',
  'constants.gameSignType_2': 'Live',
  'constants.gameSignType_3': 'Thể thao',
  'constants.gameSignType_4': 'Xổ số',
  'constants.gameSignType_5': 'Bắn cá',
  'constants.gameSignType_6': 'Cờ vua',
  'game.title.changeGamePlatformSign': 'Thay đổi ký hiệu nền tảng trò chơi',
  'game.title.signType': 'Ký hiệu thể loại',
  'game.title.hotSignType': 'Ký hiệu thể loại phổ biến',
  'game.title.signStatus': 'Ký hiệu trạng thái',
  'game.title.hotSignStatus': 'Ký hiệu trạng thái phổ biến',
  'game.title.changeStatus_0': 'Vô hiệu hóa ký hiệu',
  'game.title.changeStatus_1': 'Kích hoạt ký hiệu',
  'game.title.changeStatus_01': 'Vô hiệu hóa ký hiệu phổ biến',
  'game.title.changeStatus_10': 'Kích hoạt ký hiệu phổ biến',
  'analyze.card.rechargeRate': 'Tỉ lệ nạp tiền',
  'sys.nav.modal.list': 'Danh sách điều hường',


// assetsBalanceLog
  'common.finance.autoTransferOutGame': 'Tự động chuyển ra khỏi trò chơi {platformName}',
  'admin.pay.manualDepositWithDrawals': 'Rút tiền thủ công',
  'admin.finance.rejectWithdrawals': 'Từ chối rút tiền',
  'admin.finance.rejectWithdrawalsReason': 'Đơn xin rút tiền bị từ chối và số dư được trả lại.',
  'admin.finance.recharge': 'Nạp tiền',
  'common.bonus.bonusToGame': 'Phần thưởng {fullName} tự động được chuyển vào trò chơi',
  'common.bonus.issueBonus': '{fullName}Phát hành tiền thưởng',
  'common.finance.customerServiceManualTransfer': 'Bộ phận CSKH chuyển thủ công,{userName}',
  'common.finance.bonusAprove': '{userName} Phê duyệt,{bonusName}',
  'admin.bonus.realTimeDepositBonus': 'Thời gian hoàn tiền thực tế,{date}',
  'admin.bonus.remittanceChannelBonus': 'Tiền thưởng kênh chuyển tiền,{date}',
  'admin.bonus.dividends': 'Cổ tức,{date}',
  'common.bonus.inviteBonus': 'Phần thưởng lời mời,{date}',
  'common.bonus.signDrawBonus': 'Đăng nhập vào phần thưởng bốc thăm,{date}',
  'common.bonus.continuousDepositDrawBonus': 'Tiền thưởng tiền gửi liên tục,{date}',
  'common.bonus.continuousDepositPointsBonus': 'Điểm thưởng tiền gửi liên tục,{date}',
  'common.bonus.flowRebate': '{type}Hoàn trả doanh thu cược,{date}',
  'common.bonus.betBonus': '{type} tiền thưởng đặt cược,{date}',
  'common.bonus.rescueFundBonus': 'Quỹ tích lũy,{rescueFundBonus}',
  'common.bonus.activityType1Prize': 'Giải thưởng băng chuyền may mắn',
  'common.bonus.activityType2Prize': 'Lắc giải',
  'common.bonus.activityType4Prize': 'Giải thưởng hộp mù',
  'common.bonus.activityType5Prize': 'Giải thưởng quay tiền mặt',
  'common.bonus.alwaysRebate': '{gametype} luôn luôn giảm giá {date}',
  'common.bonus.signPointsBonus2': '{userAccount} Đăng nhập điểm thưởng, {date}',
  'front.bonus.noteBonus': 'Ghi chú phần thưởng',
  'front.bonus.memberInfoBindingBonus': 'Phần thưởng ràng buộc thông tin thành viên',
  'front.bonus.agentRegisterBonus': 'Cung cấp đăng ký miễn phí thông qua đăng ký đại lý',
  'front.bonus.depositBonus': 'Phần thưởng tiền nạp',
  'front.bonus.upgradeReward': '{bonusName}-Nâng cấp phần thưởng',
  'front.bonus.weekReward': '{bonusName}-Phần thưởng Châu Tinh Trì',
  'front.bonus.monthReward': '{bonusName}-Phần thưởng Yuelulu',
  'front.bonus.customerServiceRetrieval': 'Phục hồi dịch vụ khách hàng {platformKey}',
  'admin.finance.assetsAccountMsg1': 'Bộ phận chăm sóc khách hàng bù đơn , không lấy được từ trò chơi , {platformCode}',
  'admin.finance.assetsAccountMsg2': 'Bộ phận chăm sóc khách hàng bù đơn , chuyển sang trò chơi thất bại , {platformCode}',
  'front.bonus.customerServiceBatchRetrieval': 'Dịch vụ khách hàng truy xuất hàng loạt {platformKey}',
  'front.bonus.autoReplenishment1': 'Tự động bổ sung, không thể truy xuất từ trò chơi，{platformCode}',
  'front.bonus.autoReplenishment2': 'Tự động bổ sung, chuyển vào trò chơi thất bại，{platformCode}',
  'common.finance.autoTransferInGame': 'Tự động chuyển vào trò chơi{platformName}',
  'front.pay.applyForWithdrawal': 'Đăng ký rút tiền',
  'front.pay.applyForWithdrawalMinusAmount': 'Đăng ký rút tiền trừ đi số tiền',
  'common.bonus.addBonusesBackground': 'Tiền thưởng từ hậu đài:{name}',

  //admin_user_behavior
  'front.pay.adjustableWithdrawal': 'Điều chỉnh rút tiền:{betFlowBalance} -> {availBalance}',
  'admin.bonus.approveBonus': 'Lợi nhuận được xem xét thông qua：{bonusName}',
  'admin.bonus.effectiveFlow': '{bonusName},cài đặt lưu lượng hiệu quả：{validBetflow}',
  'admin.bonus.cancelBonus': 'Rút lợi nhuận：{bonusName}',

  //assets_bonus_log
  'common.bonus.playerManuallyApply': 'Người chơi tự thêm thủ công:{userAccount}',
  'front.bonus.extraBonus': 'Người chơi nhận thêm tiền thưởng:{userAccount}',
  'front.bonus.redeemPointsManually': 'Đổi điểm thủ công:{0}',
  'front.bonus.continuousDepositBonus': 'Thưởng tiền nạp liên tiếp',
  'front.bonus.checkInBonus': 'Đăng ký nhận phần thưởng',
  'front.bonus.invitationBonus': 'Phần thưởng lời mời',

  //bonus_article_info
  'admin.bonus.bounusCopy': '{articleName}(Sao chép)',

  //bonus_import_info
  'admin.bonus.uploadNoticeError': 'Dòng {num}; lỗi tham số, vui lòng kiểm tra cẩn thận.',
  'common.userAccountNotExist4': 'Tên người dùng không tồn tại',

  //msg_site
  'admin.bonus.bonusArrivalNotice': 'Thông báo đã nhận Tiền thưởng 【{bonusName}】',
  'admin.bonus.bonusArrivalNotice1': 'Xin chào, bạn đã nhận được  {bonusName} của bạn, tổng cộng {bonusAmount} đồng. Vui lòng kiểm tra và xác nhận',
  'admin.msg.withDrawalsApproveNotice': 'Yêu cầu rút tiền của bạn {amount} đã được xem xét thành công',
  'admin.msg.wihtDrawalsPayoutNotice': 'Lệnh rút tiền vào ngày {date} của quý khách, đã thành công, Lệnh rút tiền = {amount1}, (Phí chuyển khoản = {amount2}. Số tiền thực tế là  = {amount3}). Quý khách vui lòng kiểm tra lại. Nếu có bất kì thắc mắc nào,vui lòng liên hệ bộ phận chăm sóc khách hàng trực tuyến. Xin cảm ơn..',
  'common.msg.withDrawalsSuccess': 'Lệnh rút tiền của quý khách {amount} đã được gửi đến tài khoản ngân hàng của bạn',
  'common.msg.withDrawalsSuccessNotice': 'Lệnh rút tiền của quý khách {amount}, đã được gửi đến tài khoản ngân hàng của bạn.Nếu có bất kì thắc mắc nào,vui lòng liên hệ bộ phận chăm sóc khách hàng trực tuyến. Xin cảm ơn.',

  //notice_record
  'admin.msg.riskControlApproveNotice': '(Kiểm toán thao tac) Người dùng {userAccount} đã xin rút {amount} VNĐ, được chấp thuận bởi {userName},tài vụ có thể xem xét',
  'admin.msg.manualConfirmRechargeNotice': '(Tài vụ thao thác) Người dùng {userAccount} nạp lại {orderAmount} VNĐ, được xác nhận thủ công bởi {userName}',
  'admin.msg.riskControlRejectNotice': '(Kiểm soát viên thao tác) Người dùng {userAccount} đã xin rút {amount} VNĐ, đã bị từ chối bởi {userName}',
  'admin.msg.financeRejectWithdrawalsNotice': '(Hoạt động tài chính) Người dùng {userAccount} đã xin rút {amount} VNĐ, đã bị từ chối bởi {userName}',
  'admin.msg.financeApproveNotice': '(Hoạt động tài chính) Người dùng {userAccount} đã nộp đơn xin rút {amount} VNĐ, đã được {userName} thanh toán',
  'admin.msg.financePayforTimeoutNotice': '(Hoạt động tài chính) Người dùng {userAccount} đã xin rút {amount} VNĐ, đã được thỏa thuận bởi {userName}, {payName} yêu cầu thanh toán đã hết hạn, vui lòng kiểm tra trạng thái đơn hàng của nền tảng thanh toán',
  'admin.msg.financePayforExceptionNotice': '(Hoạt động tài chính) Người dùng {userAccount} đã xin rút {amount} VNĐ, đã được thỏa thuận bởi {userName}, {payName} yêu cầu thanh toán là bất thường, vui lòng kiểm tra trạng thái đơn hàng của nền tảng thanh toán',
  'admin.msg.financePayforFailNotice': '(Hoạt động tài chính) Người dùng {userAccount} đã xin rút {amount} VNĐ, được thỏa thuận bởi {userName}, {payName} yêu cầu thanh toán không thành công: {massage}, vui lòng kiểm tra trạng thái đơn hàng của nền tảng thanh toán "',
  'admin.msg.financePayforSuccess': '(Hoạt động tài chính) Người dùng {userAccount} đã xin rút {amount} VNĐ, đã được thỏa thuận bởi {amount}, {payName} đang thanh toán',
  'admin.msg.financePayforSuccess1': '(Hoạt động tài chính) Người dùng{userAccount} dăng ký rút tiền{amount}，Đã được{channel} thành công trong việc cho tiền',
  'admin.msg.financePayforFail': '(Hoạt động tài chính) Người dùng{userAccount} dăng ký rút tiền{amount}，{channel} không thể trả tiền',
  'admin.msg.paymentSuccessRate1': '(Hoạt động tài chính) Phương thức thanh toán: {payRemark}, kênh thanh toán: {viewName}, tỷ lệ thanh toán thành công: {successRate}, thấp hơn tỷ lệ cảnh báo thành công. Hãy chú ý kiểm soát.',
  'admin.msg.paymentSuccessRate2': '(Hoạt động tài chính) Phương thức thanh toán: {payRemark}, kênh thanh toán: {viewName}, tỷ lệ thanh toán thành công: {successRatew}, thấp hơn tỷ lệ vô hiệu hóa thành công. Phương thức thanh toán này đã được tự động vô hiệu hóa. Hãy chú ý xem xét',
  'admin.msg.companyDeposit': '(Hoạt động tài chính)Máy nghe nhạc:{userAccount},Áp dụng cho một khoản tiền gửi của công ty {amount}，Số thứ tự:{orderNo}',
  'front.finance.windControlAudit': '(Kiểm toán) Người dùng {account} đã xin rút {amount} VNĐ, kiểm toán vui lòng xem xét.',
  'front.finance.rechargeSuccess': '(Hệ thống) Người dùng{userAccount} Nạp tiền {orderAmount} thành công。',

  //log_export
  'admin.sys.ftpPathError': 'Lỗi tạo đường dẫn FTP',
  'admin.sys.ftpReaptFileError': 'Tập tin đã tồn tại , lỗi lặp lại',

  //sms_name_verify_log
  'admin.msg.realNameName': 'Tên thật：{userName}',

  //user_remark
  'admin.finance.withdrawals': 'Rút tiền',

  //assets_deposit
  'admin.pay.manualTransfer': 'Đối chiếu thủ công',
  'admin.pay.manualDeposit': 'Gửi tiền thủ công',
  'admin.pay.manualTransferRemoval': 'Đối chiếu thủ công, rút tiền thủ công:{userName}',


  'sys.frontMatch.matchName':'赛事名称',
  'sys.frontMatch.hTeam':'主队名称',
  'sys.frontMatch.hTeamLogo':'主队图标',
  'sys.frontMatch.gTeam':'客队名称',
  'sys.frontMatch.gTeamLogo':'客队图标',
  'sys.frontMatch.jumpUrl':'跳转地址',
  'sys.frontMatch.insertMatch':'新增赛事',
  'sys.frontMatch.updateMatch':'修改赛事',





  'sys.activity.win.type': '中奖展示类型',
  'sys.activity.win.type.prompt': '请选择中奖类型',
  'sys.activity.falseWin': '虚假中奖信息',
  'sys.activity.realWin': '真实中奖信息',
  'sys.activity.lotteryStyle': 'Phương pháp xổ số',
  'sys.activity.selectLotteryStyle': 'Vui lòng chọn phương pháp xổ số',
  'sys.activity.lotteryStyle1': 'Cái bánh xe lớn',
  'sys.activity.lotteryStyle2': 'Máy đánh bạc',

  'sys.pcImage': 'PC端图片',
  'sys.APPImage': '移动端图片',
  'sys.bonus.lock.type': '锁定类型 ',
  'sys.bonus.lock.type.1': '优惠金额',
  'sys.bonus.lock.type.2': '优惠金额 + 本金',
  'sys.bonus.deposit.lock.type': '解锁相关',
  'sys.bonus.deposit.lock.type.0': '不解锁',
  'sys.bonus.deposit.lock.type.1': '解锁此订单的充值锁定',
  'sys.extraLogo': '额外图标',
  'sys.msg201': 'pc端-上传游戏额外LOGO',
  'sys.msg202': 'mobile端-上传游戏额外LOGO',
  'menu.member.signMember': 'Huy hiệu người chơi',
  'menu.operation.balanceRate': 'Ví tiền',
  'menu.operation.balanceRate.programSetting': 'Phương án cài đặt',
  'menu.operation.balanceRate.buyRecord': 'Lịch sử mua hàng',
  'constants.bonusType_21': 'Điểm thưởng mới báo danh',
  'constants.newBonusType_21': 'Điểm thưởng mới báo danh',
  'constants.bonusMainType_21': 'Điểm thưởng mới báo danh',
  'constants.gameSlot1_IGS': 'IG Slot',
  'constants.gameSlot1_PT2': 'PT Slot',
  'constants.gameSlot1_GG2': 'GG2 Slot',
  'constants.gameSport3_CMD': 'CMD Sport',
  'constants.gameSport3_WS168': 'WS168 ĐÁ GÀ',
  'constants.gameSport3_S128': 'S128 ĐÁ GÀ',
  'constants.gameSport3_BBIN': 'BBIN',
  'constants.gameSport3_TP': 'TP',
  'constants.gameSport3_BTI': 'BTI Sport',
  'constants.gameSport3_DS': 'DS88 Sport',
  'constants.gameSport3_DS888': 'DS888 ĐÁ GÀ',

  'constants.gameLottery4_KK': 'KK Sport',
  'constants.gameChess6_DGC': 'DG棋牌',
  'sys.bonus.domain.type': '是否限制域名',
  'sys.bonus.domain.type.prompt': '限制域名不能为空',
  'sys.bonus.domain.noLimited': '无限制',
  'sys.bonus.domain.Limited': '限制域名',
  'sys.bonus.domain.input.prompt': '域名列表(逗号分隔)',
  'sys.bonus.domain.nullPrompt': '请输入域名',
  'sys.bonus.domain.input.maxPrompt': '最大长度256，请勿超出',
  'sys.bonus.domain.prompt': '请输入赠送的域名(顶级域名即可)；如：baidu.com,baidutwo.com',
  'front.bonus.selfRegisterBonus': '通过自己注册赠送注册优惠',

  'menu.operation.frontContent.match': 'Quản lý sự kiện',
  'sys.bonus.refuseMessage': 'Thông tin từ chối',
  'sys.bonus.signInOnlyExistOn': 'Chỉ có một đề nghị được đặt ra.',
  'sys.validit.joinUserLevel': 'Thành viên tham gia',
  'sys.validit.pleaseSelectJoinUserLevel': 'Hãy chọn mức thấp nhất của thành viên có thể tham gia vào hoạt động',
  'sys.signInCnd': 'Kiểm tra',
  'sys.signInDay': 'ngày',
  'sys.signInTotalDeposit': 'Tiền nạp lần đầu',
  'sys.signInOneDeposit': 'Mức ký gửi đơn',
  'sys.signInGiveAmount': 'Phần thưởng',
  'sys.signInGivePoint': 'Điểm thưởng',
  'sys.signInBetflowMultiple': 'Chảy nhiều',
  'sys.signInOtherAmount': 'Tiền thưởng thêm',
  'sys.signInOtherPoint': 'Thêm điểm',
  'sys.signInTotalBetflowCnd': 'Đặt hiệu quả',
  'sys.pcPicH5SmallPic': 'Biểu tượng nhỏ PC',
  'sys.pcSmallPic': 'Biểu tượng nhỏ PC',
  'sys.h5SmallPic': 'H5 biểu tượng nhỏ',
  'menu.sys.popularPlatformGame': 'Thiết lập chuẩn trò chơi',
  'sys.addGame': 'Thêm game',
  'sys.select.gameList': 'Hãy chọn một trò chơi',
  'sys.edit.popular': 'Sửa thông tin phổ biến',
  'sys.popularType': 'Kiểu bình dân',
  'user.title.signName': 'Tên nhãn',
  'user.title.signName1': 'Hãy nhập tên nhãn',
  'user.title.addMemberSign': 'Thẻ thành viên mới',
  'common.button.addMemberSign': 'Thêm thẻ thành viên',
  'sys.title.deleteMemberSignName': 'Thẻ thành viên cần xoá:{signName}',
  'sys.lengthLimit5': 'Nhập tới bảy nhân vật Trung Quốc',
  'user.button.markMember': 'Người dùng có thẻ',
  'user.title.noneSign': 'Hiện tại, không có thẻ tùy chọn. Xin hãy đến trang thẻ thành viên để thêm một thẻ.',
  'user.msg.markMember': 'Đánh dấu thành công',
  'user.msg.markMember1': 'Lỗi đánh dấu',
  'user.title.memberSign': 'Huy hiệu đã đạt',
  'sys.cellphoneNumber4': 'Hãy nhập số di động Việt Nam',
  'constants.gameChess6_BL': 'Bản cờ đậm/ điện',
  'constants.gameSlot1_AWS': 'Siêu pin',
  'sys.rateBonus.allStatus': 'Toàn bộ',
  'sys.rateBonus.create': 'Thêm phương án mới',
  'sys.rateTable.amountLimit': 'Giới hạn tiền giao dịch',
  'sys.rateTable.totalRate': 'Tổng lại suất',
  'sys.rateTable.programCycle': 'Phương án thanh toán trong tuần',
  'sys.rateTable.scheduleCycle': 'Phương án trong tuần',
  'sys.rateTable.settlementCycle': 'Thánh toán trong tuần',
  'sys.rateTable.timeType': 'Thời gian',
  'sys.rateTable.rateLimit': 'Giới hạn lãi suất',
  'sys.rateTable.needBetflow': 'Yêu cầu doanh thu',
  'sys.rateTable.capital': 'Tiền vốn',
  'sys.rateTable.rate': 'Lợi tích',
  'sys.rateTable.multiple': 'Gấp',
  'sys.rateTable.settlement': 'Tình trạng suất đi',
  'sys.rateTable.totalStock': 'Tổng tiền được chia',
  'sys.rateTable.selled': 'đã bán',
  'sys.rateTable.going': 'Tính lợi tích',
  'sys.rateTable.edit': 'Đang cài đặt',
  'sys.rateTable.market': 'Trên kệ',
  'sys.rateTable.takeOff': 'Dưới kệ',
  'sys.rateTable.sort': 'Sắp xếp theo thứ tự',
  'sys.singleTime':'Chỉ riêng lần',
  'sys.accumulative':'lí',
  'bonus.rateTitle.createBalanceRate': 'Chương trình mới Yo\'eba.',
  'bonus.rateTitle.editBalanceRate': 'Sửa chế độ u',
  'bonus.rateTitle.bonusName': 'Tên phương án',
  'bonus.rateTitle.bonusName1': 'Hãy nhập tên giản đồ',
  'bonus.rateTitle.sort': 'Thứ',
  'bonus.rateTitle.sort1': 'Xin hãy nhập đơn đặt',
  'bonus.rateTitle.minBuyAmount': 'Giá trị tối thiểu',
  'bonus.rateTitle.minBuyAmount1': 'Hãy nhập số tiền mua ít nhất',
  'bonus.rateTitle.maxBuyAmount': 'Giá trị tối đa',
  'bonus.rateTitle.maxBuyAmount1': 'Hãy nhập vào mức mua bán tối đa',
  'bonus.rateTitle.buyAmountRightNotice': 'Hãy nhập số lượng chính xác',
  'bonus.rateTitle.totalRate': 'Tổng lãi',
  'bonus.rateTitle.totalRate1': 'Ghi chú số tiền lãi',
  'bonus.rateTitle.settlementCycle': 'Thời gian trả lời',
  'bonus.rateTitle.settlementCycle1': 'Nhập thời gian giải quyết',
  'bonus.rateTitle.settlementCycleNotice': 'Trong vòng xoay của kế hoạch, lãi suất sẽ được phát hành một lần mỗi vòng dàn xếp, và lãi suất của mỗi vòng định cư là "lãi suất tổng hợp I.Giả sử như tỉ lệ lãi suất trong tổng hợp là 3=, khoảng thời gian của kế hoạch là 24h và khoảng xoay sở là 1 Giờ, 0.125=. lãi suất sẽ được trả trong mỗi mỗi kỳ định cư.',
  'bonus.rateTitle.schemeCycle': 'Thời gian kế hoạch: {schemeCycle} giờ',
  'bonus.rateTitle.schemeCycle1': 'Chu kỳ giải quyết: {settlementCycle} giờ',
  'bonus.rateTitle.loopType': 'Tính chu kỳ',
  'bonus.rateTitle.loopType1': 'Hãy chọn chế độ tính chu kỳ',
  'bonus.rateTitle.loopTypeNotice': 'Kiểm to án chu kỳ dựa trên: giảm giá lãi suất theo giới hạn tối đa của lãi suất hay thu thập tài khoản của khách hàng theo vòng kế hoạch.Cứ giả sử rằng lãi suất của RMB 10 sẽ được định vị trong ba giờ trong vòng xoay, và tiếp tục định vị trong vòng thứ sáu tới khi giới hạn tối đa hay rút xuất hiện; tính to án chu kỳ kín: sau khi quá hạn của vòng kế hoạch, vòng kế tiếp sẽ không được giải quyết.Cứ giả sử rằng lãi suất của RMB 10 sẽ được giải quyết trong vòng ba giờ của chu kỳ, và nó sẽ không được giải quyết sau một lần giải quyết.',
  'bonus.rateTitle.maxRateAmount': 'Số lãi suất tối đa',
  'bonus.rateTitle.maxRateAmount1': 'Hãy nhập số lãi suất tối đa',
  'bonus.rateTitle.capitalBetflowMultiple': 'Hiện đa nguyên tố',
  'bonus.rateTitle.capitalBetflowMultiple1': 'Hãy nhập số hiện thời cần thiết cho yêu cầu rút lui chính.',
  'bonus.rateTitle.rateBetflowMultiple': 'Tài sản hiện tại',
  'bonus.rateTitle.rateBetflowMultiple1': 'Hãy nhập số hiện thời cần thiết cho việc rút lãi.',
  'bonus.rateTitle.totalStock': 'Tổng số tiền',
  'bonus.rateTitle.totalStock1': 'Hãy nhập số bản sao tổng hợp',
  'bonus.rateTitle.userBuyCount': 'Số cổ phiếu có thể mua được',
  'bonus.rateTitle.userBuyCount1': 'Hãy nhập số thành viên tối đa cần mua',
  'bonus.rateTitle.buyAgainTime': 'Khoảng thời gian giữa mua lại (giờ)',
  'bonus.rateTitle.buyAgainTime1': 'Hãy nhập giai đoạn này',
  'bonus.rateTitle.buyUserVip': 'Giá trị đòi hỏi',
  'bonus.rateTitle.buyUserVip1': 'Hãy chọn mức độ cần thiết để mua',
  'sys.rateTable.deleteNotice': 'Vẫn còn một kế hoạch chưa được chuộc lại, và nó không thể bị xóa đi.',
  'bonus.rateMsg.buyAmountNotice': 'Giá trị tối thiểu không thể lớn hơn giá trị tối đa',
  'bonus.rateMsg.scheduleNotice1': 'Thời kỳ giải quyết không thể lớn hơn thời gian trong kế hoạch',
  'bonus.rateMsg.scheduleNotice2': 'khoảng thời gian của Scheme phải được chia ra theo thời gian giải quyết',
  'bonus.buyRecord.buyTime': 'Thời gian mua',
  'bonus.buyRecord.ransomTime': 'Thời gian đổi thưởng',
  'bonus.buyRecord.status_1': 'Đang tích lũy',
  'bonus.buyRecord.status_2': 'Chờ đổi thưởng',
  'bonus.buyRecord.status_3': 'Đã đổi thưởng',
  'bonus.buyRecordTable.bonusName': 'Tên phương án',
  'bonus.buyRecordTable.programAmount': 'Số tiền phương án',
  'bonus.buyRecordTable.captipleAmount': 'Tiền vốn',
  'bonus.buyRecordTable.rateAmount': 'Lợi tích',
  'bonus.buyRecordTable.programSchedule': 'Khái quát ví tiền',
  'bonus.buyRecordTable.schemeCycle': 'Phương án trong tuần',
  'bonus.buyRecordTable.settlementCycle': 'Thời gian kết toán',
  'bonus.buyRecordTable.loopType': 'Phương án hàng tuần',
  'bonus.buyRecordTable.status': 'Trạng thái',
  'bonus.buyRecordTable.status_1': 'Tính lợi tích',
  'bonus.buyRecordTable.status_2': 'Đang cài đặt',
  'bonus.buyRecordTable.status_3': 'Đang cài đặt',
  'bonus.buyRecordTable.time': 'Thời gian',
  'bonus.buyRecordTable.buyTime': 'Thời gian mua',
  'bonus.buyRecordTable.ransomTime': 'Thời gian đổi thưởng',
  'bonus.buyRecordTable.finishTime': 'Thời gian đổi thưởng',
  'bonus.buyRecordTable.ransomAdmin': 'Đang cài đặt',
  'bonus.buyRecordTable.operate': 'Thao tác',
  'bonus.buyRecordTable.forceRansom': 'Bắt buộc quy đổi',
  'bonus.buyRecordTable.capitalBetflowMultiple': 'Doanh thu đổi thưởng yêu cầu tiền vốn: {capitalBetflowMultiple}',
  'bonus.buyRecordTable.rateBetflowMultiple': 'lợi tích của doanh thu đổi thưởng phải đạt yêu cầu:{rateBetflowMultiple}',
  'bonus.buyRecordTable.maxRateAmount': 'số tiền lợi tích tối đa: {maxRateAmount}',
  'bonus.buyRecordTable.confirmForceRansomMsg': 'Lệnh xác nhận',
  'bonus.buyRecordTable.confirmForceRansom': 'Bạn có muốn xác nhận chọn phương án bắt buộc quy đổi không',
  'admin.bonus.rejectBonus': 'Bonus phủ nhận: {bonusName}',
  'sys.startTime2': 'Bắt đầu thời gian đấu',
  'sys.successfulOperation': 'Hoạt động thành công！',
  'admin.msg.financePayforManualFail': '(Hoạt động tài chính) Người dùng {userAccount} đã xin rút {amount} nhân dân tệ, được người dùng {userName} đặt thủ công làm lỗi thanh toán',
  'admin.msg.deposit': '(Hoạt động tài chính) Người chơi: {userAccount}, đăng ký ký gửi {amount}, số thứ tự: {orderNo}',
  'admin.pay.depositType': 'Loại hình nạp tiền',
  'sys.registerMember': 'Thành viên không phải đại lý',
  'admin.pay.deletePayment': 'Vui lòng tắt trước khi xóa！',
  'sys.title.bonusArtId': 'ID bài viết',
  'sys.title.onlinePay': 'Thanh toán trực tuyến',
  'sys.title.offlinePay': 'Thanh toán ngoại tuyến',
  'sys.title.officePay': 'Tiền gửi công ty',
  'pay.earlyWarning.addEarlyWarning': 'Thêm cảnh báo',
  'pay.earlyWarning.earlyWarningThreshold': 'Cảnh báo trước',
  'pay.earlyWarning.earlyWarningThreshold1': 'Vui lòng nhập ngưỡng cảnh báo',
  'pay.earlyWarning.editEarlyWarning': 'Điền thông tin cảnh báo',
  'pay.earlyWarning.successRoteEarlyWarning': 'Báo động tỷ lệ thành công kênh',
  'admin.finance.payEarlyWarningNotify': '{customizeName} Tỷ lệ thành công dưới {earlyWarningThreshold}%, vui lòng kiểm tra kịp thời',
  'sys.msg1421': 'Chi tiết tài khoản',
  'sys.attribution1': 'Phân bổ IP',
  'menu.ee.gameMonitor': 'Giám sát trò chơi toàn cầu',
  'user.userChangeParentAgent': 'Thay đổi đại lý cấp trên',
  'user.userChangeParentAgent1': 'Vui lòng chọn một thành viên để thay đổi các đại lý cấp trên',
  'user.addTHAUser': 'Những người chơi mới',
  'user.addTHAUser.withdrawPassword': "Rút lại mật khẩu",
  'user.addTHAUser.agentCode': "Số đại lý",
  'user.phoneIsValid': 'Số lượng có được xác minh hay không',
  'user.updateBank': "Sửa đổi thẻ ngân hàng",
  'finance.payGroup.remark': 'Hướng dẫn thanh toán',
  'finance.payGroup.addRemark': 'Thêm hướng dẫn thanh toán',
  'finance.payGroup.externalLinkAmountRange': "Hiển thị phạm vi số lượng liên kết bên ngoài",
  'sys.uniqueLimit.IP': 'Hạn chế chỉ IP',
  'sys.uniqueLimit.device': 'Hạn chế chỉ dành cho thiết bị',
  'sys.uniqueLimit.phone': 'Giới hạn số điện thoại di động',
  'sys.receiveCount': 'Thời gian đón',
  'user.member.signMember': 'Thẻ thành viên',
  'sys.title.deleteFail': 'Xóa thất bại, vui lòng thử lại',
  'user.title.realtimeListExcel': 'Báo cáo thống kê thời gian thực của thành viên.xls',
  'user.title.currentResultAmount':'Thắng hay thua',

  'bet.queryFrm.gameName':'Tên trò chơi',
  'bet.queryFrm.agentName':'Tài khoản của đại lý',
  'bet.queryFrm.betweenResultAmount':'Thắng và thua',
  'common.queryFrm.searchGameName':'Tên trò chơi',
  'common.queryFrm.searchAgentName':'Tài khoản của đại lý',
  'common.queryFrm.searchMinResultAmount':'Chiến thắng tối thiểu',
  'common.queryFrm.searchMaxResultAmount':'Thắng hay thua tối đa',
  'constants.gameSlot1_NEWSA':'SA mới',
  'constants.gameFish5_NEWSA':'SA mới',
  // 4.02
  'admin.withdraw.currentChannelDisable': 'Kênh hiện tại bị vô hiệu hóa, vui lòng sử dụng kênh khác',
  'withdraw.loadConfigInfoFail': 'Không thể tải thông tin cấu hình thanh toán',
  'withdraw.loadConfigInfoError': 'Không thể tải lỗi thông tin cấu hình thanh toán',
  'withdraw.label.withdrawChannel': 'Kênh thanh toán',
  'withdraw.label.withdrawChannel1': 'Vui lòng chọn kênh thanh toán',
  'withdraw.label.Code': 'Mã vạch của bên thử ba',
  'withdraw.channel.submit.title.prompt': 'Gửi kênh thanh toán',
  'withdraw.channel.submit.content.prompt': 'Sau khi thêm kênh thanh toán mới, vui lòng điền các thông số của kênh thanh toán, nếu không sẽ xảy ra lỗi trong quá trình thanh toán!',
  'sys.bonus.editDisplaySort': 'Sắp xếp khu hoạt động',
  'sys.editSuccess': 'Việc sắp xếp sửa đổi là thành công!',
  'sys.editFail': 'Chỉnh sửa thất bại',
  'sys.editError': 'Sửa đổi lỗi',
  'sys.approveLock': 'Khóa phê duyệt',
  'sys.confirmConsent3': 'OK để bắt đầu xem xét？',
  'sys.confirmConsent4': 'Có nên khóa rút tiền để xem xét',
  'sys.confirmConsent5': 'Dấu nhắc khóa kiểm soát rủi ro',
  'sys.confirmConsent6': 'Bản ghi kiểm soát rủi ro đang được xem xét bởi {userAccount} và bị khóa',
  'sys.confirmConsent7': 'Bản ghi kiểm soát rủi ro {userAccount} đã được xem xét và mở khóa',
  'sys.confirmConsent8': 'Bản ghi kiểm soát rủi ro bị quản trị viên {userAccount} mở khóa, đã được mở khóa',
  'risk.approveLock': 'Đánh giá bị khóa',
  'risk.approveUnLock': 'Đánh giá đã mở khóa',
  'pay.title.adminUnlock': 'Quản trị viên mở khóa',
  'sys.autofresh': 'Tự động làm mới',
  'sys.autofresh.none': 'Không làm mới',
  'sys.autofresh.15s': 'Làm mới 15 giây',
  'sys.autofresh.30s': 'Làm mới sau 30 giây',
  'sys.autofresh.60s': 'Làm mới 60 giây',
  'pay.title.withdrawalStatus10': 'Khóa phê duyệt',
  'pay.title.withdrawalStatus11': 'Phê duyệt mở khóa',

  'constants.riskLevelType_-5': 'Hạn chế nạp tiền',
  'user.button.kickOffLine': 'Khởi đầu',
  'user.button.whetherOffline': 'Có nên đi ngoại tuyến',
  'menu.operationalStatistics': 'Thống kê số liệu hoạt động',
  'menu.killAnalysis': 'Phân tích thiệt hại',
  'menu.discountAnalysis': 'Phân tích hoạt động giảm giá',
  'member.title.regCount': 'Số người đăng ký',
  'member.title.firstDepositTotal': 'Nạp lần đầu',
  'member.title.firstDepositRate': 'Lãi suất tiền gửi đầu tiên',
  'member.title.firstDepositCount': 'Tổng số tiền nạp trong ngày',
  'member.title.secondDepositCount': 'Tiền nạp lần 2 trong ngày',
  'member.title.thirdDepositCount': 'Tiền nạp lần 3 trong ngày',
  'member.title.fourthDepositCount': 'Tiền nạp lần 4 trong ngày',
  'member.title.fifthDepositCount': 'Tiền nạp lần 5 trong ngày',
  'member.title.depositCount': 'Tổng số người nạp tiền',
  'member.title.depositTotal1': 'Tổng số tiền nạp',
  'member.title.withdrawalCount': 'Tổng số người rút',
  'member.title.withdrawalTotal': 'Tổng số tiền rút',
  'member.title.depositWithdrawalDiff': 'Chênh lệch giữa nạp và rút',
  'member.title.tripartitePlatformProfit': 'Số tiền thắng của 3 nhà cái hiện có',
  'member.title.bonusName': 'Tên khuyến mãi',
  'member.title.attendCount': 'Số người tham gia',
  'member.title.depositTotal': 'Tổng số tiền nạp và người chơi tham gia',
  'member.title.withdrawTotal': 'Tổng số tiền rút và người chơi tham gia',
  'member.title.profitAndLoss': 'Hoạt động thắng thua',
  'member.title.codeBonusAmount': 'Phần thưởng hoạt động',
  'member.title.codeBonusStrSet': 'Thiết lập mật khẩu',
  'member.title.applicationConditions': 'Điều kiện ứng dụng',
  'member.title.luckyDrawOpportunity': 'Cách tiếp cận xổ số',
  'member.title.raffleLife': 'Cuộc sống nảy mầm',
  'member.title.participationRestriction': 'Hạn chế tham gia',
  'member.extra.attendCountPage': 'Số lượng người tham gia trên trang này',
  'member.extra.depositTotalPage': 'Tổng số tiền gửi trên trang này (nhân dân tệ)',
  'member.extra.depositTotalPageVN': 'Tổng số tiền gửi trên trang này (VND)',
  'member.extra.bonusTotalPage': 'Tổng số ưu đãi trên trang này (nhân dân tệ)',
  'member.extra.bonusTotalPageVN': 'Tổng số ưu đãi trên trang này (VND)',
  'member.extra.withdrawTotalPage': 'Tổng số tiền rút trên trang này (nhân dân tệ)',
  'member.extra.withdrawTotalPageVN': 'Tổng số tiền rút trên trang này (VND)',
  'member.extra.profitAndLossPage': 'Tổng lãi và lỗ trên trang này (nhân dân tệ)',
  'member.extra.profitAndLossPageVN': 'Tổng lãi và lỗ trên trang này (VND)',
  'member.extra.attendCountTotal': 'Tổng số người tham gia',
  'member.extra.depositTotalTotal': 'Tổng tiền gửi (nhân dân tệ)',
  'member.extra.depositTotalTotalVN': 'Tổng tiền gửi (VND)',
  'member.extra.bonusTotalTotal': 'Tổng chiết khấu (nhân dân tệ)',
  'member.extra.bonusTotalTotalVN': 'Tổng chiết khấu (VND)',
  'member.extra.withdrawTotalTotal': 'Tổng số tiền rút (nhân dân tệ)',
  'member.extra.withdrawTotalTotalVN': 'Tổng số tiền rút (VND)',
  'member.extra.profitAndLossTotal': 'Tổng lãi và lỗ hoạt động (nhân dân tệ)',
  'member.extra.profitAndLossTotalVN': 'Tổng lãi và lỗ hoạt động (VND)',
  'member.title.platformName': 'Tên nền tảng',
  'member.title.platformFlow': 'Doanh thu của nhà cái trong ngày',
  'member.title.platformWinAndLoss': 'Thắng thua của nhà cái trong ngày',
  'member.title.betCount': 'Tổng số người đặt cược trong ngày',
  'member.title.kill': 'Thiệt hại',
  'menu.announcementList': 'Danh sách thông báo',
  'sys.title.pubTime': 'Thời gian phát hành',
  'sys.title.title': 'Tiêu đề thông báo',
  'sys.title.content': 'Nội dung thông báo',
  'sys.title.pubAmdin': 'Người phát hành',
  'sys.title.isRead': 'Bạn đã đọc chưa',
  'sys.title.readTime': 'Thời gian đã xem',
  'sys.title.datePlatform': 'Ngày/ Nhà cái',
  'user.title.operationalStatisticsExcel': 'Báo cáo thống kê dữ liệu hoạt động.xls',
  'user.title.killAnalysisExcel': 'Báo cáo phân tích đếm.xls',
  'user.title.discountAnalysisExcel': 'Báo cáo phân tích hoạt động ưu tiên.xls',
  'user.title.countTime': 'Thời gian thống kê',
  'constants.bonusType_23': 'Ưu đãi nạp tiền VIP',
  'constants.gameSlot1_PT1': 'PT1 electron',
  'constants.payLevel1_0': 'Thành viên hạng nhất',
  'constants.payLevel1_1': 'Mọi thành viên',
  'constants.payLevel1_2': 'Thành viên thứ hai',
  'constants.payLevel1_3': 'Thành viên lớp ba',
  'constants.payLevel1_4': 'Thành viên cấp 4',
  'constants.payLevel1_5': 'Thành viên cấp năm',
  'constants.payLevel1_6': 'Thành viên cấp 6',
  'constants.payLevel1_7': 'Thành viên cấp 7',
  'constants.payLevel1_8': 'NAME OF TRANSLATORS',
  'constants.payLevel1_9': 'Thành viên cấp 9',
  'constants.payLevel1_10': 'NAME OF TRANSLATORS',
  'constants.gameLive2_WM': 'WM',
  'constants.gameLive2_WE': 'người thật về WE',
  'constants.gameLive2_EVO': 'người thật về EVO',
  'constants.gameLive2_AE': 'người thật về AE',
  'constants.gameLive2_XG': 'người thật về XG',
  // 'constants.gameLive2_Evolution': 'người thật về Evolution',
  'pay.title.ipWhite': 'Người chơi tải xuống',
  'pay.title.operateDetail': 'Người thao tác/ thời gian thao tác',
  'pay.add.newIpWhite': 'Thêm những tài khoản đăng nhập',
  'pay.query.keyword': 'Tên kênh hay IP',
  'pay.label.ipWhite': 'Xin hãy điền vào danh sách màu trắng IP',
  'pay.setting.prompt': 'Mẹo',
  'pay.setting.promptDetail': 'Hãy đặt các tham số trước',
  'pay.label.tokenKeyDetail': 'Thêm thông tin mật mã',
  'user.title.authRealName': 'Xác thực tên thật',
  'user.title.authEmail': 'Hòm thư',
  'user.title.authPhone': 'Chứng nhận số điện thoại',
  'user.title.registerAndLastLoginTime': 'Thời gian đăng ký',
  'sys.deposit': 'Nạp',
  'sys.needDeposit': 'nhu',
  'user.title.fundOverview': 'Khái quát ví tiền',
  'sys.registerItem.msg1': 'Mục nhập nhập',
  'sys.validit.length': 'Độ dài của chữ',
  'sys.validit.requireSwith': 'Yêu cầu hay không',
  'constants.require.status_1': 'Yêu cầu',
  'constants.require.status_0': 'Không cần thiết',
  'menu.operation.frontContent.RegisterItem': 'Quản lý mục đăng ký',
  'user.title.realWechat': 'Nói chuyện thật.',
  'user.title.realQQ': 'QQ thật',
  'user.title.showQQContact': 'Xem QQ',
  'user.title.showWechatContact': 'Xem wechat',
  'user.title.changeQQContact': 'Sửa đổi QQ',
  'user.title.changeWechatContact': 'Sửa wechat',
  'user.title.oldWechat': 'Trò chuyện cũ.',
  'user.title.newWechat': 'Trò chuyện mới',
  'user.title.oldQQ': 'QQComment',
  'user.title.newQQ': 'Thêm QQ',
  'user.title.pleaseEnterNewWechat': 'Hãy nhập một tài khoản wechat mới',
  'user.title.pleaseEnterNewQQ': 'Hãy nhập số QQ mới',
  'common.radio.requireTrue': 'Thay đổi sang yêu cầu',
  'common.radio.requireFalse': 'Thay đổi sang không cần thiết',
  'sys.firstDepositTimeLimit': 'Hạn chót của lần đầu gởi',
  'sys.selectFirstDepositTimeLimit': 'Hãy chọn giới hạn thời gian của lần lưu đầu tiên',
  'menu.newSetting': 'Mức thành viên VIP',
  'agent.SubordinateTransfer': 'Chuyển qua phó điệp viên hay thành viên',
  'constants.agentSubordinate_0': 'Đặc vụ phụ',
  'constants.agentSubordinate_1': 'Thành viên thứ hai',
  'agent.subordinateTransfer_0': 'Hãy chọn đặc vụ hay thành viên',
  'agent.subordinateTransfer_1': 'Hãy chọn nhân viên',
  'agent.subordinateTransfer_2': 'Xin hãy nhập số tiền chuyển',
  'common.select.beginTime': 'Hãy chọn giờ khởi động',
  'common.select.endTime': 'Hãy chọn thời gian kết thúc',
  'common.title.questionnaire': 'Tên câu hỏi',
  'common.title.questionnaireDesc': 'Nạp tiền cấp dưới',
  'common.title.respondents': 'Điểm thưởng',
  'common.title.questionnaireOperate': 'Thao tác quản lý câu hỏi',
  'common.title.questionOperate': 'Đề mục thao tác',
  'menu.operation.questionnaire': 'Câu hỏi góp ý',
  'user.disableNotice1': 'Anh có chắc muốn vô hiệu hoá câu hỏi này không?',
  'user.enableNotice1': 'Anh có chắc muốn bật câu hỏi này không?',
  'sys.addQuestionnaire': 'Thêm câu hỏi',
  'sys.enterQuestionnaireTitle': 'Hãy nhập tên câu hỏi',
  'sys.enterQuestionnaireDesc': 'Ghi lại mô tả câu hỏi',
  'sys.enterBeginDate': 'Hãy chọn ngày khởi động',
  'sys.enterRespondents': 'Hãy chọn vật thể tham khảo',
  'sys.enterEndDate': 'Hãy chọn ngày kết thúc',
  'common.title.questionDesc': 'Tiêu đề:',
  'common.title.questionType': 'Kiểu chủ đề',
  'common.title.isMust': 'Yêu cầu hay không',
  'guessRecordData.roundNo': 'Số Vòng',
  'guessRecordData.orderNo': 'Số Đơn Hàng',
  'guessRecordData.createTime': 'Thời Gian Đặt Cược',
  'guessRecordData.showId': 'Phiên Livestream',
  'guessRecordData.roomNumber': 'Số Phòng',
  'guessRecordData.groupName': 'Tên Trò Chơi/Kết Quả Mở Thưởng',
  'guessRecordData.nickname': 'Người Đặt Cược',
  'guessRecordData.antes': 'Cược Cơ Bản',
  'guessRecordData.multiple': 'Bội Số',
  'guessRecordData.status0': 'Đã Đặt Cược',
  'guessRecordData.status1': 'Đã Hủy',
  'guessRecordData.status2': 'Đã Trả Thưởng',
  'guessRecordData.payAmount': 'Tổng Số Tiền',
  'guessRecordData.sendAwardAmount': 'Số Tiền Đã Trả',
  'guessRecordData.details': 'Chi Tiết',

  'guessResultLogData.resultName': 'Tên Kết Quả Mở Thưởng',
  'guessResultLogData.resultData': 'Thông Tin Đóng Cược và Mở Thưởng',
  'guessResultLogData.status0': 'Đang Đặt Cược',
  'guessResultLogData.status1': 'Đã Đóng Cược',
  'guessResultLogData.status2': 'Đã Xác Nhận',
  'guessResultLogData.status3': 'Đã Mở Thưởng',
  'guessResultLogData.status4': 'Đã Hủy',
  'guessResultLogData.status5': 'Xác Nhận Chỉnh Sửa',
  'guessResultLogData.status6': 'Chờ Vô Hiệu',
  'guessResultLogData.status7': 'Chờ Chỉnh Sửa',
  'guessResultLogData.startTime': 'Thời Gian Bắt Đầu',
  'guessResultLogData.sealTime': 'Thời Gian Đóng Cược',
  'guessResultLogData.confirmTime': 'Thời Gian Xác Nhận',
  'guessResultLogData.reviewTime': 'Thời Gian Kiểm Duyệt',
  'guessResultLogData.mark': 'Mô Tả',
  'guessResultLogData.showPic': 'Ảnh Chụp Kết Quả',
  'guessResultLogData.sealPic': 'Ảnh Chụp Đóng Cược',
  'guessResultLogData.showClosePic': 'Video Đóng Cược',
  'guessResultLogData.showDetails': 'Xem Chi Tiết',

  'guessRecordDetailsData.odds': 'Tỷ Lệ Cược',

  'sys.enterQuestionDesc': 'Hãy nhập vào một tựa đề',
  'sys.enterQuestionType': 'Hãy chọn một kiểu chủ đề',
  'sys.title.editBonus': 'Sửa đổi ưu đãi',
  'sys.giftType': 'Kiểu năng khiếfu',
  'sys.rewardCashAmount': 'Giải thưởng tiền mặt',
  'sys.enterRewardCashAmount': 'Hãy nhập số tiền thưởng.',
  'sys.cashBetflow': 'Số tiền thưởng hiện tại',
  'sys.enterCashBetflow': 'Hãy nhập s ố tiền thưởng rút được hàng ngày',
  'sys.rewardPointAmount': 'Điểm thưởng',
  'sys.enterRewardPointAmount': 'Hãy nhập các điểm thưởng',
  'sys.rewardSwingTimes': 'Thời điểm thưởng',
  'sys.enterRewardSwingTimes': 'Hãy nhập số lần giật gân rung chuông',
  'sys.rewardSpinTimes': 'Số vòng tròn may mắn',
  'sys.enterRewardSpinTimes': 'Hãy nhập số phần thưởng bánh xe may mắn',
  'sys.rewardConditionType': 'Loại điều kiện',
  'sys.enterRewardConditionType': 'Hãy chọn kiểu điều kiện thưởng',
  'sys.title.result': 'Kết quả điều tra',
  'sys.title.searchType': 'Kiểu tìm kiếm',
  'sys.title.searchType1': 'Mã số đơn',
  'sys.title.searchType2': 'Tài khoản người chơi',
  'sys.title.searchType3': 'Kênh thanh toán',
  'sys.title.searchType4': 'Đơn của bên thứ ba',

  'menu.userSysAdmin': 'Quản lý tham số hệ thống',
  'menu.lottery': 'Quản lý xổ số',
  'menu.queryLotteryMethodList': 'Quản lý cách chơi',
  'menu.queryLotteryPropList': 'Quản lý thuộc tính',
  'menu.queryLotteryRateList': 'Quản lý tỷ lệ cược',
  'menu.popularPlatformGame': 'Thiết lập chuẩn trò chơi',
  'menu.ipBlockList': 'Danh sách IP xấu',
  'menu.deviceBlockList': 'Danh sách đen thiết bị người dùng',
  'menu.queryOfflinePayOrder': 'Phê duyệt thanh toán ngoại tuyến',
  'menu.queryOnlinePayOrder': 'Quản lý thanh toán trực tuyến',

  'menu.config': 'Cài đặt thanh toán',
  'menu.payGroup': 'Cài đặt nhóm thanh toán',
  'menu.payConfig': 'Thiết lập kênh thanh toán',
  'menu.withdrawPay': 'Thiết lập kênh thanh toán',
  'menu.payEarlyWarning': 'Cài đặt cảnh báo sớm kênh',
  'menu.payCallbackIpWhite': 'Thanh toán danh sách trắng',

  'menu.payChannel': 'Cài đặt kênh thanh toán',
  'menu.withdraw': 'Cài đặt kênh thanh toán',

  'menu.onlineUser': 'Thành viên trực tuyến',
  'menu.reportManualTransfer': 'Danh sách đối chiếu',
  'menu.agentManualTransfer': 'Báo cáo đối chiếu cơ quan',
  'menu.userGameReport': 'Danh sách tài khoản trò chơi',
  'menu.smsNameVerifyLog': 'Kỷ lục người chơi xác minh điện thoại',

  'menu.upgrade': 'Hình thức nâng cấp',
  'menu.upgradeSetting': 'Cài đặt cấp độ',
  'menu.upgradeUser': 'Danh sách người chơi',
  'menu.upgradeReport': 'Kỷ lục phát thưởng',

  'menu.programSetting': 'Cài đặt lược đồ',
  'menu.buyRecord': 'Lịch sử thanh toán',
  'menu.queryPushMessageList': 'Quản lý mục giới thiệu',
  'menu.signMember': 'Thẻ thành viên',
  'menu.balanceRate': 'Yuebao',


  'menu.articleMgmt': 'Quản lý điều lệ',
  'menu.articleTypeMgmt': 'Quản lý các thể loại điều lệ',
  'menu.nav': 'Quản lý điều hướng',
  'menu.pageMgmt': 'Quản lý trang',
  'menu.match': 'Quản lý sự kiện',
  'menu.RegisterItem': 'Quản lý mục đăng ký',
  'menu.checkin': 'Đăng nhập lịch sử khen thưởng',
  'menu.integralExchange': 'Lịch sử quy đổi điểm',
  'menu.paymentTab': 'Danh sách tỉ lệ thanh toán thành công',
  'menu.bonusArticle': 'Quản lý điều lệ',
  'menu.bonusApplyRole': 'Thiết lập bài trừ',
  'constants.transferType_16': 'Các đại lý cấp trên được chuyển bằng tay',
  'sys.addLotteryLimit': 'Số lượng cài đặt tối đa',
  'sys.cancelLottery': 'Loại bỏ tư cách rút thưởng',
  'sys.emptyLottery': 'Xóa điều kiện xổ số',
  'sys.content2': 'Có nên hủy bỏ trình độ xổ số của thành viên đã chọn？',
  'sys.enterCountLimit': 'Vui lòng nhập số lần tối đa',
  'sys.countLimit': 'Số lần tối đa',
  'sys.countLimitLength': 'Số lần tối đa là 9999',
  'sys.noneLimit': 'Vô hạn',
  'menu.questionnaire': 'Bảng câu hỏi',
  'sys.title.maintainBegin': 'Thời gian bắt đầu bảo trì',
  'sys.title.maintainEnd': 'Thời gian kết thúc bảo trì',
  'sys.button.maintainTickTock': 'Bảo trì theo lịch trình',
  'sys.button.add': 'Thêm',
  'sys.button.edit': 'Chỉnh sửa',
  'sys.button.button': 'Nút',
  'sys.button.addTitle': 'Thêm nút',
  'sys.button.editTitle': 'Chỉnh sửa nút',
  'sys.button.menu': 'Menu',
  'sys.button.selectMenu': 'Vui Lòng Chọn Menu',
  'sys.button.buttonCode': 'Mã Nút',
  'sys.button.enterButtonCode': 'Vui Lòng Nhập Mã Nút',
  'sys.button.buttonName': 'Tên Nút',
  'sys.button.enterButtonName': 'Vui Lòng Nhập Tên Nút',
  'sys.button.menuName': 'Tên Menu',
  'sys.button.deleteConfirm': 'Bạn có chắc chắn muốn xóa nút này không?',
  'sys.menu.add': 'Thêm',
  'sys.menu.edit': 'Chỉnh sửa',
  'sys.menu.menu': 'Menu',
  'sys.menu.addTitle': 'Thêm menu',
  'sys.menu.editTitle': 'Chỉnh sửa menu',
  'sys.menu.parentMenu': 'Nút Menu Cha',
  'sys.menu.selectParentMenu': 'Chọn Nút Menu Cha',
  'sys.menu.menuLevel': 'Cấp Menu',
  'sys.menu.selectMenuLevel': 'Vui Lòng Chọn Cấp Menu',
  'sys.menu.menuCode': 'Mã Menu',
  'sys.menu.menuName': 'Tên Menu',
  'sys.menu.isLeaf': 'Có Phải Nút Lá',
  'sys.menu.yes': 'Có',
  'sys.menu.no': 'Không',
  'sys.menu.menuUrl': 'Địa Chỉ URL Backend',
  'sys.menu.enterMenuUrl': 'Vui Lòng Nhập Địa Chỉ URL Backend',
  'sys.menu.menuOrder': 'Thứ Tự Menu',
  'sys.languageCurrency.languageConfig': 'Cấu Hình Đa Ngôn Ngữ',
  'sys.languageCurrency.currencyConfig': 'Cấu Hình Đa Tiền Tệ',
  'sys.language.add': 'Thêm',
  'sys.language.edit': 'Chỉnh sửa',
  'sys.language.icon': 'Biểu tượng',
  'sys.language.iconSpec': 'Thông số biểu tượng là 130*130',
  'sys.language.language': 'Ngôn ngữ',
  'sys.language.language.sign': 'Ký hiệu ngôn ngữ',
  'sys.language.enterLanguage': 'Vui lòng nhập ngôn ngữ',
  'sys.language.enterLanguage.sign': 'Vui lòng nhập mã định danh ngôn ngữ',
  'sys.language.cancel': 'Hủy',
  'sys.language.confirm': 'Xác nhận',
  'sys.language.initError': 'Vui lòng khởi tạo tham số chỉnh sửa trước',
  'sys.language.operationSuccess': 'Thao tác thành công',
  'sys.language.uploadSuccess': 'Tải lên thành công',
  'sys.language.uploadFailed': 'Tải lên thất bại',
  'sys.language.setDefaultConfirm': 'Bạn có chắc chắn muốn đặt ngôn ngữ đã chọn làm ngôn ngữ mặc định không?',
  'sys.language.enableConfirm': 'Bạn có chắc chắn muốn kích hoạt ngôn ngữ đã chọn không?',
  'sys.language.disableConfirm': 'Bạn có chắc chắn muốn vô hiệu hóa ngôn ngữ đã chọn không?',
  'sys.language.currentDefault': 'Ngôn Ngữ Mặc Định Hiện Tại',
  'sys.language.setAsDefault': 'Đặt Làm Mặc Định',
  'sys.language.addLanguage': 'Thêm Ngôn Ngữ',
  'sys.currency.add': 'Thêm',
  'sys.currency.edit': 'Chỉnh sửa',
  'sys.currency.icon': 'Biểu tượng',
  'sys.currency.iconSpec': 'Thông số biểu tượng là 130*130',
  'sys.currency.currencyName': 'Tên Tiền Tệ',
  'sys.currency.enterCurrencyName': 'Vui lòng nhập tên tiền tệ',
  'sys.currency.currencyAbbr': 'Viết Tắt Tiền Tệ',
  'sys.currency.enterCurrencyAbbr': 'Vui lòng nhập viết tắt tiền tệ',
  'sys.currency.currencySign': 'Ký Hiệu Tiền Tệ',
  'sys.currency.enterCurrencySign': 'Vui lòng nhập ký hiệu tiền tệ',
  'sys.currency.cancel': 'Hủy',
  'sys.currency.confirm': 'Xác nhận',
  'sys.currency.operationSuccess': 'Thao tác thành công',
  'sys.currency.uploadSuccess': 'Tải lên thành công',
  'sys.currency.uploadFailed': 'Tải lên thất bại',
  'sys.currency.setDefaultConfirm': 'Bạn có chắc chắn muốn đặt tiền tệ đã chọn làm tiền tệ mặc định không?',
  'sys.currency.enableConfirm': 'Bạn có chắc chắn muốn kích hoạt tiền tệ đã chọn không?',
  'sys.currency.disableConfirm': 'Bạn có chắc chắn muốn vô hiệu hóa tiền tệ đã chọn không?',
  'sys.currency.currentDefault': 'Tiền Tệ Mặc Định Hiện Tại',
  'sys.currency.setAsDefault': 'Đặt Làm Mặc Định',
  'sys.currency.addCurrency': 'Thêm Tiền Tệ',
  'sys.currency.noIcon': 'Không Có Biểu Tượng',
  'sys.addMaintenanceInfoSuccess1': 'Thêm thành công thông tin bảo trì đặt trước！',
  'sys.addMaintenanceInfoFail1': 'Không thể thêm thông tin bảo trì đặt trước',
  'sys.addMaintenanceInfoError1': 'Lỗi thêm thông tin bảo trì đặt trước',
  'sys.addMaintenanceInfoNotice': 'Thêm thông tin bảo trì đặt trước',
  'sys.addMaintenanceInfoNotice1': 'Bạn có chắc chắn để thay thế thông tin đặt trước hiện có',
  'sys.addMaintenanceInfoNotice2': 'Bạn có chắc chắn đặt trước bảo trì trong khoảng thời gian này',

  'member.remark.delete.all': 'xóa hết',
  'user.title.getBack': 'retrieve',

  'sys.msgContentTooLong':'Nội dung vượt quá 1000 ký tự, vui lòng kiểm tra nội dung văn bản và sao chép nội dung đó từ Wordman.',

  'constants.PAY_LEVEL1_VIP_MODEL_2_-1': 'Tất cả khả dụng',
  'constants.PAY_LEVEL1_VIP_MODEL_2_0': 'Cấp 0 có sẵn',
  'constants.PAY_LEVEL1_VIP_MODEL_2_1': 'Cấp 1 khả dụng',
  'constants.PAY_LEVEL1_VIP_MODEL_2_2': 'Cấp 2 có sẵn',
  'constants.PAY_LEVEL1_VIP_MODEL_2_3': '3 cấp độ khả dụng',
  'constants.PAY_LEVEL1_VIP_MODEL_2_4': '4 cấp độ khả dụng',
  'constants.PAY_LEVEL1_VIP_MODEL_2_5': '5 cấp độ khả dụng',
  'constants.PAY_LEVEL1_VIP_MODEL_2_6': '6 cấp độ khả dụng',
  'constants.PAY_LEVEL1_VIP_MODEL_2_7': '7 cấp độ khả dụng',
  'constants.PAY_LEVEL1_VIP_MODEL_2_8': '8 cấp độ khả dụng',
  'constants.PAY_LEVEL1_VIP_MODEL_2_9': '9 cấp độ khả dụng',
  'constants.PAY_LEVEL1_VIP_MODEL_2_10': 'Có sẵn ở cấp 10',

  'sys.offerCreateTime': 'Thời gian bắt đầu ưu đãi',

  'sys.betflowBonusGivePeriodType': 'Loại thời hạn thanh toán',
  'sys.betflowBonusGivePeriodTime': 'Thời hạn thanh toán',
  'sys.enterBetflowBonusGivePeriodType': 'Chọn loại thời gian giải quyết',
  'sys.betflowBonusGivePeriodTypeD Daily': 'Hàng ngày',
  'sys.betflowBonusGivePeriodTypeWeekly': 'Hàng tuần',
  'sys.betflowBonusGivePeriodTypeMonthly': 'Hàng tháng',
  'sys.enterBetflowBonusGivePeriodTime': 'Nhập thời gian giải quyết',

  'menu.four' : 'Vé số 4D ',
  'menu.bet' : 'Vé số 4D',
  'menu.drawOpen' : 'Xổ số 4D',
  'menu.fourConfig': 'Cấu hình xổ số 4D',

  'fourd.export.excel' : 'Vé số 4D.xls',
  'fourd.merchant.profit' : 'Lợi nhuận của thương gia',
  'fourd.bet.countNumber': 'Tổng cược lẻ',
  'fourd.bet.betCountNumber': 'Tổng số tiền đặt cược',
  'fourd.future.openPeriods': 'Thời gian bốc thăm dự kiến',
  'fourd.title.enteringOpenNumber': 'Nhập số xổ số, vui lòng phân tách nhiều số bằng dấu phẩy (,)',
  'fourd.title.firstPrize': 'Giải nhất',
  'fourd.title.twoPrize':   'giải nhì',
  'fourd.title.therePrize': 'Giải ba',
  'fourd.title.fourPrize':  'Chung kết',
  'fourd.title.fivePrize':  'Thoải mái chung',
  'fourd.bet.countBetAmount': 'Tổng số tiền đặt cược',
  'fourd.titile.payAmount': 'Số tiền thưởng',
  'fourd.title.lookDrawInfo': 'Xem thông tin xổ số',
  'fourd.title.payBetCount': 'Số lần thắng cược',
  'fourd.title.openType': 'Vẽ kiểu',
  'sys.title.weekType': 'tuần',

  'menu.promote': 'Quản lý Khuyến mại',
  'menu.promoteSetting': 'Cấu hình phần thưởng',
  'menu.promoteRewardReport': 'Báo cáo phần thưởng',
  'menu.promoteInvitationReport': 'Báo cáo lời mời',
  'menu.mlmSetting':'Renrendai configuration',
  'menu.mlmReport':'Report for everyone',

  'mlm.title.betflowCheck' : 'Effective betflow is satisfied',
  'mlm.title.depositCheck' : 'Definition of valid number of invitations: Deposit is met',
  'mlm.title.settingEnable' : 'Whether to enable invitation achievements',
  'mlm.title.desc1' : 'Statistics from the opening date (the opening date is displayed here)',
  'mlm.invite.id' : 'serial number',
  'mlm.invite.promoteName' : 'Achievement Name',
  'mlm.invite.promoteImgUrl' : 'Picture',
  'mlm.invite.inviteNumber' : 'The cumulative number of valid invitations',
  'mlm.invite.extraAmount' : 'Incentive amount',
  'mlm.invite.betflowMultiple' : 'flow multiple',
  'mlm.invite.extraPoint' : 'Reward Points',
  'mlm.invite.operation' : 'Operation',
  'mlm.invite.settingAdd' : 'Add invitation achievement',
  'mlm.invite.settingForm' : 'Invitation achievement configuration',
  'mlm.invite.field1' : 'Achievement name',
  'mlm.invite.field2' : 'Total number of valid invitations',
  'mlm.invite.field3' : 'Reward amount',
  'mlm.invite.field4' : 'rollover multiple',
  'mlm.invite.field5' : 'Reward Points',
  'mlm.invite.field6' : 'Whether to restrict the same IP and the same device',
  'mlm.invite.field7' : 'PC task icon',
  'mlm.invite.field8' : 'H5 side task icon',
  'mlm.invite.field9' : 'Picture',
  'mlm.invite.field10' : 'Inviter username',
  'mlm.invite.field11' : 'Number of invited registrants',
  'mlm.invite.field12' : 'Invite username',
  'mlm.invite.field13' : 'Invite reward amount',
  'mlm.invite.field14' : 'Distribution status',
  'mlm.invite.field15' : 'Accumulated effective turnover',
  'mlm.invite.field16' : 'Is it a valid member',
  'mlm.invite.field17' : 'Whether it is the same IP device',
  'mlm.invite.field18' : 'Invite valid users',
  'mlm.invite.field19' : 'Bonus type',
  'mlm.invite.field20' : 'Bonus',
  'mlm.invite.field21' : 'Points',
  'mlm.invite.field22' : 'The invitation achievement has been issued',
  'mlm.invite.field23' : 'Betting rebate has been distributed',
  'mlm.invite.field24' : 'Points for inviting students have been issued',
  'mlm.invite.field25' : 'Pen',
  'mlm.invite.field26' : 'Front desk invitation description',

  'table.title.promote.level': 'Cấp độ',
  'table.title.promote.bonus': 'Số tiền thưởng',
  'table.title.promote.multiple': 'Nhiều trình tự',
  'table.title.promote.extra.status': 'Có thêm phần thưởng nào không?',
  'table.title.promote.extra.nothing': 'Không có thêm phần thưởng',
  'table.title.promote.extra.perecent': 'Phần trăm phần thưởng',
  'table.title.promote.extra.level': 'Mức độ tham gia: {level} trở lên',
  'table.title.promote.upgradeCnd': 'Điều kiện nâng cấp và phần thưởng',
  'table.title.promote.extra.upgradeCount': 'Mời {count} người trở lên',
  'table.title.promote.extra.upgradeAmount': 'Phần thưởng {amount}',
  'table.title.promote.extra.upgradeMultiple': 'Cần phải hoàn thành {nhiều} lần đường dẫn',
  'table.title.promote.finishCnd': 'Điều kiện hoàn thành',
  'table.title.promote.checkInCount': 'Số lần đăng ký: {count}',
  'table.title.promote.totalDeposit': 'Khoản tiền gửi tích lũy: {amount}',
  'table.title.promote.betflowAmount': 'Đặt cược hợp lệ: {amount}',
  'table.title.promote.balanceFee': 'Yuebao lãi suất: {amount}',
  'table.title.promote.operate': 'Hoạt động',
  'sys.smg167': 'Bạn có chắc chắn xóa cấu hình phần thưởng khuyến mãi {level} không? ',
  'btnText.addPromoteSetting': 'Thêm cấu hình',
  'input.placeholder.msg': 'Mức thăng hạng',
  'btnText.editPromoteSetting': 'Chỉnh sửa cấu hình',
  'form.titalName.promote': 'Cấu hình Quảng cáo',
  'form.lableName.promote.level': 'Thăng cấp',
  'form.lableName.promote.level.prompt': 'Vui lòng nhập mức thăng hạng',
  'form.lableName.promote.amount': 'Số tiền thưởng',
  'form.lableName.promote.amount.prompt': 'Vui lòng nhập số tiền thưởng',
  'form.lableName.promote.multiple': 'quảng bá bội số',
  'form.lableName.promote.multiple.prompt': 'Vui lòng nhập số sê-ri',
  'form.lableName.promote.extra': 'Thêm phần thưởng',
  'form.lableName.promote.extraPercent': 'Phần trăm Phần thưởng Thêm',
  'form.lableName.promote.extraPercent.prompt': 'Vui lòng nhập phần trăm phần thưởng thêm',
  'form.lableName.promote.extraLevel': 'Mức độ tham gia phần thưởng bổ sung',
  'form.lableName.promote.extraLevel.prompt': 'Vui lòng chọn cấp độ tham gia phần thưởng bổ sung',
  'form.lableName.promote.avoidRelegation':'Bảo đảm điều kiện',
  'form.lableName.promote.upgradeCount': 'Điều kiện nâng cấp',
  'form.lableName.promote.upgradeCount.prompt': 'Vui lòng nhập các điều kiện nâng cấp',
  'form.lableName.promote.upgradeAmount': 'Phần thưởng nâng cấp',
  'form.lableName.promote.upgradeAmount.prompt': 'Vui lòng nhập phần thưởng nâng cấp',
  'form.lableName.promote.upgradeMultiple': 'Nâng cấp nhiều lần chuyển tiền thưởng',
  'form.lableName.promote.upgradeMultiple.prompt': 'Vui lòng nhập bội số doanh thu tiền thưởng nâng cấp',
  'form.lableName.promote.checkIn': 'Số lần đăng ký',
  'form.lableName.promote.checkIn.prompt': 'Vui lòng chọn có đặt điều kiện thời gian đăng ký hay không',
  'form.lableName.promote.checkInCount': 'Số lần đăng ký',
  'form.lableName.promote.checkInCount.prompt': 'Vui lòng điền số lần đăng ký',
  'form.lableName.promote.totalDeposit': 'Tiền gửi tích lũy',
  'form.lableName.promote.totalDeposit.prompt': 'Vui lòng chọn có đặt điều kiện tiền gửi tích lũy hay không',
  'form.lableName.promote.totalDepositAmount': 'Tiền gửi tích lũy',
  'form.lableName.promote.totalDepositAmount.prompt': 'Vui lòng điền vào số tiền gửi tích lũy',
  'form.lableName.promote.betflow': 'đặt cược hợp lệ',
  'form.lableName.promote.betflow.prompt': 'Vui lòng chọn có đặt điều kiện số tiền đặt cược hợp lệ hay không',
  'form.lableName.promote.betflowAmount': 'Đặt cược hợp lệ',
  'form.lableName.promote.betflowAmount.prompt': 'Vui lòng điền vào số tiền đặt cược hợp lệ',
  'form.lableName.promote.balanceFee': 'Yuebao Interest',
  'form.lableName.promote.balanceFee.prompt': 'Vui lòng chọn có thiết lập điều kiện lãi suất số dư',
  'form.lableName.promote.balanceFeeAmount': 'Số tiền lãi Yuebao',
  'form.lableName.promote.balanceFeeAmount.prompt': 'Vui lòng điền số tiền lãi của Yu`e Bao',
  'form.lableName.promote.extraLevel.1': 'Cấp VIP1 trở lên',
  'form.lableName.promote.extraLevel.2': 'Cấp VIP2 trở lên',
  'form.lableName.promote.extraLevel.3': 'Cấp VIP3 trở lên',
  'form.lableName.promote.extraLevel.4': 'Cấp VIP4 trở lên',
  'form.lableName.promote.extraLevel.5': 'Cấp VIP5 trở lên',
  'form.lableName.promote.extraLevel.6': 'Cấp VIP6 trở lên',
  'form.lableName.promote.extraLevel.7': 'Cấp VIP7 trở lên',
  'form.lableName.promote.extraLevel.8': 'Cấp VIP8 trở lên',
  'form.lableName.promote.extraLevel.9': 'Cấp VIP9 trở lên',
  'form.lableName.promote.extraLevel.10': 'Cấp VIP10 trở lên',
  'user.title.addBankCard': 'Thêm thẻ ngân hàng',
  'user.title.addBankCardSuccess': 'Thêm thẻ ngân hàng thành công',
  'user.title.addBankCardError': 'Không thêm được thẻ ngân hàng',
  'user.title.addBankCardMendAuthMobilePhone': 'Thêm thẻ ngân hàng yêu cầu ràng buộc số điện thoại di động',
  'user.title.addBankCardMendAuthWithdrawPWD': 'Thêm thẻ ngân hàng yêu cầu thiết lập mật khẩu rút tiền',
  'lable.addBankCard.name': 'tên tài khoản thẻ ngân hàng',
  'lable.addBankCard.name.msg': 'Vui lòng nhập tên tài khoản thẻ ngân hàng',
  'lable.addBankCard.bankName': 'Tên Ngân hàng',
  'lable.addBankCard.bankName.msg': 'Vui lòng chọn tên ngân hàng',
  'lable.addBankCard.bankName.msg1': 'Vui lòng nhập tên ngân hàng',
  'lable.addBankCard.bankNumber': 'Số tài khoản thẻ ngân hàng',
  'lable.addBankCard.bankNumber.msg': 'Vui lòng nhập số tài khoản thẻ ngân hàng',
  'lable.addBankCard.subBank': 'Tên ngân hàng mở',
  'lable.addBankCard.subBank.msg': 'Vui lòng nhập tên ngân hàng đã mở tài khoản',

  'agent.title.subTotalShareProfit': 'Tổng lợi nhuận ròng của các đại lý cấp dưới: {shareProfit}',
  'agent.title.subTotalShareCom': 'Tổng hoa hồng đại lý cấp dưới: {shareCommission}',
  'agent.title.subTotalShareFee': 'Hoa hồng đại lý cấp dưới: {shareFee}',
  'agent.title.billAmount': 'Hoa hồng thanh toán',
  'agent.billType.selfAmount': 'tự thu nhập: {selfAmount}',
  'agent.billType.subAmount': 'Thu nhập thấp hơn: {subAmount}',
  'agent.billType.billAmount': 'Thu nhập thanh toán: {totalAmount}',
  'agent.title.superiorAccount':'Đại lý cấp trên',
  'agent.title.superiorAccount2':'Đại lý cấp trên',
  'agent.title.level': 'Cấp độ',
  'agent.title.level.all': 'Toàn bộ trạng thái',
  'agent.title.level.1': 'cấp một',
  'agent.title.level.2': 'Mức 2',
  'agent.title.level.3': 'Cấp độ Ba',
  'agent.monthlyTable.agentLevel': '{level} đại lý cấp',
  'agent.monthlyTable.superiorAccount': 'Đại lý cấp trên: {account}',
  'agent.commissionReport.pageBetflow': 'Luồng trang này',
  'agent.commissionReport.pageBonus': 'Ưu đãi trang này',
  'agent.commissionReport.pageDeposit': 'Tiền nạp trang này',
  'agent.commissionReport.pageWithdraw': 'Rút tiền từ trang này',
  'agent.commissionReport.pageResult': 'Trang này thắng hay thua',
  'agent.commissionReport.totalBetflow': 'Tính tổng doanh thu',
  'agent.commissionReport.totalBonus': 'Tính tổng ưu đãi',
  'agent.commissionReport.totalDeposit': 'Tổng số người nạp tiền',
  'agent.commissionReport.totalWithdraw': 'Tổng số tiền rút',
  'agent.commissionReport.totalResult': 'Tổng thắng hoặc thua',
  'agent.monthlyReport.pageProfit': 'Lời lỗ hàng tháng trên trang này',
  'agent.monthlyReport.pageBetflow': 'Đặt cược trên trang này',
  'agent.monthlyReport.pageBonus': 'Ưu đãi trang này',
  'agent.monthlyReport.pageTrans': 'Phí dịch vụ trên trang này',
  'agent.monthlyReport.pageFinalProfit': 'Tiền lợi tức trên trang này',
  'agent.monthlyReport.pageShareCom': 'Tiền được trích ra trên trang này',
  'agent.monthlyReport.pageBillAmount': 'Thanh toán trên trang này',
  'agent.monthlyReport.totalProfit': 'Tính tổng lãi lỗ hàng tháng',
  'agent.monthlyReport.totalBetflow': 'Tính tổng doanh thu',
  'agent.monthlyReport.totalBonus': 'Tính tổng ưu đãi',
  'agent.monthlyReport.totalTrans': 'Tính tổng phí dịch vụ',
  'agent.monthlyReport.totalFinalProfit': 'Tính tổng số lợi tức',
  'agent.monthlyReport.totalShareCom': 'Tính tổng số tiền được trích ra',
  'agent.monthlyReport.totalBillAmount': 'Tính tổng thánh toán',
  'agent.title.agentSubUserResult': 'Thành viên thắng hoặc thua',

  'user.title.updateBirthday':'Sửa đổi ngày sinh',
  'user.title.oldBirthday':'Sinh nhật cũ',
  'user.title.newBirthday':'Sinh nhật mới',
  'user.title.pleaseEnterNewBirthday':'Vui lòng nhập thông tin sinh nhật mới',
  'member.title.markCount': 'Cột mốc số lượng người chơi',

  'user.frmTitel.userModel': 'Mục lục người chơi',
  'user.frmTitel.userPeriod': 'Giai đoạn',
  'user.frmTitel.daily': 'mỗi ngày',
  'user.frmTitel.weekly': 'Mỗi tuần',
  'user.frmTitel.monthly': 'Mỗi tháng',
  'user.frmTitel.with': 'của',
  'user.frmTitel.regisiter': 'tài khoản đăng ký',
  'user.frmTitel.regisiterAndDeposit': 'Tài khoản mới đăng ký',
  'user.frmTitel.keepCnd': 'Hình thức bảo lưu,Sau đó',
  'user.frmTitel.inCnd': 'giữa',
  'user.frmTitel.beted': 'đã từng đặt cược',
  'user.frmTitel.online': 'Đã từng lên mạng',
  'user.frmTitel.countKeepNum': 'Thống kê và bảo lưu tài khoản',
  'user.frmTitel.platform': 'Kênh',
  'common.sendMail.writeEmail': 'Viết Email',
  'common.sixLottery.deleteReply': 'Xóa câu trả lời',
  'common.betResult.lost':'Thua',
  'common.betResult.fair':'Hòa',
  'common.betResult.win':'Thắng',
  'common.btn.reset':'Làm mới',
  'common.btn.search':'Tìm kiếm',
  'user.title.firstDeposit': 'Khoản tiền gửi đầu tiên',
  'user.title.realNameAuth': 'Xác thực tên thật',
  'user.title.mobilePhoneAuth': 'Xác thực số điện thoại di động',
  'user.title.emailAuth': 'Xác thực hộp thư',
  'user.title.userVIPLevel': 'Cấp độ thành viên',
  'user.title.startTime': 'Thời gian bắt đầu',
  'user.title.endTime': 'Thời gian kết thúc',
  'agent.title.domainPublic': 'Loại tên miền',
  'agent.title.domainPublicMsg': 'Vui lòng chọn loại tên miền',
  'agent.title.domainPublic.public': 'Tên miền công cộng',
  'agent.title.domainPublic.private': 'Tên miền độc quyền',
  'agent.title.preventBlock': 'Chống chặn WeChat',
  'agent.title.agentAccountNotEmpty': 'Không được để trống tài khoản đại lý tương ứng với tên miền độc quyền',
  'user.title.loginIPAddress': 'Thuộc tính IP đăng nhập',
  'user.title.userRelationTime':'Thời gian liên kết người dùng hiện tại',
  'user.title.loginIP':'IP đăng nhập',
  'bonus.newInviteBonus.msg1':"Mỗi lần được mời",
  'bonus.newInviteBonus.msg2':"Như tiền lương mời khách",
  'bonus.newInviteBonus.msg3':"Tiền thưởng VIP được mời",
  'bonus.newInviteBonus.msg4':"Gấp đôi tiền thưởng",
  'bonus.newInviteBonus.msg5':"Giấy mời rút tiền lương",
  'bonus.newInviteBonus.msg6':"Mời nhận tiền thưởng",
  'bonus.newInviteBonus.msg7':"Nhân dân tệ và",
  'bonus.newInviteBonus.msg8':"Lần nước",
  'promotion.reward.title.regDate': 'Mời thời gian đăng ký',
  'promotion.reward.title.finishDate': 'Thời gian hoàn thành lời mời',
  'promotion.reward.title.keyword': 'Từ khóa',
  'promotion.reward.title.keyword.msg': 'tài khoản mời / mời',
  'promotion.reward.table.promoteAccount': 'Người đang mời',
  'promotion.reward.table.targetAccount': 'Mời tài khoản',
  'promotion.reward.table.targetRegDate': 'Mời thời gian đăng ký',
  'promotion.reward.table.amount': 'Số tiền thưởng',
  'promotion.reward.table.status': 'Trạng thái',
  'promotion.reward.table.finishDate': 'Thời gian kết thúc',
  'promotion.reward.table.moneyDate': 'Thời gian nhận',
  'promotion.reward.table.pageUnastyAmount': 'Số tiền chưa hoàn thành trên trang này',
  'promotion.reward.table.pageFinishingAmount': 'Trang này đã hoàn thành số tiền',
  'promotion.reward.table.totalUnastyAmount': 'Tổng số tiền chưa hoàn thành',
  'promotion.reward.table.totalFinishingAmount': 'Tổng số tiền đã hoàn thành',
  'promotion.invitation.title.queryDate': 'Ngày truy vấn',
  'promotion.invitation.table.countDate': 'Ngày thống kê',
  'promotion.invitation.table.activeCount': 'Người dùng tích cực trong ngày',
  'promotion.invitation.table.participateCount': 'Người dùng tham gia hoạt động',
  'promotion.invitation.table.participateRate': 'Tỷ lệ tham gia hoạt động',
  'Promotion.invitation.table.regCount': 'Số lượng đăng ký mới ngoại tuyến',
  'promotion.invitation.table.firstDeposit': 'Số lần gửi tiền đầu tiên ngoại tuyến',
  'promotion.invitation.table.firstDepositRate': 'Tỷ lệ gửi tiền lần đầu đăng ký mới',
  'promotion.invitation.table.pageParticipateRate': 'Tỷ lệ tham gia hoạt động trên trang này',
  'promotion.invitation.table.pageRegCount': 'Số lượng đăng ký mới trên trang này',
  'promotion.invitation.table.pageFirstDepositCount': 'Số lần gửi tiền ngoại tuyến đầu tiên trên trang này',
  'promotion.invitation.table.pageFirstDepositRate': 'Tỷ lệ đặt cọc đầu tiên của các đăng ký mới trên trang này',
  'promotion.invitation.table.totalParticipateRate': 'Tổng tỷ lệ tham gia sự kiện',
  'promotion.invitation.table.totalRegCount': 'Tổng số lượt đăng ký ngoại tuyến mới',
  'promotion.invitation.table.totalFirstDeopsitCount': 'Tổng số FirstDeopsitCount',
  'promotion.invitation.table.totalFirstDepositRate': 'Tổng lãi suất tiền gửi đăng ký mới lần đầu tiên',
  'promotion.upgrade.title.queryDate': 'Thời gian nâng cấp',
  'promotion.upgrade.title.keyword.msg': 'Tài khoản thành viên',
  'promotion.upgrade.table.userAccount': 'Tài khoản thành viên',
  'promotion.upgrade.table.amount': 'Số tiền thưởng',
  'promotion.upgrade.table.betflow': 'tiến trình luồng',
  'promotion.upgrade.table.createTime': 'Nhận thời gian',
  'promotion.upgrade.table.pageAmount': 'Số tiền thưởng trên trang này',
  'promotion.upgrade.table.totalAmount': 'Tổng số tiền thưởng',
  'menu.promoteUpgradeReport': 'Nâng cấp báo cáo phần thưởng',
  'menu.historySearch': 'Tìm kiếm Lịch sử',
  'menu.backupSetting': 'cấu hình sao lưu dữ liệu lịch sử',
  'menu.queryHistoryBonus': 'Lịch sử bộ sưu tập chiết khấu',
  'menu.queryHistoryPayOrder': 'Lịch sử nạp tiền',
  'menu.queryHistoryBalanceLog': 'Bản ghi lịch sử thay đổi tài khoản',
  'historySearch.tranLog.frm.userName': 'Tài khoản thành viên',
  'historySearch.tranLog.frm.userName.msg': 'Vui lòng nhập tài khoản thành viên',
  'historySearch.tranLog.frm.tranDate': 'Thời gian giao dịch',
  'historySearch.tranLog.frm.type': 'Loại Giao dịch',
  'historySearch.setting.table.name': 'Tên mục sao lưu',
  'historySearch.setting.table.day': 'Số ngày dự phòng',
  'historySearch.setting.table.status': 'Trạng thái',
  'historySearch.setting.table.remark': 'Mô tả mục sao lưu',
  'bonus.checkinIntegral.msg1':'Thiết lập phần thưởng cấp VIP',
  'bonus.checkinIntegral.msg2':'Cấp VIP',

  'menu.queryLoginMember': 'Thống kê khách hàng',

  'member.queryLoginMember.registeredUserTotal':'Tổng số người đăng ký',
  'member.queryLoginMember.taodyUp':'Hôm nay mới',
  'member.queryLoginMember.logedUserToday':'Tổng số đăng nhập vào ngày hôm nay',
  'member.queryLoginMember.daysUp':'Ngày trên tháng',
  'member.queryLoginMember.logedTimeToday':'Số đăng nhập vào ngày hôm nay',
  'member.queryLoginMember.logedSuccRateToday':'Đăng nhập vào ngày hôm nay tỷ lệ thành công',
  'member.queryLoginMember.thePie':'Biểu đồ hình bánh',
  'member.queryLoginMember.columnar':'Biểu đồ hình thanh',
  'member.queryLoginMember.logedTerminalStatistics':'Thông tin tổng quan về số người đăng nhập',
  'sys.welcomeLogin.msg': 'Chào mừng bạn đến với trang quản lý và ứng dụng công nghệ cao của GamesTone',
  'bonus.title.createTime':'Khuyến mãi bắt đầu từ',
  'bonus.log.remark': 'Thông tin ghi chú',
  'promotion.reward.table.operateDetail': 'Nhà điều hành / thời gian hoạt động',
  'promotion.reward.table.operate': 'Hoạt động',
  'promotion.reward.table.showDetail': 'Xem tiến trình',
  'promotion.log.showDetail.account': 'tiến độ hoàn thành {account}',
  'promotion.log.showDetail.checkIn': 'Đăng ký: {finish} / {target}',
  'promotion.log.showDetail.deposit': 'Khoản tiền gửi tích lũy: {finish} / {target}',
  'promotion.log.showDetail.betflow': 'Cá cược tích lũy: {finish} / {target}',
  'promotion.log.showDetail.balanceFee': 'Sở thích trên Yuebao: {finish} / {target}',
  'promotion.log.showRefuseReason': 'Lý do từ chối',
  'promotion.reward.table.changeRefuse': 'Đặt là không thành công',
  'promotion.reward.table.changeNormal': 'Đặt thành bình thường',
  'promotion.log.changeRewardStatus': 'Sửa đổi trạng thái phần thưởng',
  'promotion.log.confirmChangeRewardStatus': 'Bạn có chắc chắn sửa đổi trạng thái phần thưởng của các thành viên {target} không? ',
  'promotion.reward.table.status.refuse': 'Từ chối',
  'constants.bonusType_25': 'Chiết khấu lãi và lỗ',
  'constants.newBonusType_25': 'Chiết khấu lãi và lỗ',
  'constants.bonusMainType_25': 'Chiết khấu lãi và lỗ',
  'constants.newBonusMainType_25': 'Chiết khấu lãi và lỗ',
  'sys.profitType': 'Loại lãi và lỗ',
  'sys.profitType.win': 'lợi nhuận',
  'sys.profitType.lost': 'Mất mát',
  'sys.profitType.all': 'Tất cả',
  'bonus.winLost.cnd.title': 'Đặt điều kiện ưu đãi',
  'bonus.winLost.cnd.add': 'Thêm điều kiện',
  'bonus.winLost.cnd.profitAmount': 'Đã đạt được lãi / lỗ (giá trị tuyệt đối)',
  'bonus.winLost.cnd.profitAmount.msg': 'Vui lòng nhập giá trị tuyệt đối của lãi và lỗ',
  'bonus.winLost.cnd.giftAmount': 'Số tiền thưởng',
  'bonus.winLost.cnd.giftAmount.msg': 'Vui lòng nhập số tiền thưởng',
  'bonus.winLost.frm.levelLimit': 'Mức độ tham gia',
  'bonus.winLost.frm.levelLimit.msg': 'Vui lòng chọn cấp độ tham gia',
  'sys.includeAndMoreThan': 'trở lên',
  'user.title.minBalance': 'Vui lòng nhập số dư tối thiểu',
  'user.title.maxBalance': 'Vui lòng nhập số dư tối đa',
  'user.title.totalMainBalance': 'Tổng số dư tài khoản chính',
  'common.bonus.winLostBonus':'{type} chiết khấu lãi và lỗ, {date}',
  'sys.winLost.giveType.independent': 'Phân phối độc lập từng nền tảng trò chơi',
  'sys.winLost.giveType.unify': 'Tham gia vào việc phân phối thống nhất nền tảng trò chơi',
  'sys.winLost.giveType.msg': 'Vui lòng chọn phương thức phân phối',
  'sys.winLost.giveType': 'Phương pháp phân phối',
  'constants.riskLevelType_-8': 'Giới hạn để nhận lương chế độ nâng cấp',
  'front.bonus.upgradeReward.riskMsg.title': 'Hạn chế kiểm soát rủi ro',
  'front.bonus.upgradeReward.riskMsg.upgradeAmount': 'Kiểm soát rủi ro giới hạn việc phân phối phần thưởng nâng cấp chế độ nâng cấp',
  'front.bonus.upgradeReward.riskMsg.weekRemark': 'Chế độ nâng cấp giới hạn kiểm soát rủi ro, lương hàng tuần',
  'front.bonus.upgradeReward.riskMsg.monthRemark': 'Chế độ nâng cấp giới hạn kiểm soát rủi ro, lương hàng tháng',
  'menu.leaderboard': 'Bảng xếp hạng',
  'menu.gameleaderboard': 'Bảng xếp hạng nền tảng trò chơi của bên thứ ba',
  'menu.proxyleaderboard': 'Xếp hạng tác nhân kênh',
  'menu.userleaderboard': 'Xếp hạng thành viên',
  'console.leaderboard': 'Cấp',
  'console.firstAmountCount': 'Tiền gửi đầu tiên',
  'console.activeUserCount': 'Số hoạt động',
  'console.userName': 'Tên thành viên',
  'console.depositAmount': 'Đặt cọc (nhân dân tệ)',
  'console.depositAmountVN': 'Đặt cọc (VND)',
  'console.withdrawAmount': 'Rút tiền (nhân dân tệ)',
  'console.withdrawAmountVN': 'Rút tiền (VND)',
  'console.betflow': 'Đặt cược (nhân dân tệ)',
  'console.betflowVN': 'Đặt cược (VND)',
  'console.betflow2': 'Đặt cược',
  'console.resultAmount': 'Thắng hoặc thua (nhân dân tệ)',
  'console.resultAmountVN': 'Thắng hoặc thua (VND)',


  'console.totalBetflow': 'Cược hợp lệ nền tảng',
  'smsAllocation.mobilePhone.status': 'Trạng thái Số',
  'smsAllocation.mobilePhone.status_1': 'Số trống',
  'smsAllocation.mobilePhone.status_2': 'Không sử dụng được',
  'smsAllocation.mobilePhone.status_0': 'Bình thường',
  'smsAllocation.mobilePhone.sendStatus': 'Gửi Trạng thái',
  'smsAllocation.mobilePhone.sendStatus.select': 'Chọn trạng thái gửi',
  'smsAllocation.mobilePhone.sendStatus.done': 'Đã gửi',
  'smsAllocation.mobilePhone.sendStatus.not': 'chưa được gửi',
  'smsAllocation.mobilePhone.importInfo': 'Thông tin ghi chú',
  'smsAllocation.mobilePhone.sendPhoneText': 'Gửi SMS',
  'smsAllocation.mobilePhone.searchKeyword': 'Số điện thoại di động / tên người dùng / thông tin nhận xét',
  'phoneAllocation.importData': 'Nhập',
  'phoneAllocation.selectSend': 'Gửi có chọn lọc',
  'phoneAllocation.allSend': 'Gửi tất cả',
  "user.title.updPwdTime":"Sửa đổi mật khẩu ngày",
  "common.queryFrm.dayCnt":"Bao nhiêu ngày gần đây đã không thay đổi mật khẩu",
  "sys.riskUpdPwd":"Sửa đổi mật khẩu",
  "sys.riskUpdPwd.need":"YES",
  "sys.riskUpdPwd.notneed":"NO",
  'user.pay.type': 'Phương thức thanh toán',
  'user.title.payTypeList': 'Phương thức thanh toán độc quyền',
  'user.title.confirmDelete': 'Xác nhận xóa',
  'user.title.deletePayTypeMsg': 'Bạn có chắc chắn xóa phương thức thanh toán này không? ',
  'common.title.payChannel': 'Phương thức Thanh toán',
  'user.title.payType': 'Kênh thanh toán',
  'user.title.payName': 'Tên thanh toán',
  'user.title.addUserPayType': 'Thêm phương thức thanh toán',
  'lable.addUserPayType.payType': 'Phương thức Thanh toán',
  'lable.addUserPayType.payType.msg': 'Vui lòng chọn phương thức thanh toán',
  'user.title.addPayTypeSuccess': 'Thêm phương thức thanh toán thành công',
  'sys.version.announcement.add': 'Thêm thông báo',
  'sys.version.announcement.title': 'Tiêu đề',
  'sys.version.announcement.title.msg': 'Vui lòng nhập tiêu đề',
  'sys.version.announcement.content': 'Nội dung',
  'sys.version.announcement.content.msg': 'Vui lòng nhập nội dung',
  'sys.version.announcement.status': 'Bạn có trực tuyến không?',
  'sys.version.announcement.status_0': 'Sắp có',
  'sys.version.announcement.status_1': 'Trực tuyến',
  'sys.version.announcement.changeStatus': 'Phát hành trực tuyến',
  'sys.version.confirmPublic': 'Bạn có xác nhận bản phát hành trực tuyến không? ',

  'report.radio.today.data': 'Dữ liệu theo thời gian thực',
  'report.radio.history.data': 'dữ liệu lịch sử',

  'constants.ropeType_1': 'Dây đỏ',
  'constants.ropeType_2': 'Dây xanh.',
  'constants.ropeType_3': 'Dây thừng vàng',
  'constants.ropeType_4': 'Dây thừng trắng',
  'constants.ropeType_5': 'Dây thừng đen',
  'constants.ropeType_6': 'Dây thừng sặc sỡ',
  'sys.ropeType.pleaseEnterAccumulatedBet': 'Vui lòng nhập cược tích lũy',
  'sys.ropeType.pleaseSelectSyntheticRope': 'Vui lòng chọn loại dây tổng hợp mong muốn',
  'sys.ropeType.pleaseSelectQuantity': 'Vui lòng chọn số lượng dây tổng hợp cần thiết',
  'sys.ropeType.ropeType': 'loại dây',
  'sys.ropeType.pleaseSelectRopeType': 'Vui lòng chọn loại dây',
  'sys.ropeType.convertibleCash': 'chuyển đổi thành tiền mặt',
  'sys.ropeType.pleaseEnterCashExchange': 'Vui lòng nhập số tiền bạn có thể đổi',
  'sys.ropeType.accumulatedBetting': 'Cược tích lũy',
  'sys.ropeType.syntheticRopeRequiredType': 'Loại dây tổng hợp yêu cầu',
  'sys.ropeType.amountNeededSynthesizeRope': 'Số lượng cần thiết để tổng hợp dây',
  'sys.ropeType.prizeCreateTime': 'Thời gian phát sinh',
  'sys.ropeType.prizeUpdateTime': 'Time Claim Time giải thưởng',
  'sys.ropeType.convertIntoCash': 'Chuyển thành tiền mặt',
  'sys.ropeType.totalAmountReceived': 'Tổng số tiền nhận được',
  'sys.ropeType.totalDegree': 'Tổng mức độ',
  'sys.withdraw.pickType.label': 'Nhận thời hạn hiệu lực',
  'sys.withdraw.pickType.rule': 'Vui lòng chọn thời hạn hiệu lực',
  'sys.withdraw.pickType.radio.value1': 'hiệu quả lâu dài',
  'sys.withdraw.pickType.radio.value2': 'Đăng ký thành viên có hiệu lực trong vòng vài ngày',
  'sys.withdraw.pickExpireDays.rule': 'Vui lòng nhập ngày hợp lệ',
  'sys.withdraw.pickExpireDays.day': 'ngày',
  'sys.withdraw.completeWithdrawDays.valid': 'Vui lòng điền thời gian hoàn tất lần rút tiền đầu tiên',
  'sys.withdraw.pickExpireDays.valid': 'Vui lòng điền vào ngày có hiệu lực của bộ sưu tập',
  'sys.withdraw.rule': 'Vui lòng chọn thứ tự rút tiền',
  'sys.withdraw.withdrawType.label': 'Trình tự rút tiền',
  "sys.withdraw.withdrawType.radio.value1": 'đề cập đầu tiên',
  'sys.withdraw.completeWithdrawType.label': 'Hoàn thành lần rút tiền đầu tiên',
  'sys.completeWithdrawType.rule': 'Vui lòng chọn thời gian hoàn tất lần rút tiền đầu tiên',
  'sys.completeWithdrawType.prefix': 'Đăng ký',
  'sys.giftAmount.label': 'số tiền thưởng',
  'sys.giftAmount.rule': 'Vui lòng nhập số tiền tín dụng',
  'sys.maxWithdrawAmount.label': 'Số tiền rút tối đa',
  // 'sys.maxWithdrawAmount.rule': 'Vui lòng nhập số tiền rút tối đa',
  'sys.deposit.applyType.label': 'loại gửi',
  'sys.deposit.applyType.rule': 'Vui lòng chọn hình thức giao hàng',
  'sys.deposit.applyType.radio.value1': 'tự động giao hàng',
  'sys.deposit.applyType.radio.value2': 'Đón thủ công',
  'sys.deposit.pickType.label': 'Nhận thời hạn hiệu lực',
  'sys.deposit.pickType.rule': 'Vui lòng chọn thời hạn hiệu lực',
  'sys.deposit.pickType.radio.value1': 'hiệu quả lâu dài',
  'sys.deposit.pickType.radio.value2': 'Đăng ký thành viên có hiệu lực trong vòng vài ngày',
  'sys.deposit.pickExpireDays.rule': 'Vui lòng nhập ngày hợp lệ',
  'sys.deposit.pickExpireDays.day': 'ngày',
  'sys.maxWithdrawAmount.rule': 'Vui lòng nhập số tiền rút tối đa',
  'sys.withdraw.applyType.label': 'loại gửi',
  'sys.withdraw.applyType.rule': 'Vui lòng chọn hình thức giao hàng',
  'sys.withdraw.applyType.radio.value1': 'tự động giao hàng',
  'sys.withdraw.applyType.radio.value2': 'Đón thủ công',
  'front.bonus.firstWithdrawBonus': 'Ti?n th??ng r?t ti?n ??u ti?n',
  'front.bonus.firstRegisterBonus': 'Phần thưởng đăng ký người mới',
  'front.bonus.firstDepositBonus': 'Tiền thưởng ký gửi lần đầu cho người mới',
  'front.bonus.signInNewBonus': 'Phần thưởng đăng nhập mới',
  'front.bonus.lostNewBonus': 'Phần thưởng hồi sinh cho người mới',

  'pay.label.payeeName': 'Tên người nhận',
  'pay.label.payeeName1': 'Vui lòng nhập tên người nhận thanh toán',
  'pay.label.payeeName2': 'Nhập tối đa 25 ký tự',
  'pay.label.payeeNumber': 'Số tài khoản người nhận',
  'pay.label.payeeNumber1': 'Vui lòng nhập số tài khoản Người nhận thanh toán',
  'sys.title.userAccount.registrationTime': 'Người chơi Thời gian đăng ký',
  'user.title.totalResult': 'tổng số tiền thắng hoặc thua',
  'bet.label.totalResult': 'tổng số tiền thắng hoặc thua (yuan)',
  'bet.label.totalResultVN': 'tổng số tiền thắng hoặc thua (VND)',
  'bet.label.pageResult': 'thắng hay thua (yuan)',
  'bet.label.pageResultVN': 'thắng hay thua (VND)',


  'menu.questList': 'Danh sách Khảo sát',
  'menu.questRecord': 'Bản ghi Khảo sát',
  'sys.title.questionTitle': 'Tên bảng câu hỏi',
  'sys.title.userLevel': 'Cấp độ thành viên',
  'sys.title.userAwardTime':'Ngày thay đổi điểm',
  'sys.title.userAwardPointBefore':'Điểm trước khi thay đổi',
  'sys.title.userAwardPointAfter':'Điểm sau khi thay đổi',
  'menu.userAwardRecord': 'Bản ghi điểm thành viên',
  'sys.title.userAwardPoint':'Số điểm thay đổi',
  'sys.title.answerTime': 'Thời gian gửi',
  'sys.form.surveyLog.keyword': 'Tài khoản thành viên',

  'onlineuser.export.excel': 'Báo cáo người dùng trực tuyến.xlsx',
  'menu.onlineUserHistory': 'Người dùng trực tuyến (cứ sau 10 phút)',
  'onlineUserHistory.title.countHourDesc': 'mỗi giờ \\ cứ sau mười',
  'onlineUserHistory.title.userCount10': '00：00～10：00',
  'onlineUserHistory.title.userCount20': '10：00～20：00',
  'onlineUserHistory.title.userCount30': '20：00～30：00',
  'onlineUserHistory.title.userCount40': '30：00～40：00',
  'onlineUserHistory.title.userCount50': '40：00～50：00',
  'onlineUserHistory.title.userCount60': '50：00～60：00',

  'agent.title.attributes.check': 'Vui lòng chọn thuộc tính người đại diện',
  'agent.title.attributes': 'Thuộc tính người đại diện',
  'agent.title.attributes.external': 'Người đại diện bên ngoài',
  'agent.title.attributes.internal': 'Người đại diện bên trong',
  'agent.title.account.manager.check': 'Vui lòng cung cấp số tài khoản của quản lý tài khoản',
  'agent.title.account.manager': 'Quản lý tài khoản',

  'pay.title.memberPaymentStatus': 'Thành viên xác nhận trạng thái thanh toán',
  'pay.title.memberPaymentStatus0': 'Chưa mở',
  'pay.title.memberPaymentStatus1': 'được xác nhận',
  'pay.title.memberPaymentStatus2': 'Không nhận',
  'pay.title.memberPaymentStatus3': 'Đã đến',
  'user.title.bindTime': 'Thời gian ràng buộc',
  'push.title.msgId': 'ID tin nhắn',
  'menu.QueryMemberDevice': 'Thông tin thiết bị thành viên',
  'device.title.os': 'Thiết bị thành viên',
  'device.title.registrationId': 'ID Aurora',
  'user.title.isTop': 'Làm đỉnh',
  'user.title.top': 'đỉnh',
  'user.title.topCancel': 'Hủy ghim',

  'sys.vip.dayLimitWithdraw': 'Giới hạn số lần rút tiền trong ngày',
  'sys.vip.dayLimitWithdrawAmount': 'Giới hạn số tiền rút trong ngày',

  'sys.msg153': 'Nếu đáp ứng các điều kiện, thành viên có thể nhận phần thưởng theo cách thủ công trên trang sự kiện và chúng sẽ không còn hiệu lực sau ngày hết hạn.',
  'sys.msg154': 'Các loại tiền gửi thống kê',
  'sys.msg155': 'tiền gửi duy nhất',
  'sys.msg156': 'Tiền gửi tích lũy',
  'bonus.titie.publicRewardSettings': 'Cài đặt phần thưởng',
  'sys.withdrawalChannel': 'Kênh rút tiền',
  'sys.msg157': 'Số tiền rút tối đa phải lớn hơn số tiền rút tối thiểu',
  'sys.msg158': 'Rút tiền tối thiểu (bao gồm)',
  'sys.msg159': 'Vui lòng nhập số tiền rút tối thiểu',
  'sys.msg160': 'Số tiền rút tối đa (không bao gồm)',
  'sys.msg161': 'Vui lòng nhập số tiền rút tối đa',
  'sys.msg162': 'Số tiền rút: {minAmount}~{maxAmount}',
  'sys.msg163': 'Rút tiền một lần',
  'sys.msg164': 'Rút tiền tích lũy',
  'sys.selectWithdrawChannel': 'Vui lòng chọn kênh rút tiền',
  'sys.limitReceiveCount': 'Giới hạn số lần bạn có thể nhận được nó',
  'usdt.decimal.return':'USDT đổi số lẻ để hoàn trả',
  'decimal.return':'Tiền hòan trả theo số lẻ',

  // im 国际化
  'menu.im': 'quản lý IM',
  'menu.immgmt': 'Quản lý quyền IM',
  'menu.imMgmt': 'Quản lý quyền IM',
  'menu.queryMsg': 'Tin nhắn truy vấn IM',
  'menu.querymsg': 'Tin nhắn truy vấn IM',
  'user.friendRoom': 'Phòng trò chuyện đơn',
  'user.friendAllRoom': 'Phòng trò chuyện nhóm',
  'user.friendInfo': 'Danh sách bạn bè',
  'user.title.messagelist': 'Danh sách tin nhắn',
  'im.user.binding': 'Người dùng liên kết IM',
  'im.user.title.binding': 'Người dùng liên kết',
  'im.user.title.role': 'Vai trò IM',
  'im.user.title.loginName': 'Tài khoản đăng nhập IM',
  'im.user.title.systemName': 'Tên hệ thống IM',
  'im.user.unbinding': 'IM người dùng hủy liên kết',
  'im.sys.title.confirmUnbinding': 'Xác nhận hủy liên kết người dùng',
  'im.sys.unbindAccount': 'Tài khoản sẽ được hủy liên kết: {userName}',
  'im.sys.login': 'tôi đăng nhập',
  'im.sys.login.error': 'Không có tài khoản nào bị ràng buộc',
  'pay.withdraw.rejectionNotification':'Thông báo từ chối rút tiền',

  'agent.title.setPixelParam': 'Đặt tham số pixel',
  'agent.title.pixelId': 'nguồn dữ liệu ID',
  'agent.title.pixelAccessToken': 'nguồn dữ liệu KEY',
  'member.title.pixelPush': 'Đẩy pixel',
  'member.title.selectPixelPush': 'Vui lòng chọn pixel để đẩy',
  'member.title.pixelPushThat': 'Đẩy thông tin người dùng đó vào pixel',
  'pay.title.financialTime':'thời gian tài chính',
  'sys.user.virtualCurrencyAddress': 'Địa chỉ tiền ảo',
  'sys.user.virtualCurrencyAddress2': 'Danh sách địa chỉ tiền ảo',
  'user.title.delVirtualCurrencyAddress': 'Xóa địa chỉ tiền ảo',
  'user.title.askDelVirtualCurrencyAddress': 'Vui lòng xác nhận để xóa địa chỉ tiền ảo?',
  'user.title.updateVirtualCurrencyAddress':'Sửa đổi thông tin địa chỉ tiền ảo',
  'user.title.synchronizeDeposit': 'Đồng bộ hóa dữ liệu tiền gửi',
  'user.title.synchronizeWithdrawal': 'Đồng bộ hóa dữ liệu rút tiền',
  'user.title.dataInDepositReport': 'Dữ liệu trong [Báo cáo tiền gửi] là',
  'user.title.dataInWithdrawReport': 'Dữ liệu trong [Báo cáo rút tiền] là',
  'user.title.dataInMemberDetails': 'Dữ liệu trong [Chi tiết thành viên] là',
  'user.title.sureSynchronizedDeposit': 'Bạn có chắc chắn dữ liệu báo cáo tiền gửi được đồng bộ hóa với dữ liệu chi tiết thành viên không?',
  'user.title.sureSynchronizedWithdrawal': 'Bạn có chắc chắn dữ liệu báo cáo rút tiền được đồng bộ hóa với dữ liệu chi tiết thành viên không?',
  'user.title.noSynchronizationRequired': 'Số tiền như nhau, không cần đồng bộ',
  'pay.withdraw.msg9': '{0}Đăng ký rút tiền',
  'pay.withdraw.msg10': 'Đăng ký rút tiền mặt trên YBF',
  'agent.title.completeInformation': 'Vui lòng nhập thông tin đầy đủ',


  'common.use.log.count':'Tổng số lần đăng nhập trong sáu tháng qua',


  'common.export.limit.exception':'Dữ liệu đã xuất đã vượt quá cài đặt hệ thống là 10.000. Vui lòng thêm điều kiện lọc và thử lại! ',

  'agent.title.detail.activeUserNoDistinct':'同一下线活跃多天只计算一人',
  'agent.title.detail.depositUserNoDistinct':'同一下线多天充值只计算一人',

  'pay.title.orderDescription': 'Mô tả đơn hàng',
  'finance.title.orderDescription1': 'Vui lòng nhập mô tả đơn hàng',

  'admin.bonus.singleDayDeposit': 'Gửi tiền một lần trong cùng một ngày',
  'admin.bonus.accumulatedDeposits': 'Tiền gửi tích lũy trong ngày',
  'admin.pay.selectDepositType': 'Vui lòng chọn loại tiền gửi',
  'admin.bonus.sevendayDepositDay': 'bầu trời',
  'admin.bonus.sevendayDepositGear': 'bánh răng',
  'admin.bonus.sevendayDepositDayText': 'Ngày {day}',
  'admin.bonus.sevendayDepositGearText': 'bánh răng {gear}',

  'sys.allTransactionTypes': 'Tất cả các loại giao dịch',
  'admin.front.picture.domainName': 'Tên miền tương ứng',

  'sys.push.msg': 'Đẩy tin nhắn',
  'sys.push.immediate': 'Đẩy ngay lập tức',
  'sys.push.notify': 'Thông báo Umeng',
  'sys.push.type': 'Kiểu đẩy',
  'sys.confirm.enable': 'Xác nhận để kích hoạt nó?',
  'sys.confirm.disable': 'Xác nhận để đóng?',
  'sys.push.phoneStatus': 'Trạng thái đẩy di động',
  'sys.push.mailStatus': 'Trạng thái đẩy email',
  'sys.push.smsStatus': 'Trạng thái đẩy SMS',
  'push.msg.config.type1':'Nạp tiền',
  'push.msg.config.type2':'rút',
  'push.msg.config.type3':'Điều chỉnh thủ công',
  'push.msg.config.type4':'Phần thưởng nâng cấp VIP',
  'push.msg.config.type5':'một tuần Lương',
  'push.msg.config.type6':'Tháng Một Lương',
  'push.msg.config.type7':'Đẩy ngay lập tức',
  'push.msg.config.type700':'điểm danh',
  'push.msg.config.type701':'gia hạn',
  'push.msg.config.timing':'gửi định kỳ',


  'agent.title.setAdjustParam': 'Đặt tham số adjust',
  'agent.title.applicationID': 'ID ứng dụng',
  'agent.title.registrationID': 'ID đăng ký',
  'agent.title.loginID': 'Đăng nhập số nhận dạng',
  'agent.title.firstSubmitRecharge': 'Gửi nạp tiền lần đầu tiên',
  'agent.title.firstAddBankCard': 'Thêm thẻ ngân hàng lần đầu',
  'admin.bonus.dayBonusUpperLimit': 'Giảm giá tối đa trong ngày',
  'admin.bonus.relatedBonus': 'Khuyến mãi liên quan',
  'sys.selectPromotionsBonus': 'Vui lòng chọn các khuyến mãi được liên kết',

  'agent.setAgentUsdtRate': 'Đặt tỷ lệ rút tiền',
  'agent.fillFixedExchangeRate': 'Vui lòng điền tỷ giá hối đoái cố định',
  'admin.bonus.client': 'Khách hàng được phép nhận',
  'admin.bonus.calculationRules': 'Quy tắc tính toán',
  'admin.bonus.calculationRules1': 'Tính toán ưu đãi (quy tắc cũ)',
  'admin.bonus.calculationRules2': 'Không tính giảm giá (quy định mới)',
  'admin.bonus.calculationRulesInfo': '【Tính khuyến mãi】: Số tiền đơn đặt cược - Số tiền thắng trong đơn đặt cược = Số tiền thua lỗ 【Không tính tiền khuyến mãi】: Số tiền thua lỗ - Tổng số tiền khuyến mãi đã nhận = Số tiền thực tế thua lỗ',
  'menu.matrixRoomMgmt': 'Quản lý phòng ban đầu',
  'user.title.addRoom': 'Tạo phòng trò chuyện',
  'user.button.addRoom': 'Tạo phòng trò chuyện',
  'user.button.room.select.func': 'Vui lòng chọn loại phòng',
  'user.title.room.name': 'Tên phòng trò chuyện',
  'user.title.room.name.input': 'Vui lòng nhập tên phòng trò chuyện',
  'user.title.room.title': 'Ghi chú phòng trò chuyện',
  'user.title.room.title.input': 'Vui lòng nhập nhận xét trong phòng trò chuyện',
  'user.title.room.title.max': 'Vượt quá độ dài nhận xét của phòng trò chuyện',
  'user.title.room.service': 'Dịch vụ khách hàng',
  'user.title.room.service.input': 'Vui lòng chọn dịch vụ khách hàng',
  'user.title.room.func': 'Loại phòng trò chuyện',
  'user.title.room.order': 'chuyện',
  'user.title.room.order.input': 'Xin vui lòng nhập thứ tự phòng trò chuyện',
  'user.title.updateRoom': 'Sửa đổi phòng trò chuyện',
  'common.title.account.freeze': 'Đóng băng',
  'common.title.account.unfreeze': 'Giải phóng',
  'common.title.status.running': 'Bình thường',
  'common.title.status.freeze': 'Đóng băng',
  'sys.account.freeze': 'Tài khoản sắp bị đóng băng：{matrixAccount}',
  'sys.account.unfreeze': 'Các tài khoản sẽ được giải phóng：{matrixAccount}',
  'user.button.room.message.list': 'Danh sách tin nhắn',
  'menu.matrixRoomContentMgmt': 'Quản lý tin nhắn trong phòng trò chuyện',
  'user.button.addRoomContent': 'Thêm tin nhắn',
  'common.radio.room.list': 'Danh sách phòng trò chuyện',
  'user.title.room.content': 'Nội dung tin nhắn',
  'user.title.room.content.status': 'Trạng thái tin nhắn',
  'user.title.room.content.input': 'Vui lòng nhập nội dung tin nhắn',
  'common.radio.room.list.input': 'Hãy chọn danh sách phòng trò chuyện',
  'menu.ImNotifiMsgMgmt': 'Truy vấn tin nhắn thông báo thành viên',
  'user.title.room.id': 'ID phòng trò chuyện',
  'member.title.account.name': 'Tài khoản thành viên',
  'member.title.nickname': 'Biệt hiệu của thành viên',
  'common.title.room.deploy': 'Phát hành',
  'common.title.room.withdraw': 'Rút tiền',
  'admin.title.addTelemarketingList': 'Thêm phương pháp',
  'admin.title.selectedMembers': 'Thành viên được chọn',
  'admin.title.addMethod': 'Thêm phương pháp',
  'admin.title.remove': 'Di dời',
  'admin.title.memberActivateCount':'Nhập danh sách thành viên để kích hoạt người dùng',
  'user.title.activatedDepositorsCount': 'Số lượng người gửi tiền được kích hoạt',
  'user.title.activatedBetCount': 'Kích hoạt số lượng người đặt cược',
  'user.title.lastCallTime': 'Lần gọi cuối cùng',
  'user.title.depositTimeActivation': 'Thời gian gửi tiền khi kích hoạt',
  'user.title.betTimeActivation': 'Thời gian đặt cược khi kích hoạt',
  'user.title.dialStatus': 'Trạng thái quay số',
  'user.title.notConnected': 'Không kết nối',
  'user.title.connected': 'Đã kết nối',
  'user.title.numberCalls': 'Số lượng cuộc gọi',
  'user.title.callPerson': 'gọi người',
  'user.title.dialTime': 'Quay số thời gian',
  'user.title.hangUpTime': 'gác máy thời gian',
  'user.title.callDuration': 'Thời gian gọi',
  'agent.title.room.info': 'Thông tin nhóm IM',
  'pay.withdraw.payMayaName': 'PayMaya name',
  'pay.withdraw.payMayaAccount': 'Số tài khoản PayMaya',
  'pay.withdraw.grabPayName': 'GrabPay name',
  'pay.withdraw.grabPayAccount': 'Số tài khoản GrabPay',
  'user.title.payMayaPhone': 'Số điện thoại di động PayMaya',
  'user.title.payMayaRealName': 'PayMaya tên thật',
  'user.title.delPayMaya': 'Xóa tài khoản PayMaya',
  'user.title.askDelPayMaya': 'Hãy xác nhận xóa tài khoản PayMaya',
  'user.title.confirmUnbindingAllPayMaya': 'Lưu ý: sau khi hoạt động này, sẽ được gỡ bỏ tất cả các tài khoản PayMaya thuộc về người dùng',
  'user.title.grabPayPhone': 'Số điện thoại di động GrabPay',
  'user.title.grabPayRealName': 'GrabPay tên thật',
  'user.title.delGrabPay': 'Xóa tài khoản GrabPay',
  'user.title.askDelGrabPay': 'Hãy xác nhận xóa tài khoản GrabPay',
  'user.title.confirmUnbindingAllGrabPay': 'Lưu ý: sau khi hoạt động này, sẽ được gỡ bỏ tất cả các tài khoản GrabPay thuộc về người dùng',
  'user.title.enterPayMayaPhone': 'Vui lòng nhập số điện thoại PayMaya của bạn',
  'user.title.enterGrabPayPhone': 'Vui lòng nhập số điện thoại GrabPay của bạn',
  'user.title.enterPayMayaRealName': 'Vui lòng nhập tên thật PayMaya',
  'user.title.enterGrabPayRealName': 'Vui lòng nhập tên thật GrabPay',
  'user.title.exportMemberData': '导出会员资料',
  'user.title.email': 'Email',
  'user.title.importAndExport': 'Tải lên và xuất dữ liệu',
  'user.title.importAndExportType': 'Xuất dữ liệu',
  'user.title.pleaseEnterImportAndExportType': 'Vui lòng kiểm tra dữ liệu xuất trước',

  'user.title.OneKeyRecycle': 'Tái chế bằng một cú nhấp chuột',
  'pay.withdraw.weChatName': 'WeChat name',
  'pay.withdraw.weChatAccount': 'Số tài khoản WeChat',
  'user.title.weChatRealName': 'Tên thật WeChat',
  'user.title.delWeChat': 'Xóa tài khoản WeChat',
  'user.title.askDelWeChat': 'Vui lòng xác nhận xóa tài khoản WeChat',
  'user.title.confirmUnbindingAllWeChat': 'Lưu ý: Sau thao tác này, tất cả tài khoản WeChat thuộc về người dùng này sẽ không bị ràng buộc',
  'user.title.enterWeChatAccount': 'Vui lòng nhập tài khoản WeChat của bạn',
  'user.title.enterWeChatRealName': 'Vui lòng nhập tên thật WeChat',
  'user.title.modifyChannelInformation': 'Sửa đổi thông tin tài khoản {channelName}',

  'sys.rewardGoldenEgg': 'Phần thưởng Trứng Vàng',
  'sys.rewardRedEnvelope': 'Phần thưởng Phong bì màu đỏ',
  'sys.setPrizeDay': 'Vui lòng đặt giải thưởng cho ngày {dayCount}',

  "sign.receive,type1" :"Thưởng tiền mặt",
  "sign.receive,type2" :"Phần thưởng Trứng Vàng",
  "sign.receive,type3" :"Thưởng phong bì màu đỏ",
  'device.install.src.title': 'Nguồn cài đặt',
  'device.id.title': 'ID thiết bị',
  'device.serial.title': 'Thiết bị mô hình',
  'user.title.withdrawalsProhibited': 'Rút tiền bị cấm',
  'user.title.sign-inDays': 'Ngày nhận phòng',
  'pay.title.payerName': 'Tên người trả tiền',

  'member.select.filterRepeat.account.title': 'Xóa thành viên trùng lặp',
  'member.select.filterRepeat.ip.title': 'Xóa dữ liệu IP trùng lặp',
  'user.title.paymentCode': 'Mã thanh toán',
  'user.title.uploadPaymentCode': 'Vui lòng tải lên mã thanh toán',
  'user.title.pointCreateTime': 'Thời gian cấp điểm',
  'user.title.pointAmount': 'Số điểm thay đổi',
  'user.title.pointAmountAfter': 'Số tiền sau khi thay đổi',
  'user.title.pointAmountType': 'Loại điểm',
  'bonus.pointType.1':'Điểm giảm giá khi đăng nhập',
  'bonus.pointType.2':'Đổi điểm',
  'bonus.pointType.3':'Điểm thưởng tiền gửi theo thời gian thực',
  'bonus.pointType.4':'Điểm giảm giá nhiệm vụ',
  'bonus.pointType.5':'Điểm thưởng gửi tiền',
  'bonus.pointType.6':'Điều chỉnh điểm theo cách thủ công',
  'bonus.pointType.7':'Không xác định',
  'bonus.pointType.8':'Điều chỉnh điểm theo cách thủ công',
  'constants.regSourceTypeJk4_0': 'Chính thức',

  'analyze.quick3.deviceSource': 'Nguồn hóa đơn',
  'analyze.quick3.lotNo': 'Số vấn đề',
  'analyze.quick3.playName': 'Cách chơi số cá cược',
  'analyze.quick3.status': 'Trạng thái đặt cược',
  'analyze.quick3.status0': 'Sẽ được rút ra',
  'analyze.quick3.status1': 'Chưa rút ra',
  'analyze.quick3.status2': 'Xổ số đã được rút',
  'analyze.quick3.status3': 'Người dùng hủy đơn hàng',
  'analyze.quick3.status4': 'Hủy đơn hàng có hệ thống',
  'analyze.quick3.result': 'Lợi nhuận và thua lỗ',
  'analyze.quick3.playId1': 'Tổng',
  'analyze.quick3.playId2': 'hai cái giống nhau',
  'analyze.quick3.playId3': 'Cùng nhau',
  'analyze.quick3.deviceSource1': 'PC',
  'analyze.quick3.deviceSource2': 'H5',
  'analyze.quick3.deviceSource3': 'Android',
  'analyze.quick3.deviceSource4': 'IOS',
  'analyze.quick3.totalBets': 'Tổng số lần đặt cược',
  'analyze.quick3.totalBetAmount': 'Tổng số tiền đặt cược',
  'analyze.quick3.unawardedAmount': 'Số tiền chưa được thưởng',
  'analyze.quick3.cancellationAmount': 'Số tiền hủy',
  'analyze.quick3.totalUsers': 'Tổng số người dùng',
  'menu.betManagement': 'Quản lý cá cược',
  'menu.gamePlayRanking': 'Đang chơi Xếp hạng',
  'menu.playOdds': 'Chơi tỷ lệ',
  'menu.gameConfiguration': 'Cấu hình lối chơi',
  'menu.winningNumbers': 'Số xổ số',
  'menu.quick3': 'Nhanh ba',
  'analyze.quick3.nowOdds': 'Tỷ lệ cược hiện tại',
  'analyze.quick3.reset': 'Khôi phục cấu hình cuối cùng',
  'finance.export.gamePlayRanking': 'Xếp hạng lối chơi ba nhanh.xls',
  'analyze.quick3.gameType': 'Loại trò chơi',
  'analyze.quick3.maximumAmountSingleBet': 'Số tiền tối đa của một lần đặt cược',
  'analyze.quick3.userMaximumBet': 'Số tiền đặt cược tối đa của người dùng trong giai đoạn hiện tại',
  'analyze.quick3.currentPeriodMaximumBet': 'Đặt cược tối đa trong giai đoạn chơi trò chơi hiện tại',
  'analyze.quick3.gameplayEnableDisable': 'Bật/tắt lối chơi',
  'analyze.quick3.gameplayAbbreviation': 'Từ viết tắt trong lối chơi',
  'analyze.quick3.gameplay': 'Giới thiệu lối chơi',
  'analyze.quick3.bettingExamples': 'Ví dụ cá cược',
  'analyze.quick3.sampleCode': 'Mã mẫu',
  'analyze.quick3.lotteryName': 'Tên xổ số',
  'analyze.quick3.deadlineIssue': 'Hạn chót của vấn đề này',
  'analyze.quick3.fullRandom': 'Hoàn toàn ngẫu nhiên',
  'analyze.quick3.profitability': 'Tỷ lệ sinh lời',
  'analyze.quick3.betDetails': 'Chi tiết đặt cược',
  'analyze.quick3.bettingNumbers': 'Số cá cược',
  'analyze.quick3.numberBets': 'Số lần đặt cược',
  'analyze.quick3.totalBetAmount2': 'Tổng số BetAmount2',
  'analyze.quick3.singleBetAmount': 'Số tiền đặt cược duy nhất',
  'analyze.quick3.prizes': 'Bạn có thể giành được giải thưởng',

  'live.title.36': 'Nhận bao lì xì trong phòng phát trực tiếp',
  'live.title.42': 'Tiền thưởng hoàn thành nhiệm vụ phát trực tiếp',
  'live.title.71': 'Giải thưởng tiền mặt từ vòng quay may mắn trong phòng phát trực tiếp',
  'live.title.80': 'Quy đổi số tiền quà tặng của Streamer, tổng thu nhập của người dẫn chương trình{changeMoney}',
  'live.title.107': 'Mua cược dự đoán',
  'live.title.142': 'Gửi [{0}] * {1} cái',
  'live.title.168': 'Phòng phát trực tiếp gửi bao lì xì',
  'live.title.208': 'Thanh toán thưởng dự đoán',
  'live.title.209': 'Hoàn tiền dự đoán vô hiệu',
  'live.title.210': 'BXH vua thần bài đã tăng',
  'live.title.211': 'BXH vua thần bài đã giảm',

  'user.title.connectedState': 'Trên tiểu bang',
  'user.title.totalCalls': 'Tổng số cuộc gọi',

  'quick3.table.title': 'Số phòng/tên phòng/biệt hiệu của chủ nhà',
  'analyze.card.depositBetInfo': 'Thống kê các thành viên đầu tiên và các thành viên đặt cược hiệu quả trong ngày, cộng với nhau và sau đó đi',

  'quick3.quick3Bets': 'Đặt cược tài xỉu',
  'quick3.orderCancellation': 'Hoàn tiền huỷ cược tài xỉu',
  'quick3.quick3Payout': 'Trả thưởng tài xỉu',

  'bonus.checkin.xls': 'Bản ghi phần thưởng đăng nhập.xls',
  'bonus.integral.xls': 'Bản ghi đổi điểm.xls',
  'job.progress.xls': 'Progress.xls tác vụ của người dùng',
  'job.progress.acceptTime': 'Thời gian chấp nhận nhiệm vụ',
  'job.progress.completeTime': 'Thời gian hoàn thành nhiệm vụ',
  'job.progress.receiveTime': 'Thời gian nhận nhiệm vụ',
  'job.progress.title': 'Tiêu đề',
  'job.progress.userAccount': 'ID người dùng/Tên người dùng/Biệt hiệu',
  'job.progress.status': 'Trạng thái nhiệm vụ',
  'job.progress.status0': 'Đã nhận nhiệm vụ',
  'job.progress.status1': 'Nhiệm vụ đã hoàn thành',
  'job.progress.status2': 'Nhiệm vụ thu thập chưa hoàn thành',
  'job.progress.status3': 'Tiền thưởng đã nhận',
  'job.progress.jobType': 'Loại nhiệm vụ',
  'job.progress.jobType0': 'Nhiệm vụ mới',
  'job.progress.jobType1': 'Công việc hàng ngày',
  'menu.MerberLoginLock': 'Khóa danh sách người dùng',
  'user.title.loginLockTime': 'Thời gian khóa đăng nhập',
  'user.title.notUnlocked': 'Đã mở khóa',
  'user.title.unlocked': 'Đã mở khóa',
  'user.title.lockedState': 'Trạng thái bị khóa',
  'user.title.loginPasswordChange': 'Đăng nhập thay đổi mật khẩu',
  'user.title.loginPassword': 'Mật khẩu đăng nhập',
  'user.title.generatePasswordDirectly': 'Tạo mật khẩu trực tiếp',
  'user.title.re-enter': 'Nhập lại',
  'user.title.pleaseEnterAgain': 'Vui lòng nhập lại',
  'user.title.confirmUnlock': 'Xác nhận để mở khóa?',
  'user.title.activatedBetStatus': 'Trạng thái cá cược đã kích hoạt',
  'user.title.activatedDepositStatus': 'Trạng thái tiền gửi được kích hoạt',
  'user.title.selectActivatedBetStatus': 'Chọn trạng thái cá cược đã kích hoạt',
  'user.title.selectActivatedDepositStatus': 'Chọn trạng thái tiền gửi được kích hoạt',

  'analyze.title.applicationScenario': 'Kịch bản ứng dụng',
  'analyze.title.sendContent': 'Gửi nội dung',
  'analyze.title.causeOfFailure': 'Lý do thất bại',
  'analyze.title.verificationCodeFilledIn': 'Liệu mã xác minh có được chèn lấp hay không',
  'analyze.title.backfillStatus': 'Trạng thái chèn lấp',
  'analyze.title.registerToSend': 'Đăng ký để gửi',
  'analyze.title.loginToSend': 'Đăng nhập để gửi',
  'menu.smsDeliveryRate': 'Danh sách tốc độ gửi SMS',

  'front.onebuy.amount.sub': 'mua hàng onebuy',
  'front.onebuy.amount.change': 'thay đổi phần thưởng onebuy',
  'front.onebuy.amount.return': 'trả lại đơn hàng onebuy',
  'front.onebuy.amount.rebuy': 'mua lại hàng hóa onebuy',
  'admin.onebuy.excelExport.odrder': 'Dữ liệu đặt hàng',
  'admin.onebuy.excelExport.commodity': 'Dữ liệu sản phẩm',
  'admin.onebuy.excelExport.plan': 'Dữ liệu kế hoạch mua gấp',
  'admin.onebuy.excelExport.platformStatistic': 'Tóm tắt dữ liệu',
  'admin.onebuy.excelExport.platformDetailStatistic': 'Chi tiết dữ liệu',

  'constants.transferType_18': 'Mua một nhân dân tệ',
  'constants.transferType_19': 'Mua hàng bằng một nhân dân tệ',
  'constants.transferType_20': 'Đổi tiền thưởng mua hàng một đô la',
  'constants.transferType_21': 'Một nhân dân tệ Mua hàng gấp Trả lại',
  'constants.onebuyType_1': 'Phiếu mua một lần',
  'user.title.onebuyBalance': 'Số dư mua một lần',
  'user.title.onebuyBalanceTooltip': 'Quỹ mua một nhân dân tệ = Số tiền có thể rút + Số tiền gửi',
  'analyze.title.SMSLog': 'Bản ghi SMS',
  'analyze.title.loginSMSStatistics': 'Thống kê SMS đăng nhập',
  'analyze.title.registrationSMSStatistics': 'Thống kê SMS đăng ký',
  'analyze.title.numberApplications': 'Số lượng ứng dụng',
  'analyze.title.numberSuccessfulBackfills': 'Số lần chèn lấp thành công',
  'analyze.title.backfillSuccessRate': 'Số lần chèn lấp thành công',
  'analyze.title.backfillFailureCount': 'Số lần chèn lấp không thành công',
  'analyze.title.backfillFailureRate': 'Tỷ lệ lỗi chèn lấp',

  'common.bonus.vipRewardType1': 'Thưởng thăng cấp',
  'common.bonus.vipRewardType2': 'Thưởng duy trì liên tiếp',
  'common.bonus.vipRewardType3': 'Tiền thưởng sinh nhật',
  'common.bonus.vipRewardType4': 'Tiền cứu trợ nổ hũ',
  'common.bonus.vipRewardType5': 'Tiền cứu trợ Casino',
  'common.bonus.vipRewardType6': 'Tiền cứu trợ thể thao',
  'common.bonus.vipRewardType7': 'Tiền cứu trợ xổ số',
  'common.bonus.vipRewardType8': 'Tiền cứu trợ bắn cá',
  'common.bonus.vipRewardType9': 'Tiền cứu trợ game bài',
  'common.bonus.vipRewardType10': 'Chip miễn phí phiên bản H5',
  'common.bonus.vipRewardType11': 'Thưởng tuần',
  'common.bonus.vipRewardType12': 'Thưởng tháng',
  'common.bonus.vipRewardType13': 'Chip miễn phí phiên bản PC',
  'common.bonus.vipRewardType14': 'Số lượt thưởng vòng quay may mắn',
  'common.bonus.vipRewardType15': 'Xác nhận',
  'common.bonus.vipRewardType16': 'Chip miễn phí phiên bản APP',
  'common.bonus.vipRewardType17': 'Chip miễn phí phiên bản PWA',
  'common.bonus.vipLevelBonusName': '{vipLevel}{bonusName}',
  'admin.bonus.profitLoss': 'Phần thưởng lãi và lỗ',
  'common.title.expirationDay': 'Thời hạn hiệu lực / Số ngày',
  'common.title.flowIssued': 'Phát thưởng theo doanh thu',
  'common.title.sufficientDeposit': 'Đạt yêu cầu về số tiền gửi',
  'common.title.grant': 'Có thể phát thưởng',
  'common.title.usersSendComments': 'Người dùng có cho phép gửi bình luận hay không',
  'front.vip.level': '{0}Ưu đãi cấp bậc',
  'front.vip.up': 'Tiền thưởng thăng cấp {0}',
  'front.vip.upMsg1': 'Không có tiền thưởng thăng cấp nào để nhận',
  'front.vip.upMsg2': 'Bạn đã nhận tiền thưởng thăng cấp của cấp bậc hiện tại',
  'front.vip.birthday': 'Tiền thưởng sinh nhật {0}',
  'front.vip.birthdayMsg1': 'Hiện không có tiền thưởng sinh nhật nào để nhận',
  'front.vip.birthdayMsg2': 'Vui lòng nhập ngày sinh trước',
  'front.vip.birthdayMsg3': 'Lỗi do quá thời gian  nhận tiền thưởng sinh nhật',
  'front.vip.birthdayMsg4': 'Bạn đã nhận tiền thưởng sinh nhật cấp hiện tại trong năm',
  'front.vio.depositMsg1': 'Bạn đã nhận tiền thưởng này, vui lòng nạp tiền lại',
  'front.vio.depositMsg2': 'Vui lòng nạp tiền trước rồi nhận ưu đãi',
  'front.vio.depositMsg3': 'Hiện không có ưu đãi nạp tiền cấp bậc VIP',
  'front.vio.depositMsg4': 'Không có ưu đãi nào để nhận',
  'sys.oneBuyCouponTimes': 'Phiếu mua hàng một đô la',
  'sys.enterOneBuyCouponTimes': 'Vui lòng nhập số phiếu thưởng mua hàng một nhân dân tệ',

  'common.userPoint.noEnough':'Thành viên không có đủ điểm',
  'user.title.addPointSuccess':'Điểm được sửa đổi thành công. ',
  'user.title.addPointError':'Thao tác sửa đổi điểm không thành công. ',
  'user.title.addPoint':'Sửa đổi điểm thành viên',
  'user.title.increasePoint':'Thêm điểm',
  'user.title.decreaspoint':'Trừ điểm',
  'sys.enterPreferentialPoint':'Vui lòng nhập số điểm',
  'sys.PreferencePoint.msg':'Số điểm',

  'menu.yygCoupon': 'Phiếu giảm giá',
  'push.msg.config.typeOnebuy': 'Mua với giá một đô la',
  'sys.msgDepositPage': 'Số tiền gửi tối thiểu: {minDeposit}',
  'admin.bonus.depositPageBonus': 'Ưu đãi hoàn tiền khi nạp tiền,{date}',

  'sys.title.verificationRequestTime': 'Thời gian yêu cầu xác minh',
  'sys.title.numberVerificationFailures': 'Số lần xác minh không thành công',
  'sys.title.timeIncurrifyPasswordInput': 'Thời gian nhập mật khẩu không chính xác',
  'sys.title.numberIn CorrectPasswords': 'Số lượng mật khẩu không chính xác',
  'sys.title.loginRequestTime': 'Yêu cầu thời gian đăng nhập',
  'sys.title.numberLoginRequests': 'Số yêu cầu đăng nhập',
  'sys.title.restrictionMethod': 'Phương pháp hạn chế',
  'sys.title.IPBlacklist': 'Danh sách đen IP',
  'sys.title.deviceBlacklist': 'Danh sách đen thiết bị',
  'sys.title.loginRestriction': 'Hạn chế đăng nhập',
  'admin.onebuy.type.return': 'Đền bù',
  'admin.onebuy.name.return': 'Hoàn tiền mua hàng một đô la',

  'sys.title.blindBoxConfiguration': 'Cấu hình hộp mù',
  'sys.title.dailyOpeningTimes': 'Số lần mở hộp mù mỗi ngày',
  'sys.title.dayTime': 'Thời gian mở cửa hàng ngày',
  'sys.title.dailyBlindBoxDrawLimit': 'Giới hạn vẽ hộp mù hàng ngày',
  'sys.title.rebateRatio': 'Tỷ lệ chiết khấu',
  'sys.title.weight': 'trọng lượng',
  'sys.title.orAbove': 'hoặc cao hơn',
  'sys.title.depositsAndBet': 'Gửi tiền và đặt cược',
  'sys.title.maximumIssuance': 'Phát hành tối đa',


  'sys.title.setCashWheel': 'Đặt vòng quay tiền mặt',
  'sys.title.timePeriod': 'Khoảng thời gian',
  'sys.title.activityRewardAmount': 'Số tiền thưởng hoạt động',
  'sys.title.directCashWithdrawalNotPossible': 'Không thể rút tiền mặt trực tiếp',
  'sys.title.initialAmountFirstLotteryDraw': 'Số tiền khởi tạo xổ số đầu tiên',
  'sys.title.numberDraws': 'Số lần rút thăm',
  'sys.title.falseWithdrawalInformation': 'Thông tin rút tiền sai',
  'sys.title.realWithdrawalInformation': 'Thông tin rút tiền thực',
  'sys.title.uploadAwardImage': 'Tải hình ảnh giải thưởng lên',
  'sys.title.addAwards': 'Thêm giải thưởng',
  'sys.title.conditionSettings': 'Cài đặt có điều kiện',
  'sys.title.validNumberInvitations': 'Số lượng lời mời hợp lệ',
  'sys.title.giveawayDraw': 'Rút quà',
  'sys.title.taskDescription': 'Mô tả nhiệm vụ',
  'sys.title.depositBonus': 'Tiền thưởng gửi tiền',
  'sys.title.numberDeposits': 'Số lượng tiền gửi',
  'sys.title.amountCannotLessThan': 'Mỗi số tiền không được nhỏ hơn',
  'sys.title.downloadAPPLoginReward': 'Tải xuống phần thưởng đăng nhập APP',
  'sys.title.downloadAPPLogDraw': 'Tải xuống APP và đăng nhập để nhận rút thăm may mắn',
  'sys.title.withdrawalRestrictions': 'Hạn chế rút tiền',
  'sys.title.amountMustDepositRequirement': 'Tất cả số tiền thưởng rút được phải thỏa mãn số tiền gửi',
  'sys.title.ifNotMetReduce': 'Nếu không đạt, hãy giảm',
  'sys.title.activityRules': 'Mô tả quy tắc hoạt động',
  'sys.title.lotteryRecords': 'Hồ sơ xổ số',
  'sys.title.firstFewDraws': 'Số lần rút',
  'sys.title.lotteryResults': 'Kết quả xổ số',
  'sys.title.amountAfterChange': 'Số tiền sau khi thay đổi',
  'sys.title.completed': 'Liệu nó đã hoàn thành chưa',
  'sys.title.numberAssistsRecorded': 'Số bản ghi hỗ trợ',
  'sys.title.assistTime': 'Thời gian hỗ trợ',
  'sys.title.numberLotteryDraws': 'Số lần rút hỗ trợ',
  'sys.title.withdrawalRecord': 'Hồ sơ rút tiền',
  'sys.title.withdrawalTime': 'Thời gian rút tiền',
  'sys.title.withdrawalAmount': 'Số tiền rút',
  'sys.title.withdrawalRatio': 'Tỷ lệ rút tiền',
  'sys.title.meetDepositRequirements': 'Liệu điều kiện gửi tiền có được đáp ứng hay không',
  'sys.title.timeSettings': 'Cài đặt thời gian',
  'sys.title.addFalseWithdrawalInformation': 'Thêm thông tin rút tiền sai',
  'common.bonus.systemGive': 'Quà tặng hệ thống',
  'common.bonus.deposit': 'Hoàn tất nạp tiền',
  'common.bonus.appLogin': 'Phần thưởng đăng nhập APP',
  'common.bonus.invite': 'Mời {count} bạn bè',
  'menu.automaticReview': 'rút tiềnXem lạiCấu hình',
  'sys.rolemanagement.rolename': 'Tên nhân vật',
  'sys.rolemanagement.rolenote': 'Mô tả vai trò',
  'sys.rolemanagement.issuper': 'siêu quản trị viên',
  'sys.rolemanagement.rolewarnning': 'Vui lòng kiểm tra ít nhất một mục menu',
  'sys.rolemanagement.menus.tree': 'Menu quyền',
  'sys.rolemanagement.editTitle': 'Sửa đổi vai trò',
  'userDomain.title.status': 'Trạng thái',
  'userDomain.status.enabled': 'Kích hoạt',
  'userDomain.status.disabled': 'Cấm',
  'sys.row.title': 'số seri',
  'sys.user.name': 'Tài khoản người dùng',
  'sys.user.use': 'Người sử dụng',
  'sys.user.selectRole': 'Chọn Vai Trò',
  'sys.user.selectRolePlaceholder': 'Vui Lòng Chọn Vai Trò',
  'sys.user.status': 'Trạng Thái',
  'sys.user.selectStatusPlaceholder': 'Vui Lòng Chọn Trạng Thái',
  'sys.user.enabled': 'Kích Hoạt',
  'sys.user.disabled': 'Vô Hiệu Hóa',
  'sys.role.delete1': 'Để tránh lỗi, vui lòng vô hiệu hóa trước khi xóa',
  'sys.role.delete2': 'Có {count} tài khoản người dùng sử dụng quyền này',
  'sys.role.delete3': 'Bạn có chắc chắn muốn xóa vai trò này không?',
  'game.gameTypeMgmt.column.title.index': 'số seri',
  'game.gameTypeMgmt.column.title.gameGroupName': 'kiểu',
  'game.gameTypeMgmt.column.title.gameDefaultSort': 'loại',
  'game.gameTypeMgmt.column.title.gameGroupPcImg': 'Biểu tượng PC không được chọn',
  'game.gameTypeMgmt.column.title.gameGroupH5Img': 'Biểu tượng bỏ chọn H5',
  'game.gameTypeMgmt.column.title.gameGroupAppImg': 'Biểu tượng bỏ chọn ứng dụng',
  'game.gameTypeMgmt.column.title.gameGroupPcImgEnlarge': 'Biểu tượng được chọn trên PC',
  'game.gameTypeMgmt.column.title.gameGroupH5ImgEnlarge': 'Biểu tượng đã chọn H5',
  'game.gameTypeMgmt.column.title.gameGroupAppImgEnlarge': 'Biểu tượng đã chọn ứng dụng',
  'game.gameTypeMgmt.column.title.gameStatus': 'Có bật hay không',
  'game.gameTypeMgmt.column.title.operator': 'toán tử',
  'game.gameTypeMgmt.column.title.operateTime': 'Thời gian hoạt động',
  'game.gameTypeMgmt.column.title.operateAction': 'vận hành',
  'game.gamePlatformMgmt.column.title.index': 'số seri',
  'game.gamePlatformMgmt.column.title.gamePlatformName': 'Tên nền tảng',
  'game.gamePlatformMgmt.column.title.gameFullName': 'Tên đầy đủ của nền tảng',
  'game.gamePlatformMgmt.column.title.gameShowName': 'tên hiển thị',
  'game.gamePlatformMgmt.column.title.gamePlatformCode': 'Nhận dạng nền tảng',
  'game.gamePlatformMgmt.column.title.gameType': 'loại nền tảng',
  'game.gamePlatformMgmt.column.title.percent': 'Tỷ lệ nền tảng',
  'game.gamePlatformMgmt.column.title.status': 'tình trạng',
  'game.gamePlatformMgmt.column.title.desc': 'Mô tả nền tảng',
  'game.gamePlatformMgmt.column.title.gameCount': 'Số lượng trò chơi',
  'game.gamePlatformMgmt.column.title.action': 'vận hành',
  'game.gamePlatformMgmt.editconfig': 'Cấu hình trò chơi',
  'game.gameListMgmt.column.title.index': 'số seri',
  'game.gameListMgmt.column.title.gamePlatformName': 'Tên nền tảng',
  'game.gameListMgmt.column.title.gameName': 'Tên trò chơi',
  'game.gameListMgmt.column.title.rpt.recommendRate': 'RPT chính thức',
  'game.gameListMgmt.column.title.rpt.showRate': 'Khoảng thời gian hiển thị RPT',
  'game.gameListMgmt.column.title.rpt.boostRate': 'giá trị ước tính tăng cường',
  'game.gameListMgmt.column.title.winPlayerRange': 'Khoảng người chơi thắng',
  'game.gameListMgmt.column.title.player30MinRange': 'Khoảng người chơi 30 phút',
  'game.gameListMgmt.column.title.maxPrizeRange': 'Khoảng giải thưởng tối đa',
  'game.gameListMgmt.placeholder.minPlayerCount': 'Số người tối thiểu',
  'game.gameListMgmt.placeholder.maxPlayerCount': 'Số người tối đa',
  'game.gameListMgmt.placeholder.minAmount': 'Giá trị tối thiểu',
  'game.gameListMgmt.placeholder.maxAmount': 'Giá trị tối đa',
  'game.gameListMgmt.validation.positiveIntegerOnly': 'Vui lòng nhập số nguyên dương',
  'game.gameListMgmt.validation.maxValueExceeded': 'Giá trị không được vượt quá 2,147,483,647',
  'game.gameListMgmt.validation.maxPrizePairIncomplete': 'Giá trị nhỏ nhất và lớn nhất phải được nhập cùng nhau',
  'game.gameListMgmt.column.title.gameFullName': 'Tên trò chơi đầy đủ',
  'game.gameListMgmt.column.title.gameCode': 'mã hóa trò chơi',
  'game.gameListMgmt.column.title.gameType': 'loại nền tảng',
  'game.gameListMgmt.column.title.currency': 'Tiền tệ',
  'game.gameListMgmt.column.title.gamePcImg': 'hình ảnh máy tính',
  'game.gameListMgmt.column.title.gameH5Img': 'hình ảnh H5',
  'game.gameListMgmt.column.title.gameAppImg': 'Hình ảnh ứng dụng',
  'game.disable': 'Bạn có muốn vô hiệu hóa nó?',
  'game.enable': 'Bạn có muốn kích hoạt nó?',
  'common.tradeId' : 'buôn bán',
  'common.enterTradeId' : 'Xin vui lòng nhập buôn bán',
  'activity.activityMgmt.column.title.index': 'Mã khuyến mại',
  'activity.activityMgmt.column.name': 'Tên khuyến mại',
  'activity.activityMgmt.column.multiType': 'Thể loại khuyến mại',
  'activity.activityMgmt.column.templateType': 'Mẫu giảm giá',
  'activity.activityMgmt.column.lang': 'Ngôn ngữ',
  'activity.activityMgmt.column.status': 'Trạng thái hoạt động',
  'activity.activityMgmt.column.showTime': 'Thời gian hiển thị giảm giá',
  'activity.activityMgmt.column.enableTime': 'Giảm giá thời gian hiệu quả',
  'activity.activityMgmt.column.sort': 'Sắp xếp',
  'activity.activityMgmt.column.action': 'Hành động',

  'sys.resetGoogleAuthPassword': 'Đặt lại Mã xác minh của Google',
  'sys.confirmGoogleAuthPassword': 'Xác nhận để đặt lại mã xác minh của Google? ',
  'sys.googleAuth': 'Mã xác minh của Google',
  'sys.googleAuth.val': 'Vui lòng nhập mã xác minh của Google',

  'game.show.type': 'Phương pháp hiển thị',
  'game.show.type.input': 'Vui lòng chọn phương pháp hiển thị',

  // Bản dịch cấu hình website
  'webConfig.depositTurnoverMultiplier': 'Bội số doanh thu nạp tiền',
  'webConfig.saveSuccess': 'Lưu thành công',
  'webConfig.updateSuccess': 'Cập nhật thành công',
  'webConfig.disableSuccess': 'Vô hiệu hóa thành công',
  'webConfig.enableSuccess': 'Kích hoạt thành công',
  'webConfig.deleteSuccess': 'Xóa thành công',

  'clientInfo.contactUs': 'Thông tin liên hệ',
  'clientInfo.displayIcon': 'Hiển thị biểu tượng',
  'clientInfo.registerNoDeposit': 'Đã đăng ký chưa nạp tiền',
  'clientInfo.firstDepositSubmit': 'Đã gửi nạp lần đầu',
  'clientInfo.firstDepositSuccess': 'Nạp lần đầu thành công',

  // Bản dịch cấu hình rút tiền
  'payWithdraw.autoApproval': 'Kiểm soát rủi ro có tự động phê duyệt rút tiền hay không',
  'payWithdraw.withdrawPassword': 'Rút tiền có cần xác thực mật khẩu rút tiền hay không',
  'payWithdraw.bankCard': 'Thẻ ngân hàng',
  'payWithdraw.config.title': 'Cấu hình nạp và rút tiền',
  'payWithdraw.save': 'Lưu',
  'payWithdraw.basicConfig': 'Cấu hình rút tiền cơ bản',
  'payWithdraw.accountBindConfig': 'Cấu hình liên kết tài khoản rút tiền',
  'payWithdraw.disabled': 'Vô hiệu hóa',
  'payWithdraw.enabled': 'Kích hoạt',
  'payWithdraw.bindableAccountCount': 'Số lượng tài khoản có thể liên kết',
  'payWithdraw.bindableAccountCountInvalid': 'Số lượng tài khoản liên kết phải lớn hơn hoặc bằng 1',
  'payWithdraw.updateSuccess': 'Cập nhật thành công',
  'payWithdraw.formValidationFailed': 'Xác thực biểu mẫu thất bại',
  'payWithdraw.vipRange': 'Cấp VIP',
  'payWithdraw.addRange': 'Thêm khoảng',
  'payWithdraw.deleteRange': 'Xóa',
  'payWithdraw.vipRangeTips': 'Cấu hình số lượng tài khoản liên kết theo khoảng VIP (bao gồm cả điểm đầu và điểm cuối)',
  'payWithdraw.vipRangeOverlap': 'Các khoảng VIP không được chồng lấp',
  'payWithdraw.vipRangeInvalid': 'VIP bắt đầu không được lớn hơn VIP kết thúc',
  'payWithdraw.vipRangeContinuous': 'Khoảng mới phải bắt đầu ngay sau khoảng trước đó',
  'payWithdraw.vipRangeMaxReached': 'Đã bao phủ đến VIP31, không thể thêm khoảng mới',

  // Quốc tế hóa cấu hình xác thực rút tiền
  'payWithdraw.withdraw_verification_mobile': 'Rút tiền có cần xác thực số điện thoại hay không',
  'payWithdraw.withdraw_verification_real_name': 'Rút tiền có cần xác thực tên thật hay không',
  'payWithdraw.withdraw_verification_card_valid': 'Rút tiền có cần ngày hết hạn thẻ ngân hàng hay không',
  'payWithdraw.withdraw_verification_email': 'Rút tiền có cần xác thực email hay không',
  'payWithdraw.withdraw_verification_withdraw_pwd': 'Rút tiền có cần xác thực mật khẩu rút tiền hay không',
  'payWithdraw.withdraw_verification_login_pwd': 'Xác thực mật khẩu đăng nhập khi liên kết tài khoản rút tiền',
  'payWithdraw.withdraw_maya_auth': 'Ủy quyền rút tiền Maya',

  // Quốc tế hóa cấu hình liên kết tài khoản
  'payWithdraw.bind_USDT': 'USDT',
  'payWithdraw.bind_SPEI': 'SPEI',
  'payWithdraw.bind_bank': 'BankCard',
  'payWithdraw.bind_cashapp': 'CashApp',
  'payWithdraw.bind_chime': 'Chime',
  'payWithdraw.bind_zelle': 'Zelle',
  'payWithdraw.bind_paypal': 'PayPal',
  'payWithdraw.bind_ach': 'ACH',
  'payWithdraw.bind_Grabpay': 'Grabpay',
  'payWithdraw.bind_Gcash': 'Gcash',
  'payWithdraw.bind_Paymaya': 'Paymaya',

  // Notice component internationalization
  'notice.soundSettings': 'Cài đặt âm thanh',
  'notice.withdrawSoundPrompt': 'Nhắc nhở âm thanh rút tiền',
  'notice.kycSoundPrompt': 'Nhắc nhở âm thanh KYC',
  'notice.close': 'Đóng',


  // Modal chi tiết thành viên
  'memberDetail.modal.title': 'Chi tiết thành viên - {memberAccount}',

  // Danh mục sản phẩm
  'product.category.cash': 'Tiền mặt',
  'product.category.props': 'Đạo cụ',
  'product.category.product': 'Sản phẩm vật lý',
  'product.category.unknown': 'Loại không xác định',

  // ==================== Bảng xếp hạng ====================
  // Tiêu đề
  'leaderboard.depositTitle': 'Bảng xếp hạng nạp tiền',
  'leaderboard.withdrawTitle': 'Bảng xếp hạng rút tiền',
  'leaderboard.promoTitle': 'Bảng xếp hạng khuyến mãi',

  // Trường thông tin chung
  'leaderboard.rank': 'Xếp hạng',
  'leaderboard.userAccount': 'Tài khoản thành viên',
  'leaderboard.nickname': 'Biệt danh',
  'leaderboard.realName': 'Tên thật',
  'leaderboard.mobile': 'Số điện thoại',
  'leaderboard.vipLevel': 'Cấp VIP',
  'leaderboard.currency': 'Tiền tệ',

  // Trường nạp tiền
  'leaderboard.depositAmount': 'Tổng nạp tiền',
  'leaderboard.depositCount': 'Số lần nạp tiền',
  'leaderboard.avgDeposit': 'Nạp tiền trung bình',
  'leaderboard.maxDeposit': 'Nạp tiền tối đa',
  'leaderboard.lastDepositTime': 'Thời gian nạp tiền gần nhất',

  // Trường rút tiền
  'leaderboard.withdrawAmount': 'Tổng rút tiền',
  'leaderboard.withdrawCount': 'Số lần rút tiền',
  'leaderboard.avgWithdraw': 'Rút tiền trung bình',
  'leaderboard.maxWithdraw': 'Rút tiền tối đa',
  'leaderboard.lastWithdrawTime': 'Thời gian rút tiền gần nhất',

  // Trường khuyến mãi
  'leaderboard.promoClaimCount': 'Số lần nhận khuyến mãi',
  'leaderboard.promoAmount': 'Số tiền khuyến mãi',
  'leaderboard.promoPoints': 'Điểm khuyến mãi',
  'leaderboard.lastPromoTime': 'Thời gian nhận khuyến mãi gần nhất',
  'leaderboard.clickToSort': 'Nhấp để sắp xếp theo trường này',

  // Thời gian
  'leaderboard.periodLabel': 'Thời gian xếp hạng',
  'leaderboard.today': 'Hôm nay',
  'leaderboard.todayRealtime': 'Hôm nay thời gian thực',
  'leaderboard.yesterday': 'Hôm qua',
  'leaderboard.lastWeek': 'Tuần trước',
  'leaderboard.lastMonth': 'Tháng trước',
  'leaderboard.hourly': 'Hôm nay thời gian thực',
  'leaderboard.periodDaily': 'Bảng xếp hạng hôm qua',
  'leaderboard.periodWeekly': 'Bảng xếp hạng tuần trước',
  'leaderboard.periodMonthly': 'Bảng xếp hạng tháng trước',
  'leaderboard.periodHourly': 'Bảng xếp hạng hôm nay thời gian thực',

  // Trường thống kê
  'leaderboard.sortField': 'Trường thống kê',
  'leaderboard.selectSortField': 'Chọn trường thống kê',

  // Placeholder
  'leaderboard.userAccountPlaceholder': 'Nhập tài khoản thành viên',
  'leaderboard.nicknamePlaceholder': 'Nhập biệt danh',
  'leaderboard.realNamePlaceholder': 'Nhập tên thật',
  'leaderboard.mobilePlaceholder': 'Nhập số điện thoại',

  // ==================== Bảng xếp hạng Thắng/Thua/Cược ====================
  // Trường biểu mẫu
  'leaderboard.periodType': 'Loại thời gian',
  'leaderboard.periodTypeRequired': 'Vui lòng chọn loại thời gian',
  'leaderboard.selectPeriodType': 'Chọn loại thời gian',
  'leaderboard.currencyRequired': 'Vui lòng chọn tiền tệ',
  'leaderboard.selectCurrency': 'Chọn tiền tệ',
  'leaderboard.enterUserAccount': 'Nhập tài khoản thành viên',
  'leaderboard.selectVipLevel': 'Chọn cấp VIP',

  // Trường Bảng xếp hạng Thắng/Thua/Cược
  'leaderboard.netProfit': 'Lợi nhuận ròng',
  'leaderboard.netLoss': 'Thua lỗ ròng',
  'leaderboard.validBet': 'Cược hợp lệ',
  'leaderboard.profitRate': 'Tỷ lệ lợi nhuận',
  'leaderboard.lossRate': 'Tỷ lệ thua lỗ',
  'leaderboard.betCount': 'Số lần cược',
  'leaderboard.lastBetTime': 'Thời gian cược gần nhất',

  // Xuất và gợi ý bảng xếp hạng
  'leaderboard.naturalTimeCycleHint': 'Bảng xếp hạng được tính theo chu kỳ thời gian tự nhiên (không phải thời gian cuộn)',
  'leaderboard.exportSubmitSuccess': 'Đã gửi yêu cầu xuất, vui lòng kiểm tra "Tải xuống tệp" sau',
  'leaderboard.exportFailed': 'Xuất thất bại, vui lòng thử lại sau',

  // Bảng xếp hạng theo giờ
  'leaderboard.statsDate': 'Ngày thống kê',
  'leaderboard.statsHour': 'Đến giờ',
  'leaderboard.selectStatsDate': 'Chọn ngày thống kê',
  'leaderboard.selectStatsHour': 'Chọn đến giờ',
  'leaderboard.statsDateRequired': 'Vui lòng chọn ngày thống kê',
  'leaderboard.statsHourRequired': 'Vui lòng chọn đến giờ',
  'leaderboard.hourlyHint': 'Hiển thị dữ liệu xếp hạng tích lũy từ 00:00 đến giờ đã chọn',
  'leaderboard.hourlyDataUpdatedAt': 'Dữ liệu cập nhật đến {hour} giờ',

  // Bảng xếp hạng trò chơi
  'gameRanking.title': 'Bảng xếp hạng trò chơi',
  'gameRanking.gameName': 'Tên trò chơi',
  'gameRanking.gameNamePlaceholder': 'Nhập tên trò chơi',
  'gameRanking.gameId': 'ID trò chơi',
  'gameRanking.gameIdPlaceholder': 'Nhập ID trò chơi',
  'gameRanking.gameVendor': 'Nhà cung cấp',
  'gameRanking.gameVendorPlaceholder': 'Nhập nhà cung cấp',
  'gameRanking.gameShowName': 'Tên hiển thị',
  'gameRanking.rank': 'Xếp hạng',
  'gameRanking.betUserCount': 'Số người cược',
  'gameRanking.betCount': 'Số lượt cược',
  'gameRanking.betAmount': 'Số tiền cược',
  'gameRanking.winUserCount': 'Số lần thắng',
  'gameRanking.playerWinAmount': 'Tiền thắng người chơi',
  'gameRanking.playerLossAmount': 'Tiền thua người chơi',
  'gameRanking.platformNetAmount': 'Lãi ròng nền tảng',
  'gameRanking.avgBetAmount': 'Cược TB/người',
  'gameRanking.avgBetCount': 'Lượt cược TB/người',
  'gameRanking.avgPlatformNet': 'Lãi TB/người',
  'gameRanking.dataHint': 'Phạm vi dữ liệu: Hôm nay thời gian thực (cập nhật tích lũy mỗi giờ)/Hôm qua/Thứ Hai đến Chủ Nhật tuần trước/Ngày 1 đến ngày cuối tháng trước (chu kỳ thời gian tự nhiên)',
};
